var Zv = Object.defineProperty;
var Qv = (e, t, n) => t in e ? Zv(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Te = (e, t, n) => (Qv(e, typeof t != "symbol" ? t + "" : t, n), n);
import { useSlots as Yi, computed as ae, openBlock as y, createElementBlock as O, normalizeClass as Ne, renderSlot as me, createTextVNode as sa, toDisplayString as et, createCommentVNode as F, createBlock as le, Teleport as zf, createElementVNode as ee, createVNode as Pe, Transition as Ri, withCtx as De, resolveComponent as _e, normalizeStyle as kn, withKeys as Hf, Fragment as Fe, renderList as Xe, resolveDynamicComponent as li, resolveDirective as td, mergeProps as Ft, withDirectives as ai, vShow as Sr, withModifiers as ii, reactive as Go, ref as he, defineComponent as nn, toRef as Lo, onMounted as wn, nextTick as Un, onUnmounted as vl, watch as ra, unref as x, isRef as Sh, createSlots as gn, normalizeProps as tn, guardReactiveProps as Cn, h as nd, render as Th, onBeforeUpdate as Kv, getCurrentScope as Jv, onScopeDispose as eg, defineAsyncComponent as jr } from "vue";
import { _ as an } from "./_plugin-vue_export-helper-dad06003.js";
import { H as Wf } from "./HelpIcon-2069ddad.js";
import { B as tg, a as Ad } from "./ButtonPlay-d3872713.js";
import { useNotificationHandler as Bf } from "./useNotificationHandler.js";
import { b as Ah, I as Oh, S as Ch, H as Eh, N as Ph, B as Rh, L as Ih, a as Yh, A as ng, d as ag, V as Vf, T as Od, F as jf, c as ig, D as rg, U as og, P as Cd, Z as Ed } from "./DownloadFileIcon-8a003268.js";
import { B as sg, a as lg } from "./BarProgressMd-c3ebb73b.js";
import { d as Uf, B as ug, b as dg, c as cg, a as hg } from "./ButtonCloseSm-209b27c6.js";
import { b as fn, A as Gf, B as Nh, c as fg, d as mg, g as pg } from "./FormRichText.model-53e072ea.js";
import { C as vg } from "./PreloaderIcon-b44be854.js";
import { C as gg, A as yg } from "./ChevronLeftIcon-b6affe9b.js";
import "./glightbox-13d8fc52.js";
function Ur() {
  return Math.random().toString(16).slice(2);
}
function CA() {
  const e = navigator.userAgentData;
  if (e) {
    const t = e.platform.toLowerCase();
    if (t.includes("mac"))
      return !0;
    if (t.includes("win"))
      return !1;
  } else {
    const t = navigator.userAgent.toLowerCase();
    if (t.includes("mac"))
      return !0;
    if (t.includes("win"))
      return !1;
  }
  return !1;
}
const wg = ["data-error"], bg = "mt-2 text-sm ct-text-3 ct-word-breaks", _g = "mt-2 text-sm ct-text-error ct-word-breaks", qf = {
  __name: "FormNotification",
  props: {
    message: {
      type: String,
      default: ""
    },
    innerClasses: {
      type: [String, Object],
      default: ""
    },
    help: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Yi(), a = ae(() => n.default), i = ae(() => !!t.message), r = ae(() => t.innerClasses ? t.innerClasses : t.error ? _g : t.help ? bg : "");
    return (o, l) => a.value || i.value ? (y(), O("div", {
      key: 0,
      class: Ne(r.value),
      "data-error": e.error || null
    }, [
      me(o.$slots, "default", {}, () => [
        sa(et(t.message), 1)
      ])
    ], 10, wg)) : F("", !0);
  }
}, kg = {
  name: "LayoutModal",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    topPosition: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "close"],
  computed: {
    isOpen: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, xg = { class: "ct-bg-1--alt" }, Mg = {
  class: "relative z-50",
  role: "dialog",
  "aria-modal": "true"
}, Dg = {
  key: 0,
  class: "fixed inset-0 ct-bg-overlay"
}, Sg = {
  key: 0,
  class: "fixed inset-0 z-10 w-screen overflow-y-auto"
};
function Tg(e, t, n, a, i, r) {
  return y(), le(zf, { to: "body" }, [
    ee("div", xg, [
      ee("div", Mg, [
        Pe(Ri, {
          name: "fade",
          appear: ""
        }, {
          default: De(() => [
            r.isOpen ? (y(), O("div", Dg)) : F("", !0)
          ]),
          _: 1
        }),
        Pe(Ri, {
          name: "modal-transition",
          appear: "",
          onAfterLeave: t[0] || (t[0] = (o) => e.$emit("close"))
        }, {
          default: De(() => [
            r.isOpen ? (y(), O("div", Sg, [
              ee("div", {
                class: Ne(["flex min-h-full justify-center p-4 text-center", [
                  n.topPosition ? "sm:pt-[10vh] items-start" : "items-end sm:items-center"
                ]])
              }, [
                me(e.$slots, "default")
              ], 2)
            ])) : F("", !0)
          ]),
          _: 3
        })
      ])
    ])
  ]);
}
const Xf = /* @__PURE__ */ an(kg, [["render", Tg]]);
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function $h(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ag(e) {
  var t, n;
  return $h(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !($h(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
function To() {
  return To = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, To.apply(this, arguments);
}
function Zf(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      if (t.indexOf(a) >= 0)
        continue;
      n[a] = e[a];
    }
  return n;
}
const ad = { silent: !1, logLevel: "warn" }, Og = ["validator"], Qf = Object.prototype, Kf = Qf.toString, Cg = Qf.hasOwnProperty, Jf = /^\s*function (\w+)/;
function Lh(e) {
  var t;
  const n = (t = e == null ? void 0 : e.type) !== null && t !== void 0 ? t : e;
  if (n) {
    const a = n.toString().match(Jf);
    return a ? a[1] : "";
  }
  return "";
}
const ar = Ag;
function em() {
}
let Lt = em;
process.env.NODE_ENV !== "production" && (Lt = typeof console < "u" ? function(t, n = ad.logLevel) {
  ad.silent === !1 && console[n](`[VueTypes warn]: ${t}`);
} : em);
const Er = (e, t) => Cg.call(e, t), Eg = Number.isInteger || function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}, Pr = Array.isArray || function(e) {
  return Kf.call(e) === "[object Array]";
}, Rr = (e) => Kf.call(e) === "[object Function]", el = (e, t) => ar(e) && Er(e, "_vueTypes_name") && (!t || e._vueTypes_name === t), tm = (e) => ar(e) && (Er(e, "type") || ["_vueTypes_name", "validator", "default", "required"].some((t) => Er(e, t)));
function Pd(e, t) {
  return Object.defineProperty(e.bind(t), "__original", { value: e });
}
function rr(e, t, n = !1) {
  let a, i = !0, r = "";
  a = ar(e) ? e : { type: e };
  const o = el(a) ? a._vueTypes_name + " - " : "";
  if (tm(a) && a.type !== null) {
    if (a.type === void 0 || a.type === !0 || !a.required && t == null)
      return i;
    Pr(a.type) ? (i = a.type.some((l) => rr(l, t, !0) === !0), r = a.type.map((l) => Lh(l)).join(" or ")) : (r = Lh(a), i = r === "Array" ? Pr(t) : r === "Object" ? ar(t) : r === "String" || r === "Number" || r === "Boolean" || r === "Function" ? function(l) {
      if (l == null)
        return "";
      const s = l.constructor.toString().match(Jf);
      return s ? s[1].replace(/^Async/, "") : "";
    }(t) === r : t instanceof a.type);
  }
  if (!i) {
    const l = `${o}value "${t}" should be of type "${r}"`;
    return n === !1 ? (Lt(l), !1) : l;
  }
  if (Er(a, "validator") && Rr(a.validator)) {
    const l = Lt, s = [];
    if (Lt = (u) => {
      s.push(u);
    }, i = a.validator(t), Lt = l, !i) {
      const u = (s.length > 1 ? "* " : "") + s.join(`
* `);
      return s.length = 0, n === !1 ? (Lt(u), i) : u;
    }
  }
  return i;
}
function jn(e, t) {
  const n = Object.defineProperties(t, { _vueTypes_name: { value: e, writable: !0 }, isRequired: { get() {
    return this.required = !0, this;
  } }, def: { value(i) {
    return i === void 0 ? this.type === Boolean || Array.isArray(this.type) && this.type.includes(Boolean) ? void (this.default = void 0) : (Er(this, "default") && delete this.default, this) : Rr(i) || rr(this, i, !0) === !0 ? (this.default = Pr(i) ? () => [...i] : ar(i) ? () => Object.assign({}, i) : i, this) : (Lt(`${this._vueTypes_name} - invalid default value: "${i}"`), this);
  } } }), { validator: a } = n;
  return Rr(a) && (n.validator = Pd(a, n)), n;
}
function $a(e, t) {
  const n = jn(e, t);
  return Object.defineProperty(n, "validate", { value(a) {
    return Rr(this.validator) && Lt(`${this._vueTypes_name} - calling .validate() will overwrite the current custom validator function. Validator info:
${JSON.stringify(this)}`), this.validator = Pd(a, this), this;
  } });
}
function Fh(e, t, n) {
  const a = function(s) {
    const u = {};
    return Object.getOwnPropertyNames(s).forEach((d) => {
      u[d] = Object.getOwnPropertyDescriptor(s, d);
    }), Object.defineProperties({}, u);
  }(t);
  if (a._vueTypes_name = e, !ar(n))
    return a;
  const { validator: i } = n, r = Zf(n, Og);
  if (Rr(i)) {
    let { validator: s } = a;
    s && (s = (l = (o = s).__original) !== null && l !== void 0 ? l : o), a.validator = Pd(s ? function(u) {
      return s.call(this, u) && i.call(this, u);
    } : i, a);
  }
  var o, l;
  return Object.assign(a, r);
}
function gl(e) {
  return e.replace(/^(?!\s*$)/gm, "  ");
}
const Pg = () => $a("any", {}), Rg = () => $a("function", { type: Function }), zh = () => $a("boolean", { type: Boolean }), Ig = () => $a("string", { type: String }), Yg = () => $a("number", { type: Number }), Ng = () => $a("array", { type: Array }), $g = () => $a("object", { type: Object }), Lg = () => jn("integer", { type: Number, validator(e) {
  const t = Eg(e);
  return t === !1 && Lt(`integer - "${e}" is not an integer`), t;
} }), Fg = () => jn("symbol", { validator(e) {
  const t = typeof e == "symbol";
  return t === !1 && Lt(`symbol - invalid value "${e}"`), t;
} }), zg = () => Object.defineProperty({ type: null, validator(e) {
  const t = e === null;
  return t === !1 && Lt("nullable - value should be null"), t;
} }, "_vueTypes_name", { value: "nullable" });
function Hg(e, t = "custom validation failed") {
  if (typeof e != "function")
    throw new TypeError("[VueTypes error]: You must provide a function as argument");
  return jn(e.name || "<<anonymous function>>", { type: null, validator(n) {
    const a = e(n);
    return a || Lt(`${this._vueTypes_name} - ${t}`), a;
  } });
}
function tl(e) {
  if (!Pr(e))
    throw new TypeError("[VueTypes error]: You must provide an array as argument.");
  const t = `oneOf - value should be one of "${e.map((a) => typeof a == "symbol" ? a.toString() : a).join('", "')}".`, n = { validator(a) {
    const i = e.indexOf(a) !== -1;
    return i || Lt(t), i;
  } };
  if (e.indexOf(null) === -1) {
    const a = e.reduce((i, r) => {
      if (r != null) {
        const o = r.constructor;
        i.indexOf(o) === -1 && i.push(o);
      }
      return i;
    }, []);
    a.length > 0 && (n.type = a);
  }
  return jn("oneOf", n);
}
function nm(e) {
  if (!Pr(e))
    throw new TypeError("[VueTypes error]: You must provide an array as argument");
  let t = !1, n = !1, a = [];
  for (let r = 0; r < e.length; r += 1) {
    const o = e[r];
    if (tm(o)) {
      if (Rr(o.validator) && (t = !0), el(o, "oneOf") && o.type) {
        a = a.concat(o.type);
        continue;
      }
      if (el(o, "nullable")) {
        n = !0;
        continue;
      }
      if (o.type === !0 || !o.type) {
        Lt('oneOfType - invalid usage of "true" and "null" as types.');
        continue;
      }
      a = a.concat(o.type);
    } else
      a.push(o);
  }
  a = a.filter((r, o) => a.indexOf(r) === o);
  const i = n === !1 && a.length > 0 ? a : null;
  return jn("oneOfType", t ? { type: i, validator(r) {
    const o = [], l = e.some((s) => {
      const u = rr(s, r, !0);
      return typeof u == "string" && o.push(u), u === !0;
    });
    return l || Lt(`oneOfType - provided value does not match any of the ${o.length} passed-in validators:
${gl(o.join(`
`))}`), l;
  } } : { type: i });
}
function Rd(e) {
  return jn("arrayOf", { type: Array, validator(t) {
    let n = "";
    const a = t.every((i) => (n = rr(e, i, !0), n === !0));
    return a || Lt(`arrayOf - value validation error:
${gl(n)}`), a;
  } });
}
function Wg(e) {
  return jn("instanceOf", { type: e });
}
function Bg(e) {
  return jn("objectOf", { type: Object, validator(t) {
    let n = "";
    const a = Object.keys(t).every((i) => (n = rr(e, t[i], !0), n === !0));
    return a || Lt(`objectOf - value validation error:
${gl(n)}`), a;
  } });
}
function Vg(e) {
  const t = Object.keys(e), n = t.filter((i) => {
    var r;
    return !((r = e[i]) === null || r === void 0 || !r.required);
  }), a = jn("shape", { type: Object, validator(i) {
    if (!ar(i))
      return !1;
    const r = Object.keys(i);
    if (n.length > 0 && n.some((o) => r.indexOf(o) === -1)) {
      const o = n.filter((l) => r.indexOf(l) === -1);
      return Lt(o.length === 1 ? `shape - required property "${o[0]}" is not defined.` : `shape - required properties "${o.join('", "')}" are not defined.`), !1;
    }
    return r.every((o) => {
      if (t.indexOf(o) === -1)
        return this._vueTypes_isLoose === !0 || (Lt(`shape - shape definition does not include a "${o}" property. Allowed keys: "${t.join('", "')}".`), !1);
      const l = rr(e[o], i[o], !0);
      return typeof l == "string" && Lt(`shape - "${o}" property validation error:
 ${gl(l)}`), l === !0;
    });
  } });
  return Object.defineProperty(a, "_vueTypes_isLoose", { writable: !0, value: !1 }), Object.defineProperty(a, "loose", { get() {
    return this._vueTypes_isLoose = !0, this;
  } }), a;
}
const jg = ["name", "validate", "getter"], Ug = /* @__PURE__ */ ((e) => ((e = class {
  static get any() {
    return Pg();
  }
  static get func() {
    return Rg().def(this.defaults.func);
  }
  static get bool() {
    return this.defaults.bool === void 0 ? zh() : zh().def(this.defaults.bool);
  }
  static get string() {
    return Ig().def(this.defaults.string);
  }
  static get number() {
    return Yg().def(this.defaults.number);
  }
  static get array() {
    return Ng().def(this.defaults.array);
  }
  static get object() {
    return $g().def(this.defaults.object);
  }
  static get integer() {
    return Lg().def(this.defaults.integer);
  }
  static get symbol() {
    return Fg();
  }
  static get nullable() {
    return zg();
  }
  static extend(t) {
    if (Lt("VueTypes.extend is deprecated. Use the ES6+ method instead. See https://dwightjack.github.io/vue-types/advanced/extending-vue-types.html#extending-namespaced-validators-in-es6 for details."), Pr(t))
      return t.forEach((s) => this.extend(s)), this;
    const { name: n, validate: a = !1, getter: i = !1 } = t, r = Zf(t, jg);
    if (Er(this, n))
      throw new TypeError(`[VueTypes error]: Type "${n}" already defined`);
    const { type: o } = r;
    if (el(o))
      return delete r.type, Object.defineProperty(this, n, i ? { get: () => Fh(n, o, r) } : { value(...s) {
        const u = Fh(n, o, r);
        return u.validator && (u.validator = u.validator.bind(u, ...s)), u;
      } });
    let l;
    return l = i ? { get() {
      const s = Object.assign({}, r);
      return a ? $a(n, s) : jn(n, s);
    }, enumerable: !0 } : { value(...s) {
      const u = Object.assign({}, r);
      let d;
      return d = a ? $a(n, u) : jn(n, u), u.validator && (d.validator = u.validator.bind(d, ...s)), d;
    }, enumerable: !0 }, Object.defineProperty(this, n, l);
  }
}).defaults = {}, e.sensibleDefaults = void 0, e.config = ad, e.custom = Hg, e.oneOf = tl, e.instanceOf = Wg, e.oneOfType = nm, e.arrayOf = Rd, e.objectOf = Bg, e.shape = Vg, e.utils = { validate: (t, n) => rr(n, t, !0) === !0, toType: (t, n, a = !1) => a ? $a(t, n) : jn(t, n) }, e))();
function Gg(e = { func: () => {
}, bool: !0, string: "", number: 0, array: () => [], object: () => ({}), integer: 0 }) {
  var t;
  return (t = class extends Ug {
    static get sensibleDefaults() {
      return To({}, this.defaults);
    }
    static set sensibleDefaults(n) {
      this.defaults = n !== !1 ? To({}, n !== !0 ? n : e) : {};
    }
  }).defaults = To({}, e), t;
}
let EA = class extends Gg() {
};
const qg = {}, Xg = {
  width: "18",
  height: "20",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Zg(e, t) {
  return y(), O("svg", Xg, t[0] || (t[0] = [
    ee("path", {
      d: "M9.13588 14.5636C8.4303 14.6219 6.77445 15.1592 5.80347 16.8396M5.80347 16.8396L4.98008 18.2689L0.861816 18.265L2.77659 15.0918M5.80347 16.8396L2.77659 15.0918M2.77659 15.0918C3.74758 13.4114 3.38508 11.7089 3.08213 11.0681M0.861816 18.2689H17.1394M12.2624 2.15836C15.912 4.26604 12.489 10.6836 10.2363 14.0264C10.0566 14.2885 9.78402 14.4726 9.47371 14.5413C9.16339 14.6101 8.83855 14.5584 8.56494 14.3966L3.51066 11.4785C3.23385 11.3227 3.02655 11.0676 2.93065 10.7647C2.83476 10.4619 2.85743 10.134 2.99409 9.84725C4.76646 6.22354 8.61155 0.0506834 12.2624 2.15707V2.15836Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Qg = /* @__PURE__ */ an(qg, [["render", Zg]]), Kg = {
  components: {
    ButtonTertiaryIconSm: Uf,
    BoldTextIcon: Ah,
    ItalicTextIcon: Oh,
    StrikeThroughIcon: Ch,
    Heading1Icon: Eh,
    NumberedListIcon: Ph,
    BulletListIcon: Rh,
    LinkChainIcon: Ih,
    BracketIcon: Yh,
    AiIcon: ng,
    FullScreenIcon: ag
  },
  props: {
    modelValue: Boolean,
    aiRewriteLabel: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    hasError: {
      type: Boolean,
      default: !1
    },
    fieldId: {
      type: String,
      default: ""
    },
    buttonList: Rd(tl(Gf)).def([]),
    buttonFullScreen: {
      type: Boolean,
      default: !0
    },
    buttonAi: {
      type: Boolean,
      default: !0
    },
    rows: {
      type: Number,
      default: 10
    }
  },
  emits: ["blur", "formatText", "update:modelValue", "ai-rewrite", "passFocusToEditor"],
  data() {
    return {
      areaHeight: null
    };
  },
  computed: {
    heightCalculatedFromRows() {
      const e = this.rows * 24 + 72;
      return this.areaHeight ? `${this.areaHeight}px` : `${e}px`;
    },
    fullScreenMode: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    barButtons() {
      return this.buttonList.map((e) => this.allButtons[e]).filter(Boolean);
    },
    allButtons() {
      return {
        [fn.bold]: {
          action: fn.bold,
          disabled: this.disabled,
          icon: Ah
        },
        [fn.italic]: {
          action: fn.italic,
          disabled: this.disabled,
          icon: Oh
        },
        [fn.mark]: {
          action: fn.mark,
          disabled: this.disabled,
          icon: Qg
        },
        [fn.del]: {
          action: "strike",
          disabled: this.disabled,
          icon: Ch
        },
        [fn.header1]: {
          action: "header",
          disabled: this.disabled,
          icon: Eh
        },
        [fn.list]: {
          action: fn.list,
          disabled: this.disabled,
          icon: Ph
        },
        [fn.listBullet]: {
          action: fn.listBullet,
          disabled: this.disabled,
          icon: Rh
        },
        [fn.link]: {
          action: fn.link,
          disabled: this.disabled,
          icon: Ih
        },
        [fn.code]: {
          action: fn.code,
          disabled: this.disabled,
          icon: Yh
        }
      };
    }
  },
  mounted() {
    new ResizeObserver(() => {
      var t;
      this.fullScreenMode || (this.areaHeight = ((t = this.$refs.textEditor) == null ? void 0 : t.clientHeight) || null);
    }).observe(this.$refs.textEditor);
  },
  methods: {
    forceTabToMoveFocus(e) {
      e.preventDefault(), e.stopPropagation(), e.target.blur();
      const t = 'button:not([tabindex="-1"]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable]:not([contenteditable="false"])', n = Array.prototype.slice.call(
        document.querySelectorAll(t)
      ), a = n.indexOf(e.target);
      e.shiftKey ? a > 0 && n[a - 1].focus() : a > -1 && a < n.length - 1 && n[a + 1].focus();
    }
  }
}, Jg = ["id"], ey = { class: "ct-input--rich__buttons absolute inset-x-0.5 bottom-2 flex flex-col z-[2]" }, ty = { class: "text-sm ct-text-2 font-medium" }, ny = { class: "px-0.5 pt-2 pb-0 flex items-center space-x-0.5 overflow-x-auto no-scrollbar" }, ay = { class: "flex-grow flex items-center space-x-0.5" };
function iy(e, t, n, a, i, r) {
  const o = _e("AiIcon"), l = _e("ButtonTertiaryIconSm"), s = _e("FullScreenIcon");
  return y(), O("div", null, [
    ee("div", {
      class: Ne(["relative rounded-lg shadow-sm shadow-gray-900/5", { "mt-2": !r.fullScreenMode }])
    }, [
      n.placeholder ? (y(), O("div", {
        key: 0,
        class: "absolute w-full inset-0 bottom-[53px] ct-text-placeholder select-none py-2.5 sm:py-3 px-3.5 sm:px-4 overflow-y-auto no-scrollbar",
        onClick: t[0] || (t[0] = (u) => e.$emit("passFocusToEditor"))
      }, et(n.placeholder), 1)) : F("", !0),
      ee("div", {
        id: n.fieldId,
        ref: "textEditor",
        style: kn({ height: r.fullScreenMode ? "80vh" : r.heightCalculatedFromRows }),
        class: Ne(["ct-markdown ct-input ct-input--rich resize-y user-select min-h-24 whitespace-break-spaces", { "is-error": n.hasError, "is-disabled": n.disabled }]),
        onKeydown: t[1] || (t[1] = Hf((...u) => r.forceTabToMoveFocus && r.forceTabToMoveFocus(...u), ["tab"]))
      }, null, 46, Jg),
      ee("div", ey, [
        !n.disabled && n.buttonAi ? (y(), O("button", {
          key: 0,
          tabindex: "-1",
          type: "button",
          class: "self-end mb-3 mr-4 rounded py-1 px-2 border ct-border-1 ct-bg-1 hover:ct-bg-1 shadow-sm flex items-center space-x-1",
          onClick: t[2] || (t[2] = (u) => e.$emit("ai-rewrite"))
        }, [
          Pe(o, { class: "w-4 h-4" }),
          ee("span", ty, et(n.aiRewriteLabel), 1)
        ])) : F("", !0),
        t[4] || (t[4] = ee("div", { class: "ct-input--rich__border border-t ct-border-2 -mx-px" }, null, -1)),
        ee("div", ny, [
          ee("div", ay, [
            (y(!0), O(Fe, null, Xe(r.barButtons, (u) => (y(), le(l, {
              key: u.action,
              tabindex: "-1",
              disabled: u.disabled,
              onClick: (d) => e.$emit("formatText", u.action)
            }, {
              default: De(() => [
                (y(), le(li(u.icon)))
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]))), 128))
          ]),
          !r.fullScreenMode && n.buttonFullScreen ? (y(), le(l, {
            key: 0,
            disabled: n.disabled,
            tabindex: "-1",
            onClick: t[3] || (t[3] = (u) => r.fullScreenMode = !0)
          }, {
            default: De(() => [
              Pe(s)
            ]),
            _: 1
          }, 8, ["disabled"])) : F("", !0)
        ])
      ])
    ], 2),
    me(e.$slots, "default")
  ]);
}
const ry = /* @__PURE__ */ an(Kg, [["render", iy]]);
const oy = {
  components: {
    FormNotification: qf,
    HelpIcon: Wf,
    LayoutModal: Xf,
    ButtonCloseXs: tg,
    FormRichTextArea: ry
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    buttonList: nm([
      Rd(tl(Gf)),
      tl(Object.keys(Nh))
    ]).def("full"),
    buttonAi: {
      type: Boolean,
      default: !1
    },
    buttonFullScreen: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    aiRewriteLabel: {
      type: String,
      default: "Rewrite with Ai"
    },
    rows: {
      type: Number,
      default: 10
    }
  },
  emits: ["update:modelValue", "blur", "ai-rewrite"],
  setup(e) {
    return Bf(e);
  },
  data() {
    return {
      id: Ur(),
      pristine: !0,
      // the control need to convert markdown to HTML ONLY once!
      fullScreenMode: !1,
      localValue: ""
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e), this.localValue = e;
      }
    },
    chosenListOfButtons() {
      return Array.isArray(this.buttonList) ? this.buttonList : Nh[this.buttonList] || [];
    }
  },
  watch: {
    fullScreenMode(e) {
      const t = this.$refs.textContainer.$el;
      this.$nextTick(() => {
        e ? this.$refs.maxContainer.append(t) : this.$refs.minContainer.append(t);
      });
    },
    // This model value will work ONLY in one direction (binding is just .once)
    modelValue: {
      handler(e, t) {
        const n = e !== t;
        (this.pristine || e && n && this.pristine) && (this.pristine = !1, this.$nextTick(() => {
          fg(this.quill, e);
        }));
      },
      immediate: !0
    },
    disabled: {
      handler(e) {
        this.$nextTick(() => {
          this.quill.enable(!e);
        });
      },
      immediate: !0
    }
  },
  mounted() {
    const { quillInstance: e, quillActions: t } = mg(
      this.$refs.textContainer.$refs.textEditor,
      {
        modalActionMethod: this.showModal.bind(this),
        updateHandler: this.updateModelValue.bind(this)
      }
    );
    this.quill = e, this.quillActions = t, this.quill.root.addEventListener("blur", (n) => {
      n.sourceCapabilities && this.$emit("blur", n);
    }), window.addEventListener("keydown", this.onKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  methods: {
    onKeyDown(e) {
      e.key === "Escape" && this.fullScreenMode && (this.fullScreenMode = !1);
    },
    formatText(e) {
      var a, i;
      const { quill: t } = this;
      t.getSelection() && ((i = (a = this.quillActions)[e]) == null || i.call(a, t), this.updateModelValue());
    },
    updateModelValue() {
      this.model = pg(this.quill);
    },
    async showModal(e, t) {
      if (e === "link") {
        const n = prompt("URL:", t);
        if (n === null)
          throw new Error("link input canceled");
        return n;
      }
    },
    expandView() {
      this.fullScreenMode = !0;
    },
    // SPECIAL public METHOD to allow by $refs -> mark recalculation of model value (Markdown to HTML)
    markPristine() {
      this.pristine = !0;
    },
    closeFullScreen() {
      this.fullScreenMode = !1;
    }
  }
}, sy = ["for"], ly = {
  key: 0,
  class: "ct-text-error"
}, uy = { ref: "minContainer" }, dy = { class: "relative max-h-screen w-full max-w-7xl border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col shadow-xl p-6 text-left" }, cy = { ref: "maxContainer" };
function hy(e, t, n, a, i, r) {
  const o = _e("HelpIcon"), l = _e("FormNotification"), s = _e("FormRichTextArea"), u = _e("ButtonCloseXs"), d = _e("LayoutModal"), c = td("tooltip"), f = td("click-outside");
  return y(), O(Fe, null, [
    ee("div", Ft({ "data-scroll": "" }, e.$attrs), [
      ee("label", {
        for: i.id,
        class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1 mb-2"
      }, [
        ee("span", null, et(n.title), 1),
        n.required ? (y(), O("span", ly, "*")) : F("", !0),
        n.tooltip ? ai((y(), le(o, {
          key: 1,
          class: "cursor-pointer ct-fg-4 h-4 w-4"
        }, null, 512)), [
          [c, { content: n.tooltip }]
        ]) : F("", !0)
      ], 8, sy),
      ee("div", uy, [
        Pe(s, {
          ref: "textContainer",
          modelValue: i.fullScreenMode,
          "onUpdate:modelValue": t[0] || (t[0] = (v) => i.fullScreenMode = v),
          "field-id": i.id,
          "ai-rewrite-label": n.aiRewriteLabel,
          disabled: n.disabled,
          "has-error": e.hasError,
          "button-list": r.chosenListOfButtons,
          "button-ai": n.buttonAi,
          "button-full-screen": n.buttonFullScreen,
          rows: n.rows,
          placeholder: r.model ? "" : n.placeholder,
          onPassFocusToEditor: t[1] || (t[1] = (v) => e.quill.focus()),
          onFormatText: r.formatText,
          onAiRewrite: t[2] || (t[2] = (v) => e.$emit("ai-rewrite"))
        }, {
          default: De(() => [
            e.hasHelp ? (y(), le(l, {
              key: 0,
              message: n.help,
              help: ""
            }, {
              default: De(() => [
                me(e.$slots, "help")
              ]),
              _: 3
            }, 8, ["message"])) : F("", !0),
            e.hasError ? (y(), le(l, {
              key: 1,
              message: n.error,
              error: ""
            }, {
              default: De(() => [
                me(e.$slots, "error")
              ]),
              _: 3
            }, 8, ["message"])) : F("", !0)
          ]),
          _: 3
        }, 8, ["modelValue", "field-id", "ai-rewrite-label", "disabled", "has-error", "button-list", "button-ai", "button-full-screen", "rows", "placeholder", "onFormatText"])
      ], 512)
    ], 16),
    i.fullScreenMode ? (y(), le(d, {
      key: 0,
      modelValue: i.fullScreenMode,
      "onUpdate:modelValue": t[3] || (t[3] = (v) => i.fullScreenMode = v)
    }, {
      default: De(() => [
        ai((y(), O("div", dy, [
          Pe(u, {
            class: "absolute top-0 right-0",
            onClick: r.closeFullScreen
          }, null, 8, ["onClick"]),
          ee("div", cy, null, 512)
        ])), [
          [f, r.closeFullScreen]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])) : F("", !0)
  ], 64);
}
const RA = /* @__PURE__ */ an(oy, [["render", hy]]), fy = [
  "B",
  "kB",
  "MB",
  "GB",
  "TB",
  "PB",
  "EB",
  "ZB",
  "YB"
], my = [
  "B",
  "KiB",
  "MiB",
  "GiB",
  "TiB",
  "PiB",
  "EiB",
  "ZiB",
  "YiB"
], py = [
  "b",
  "kbit",
  "Mbit",
  "Gbit",
  "Tbit",
  "Pbit",
  "Ebit",
  "Zbit",
  "Ybit"
], vy = [
  "b",
  "kibit",
  "Mibit",
  "Gibit",
  "Tibit",
  "Pibit",
  "Eibit",
  "Zibit",
  "Yibit"
], Hh = (e, t, n) => {
  let a = e;
  return typeof t == "string" || Array.isArray(t) ? a = e.toLocaleString(t, n) : (t === !0 || n !== void 0) && (a = e.toLocaleString(void 0, n)), a;
};
function gy(e, t) {
  if (!Number.isFinite(e))
    throw new TypeError(`Expected a finite number, got ${typeof e}: ${e}`);
  t = {
    bits: !1,
    binary: !1,
    space: !0,
    ...t
  };
  const n = t.bits ? t.binary ? vy : py : t.binary ? my : fy, a = t.space ? " " : "";
  if (t.signed && e === 0)
    return ` 0${a}${n[0]}`;
  const i = e < 0, r = i ? "-" : t.signed ? "+" : "";
  i && (e = -e);
  let o;
  if (t.minimumFractionDigits !== void 0 && (o = { minimumFractionDigits: t.minimumFractionDigits }), t.maximumFractionDigits !== void 0 && (o = { maximumFractionDigits: t.maximumFractionDigits, ...o }), e < 1) {
    const d = Hh(e, t.locale, o);
    return r + d + a + n[0];
  }
  const l = Math.min(Math.floor(t.binary ? Math.log(e) / Math.log(1024) : Math.log10(e) / 3), n.length - 1);
  e /= (t.binary ? 1024 : 1e3) ** l, o || (e = e.toPrecision(3));
  const s = Hh(Number(e), t.locale, o), u = n[l];
  return r + s + a + u;
}
const aa = {
  AWAITING: "AWAITING",
  // File chosen by user
  UPLOADING: "UPLOADING",
  // File uploading by outer source ( onUploadProgress happening)
  UPLOADED: "UPLOADED",
  // onUploadProgress reaches 100%
  FAILED: "FAILED",
  // Controlled by (onUploadError) outer source
  // @deprecated: FAILED_INVALID: "FAILED_INVALID", // File did not pass local validators (Max size or Type)
  DONE: "DONE"
  // default state of existing image (it does not need to be uploaded)!
}, am = (e) => e ? e.startsWith("image") : !1, yy = (e) => e ? e.startsWith("video") : !1, wy = (e) => e.url ? { preview: e.url } : am(e.type) ? { preview: URL.createObjectURL(e) } : {};
function Wh(e, t) {
  const {
    name: n,
    type: a,
    size: i,
    // for model - we need size in bytes (as you will provide from the browser itself)
    // Default values if originalFile not provide them:
    error: r = "",
    id: o = im(),
    status: l = t || aa.DONE,
    progress: s = "0%",
    canRemove: u = !0,
    url: d = ""
  } = e, c = i || 0;
  return {
    id: o,
    name: n,
    type: a,
    error: r,
    status: l,
    progress: s,
    url: d,
    size: gy(c, { locale: !0 }),
    // readable size
    originalFile: e,
    originalSize: c,
    canRemove: u,
    ...wy(e),
    isVideo: yy(a),
    isImage: am(a),
    onUploadProgress(f) {
      const { loaded: v, total: k } = f;
      this.progress = `${Math.round(v * 100 / k)}%`, v === k ? this.uploadComplete() : this.status = aa.UPLOADING;
    },
    uploadComplete() {
      this.status = aa.UPLOADED, this.progress = "100%";
    },
    onUploadError(f = "") {
      this.status = aa.FAILED, this.error = f;
    }
  };
}
function im() {
  return Ur();
}
const nl = {
  circle: "circle",
  rectangle: "rectangle"
}, by = {
  SQUARE: (e = void 0, t = void 0) => ({
    ratio: "1:1",
    minWidth: e,
    maxWidth: t
  }),
  CIRCLE: (e = void 0, t = void 0) => ({
    ratio: "1:1",
    type: nl.circle,
    minWidth: e,
    maxWidth: t
  }),
  AVATAR: (e = 400, t = 1024) => ({
    ratio: "1:1",
    type: nl.circle,
    minWidth: e,
    maxWidth: t
  }),
  RECTANGLE_16_9: (e = void 0, t = void 0) => ({
    ratio: "16:9",
    minWidth: e,
    maxWidth: t,
    minHeight: e ? Math.round(e * (9 / 16)) : void 0,
    maxHeight: t ? Math.round(t * (9 / 16)) : void 0
  }),
  RECTANGLE_4_3: (e = void 0, t = void 0) => ({
    ratio: "4:3",
    minWidth: e,
    maxWidth: t,
    minHeight: e ? Math.round(e * (3 / 4)) : void 0,
    maxHeight: t ? Math.round(t * (3 / 4)) : void 0
  })
};
function Bh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function tt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bh(Object(n), !0).forEach(function(a) {
      ia(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bh(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function ia(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _y(e, t) {
  if (e == null)
    return {};
  var n, a, i = function(o, l) {
    if (o == null)
      return {};
    var s, u, d = {}, c = Object.keys(o);
    for (u = 0; u < c.length; u++)
      s = c[u], l.indexOf(s) >= 0 || (d[s] = o[s]);
    return d;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    for (a = 0; a < r.length; a++)
      n = r[a], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function ir(e) {
  return function(t) {
    if (Array.isArray(t))
      return yu(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || function(t, n) {
    if (t) {
      if (typeof t == "string")
        return yu(t, n);
      var a = Object.prototype.toString.call(t).slice(8, -1);
      if (a === "Object" && t.constructor && (a = t.constructor.name), a === "Map" || a === "Set")
        return Array.from(t);
      if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))
        return yu(t, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function yu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = new Array(t); n < t; n++)
    a[n] = e[n];
  return a;
}
var Vh, ky, Cs, Et = (Vh = function(e) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var a = [], i = 0; i < arguments.length; i++) {
        var r = arguments[i];
        if (r) {
          var o = typeof r;
          if (o === "string" || o === "number")
            a.push(r);
          else if (Array.isArray(r)) {
            if (r.length) {
              var l = n.apply(null, r);
              l && a.push(l);
            }
          } else if (o === "object")
            if (r.toString === Object.prototype.toString)
              for (var s in r)
                t.call(r, s) && r[s] && a.push(s);
            else
              a.push(r.toString());
        }
      }
      return a.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
}, Vh(Cs = { path: ky, exports: {}, require: function(e, t) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(t == null && Cs.path);
} }, Cs.exports), Cs.exports), la = function(e) {
  return function(t, n) {
    if (!t)
      return e;
    var a;
    typeof t == "string" ? a = t : n = t;
    var i = e;
    return a && (i += "__" + a), i + (n ? Object.keys(n).reduce(function(r, o) {
      var l = n[o];
      return l && (r += " " + (typeof l == "boolean" ? i + "--" + o : i + "--" + o + "_" + l)), r;
    }, "") : "");
  };
};
function id(e, t, n) {
  var a, i, r, o, l;
  function s() {
    var d = Date.now() - o;
    d < t && d >= 0 ? a = setTimeout(s, t - d) : (a = null, n || (l = e.apply(r, i), r = i = null));
  }
  t == null && (t = 100);
  var u = function() {
    r = this, i = arguments, o = Date.now();
    var d = n && !a;
    return a || (a = setTimeout(s, t)), d && (l = e.apply(r, i), r = i = null), l;
  };
  return u.clear = function() {
    a && (clearTimeout(a), a = null);
  }, u.flush = function() {
    a && (l = e.apply(r, i), r = i = null, clearTimeout(a), a = null);
  }, u;
}
id.debounce = id;
var rd = id, Ye = function() {
  return Ye = Object.assign || function(e) {
    for (var t, n = 1, a = arguments.length; n < a; n++)
      for (var i in t = arguments[n])
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, Ye.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function rm(e, t) {
  var n, a;
  return e && t ? (n = "" + e + t[0].toUpperCase() + t.slice(1), a = e + "-" + t) : (n = e || t, a = e || t), { name: n, classname: a };
}
function om(e) {
  return /^blob:/.test(e);
}
function jh(e) {
  return om(e) || function(t) {
    return /^data:/.test(t);
  }(e);
}
function mr(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function en(e) {
  return e === void 0;
}
function js(e) {
  return typeof e == "object" && e !== null;
}
function od(e, t, n) {
  var a = {};
  return js(e) ? (Object.keys(t).forEach(function(i) {
    en(e[i]) ? a[i] = t[i] : js(t[i]) ? js(e[i]) ? a[i] = od(e[i], t[i], n[i]) : a[i] = e[i] ? t[i] : n[i] : t[i] === !0 || t[i] === !1 ? a[i] = !!e[i] : a[i] = e[i];
  }), a) : e ? t : n;
}
function Es(e) {
  var t = Number(e);
  return Number.isNaN(t) ? e : t;
}
function Uh(e) {
  return typeof (e == "number" || function(t) {
    return typeof t == "object" && t !== null;
  }(e) && toString.call(e) == "[object Number]") && !sm(e);
}
function sm(e) {
  return e != e;
}
function lm(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
var Ao = function(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {}), this.type = "manipulateImage", this.move = e, this.scale = t;
}, xy = function(e, t) {
  t === void 0 && (t = {}), this.type = "resize", this.directions = e, this.params = t;
}, Id = function(e) {
  this.type = "move", this.directions = e;
}, My = function() {
  function e(t, n, a, i, r) {
    this.type = "drag", this.nativeEvent = t, this.position = a, this.previousPosition = i, this.element = n, this.anchor = r;
  }
  return e.prototype.shift = function() {
    var t = this, n = t.element, a = t.anchor, i = t.position;
    if (n) {
      var r = n.getBoundingClientRect(), o = r.left, l = r.top;
      return { left: i.left - o - a.left, top: i.top - l - a.top };
    }
    return { left: 0, top: 0 };
  }, e;
}(), Yd = { name: "DraggableElement", props: { classname: { type: String } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  if (!this.$refs.draggable)
    throw new Error('You should add ref "draggable" to your root element to use draggable mixin');
  this.touches = [], this.hovered = !1;
}, methods: { onMouseOver: function() {
  this.hovered || (this.hovered = !0, this.$emit("enter"));
}, onMouseLeave: function() {
  this.hovered && !this.touches.length && (this.hovered = !1, this.$emit("leave"));
}, onTouchStart: function(e) {
  e.cancelable && !this.disabled && e.touches.length === 1 && (this.touches = ir(e.touches), this.hovered || (this.$emit("enter"), this.hovered = !0), e.touches.length && this.initAnchor(this.touches.reduce(function(t, n) {
    return { clientX: t.clientX + n.clientX / e.touches.length, clientY: t.clientY + n.clientY / e.touches.length };
  }, { clientX: 0, clientY: 0 })), e.preventDefault && e.preventDefault(), e.stopPropagation());
}, onTouchEnd: function() {
  this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length && (this.processMove(e, e.touches), e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation());
}, onMouseDown: function(e) {
  if (!this.disabled) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.initAnchor(t), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.preventDefault());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var t = this.$refs.draggable.getBoundingClientRect(), n = t.left, a = t.right, i = t.bottom, r = t.top;
  this.anchor = { left: e.clientX - n, top: e.clientY - r, bottom: i - e.clientY, right: a - e.clientX };
}, processMove: function(e, t) {
  var n = ir(t);
  if (this.touches.length) {
    if (this.touches.length === 1 && n.length === 1) {
      var a = this.$refs.draggable;
      this.$emit("drag", new My(e, a, { left: n[0].clientX, top: n[0].clientY }, { left: this.touches[0].clientX, top: this.touches[0].clientY }, this.anchor));
    }
    this.touches = n;
  }
}, processEnd: function() {
  this.touches.length && this.$emit("drag-end"), this.hovered && (this.$emit("leave"), this.hovered = !1), this.touches = [];
} }, emits: ["drag", "drag-end", "leave", "enter"] };
Yd.render = function(e, t, n, a, i, r) {
  return y(), le("div", { ref: "draggable", class: n.classname, onTouchstart: t[1] || (t[1] = function() {
    return r.onTouchStart && r.onTouchStart.apply(r, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return r.onMouseDown && r.onMouseDown.apply(r, arguments);
  }), onMouseover: t[3] || (t[3] = function() {
    return r.onMouseOver && r.onMouseOver.apply(r, arguments);
  }), onMouseleave: t[4] || (t[4] = function() {
    return r.onMouseLeave && r.onMouseLeave.apply(r, arguments);
  }) }, [me(e.$slots, "default")], 34);
};
var wu = la("vue-handler-wrapper"), um = { name: "HandlerWrapper", components: { DraggableElement: Yd }, props: { horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, computed: { classes: function() {
  var e;
  if (this.horizontalPosition || this.verticalPosition) {
    var t, n = rm(this.horizontalPosition, this.verticalPosition);
    e = wu((ia(t = {}, n.classname, !0), ia(t, "disabled", this.disabled), t));
  } else
    e = wu({ disabled: this.disabled });
  return { root: e, draggable: wu("draggable") };
} }, emits: ["leave", "enter", "drag", "drag-end"] };
um.render = function(e, t, n, a, i, r) {
  var o = _e("DraggableElement");
  return y(), le("div", { class: r.classes.root }, [Pe(o, { class: r.classes.draggable, onDrag: t[1] || (t[1] = function(l) {
    return e.$emit("drag", l);
  }), onDragEnd: t[2] || (t[2] = function(l) {
    return e.$emit("drag-end");
  }), onLeave: t[3] || (t[3] = function(l) {
    return e.$emit("leave");
  }), onEnter: t[4] || (t[4] = function(l) {
    return e.$emit("enter");
  }) }, { default: De(function() {
    return [me(e.$slots, "default")];
  }), _: 3 }, 8, ["class"])], 2);
};
var Dy = la("vue-line-wrapper"), dm = { name: "LineWrapper", components: { DraggableElement: Yd }, props: { position: { type: String, required: !0 }, disabled: { type: Boolean, default: !1 } }, computed: { classname: function() {
  var e;
  return Dy((ia(e = {}, this.position, !0), ia(e, "disabled", this.disabled), e));
} }, emits: ["leave", "enter", "drag", "drag-end"] };
dm.render = function(e, t, n, a, i, r) {
  var o = _e("DraggableElement");
  return y(), le(o, { class: r.classname, onDrag: t[1] || (t[1] = function(l) {
    return e.$emit("drag", l);
  }), onDragEnd: t[2] || (t[2] = function(l) {
    return e.$emit("drag-end");
  }), onLeave: t[3] || (t[3] = function(l) {
    return e.$emit("leave");
  }), onEnter: t[4] || (t[4] = function(l) {
    return e.$emit("enter");
  }) }, { default: De(function() {
    return [me(e.$slots, "default")];
  }), _: 3 }, 8, ["class"]);
};
var Pa = ["left", "right", "top", "bottom"], Sy = ["left", "right"], Ty = ["top", "bottom"], Ay = ["left", "top"], Oy = ["fill-area", "fit-area", "stencil", "none"], Gh = { left: 0, top: 0, width: 0, height: 0 };
function qh(e, t, n) {
  return !(n = n || ["width", "height", "left", "top"]).some(function(a) {
    return e[a] !== t[a];
  });
}
function za(e) {
  return { left: e.left, top: e.top, right: e.left + e.width, bottom: e.top + e.height };
}
function Ir(e, t) {
  return { left: e.left - t.left, top: e.top - t.top };
}
function un(e) {
  return { left: e.left + e.width / 2, top: e.top + e.height / 2 };
}
function Fo(e, t) {
  var n = { left: 0, top: 0, right: 0, bottom: 0 };
  return Pa.forEach(function(a) {
    var i = t[a], r = za(e)[a];
    n[a] = i !== void 0 && r !== void 0 ? a === "left" || a === "top" ? Math.max(0, i - r) : Math.max(0, r - i) : 0;
  }), n;
}
function Ea(e, t) {
  return { left: e.left - t.left, top: e.top - t.top, width: e.width + t.left + t.right, height: e.height + t.top + t.bottom };
}
function yl(e) {
  return { left: -e.left, top: -e.top };
}
function Pn(e, t) {
  return Ye(Ye({}, e), { left: e.left + t.left, top: e.top + t.top });
}
function oa(e, t, n, a) {
  if (t !== 1) {
    if (n) {
      var i = un(e);
      return { width: e.width * t, height: e.height * t, left: e.left + e.width * (1 - t) / 2 + (n.left - i.left) * (a || 1 - t), top: e.top + e.height * (1 - t) / 2 + (n.top - i.top) * (a || 1 - t) };
    }
    return { width: e.width * t, height: e.height * t, left: e.left + e.width * (1 - t) / 2, top: e.top + e.height * (1 - t) / 2 };
  }
  return e;
}
function nt(e) {
  return e.width / e.height;
}
function Yr(e, t) {
  return Math.min(t.right !== void 0 && t.left !== void 0 ? (t.right - t.left) / e.width : 1 / 0, t.bottom !== void 0 && t.top !== void 0 ? (t.bottom - t.top) / e.height : 1 / 0);
}
function Nr(e, t) {
  var n = { left: 0, top: 0 }, a = Fo(e, t);
  return a.left && a.left > 0 ? n.left = a.left : a.right && a.right > 0 && (n.left = -a.right), a.top && a.top > 0 ? n.top = a.top : a.bottom && a.bottom > 0 && (n.top = -a.bottom), n;
}
function bu(e, t) {
  var n;
  return t.minimum && e < t.minimum ? n = t.minimum : t.maximum && e > t.maximum && (n = t.maximum), n;
}
function cm(e, t) {
  var n = nt(e), a = nt(t);
  return t.width < 1 / 0 && t.height < 1 / 0 ? n > a ? { width: t.width, height: t.width / n } : { width: t.height * n, height: t.height } : t.width < 1 / 0 ? { width: t.width, height: t.width / n } : t.height < 1 / 0 ? { width: t.height * n, height: t.height } : e;
}
function hm(e, t) {
  var n = t * Math.PI / 180;
  return { width: Math.abs(e.width * Math.cos(n)) + Math.abs(e.height * Math.sin(n)), height: Math.abs(e.width * Math.sin(n)) + Math.abs(e.height * Math.cos(n)) };
}
function Mi(e, t) {
  var n = t * Math.PI / 180;
  return { left: e.left * Math.cos(n) - e.top * Math.sin(n), top: e.left * Math.sin(n) + e.top * Math.cos(n) };
}
function wl(e, t) {
  var n = Fo(dn(e, t), t);
  return n.left + n.right + n.top + n.bottom ? n.left + n.right > n.top + n.bottom ? Math.min((e.width + n.left + n.right) / e.width, Yr(e, t)) : Math.min((e.height + n.top + n.bottom) / e.height, Yr(e, t)) : 1;
}
function dn(e, t, n) {
  n === void 0 && (n = !1);
  var a = Nr(e, t);
  return Pn(e, n ? yl(a) : a);
}
function sd(e) {
  return { width: e.right !== void 0 && e.left !== void 0 ? e.right - e.left : 1 / 0, height: e.bottom !== void 0 && e.top !== void 0 ? e.bottom - e.top : 1 / 0 };
}
function Cy(e, t) {
  return Ye(Ye({}, e), { minWidth: Math.min(t.width, e.minWidth), minHeight: Math.min(t.height, e.minHeight), maxWidth: Math.min(t.width, e.maxWidth), maxHeight: Math.min(t.height, e.maxHeight) });
}
function fm(e, t, n) {
  n === void 0 && (n = !0);
  var a = {};
  return Pa.forEach(function(i) {
    var r = e[i], o = t[i];
    r !== void 0 && o !== void 0 ? a[i] = i === "left" || i === "top" ? n ? Math.max(r, o) : Math.min(r, o) : n ? Math.min(r, o) : Math.max(r, o) : o !== void 0 ? a[i] = o : r !== void 0 && (a[i] = r);
  }), a;
}
function bl(e, t) {
  return fm(e, t, !0);
}
function Xh(e) {
  var t = e.size, n = e.aspectRatio, a = e.ignoreMinimum, i = e.sizeRestrictions;
  return !!((t.correctRatio || nt(t) >= n.minimum && nt(t) <= n.maximum) && t.height <= i.maxHeight && t.width <= i.maxWidth && t.width && t.height && (a || t.height >= i.minHeight && t.width >= i.minWidth));
}
function Zh(e, t) {
  return Math.pow(e.width - t.width, 2) + Math.pow(e.height - t.height, 2);
}
function Ja(e) {
  var t = e.width, n = e.height, a = e.sizeRestrictions, i = { minimum: e.aspectRatio && e.aspectRatio.minimum || 0, maximum: e.aspectRatio && e.aspectRatio.maximum || 1 / 0 }, r = { width: Math.max(a.minWidth, Math.min(a.maxWidth, t)), height: Math.max(a.minHeight, Math.min(a.maxHeight, n)) };
  function o(u, d) {
    return d === void 0 && (d = !1), u.reduce(function(c, f) {
      return Xh({ size: f, aspectRatio: i, sizeRestrictions: a, ignoreMinimum: d }) && (!c || Zh(f, { width: t, height: n }) < Zh(c, { width: t, height: n })) ? f : c;
    }, null);
  }
  var l = [];
  i && [i.minimum, i.maximum].forEach(function(u) {
    u && l.push({ width: r.width, height: r.width / u, correctRatio: !0 }, { width: r.height * u, height: r.height, correctRatio: !0 });
  }), Xh({ size: r, aspectRatio: i, sizeRestrictions: a }) && l.push(r);
  var s = o(l) || o(l, !0);
  return s && { width: s.width, height: s.height };
}
function ld(e) {
  var t = e.event, n = e.coordinates, a = e.positionRestrictions, i = a === void 0 ? {} : a, r = Pn(n, t.directions);
  return Pn(r, Nr(r, i));
}
function Ey(e) {
  var t = e.coordinates, n = e.transform, a = e.imageSize, i = e.sizeRestrictions, r = e.positionRestrictions, o = e.aspectRatio, l = e.visibleArea, s = function(d, c) {
    return ld({ coordinates: d, positionRestrictions: r, event: new Id({ left: c.left - d.left, top: c.top - d.top }) });
  }, u = Ye({}, t);
  return (Array.isArray(n) ? n : [n]).forEach(function(d) {
    var c = {};
    en((c = typeof d == "function" ? d({ coordinates: u, imageSize: a, visibleArea: l }) : d).width) && en(c.height) || (u = function(f, v) {
      var k = Ye(Ye(Ye({}, f), Ja({ width: v.width, height: v.height, sizeRestrictions: i, aspectRatio: o })), { left: 0, top: 0 });
      return s(k, { left: f.left, top: f.top });
    }(u, Ye(Ye({}, u), c))), en(c.left) && en(c.top) || (u = s(u, Ye(Ye({}, u), c)));
  }), u;
}
function Py(e) {
  e.event;
  var t = e.getAreaRestrictions, n = e.boundaries, a = e.coordinates, i = e.visibleArea;
  e.aspectRatio;
  var r = e.stencilSize, o = e.sizeRestrictions, l = e.positionRestrictions;
  e.stencilReference;
  var s, u, d, c = Ye({}, a), f = Ye({}, i), v = Ye({}, r);
  s = nt(v), u = nt(c), d === void 0 && (d = 1e-3), (s === 0 || u === 0 ? Math.abs(u - s) < d : Math.abs(u / s) < 1 + d && Math.abs(u / s) > 1 - d) || (c = Ye(Ye({}, c), Ja({ sizeRestrictions: o, width: c.width, height: c.height, aspectRatio: { minimum: nt(v), maximum: nt(v) } })));
  var k = wl(f = oa(f, c.width * n.width / (f.width * v.width)), t({ visibleArea: f, type: "resize" }));
  return k !== 1 && (f = oa(f, k), c = oa(c, k)), f = dn(f = Pn(f, Ir(un(c), un(f))), t({ visibleArea: f, type: "move" })), { coordinates: c = dn(c, bl(za(f), l)), visibleArea: f };
}
function Ry(e) {
  var t = e.event, n = e.getAreaRestrictions, a = e.boundaries, i = e.coordinates, r = e.visibleArea;
  e.aspectRatio, e.stencilSize, e.sizeRestrictions;
  var o = e.positionRestrictions;
  e.stencilReference;
  var l = Ye({}, i), s = Ye({}, r);
  if (i && r && t.type !== "manipulateImage") {
    var u = { width: 0, height: 0 };
    s.width, a.width, nt(a) > nt(l) ? (u.height = 0.8 * a.height, u.width = u.height * nt(l)) : (u.width = 0.8 * a.width, u.height = u.width * nt(l));
    var d = wl(s = oa(s, l.width * a.width / (s.width * u.width)), n({ visibleArea: s, type: "resize" }));
    s = oa(s, d), d !== 1 && (u.height /= d, u.width /= d), s = dn(s = Pn(s, Ir(un(l), un(s))), n({ visibleArea: s, type: "move" })), l = dn(l, bl(za(s), o));
  }
  return { coordinates: l, visibleArea: s };
}
function Iy(e) {
  var t = e.event, n = e.coordinates, a = e.visibleArea, i = e.getAreaRestrictions, r = Ye({}, a), o = Ye({}, n);
  if (t.type === "setCoordinates") {
    var l = Math.max(0, o.width - r.width), s = Math.max(0, o.height - r.height);
    l > s ? r = oa(r, Math.min(o.width / r.width, Yr(r, i({ visibleArea: r, type: "resize" })))) : s > l && (r = oa(r, Math.min(o.height / r.height, Yr(r, i({ visibleArea: r, type: "resize" }))))), r = dn(r = Pn(r, yl(Nr(o, za(r)))), i({ visibleArea: r, type: "move" }));
  }
  return { visibleArea: r, coordinates: o };
}
function Yy(e) {
  var t = e.imageSize, n = e.visibleArea, a = e.coordinates, i = n || t;
  return { left: (n ? n.left : 0) + i.width / 2 - a.width / 2, top: (n ? n.top : 0) + i.height / 2 - a.height / 2 };
}
function Ny(e) {
  var t = e.imageSize, n = e.visibleArea, a = e.aspectRatio, i = e.sizeRestrictions, r = n || t, o = Math.min(a.maximum || 1 / 0, Math.max(a.minimum || 0, nt(r))), l = r.width < r.height ? { width: 0.8 * r.width, height: 0.8 * r.width / o } : { height: 0.8 * r.height, width: 0.8 * r.height * o };
  return Ja(Ye(Ye({}, l), { aspectRatio: a, sizeRestrictions: i }));
}
function $y(e) {
  var t, n, a = e.imageSize, i = e.visibleArea, r = e.boundaries, o = e.aspectRatio, l = e.sizeRestrictions, s = e.stencilSize, u = i || a;
  return nt(u) > nt(r) ? n = (t = s.height * u.height / r.height) * nt(s) : t = (n = s.width * u.width / r.width) / nt(s), Ja({ width: n, height: t, aspectRatio: o, sizeRestrictions: l });
}
function Ly(e) {
  var t = e.getAreaRestrictions, n = e.coordinates, a = e.imageSize, i = nt(e.boundaries);
  if (n) {
    var r = { height: Math.max(n.height, a.height), width: Math.max(n.width, a.width) }, o = cm({ width: nt(r) > i ? r.width : r.height * i, height: nt(r) > i ? r.width / i : r.height }, sd(t())), l = { left: n.left + n.width / 2 - o.width / 2, top: n.top + n.height / 2 - o.height / 2, width: o.width, height: o.height }, s = Fo(n, za(Ye({ left: 0, top: 0 }, a))), u = {};
    return !s.left && !s.right && l.width <= a.width && (u.left = 0, u.right = a.width), !s.top && !s.bottom && l.height <= a.height && (u.top = 0, u.bottom = a.height), dn(l, u);
  }
  var d = nt(a);
  return o = { height: d > i ? a.height : a.width / i, width: d > i ? a.height * i : a.width }, { left: a.width / 2 - o.width / 2, top: a.height / 2 - o.height / 2, width: o.width, height: o.height };
}
function Ps(e, t) {
  return fm(e, za(t));
}
function Fy(e) {
  var t = e.event, n = e.coordinates, a = e.visibleArea, i = e.sizeRestrictions, r = e.getAreaRestrictions, o = e.positionRestrictions, l = e.adjustStencil, s = t.scale, u = t.move, d = Ye({}, a), c = Ye({}, n), f = 1, v = 1, k = s.factor && Math.abs(s.factor - 1) > 1e-3;
  d = Pn(d, { left: u.left || 0, top: u.top || 0 });
  var b = { stencil: { minimum: Math.max(i.minWidth ? i.minWidth / c.width : 0, i.minHeight ? i.minHeight / c.height : 0), maximum: Math.min(i.maxWidth ? i.maxWidth / c.width : 1 / 0, i.maxHeight ? i.maxHeight / c.height : 1 / 0, Yr(c, o)) }, area: { maximum: Yr(d, r({ visibleArea: d, type: "resize" })) } };
  s.factor && k && (s.factor < 1 ? (v = Math.max(s.factor, b.stencil.minimum)) > 1 && (v = 1) : s.factor > 1 && (v = Math.min(s.factor, Math.min(b.area.maximum, b.stencil.maximum))) < 1 && (v = 1)), v && (d = oa(d, v, s.center));
  var R = n.left - a.left, V = a.width + a.left - (n.width + n.left), G = n.top - a.top, C = a.height + a.top - (n.height + n.top);
  return d = dn(d = Pn(d, Nr(d, { left: o.left !== void 0 ? o.left - R * v : void 0, top: o.top !== void 0 ? o.top - G * v : void 0, bottom: o.bottom !== void 0 ? o.bottom + C * v : void 0, right: o.right !== void 0 ? o.right + V * v : void 0 })), r({ visibleArea: d, type: "move" })), c.width = c.width * v, c.height = c.height * v, c.left = d.left + R * v, c.top = d.top + G * v, c = dn(c, bl(za(d), o)), s.factor && k && l && (s.factor > 1 ? f = Math.min(b.area.maximum, s.factor) / v : s.factor < 1 && (f = Math.max(c.height / d.height, c.width / d.width, s.factor / v)), f !== 1 && (d = Pn(d = dn(d = oa(d, f, s.factor > 1 ? s.center : un(c)), r({ visibleArea: d, type: "move" })), yl(Nr(c, za(d)))))), { coordinates: c, visibleArea: d };
}
function zy(e) {
  var t = e.aspectRatio, n = e.getAreaRestrictions, a = e.coordinates, i = e.visibleArea, r = e.sizeRestrictions, o = e.positionRestrictions, l = e.imageSize, s = e.previousImageSize, u = e.angle, d = Ye({}, a), c = Ye({}, i), f = Mi(un(Ye({ left: 0, top: 0 }, s)), u);
  return (d = Ye(Ye({}, Ja({ sizeRestrictions: r, aspectRatio: t, width: d.width, height: d.height })), Mi(un(d), u))).left -= f.left - l.width / 2 + d.width / 2, d.top -= f.top - l.height / 2 + d.height / 2, c = oa(c, wl(c, n({ visibleArea: c, type: "resize" }))), { coordinates: d = dn(d, o), visibleArea: c = dn(c = Pn(c, Ir(un(d), un(a))), n({ visibleArea: c, type: "move" })) };
}
function Hy(e) {
  var t = e.flip, n = e.previousFlip, a = e.rotate;
  e.aspectRatio;
  var i = e.getAreaRestrictions, r = e.coordinates, o = e.visibleArea, l = e.imageSize, s = Ye({}, r), u = Ye({}, o), d = n.horizontal !== t.horizontal, c = n.vertical !== t.vertical;
  if (d || c) {
    var f = Mi({ left: l.width / 2, top: l.height / 2 }, -a), v = Mi(un(s), -a), k = Mi({ left: d ? f.left - (v.left - f.left) : v.left, top: c ? f.top - (v.top - f.top) : v.top }, a);
    s = Pn(s, Ir(k, un(s))), v = Mi(un(u), -a), u = dn(u = Pn(u, Ir(k = Mi({ left: d ? f.left - (v.left - f.left) : v.left, top: c ? f.top - (v.top - f.top) : v.top }, a), un(u))), i({ visibleArea: u, type: "move" }));
  }
  return { coordinates: s, visibleArea: u };
}
function Qh(e) {
  var t = e.directions, n = e.coordinates, a = e.positionRestrictions, i = a === void 0 ? {} : a, r = e.sizeRestrictions, o = e.preserveRatio, l = e.compensate, s = Ye({}, t), u = Ea(n, s).width, d = Ea(n, s).height;
  u < 0 && (s.left < 0 && s.right < 0 ? (s.left = -(n.width - r.minWidth) / (s.left / s.right), s.right = -(n.width - r.minWidth) / (s.right / s.left)) : s.left < 0 ? s.left = -(n.width - r.minWidth) : s.right < 0 && (s.right = -(n.width - r.minWidth))), d < 0 && (s.top < 0 && s.bottom < 0 ? (s.top = -(n.height - r.minHeight) / (s.top / s.bottom), s.bottom = -(n.height - r.minHeight) / (s.bottom / s.top)) : s.top < 0 ? s.top = -(n.height - r.minHeight) : s.bottom < 0 && (s.bottom = -(n.height - r.minHeight)));
  var c = Fo(Ea(n, s), i);
  l && (c.left && c.left > 0 && c.right === 0 ? (s.right += c.left, s.left -= c.left) : c.right && c.right > 0 && c.left === 0 && (s.left += c.right, s.right -= c.right), c.top && c.top > 0 && c.bottom === 0 ? (s.bottom += c.top, s.top -= c.top) : c.bottom && c.bottom > 0 && c.top === 0 && (s.top += c.bottom, s.bottom -= c.bottom), c = Fo(Ea(n, s), i));
  var f = { width: 1 / 0, height: 1 / 0, left: 1 / 0, right: 1 / 0, top: 1 / 0, bottom: 1 / 0 };
  if (Pa.forEach(function(b) {
    var R = c[b];
    R && s[b] && (f[b] = Math.max(0, 1 - R / s[b]));
  }), o) {
    var v = Math.min.apply(null, Pa.map(function(b) {
      return f[b];
    }));
    v !== 1 / 0 && Pa.forEach(function(b) {
      s[b] *= v;
    });
  } else
    Pa.forEach(function(b) {
      f[b] !== 1 / 0 && (s[b] *= f[b]);
    });
  if (u = Ea(n, s).width, d = Ea(n, s).height, s.right + s.left && (u > r.maxWidth ? f.width = (r.maxWidth - n.width) / (s.right + s.left) : u < r.minWidth && (f.width = (r.minWidth - n.width) / (s.right + s.left))), s.bottom + s.top && (d > r.maxHeight ? f.height = (r.maxHeight - n.height) / (s.bottom + s.top) : d < r.minHeight && (f.height = (r.minHeight - n.height) / (s.bottom + s.top))), o) {
    var k = Math.min(f.width, f.height);
    k !== 1 / 0 && Pa.forEach(function(b) {
      s[b] *= k;
    });
  } else
    f.width !== 1 / 0 && Sy.forEach(function(b) {
      s[b] *= f.width;
    }), f.height !== 1 / 0 && Ty.forEach(function(b) {
      s[b] *= f.height;
    });
  return s;
}
function Rs(e, t, n) {
  return t == 0 && n == 0 ? e / 2 : t == 0 ? 0 : n == 0 ? e : e * Math.abs(t / (t + n));
}
var Wy = la("vue-simple-handler"), By = la("vue-simple-handler-wrapper"), _l = { name: "SimpleHandler", components: { HandlerWrapper: um }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  var e, t = (ia(e = {}, this.horizontalPosition, !!this.horizontalPosition), ia(e, this.verticalPosition, !!this.verticalPosition), ia(e, "".concat(this.horizontalPosition, "-").concat(this.verticalPosition), !!(this.verticalPosition && this.horizontalPosition)), ia(e, "hover", this.hover), e);
  return { default: Et(Wy(t), this.defaultClass, this.hover && this.hoverClass), wrapper: Et(By(t), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
_l.render = function(e, t, n, a, i, r) {
  var o = _e("HandlerWrapper");
  return y(), le(o, { class: r.classes.wrapper, "vertical-position": n.verticalPosition, "horizontal-position": n.horizontalPosition, disabled: n.disabled, onDrag: r.onDrag, onDragEnd: r.onDragEnd, onEnter: r.onEnter, onLeave: r.onLeave }, { default: De(function() {
    return [Pe("div", { class: r.classes.default }, null, 2)];
  }), _: 1 }, 8, ["class", "vertical-position", "horizontal-position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var Vy = la("vue-simple-line"), jy = la("vue-simple-line-wrapper"), kl = { name: "SimpleLine", components: { LineWrapper: dm }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, position: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  return { root: Et(Vy(ia({}, this.position, !0)), this.defaultClass, this.hover && this.hoverClass), wrapper: Et(jy(ia({}, this.position, !0)), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
kl.render = function(e, t, n, a, i, r) {
  var o = _e("LineWrapper");
  return y(), le(o, { class: r.classes.wrapper, position: n.position, disabled: n.disabled, onDrag: r.onDrag, onDragEnd: r.onDragEnd, onEnter: r.onEnter, onLeave: r.onLeave }, { default: De(function() {
    return [Pe("div", { class: r.classes.root }, null, 2)];
  }), _: 1 }, 8, ["class", "position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var _u = la("vue-bounding-box"), Uy = ["east", "west", null], Gy = ["south", "north", null], Nd = { name: "BoundingBox", props: { width: { type: Number }, height: { type: Number }, transitions: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, north: !0, westNorth: !0, west: !0, westSouth: !0, south: !0, eastSouth: !0, east: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return _l;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object, default: function() {
  return { west: !0, north: !0, east: !0, south: !0 };
} }, linesComponent: { type: [Object, String], default: function() {
  return kl;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, resizable: { type: Boolean, default: !0 } }, data: function() {
  var e = [];
  return Uy.forEach(function(t) {
    Gy.forEach(function(n) {
      if (t !== n) {
        var a = rm(t, n), i = a.name, r = a.classname;
        e.push({ name: i, classname: r, verticalDirection: n, horizontalDirection: t });
      }
    });
  }), { points: e };
}, computed: { style: function() {
  var e = {};
  return this.width && this.height && (e.width = "".concat(this.width, "px"), e.height = "".concat(this.height, "px"), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction))), e;
}, classes: function() {
  var e = this.handlersClasses, t = this.handlersWrappersClasses, n = this.linesClasses, a = this.linesWrappersClasses;
  return { root: _u(), handlers: e, handlersWrappers: t, lines: n, linesWrappers: a };
}, lineNodes: function() {
  var e = this, t = [];
  return this.points.forEach(function(n) {
    n.horizontalDirection && n.verticalDirection || !e.lines[n.name] || t.push({ name: n.name, component: e.linesComponent, class: Et(e.classes.lines.default, e.classes.lines[n.name], !e.resizable && e.classes.lines.disabled), wrapperClass: Et(e.classes.linesWrappers.default, e.classes.linesWrappers[n.name], !e.resizable && e.classes.linesWrappers.disabled), hoverClass: e.classes.lines.hover, verticalDirection: n.verticalDirection, horizontalDirection: n.horizontalDirection, disabled: !e.resizable });
  }), t;
}, handlerNodes: function() {
  var e = this, t = [], n = this.width, a = this.height;
  return this.points.forEach(function(i) {
    if (e.handlers[i.name]) {
      var r = { name: i.name, component: e.handlersComponent, class: Et(e.classes.handlers.default, e.classes.handlers[i.name]), wrapperClass: Et(e.classes.handlersWrappers.default, e.classes.handlersWrappers[i.name]), hoverClass: e.classes.handlers.hover, verticalDirection: i.verticalDirection, horizontalDirection: i.horizontalDirection, disabled: !e.resizable };
      if (n && a) {
        var o = i.horizontalDirection, l = i.verticalDirection, s = o === "east" ? n : o === "west" ? 0 : n / 2, u = l === "south" ? a : l === "north" ? 0 : a / 2;
        r.wrapperClass = _u("handler"), r.wrapperStyle = { transform: "translate(".concat(s, "px, ").concat(u, "px)") }, e.transitions && e.transitions.enabled && (r.wrapperStyle.transition = "".concat(e.transitions.time, "ms ").concat(e.transitions.timingFunction));
      } else
        r.wrapperClass = _u("handler", ia({}, i.classname, !0));
      t.push(r);
    }
  }), t;
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [];
}, methods: { onEnd: function() {
  this.$emit("resize-end");
}, onHandlerDrag: function(e, t, n) {
  var a, i = e.shift(), r = i.left, o = i.top, l = { left: 0, right: 0, top: 0, bottom: 0 };
  t === "west" ? l.left -= r : t === "east" && (l.right += r), n === "north" ? l.top -= o : n === "south" && (l.bottom += o), !n && t ? a = "width" : n && !t && (a = "height"), this.resizable && this.$emit("resize", new xy(l, { allowedDirections: { left: t === "west" || !t, right: t === "east" || !t, bottom: n === "south" || !n, top: n === "north" || !n }, preserveAspectRatio: e.nativeEvent && e.nativeEvent.shiftKey, respectDirection: a }));
} }, emits: ["resize", "resize-end"] };
Nd.render = function(e, t, n, a, i, r) {
  return y(), le("div", { ref: "box", class: r.classes.root, style: r.style }, [me(e.$slots, "default"), Pe("div", null, [(y(!0), le(Fe, null, Xe(r.lineNodes, function(o) {
    return y(), le(li(o.component), { key: o.name, "default-class": o.class, "hover-class": o.hoverClass, "wrapper-class": o.wrapperClass, position: o.name, disabled: o.disabled, onDrag: function(l) {
      return r.onHandlerDrag(l, o.horizontalDirection, o.verticalDirection);
    }, onDragEnd: t[1] || (t[1] = function(l) {
      return r.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "position", "disabled", "onDrag"]);
  }), 128))]), (y(!0), le(Fe, null, Xe(r.handlerNodes, function(o) {
    return y(), le("div", { key: o.name, style: o.wrapperStyle, class: o.wrapperClass }, [(y(), le(li(o.component), { "default-class": o.class, "hover-class": o.hoverClass, "wrapper-class": o.wrapperClass, "horizontal-position": o.horizontalDirection, "vertical-position": o.verticalDirection, disabled: o.disabled, onDrag: function(l) {
      return r.onHandlerDrag(l, o.horizontalDirection, o.verticalDirection);
    }, onDragEnd: t[2] || (t[2] = function(l) {
      return r.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "horizontal-position", "vertical-position", "disabled", "onDrag"]))], 6);
  }), 128))], 6);
};
var qy = la("vue-draggable-area"), $d = { name: "DraggableArea", props: { movable: { type: Boolean, default: !0 }, activationDistance: { type: Number, default: 20 } }, computed: { classnames: function() {
  return { default: qy() };
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [], this.touchStarted = !1;
}, methods: { onTouchStart: function(e) {
  if (e.cancelable) {
    var t = this.movable && e.touches.length === 1;
    t && (this.touches = ir(e.touches)), (this.touchStarted || t) && (e.preventDefault(), e.stopPropagation());
  }
}, onTouchEnd: function() {
  this.touchStarted = !1, this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length >= 1 && (this.touchStarted ? (this.processMove(e, e.touches), e.preventDefault(), e.stopPropagation()) : lm({ x: this.touches[0].clientX, y: this.touches[0].clientY }, { x: e.touches[0].clientX, y: e.touches[0].clientY }) > this.activationDistance && (this.initAnchor({ clientX: e.touches[0].clientX, clientY: e.touches[0].clientY }), this.touchStarted = !0));
}, onMouseDown: function(e) {
  if (this.movable && e.button === 0) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.initAnchor(t), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.cancelable && e.preventDefault(), e.stopPropagation());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var t = this.$refs.container.getBoundingClientRect(), n = t.left, a = t.top;
  this.anchor = { x: e.clientX - n, y: e.clientY - a };
}, processMove: function(e, t) {
  var n = ir(t);
  if (this.touches.length) {
    var a = this.$refs.container.getBoundingClientRect(), i = a.left, r = a.top;
    this.touches.length === 1 && n.length === 1 && this.$emit("move", new Id({ left: n[0].clientX - (i + this.anchor.x), top: n[0].clientY - (r + this.anchor.y) }));
  }
}, processEnd: function() {
  this.touches.length && this.$emit("move-end"), this.touches = [];
} }, emits: ["move", "move-end"] };
$d.render = function(e, t, n, a, i, r) {
  return y(), le("div", { ref: "container", onTouchstart: t[1] || (t[1] = function() {
    return r.onTouchStart && r.onTouchStart.apply(r, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return r.onMouseDown && r.onMouseDown.apply(r, arguments);
  }) }, [me(e.$slots, "default")], 544);
};
function ku(e) {
  var t, n;
  return { rotate: e.rotate || 0, flip: { horizontal: ((t = e == null ? void 0 : e.flip) === null || t === void 0 ? void 0 : t.horizontal) || !1, vertical: ((n = e == null ? void 0 : e.flip) === null || n === void 0 ? void 0 : n.vertical) || !1 } };
}
function Xy(e) {
  return new Promise(function(t, n) {
    try {
      if (e)
        if (/^data:/i.test(e))
          t(function(s) {
            s = s.replace(/^data:([^;]+);base64,/gim, "");
            for (var u = atob(s), d = u.length, c = new ArrayBuffer(d), f = new Uint8Array(c), v = 0; v < d; v++)
              f[v] = u.charCodeAt(v);
            return c;
          }(e));
        else if (/^blob:/i.test(e)) {
          var a = new FileReader();
          a.onload = function(s) {
            t(s.target.result);
          }, r = e, o = function(s) {
            a.readAsArrayBuffer(s);
          }, (l = new XMLHttpRequest()).open("GET", r, !0), l.responseType = "blob", l.onload = function() {
            this.status != 200 && this.status !== 0 || o(this.response);
          }, l.send();
        } else {
          var i = new XMLHttpRequest();
          i.onreadystatechange = function() {
            i.readyState === 4 && (i.status === 200 || i.status === 0 ? t(i.response) : n("Warning: could not load an image to parse its orientation"), i = null);
          }, i.onprogress = function() {
            i.getResponseHeader("content-type") !== "image/jpeg" && i.abort();
          }, i.withCredentials = !1, i.open("GET", e, !0), i.responseType = "arraybuffer", i.send(null);
        }
      else
        n("Error: the image is empty");
    } catch (s) {
      n(s);
    }
    var r, o, l;
  });
}
function mm(e) {
  var t = e.rotate, n = e.flip, a = e.scaleX, i = e.scaleY, r = "";
  return r += " rotate(" + t + "deg) ", r += " scaleX(" + a * (n.horizontal ? -1 : 1) + ") ", r += " scaleY(" + i * (n.vertical ? -1 : 1) + ") ";
}
function Zy(e) {
  try {
    var t, n = new DataView(e), a = void 0, i = void 0, r = void 0, o = void 0;
    if (n.getUint8(0) === 255 && n.getUint8(1) === 216)
      for (var l = n.byteLength, s = 2; s + 1 < l; ) {
        if (n.getUint8(s) === 255 && n.getUint8(s + 1) === 225) {
          r = s;
          break;
        }
        s++;
      }
    if (r && (a = r + 10, function(v, k, b) {
      var R, V = "";
      for (R = k, b += k; R < b; R++)
        V += String.fromCharCode(v.getUint8(R));
      return V;
    }(n, r + 4, 4) === "Exif")) {
      var u = n.getUint16(a);
      if (((i = u === 18761) || u === 19789) && n.getUint16(a + 2, i) === 42) {
        var d = n.getUint32(a + 4, i);
        d >= 8 && (o = a + d);
      }
    }
    if (o) {
      for (var c = n.getUint16(o, i), f = 0; f < c; f++)
        if (s = o + 12 * f + 2, n.getUint16(s, i) === 274) {
          s += 8, t = n.getUint16(s, i), n.setUint16(s, 1, i);
          break;
        }
    }
    return t;
  } catch {
    return null;
  }
}
function Kh(e, t) {
  var n = t.getBoundingClientRect(), a = n.left, i = n.top, r = { left: 0, top: 0 }, o = 0;
  return e.forEach(function(l) {
    r.left += (l.clientX - a) / e.length, r.top += (l.clientY - i) / e.length;
  }), e.forEach(function(l) {
    o += lm({ x: r.left, y: r.top }, { x: l.clientX - a, y: l.clientY - i });
  }), { centerMass: r, spread: o, count: e.length };
}
var pm = { props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 }, eventsFilter: { type: Function, required: !1 } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, created: function() {
  this.transforming = !1, this.debouncedProcessEnd = rd(this.processEnd), this.touches = [];
}, methods: { processMove: function(e, t) {
  if (this.touches.length) {
    if (this.touches.length === 1 && t.length === 1)
      this.$emit("move", new Ao({ left: this.touches[0].clientX - t[0].clientX, top: this.touches[0].clientY - t[0].clientY }));
    else if (this.touches.length > 1 && this.touchResize) {
      var n = Kh(t, this.$refs.container), a = this.oldGeometricProperties;
      a.count === n.count && a.count > 1 && this.$emit("resize", new Ao({ left: a.centerMass.left - n.centerMass.left, top: a.centerMass.top - n.centerMass.top }, { factor: a.spread / n.spread, center: n.centerMass })), this.oldGeometricProperties = n;
    }
    this.touches = t;
  }
}, processEnd: function() {
  this.transforming && (this.transforming = !1, this.$emit("transform-end"));
}, processStart: function() {
  this.transforming = !0, this.debouncedProcessEnd.clear();
}, processEvent: function(e) {
  return this.eventsFilter ? this.eventsFilter(e, this.transforming) !== !1 : (e.preventDefault(), e.stopPropagation(), !0);
}, onTouchStart: function(e) {
  if (e.cancelable && (this.touchMove || this.touchResize && e.touches.length > 1) && this.processEvent(e)) {
    var t = this.$refs.container, n = t.getBoundingClientRect(), a = n.left, i = n.top, r = n.bottom, o = n.right;
    this.touches = ir(e.touches).filter(function(l) {
      return l.clientX > a && l.clientX < o && l.clientY > i && l.clientY < r;
    }), this.oldGeometricProperties = Kh(this.touches, t);
  }
}, onTouchEnd: function(e) {
  e.touches.length === 0 && (this.touches = [], this.processEnd());
}, onTouchMove: function(e) {
  var t = this;
  if (this.touches.length) {
    var n = ir(e.touches).filter(function(a) {
      return !a.identifier || t.touches.find(function(i) {
        return i.identifier === a.identifier;
      });
    });
    this.processEvent(e) && (this.processMove(e, n), this.processStart());
  }
}, onMouseDown: function(e) {
  if (this.mouseMove && "buttons" in e && e.buttons === 1 && this.processEvent(e)) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.processStart();
  }
}, onMouseMove: function(e) {
  this.touches.length && this.processEvent(e) && this.processMove(e, [{ clientX: e.clientX, clientY: e.clientY }]);
}, onMouseUp: function() {
  this.touches = [], this.processEnd();
}, onWheel: function(e) {
  if (this.wheelResize && this.processEvent(e)) {
    var t = this.$refs.container.getBoundingClientRect(), n = t.left, a = t.top, i = 1 + this.wheelResize.ratio * (o = e.deltaY || e.detail || e.wheelDelta, (l = +o) == 0 || sm(l) ? l : l > 0 ? 1 : -1), r = { left: e.clientX - n, top: e.clientY - a };
    this.$emit("resize", new Ao({}, { factor: i, center: r })), this.touches.length || this.debouncedProcessEnd();
  }
  var o, l;
} }, emits: ["resize", "move", "transform-end"] };
pm.render = function(e, t, n, a, i, r) {
  return y(), le("div", { ref: "container", onTouchstart: t[1] || (t[1] = function() {
    return r.onTouchStart && r.onTouchStart.apply(r, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return r.onMouseDown && r.onMouseDown.apply(r, arguments);
  }), onWheel: t[3] || (t[3] = function() {
    return r.onWheel && r.onWheel.apply(r, arguments);
  }) }, [me(e.$slots, "default")], 544);
};
var ud = { components: { TransformableImage: pm }, props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 } }, emits: ["resize", "move"] };
ud.render = function(e, t, n, a, i, r) {
  var o = _e("transformable-image");
  return y(), le(o, { "touch-move": n.touchMove, "touch-resize": n.touchResize, "mouse-move": n.mouseMove, "wheel-resize": n.wheelResize, onMove: t[1] || (t[1] = function(l) {
    return e.$emit("move", l);
  }), onResize: t[2] || (t[2] = function(l) {
    return e.$emit("resize", l);
  }) }, { default: De(function() {
    return [me(e.$slots, "default")];
  }), _: 3 }, 8, ["touch-move", "touch-resize", "mouse-move", "wheel-resize"]);
};
var Is = la("vue-preview"), vm = { props: { coordinates: { type: Object }, transitions: { type: Object }, image: { type: Object, default: function() {
  return {};
} }, imageClass: { type: String }, width: { type: Number }, height: { type: Number }, fill: { type: Boolean } }, data: function() {
  return { calculatedImageSize: { width: 0, height: 0 }, calculatedSize: { width: 0, height: 0 } };
}, computed: { classes: function() {
  return { root: Is({ fill: this.fill }), wrapper: Is("wrapper"), imageWrapper: Is("image-wrapper"), image: Et(Is("image"), this.imageClass) };
}, style: function() {
  if (this.fill)
    return {};
  var e = {};
  return this.width && (e.width = "".concat(this.size.width, "px")), this.height && (e.height = "".concat(this.size.height, "px")), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, wrapperStyle: function() {
  var e = { width: "".concat(this.size.width, "px"), height: "".concat(this.size.height, "px"), left: "calc(50% - ".concat(this.size.width / 2, "px)"), top: "calc(50% - ".concat(this.size.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, imageStyle: function() {
  if (this.coordinates && this.image) {
    var e = this.coordinates.width / this.size.width, t = tt(tt({ rotate: 0, flip: { horizontal: !1, vertical: !1 } }, this.image.transforms), {}, { scaleX: 1 / e, scaleY: 1 / e }), n = this.imageSize.width, a = this.imageSize.height, i = hm({ width: n, height: a }, t.rotate), r = { width: "".concat(n, "px"), height: "".concat(a, "px"), left: "0px", top: "0px" }, o = { rotate: { left: (n - i.width) * t.scaleX / 2, top: (a - i.height) * t.scaleY / 2 }, scale: { left: (1 - t.scaleX) * n / 2, top: (1 - t.scaleY) * a / 2 } };
    return r.transform = `translate(
				`.concat(-this.coordinates.left / e - o.rotate.left - o.scale.left, "px,").concat(-this.coordinates.top / e - o.rotate.top - o.scale.top, "px) ") + mm(t), this.transitions && this.transitions.enabled && (r.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), r;
  }
  return {};
}, size: function() {
  return { width: this.width || this.calculatedSize.width, height: this.height || this.calculatedSize.height };
}, imageSize: function() {
  return { width: this.image.width || this.calculatedImageSize.width, height: this.image.height || this.calculatedImageSize.height };
} }, watch: { image: function(e) {
  (e.width || e.height) && this.onChangeImage();
} }, mounted: function() {
  var e = this;
  this.onChangeImage(), this.$refs.image.addEventListener("load", function() {
    e.refreshImage();
  }), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh);
}, methods: { refreshImage: function() {
  var e = this.$refs.image;
  this.calculatedImageSize.height = e.naturalHeight, this.calculatedImageSize.width = e.naturalWidth;
}, refresh: function() {
  var e = this.$refs.root;
  this.width || (this.calculatedSize.width = e.clientWidth), this.height || (this.calculatedSize.height = e.clientHeight);
}, onChangeImage: function() {
  var e = this.$refs.image;
  e && e.complete && this.refreshImage(), this.refresh();
} } };
vm.render = function(e, t, n, a, i, r) {
  return y(), le("div", { ref: "root", class: r.classes.root, style: r.style }, [Pe("div", { ref: "wrapper", class: r.classes.wrapper, style: r.wrapperStyle }, [ai(Pe("img", { ref: "image", src: n.image && n.image.src, class: r.classes.image, style: r.imageStyle }, null, 14, ["src"]), [[Sr, n.image && n.image.src]])], 6)], 6);
};
var Ld = { components: { Preview: vm }, inheritAttrs: !1 };
Ld.render = function(e, t, n, a, i, r) {
  var o = _e("preview");
  return y(), le(o, Ft(e.$attrs, { fill: !0 }), null, 16);
};
var xu = la("vue-rectangle-stencil"), Fd = { name: "RectangleStencil", components: { StencilPreview: Ld, BoundingBox: Nd, DraggableArea: $d }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object }, handlersComponent: { type: [Object, String], default: function() {
  return _l;
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return kl;
} }, aspectRatio: { type: [Number, String] }, minAspectRatio: { type: [Number, String] }, maxAspectRatio: { type: [Number, String] }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: Et(xu({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: Et(xu("preview"), this.previewClass), boundingBox: Et(xu("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var e = this.stencilCoordinates, t = e.height, n = e.width, a = e.left, i = e.top, r = { width: "".concat(n, "px"), height: "".concat(t, "px"), transform: "translate(".concat(a, "px, ").concat(i, "px)") };
  return this.transitions && this.transitions.enabled && (r.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), r;
} }, methods: { onMove: function(e) {
  this.$emit("move", e), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(e) {
  this.$emit("resize", e), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: this.aspectRatio || this.minAspectRatio, maximum: this.aspectRatio || this.maxAspectRatio };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
Fd.render = function(e, t, n, a, i, r) {
  var o = _e("stencil-preview"), l = _e("draggable-area"), s = _e("bounding-box");
  return y(), le("div", { class: r.classes.stencil, style: r.style }, [Pe(s, { width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, transitions: n.transitions, class: r.classes.boundingBox, handlers: n.handlers, "handlers-component": n.handlersComponent, "handlers-classes": n.handlersClasses, "handlers-wrappers-classes": n.handlersWrappersClasses, lines: n.lines, "lines-component": n.linesComponent, "lines-classes": n.linesClasses, "lines-wrappers-classes": n.linesWrappersClasses, resizable: n.resizable, onResize: r.onResize, onResizeEnd: r.onResizeEnd }, { default: De(function() {
    return [Pe(l, { movable: n.movable, onMove: r.onMove, onMoveEnd: r.onMoveEnd }, { default: De(function() {
      return [Pe(o, { image: n.image, coordinates: n.coordinates, width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, class: r.classes.preview, transitions: n.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var Mu = la("vue-circle-stencil"), gm = { components: { StencilPreview: Ld, BoundingBox: Nd, DraggableArea: $d }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, westNorth: !0, westSouth: !0, eastSouth: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return _l;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return kl;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: Et(Mu({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: Et(Mu("preview"), this.previewClass), boundingBox: Et(Mu("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var e = this.stencilCoordinates, t = e.height, n = e.width, a = e.left, i = e.top, r = { width: "".concat(n, "px"), height: "".concat(t, "px"), transform: "translate(".concat(a, "px, ").concat(i, "px)") };
  return this.transitions && this.transitions.enabled && (r.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), r;
} }, methods: { onMove: function(e) {
  this.$emit("move", e), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(e) {
  this.$emit("resize", e), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: 1, maximum: 1 };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
gm.render = function(e, t, n, a, i, r) {
  var o = _e("stencil-preview"), l = _e("draggable-area"), s = _e("bounding-box");
  return y(), le("div", { class: r.classes.stencil, style: r.style }, [Pe(s, { width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, transitions: n.transitions, class: r.classes.boundingBox, handlers: n.handlers, "handlers-component": n.handlersComponent, "handlers-classes": n.handlersClasses, "handlers-wrappers-classes": n.handlersWrappersClasses, lines: n.lines, "lines-component": n.linesComponent, "lines-classes": n.linesClasses, "lines-wrappers-classes": n.linesWrappersClasses, resizable: n.resizable, onResize: r.onResize, onResizeEnd: r.onResizeEnd }, { default: De(function() {
    return [Pe(l, { movable: n.movable, onMove: r.onMove, onMoveEnd: r.onMoveEnd }, { default: De(function() {
      return [Pe(o, { image: n.image, coordinates: n.coordinates, width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, class: r.classes.preview, transitions: n.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var Qy = ["transitions"], qa = la("vue-advanced-cropper"), ym = { name: "Cropper", components: { BackgroundWrapper: ud }, props: { src: { type: String, default: null }, stencilComponent: { type: [Object, String], default: function() {
  return Fd;
} }, backgroundWrapperComponent: { type: [Object, String], default: function() {
  return ud;
} }, stencilProps: { type: Object, default: function() {
  return {};
} }, autoZoom: { type: Boolean, default: !1 }, imageClass: { type: String }, boundariesClass: { type: String }, backgroundClass: { type: String }, foregroundClass: { type: String }, minWidth: { type: [Number, String] }, minHeight: { type: [Number, String] }, maxWidth: { type: [Number, String] }, maxHeight: { type: [Number, String] }, debounce: { type: [Boolean, Number], default: 500 }, transitions: { type: Boolean, default: !0 }, checkOrientation: { type: Boolean, default: !0 }, canvas: { type: [Object, Boolean], default: !0 }, crossOrigin: { type: [Boolean, String], default: void 0 }, transitionTime: { type: Number, default: 300 }, imageRestriction: { type: String, default: "fit-area", validator: function(e) {
  return Oy.indexOf(e) !== -1;
} }, roundResult: { type: Boolean, default: !0 }, defaultSize: { type: [Function, Object] }, defaultPosition: { type: [Function, Object] }, defaultVisibleArea: { type: [Function, Object] }, defaultTransforms: { type: [Function, Object] }, defaultBoundaries: { type: [Function, String], validator: function(e) {
  return !(typeof e == "string" && e !== "fill" && e !== "fit");
} }, priority: { type: String, default: "coordinates" }, stencilSize: { type: [Object, Function] }, resizeImage: { type: [Boolean, Object], default: !0 }, moveImage: { type: [Boolean, Object], default: !0 }, autoZoomAlgorithm: { type: Function }, resizeAlgorithm: { type: Function, default: function(e) {
  var t = e.event, n = e.coordinates, a = e.aspectRatio, i = e.positionRestrictions, r = e.sizeRestrictions, o = Ye(Ye({}, n), { right: n.left + n.width, bottom: n.top + n.height }), l = t.params || {}, s = Ye({}, t.directions), u = l.allowedDirections || { left: !0, right: !0, bottom: !0, top: !0 };
  r.widthFrozen && (s.left = 0, s.right = 0), r.heightFrozen && (s.top = 0, s.bottom = 0), Pa.forEach(function(q) {
    u[q] || (s[q] = 0);
  });
  var d = Ea(o, s = Qh({ coordinates: o, directions: s, sizeRestrictions: r, positionRestrictions: i })).width, c = Ea(o, s).height, f = l.preserveRatio ? nt(o) : bu(d / c, a);
  if (f) {
    var v = l.respectDirection;
    if (v || (v = o.width >= o.height || f === 1 ? "width" : "height"), v === "width") {
      var k = d / f - o.height;
      if (u.top && u.bottom) {
        var b = s.top, R = s.bottom;
        s.bottom = Rs(k, R, b), s.top = Rs(k, b, R);
      } else
        u.bottom ? s.bottom = k : u.top ? s.top = k : u.right ? s.right = 0 : u.left && (s.left = 0);
    } else if (v === "height") {
      var V = o.width - c * f;
      if (u.left && u.right) {
        var G = s.left, C = s.right;
        s.left = -Rs(V, G, C), s.right = -Rs(V, C, G);
      } else
        u.left ? s.left = -V : u.right ? s.right = -V : u.top ? s.top = 0 : u.bottom && (s.bottom = 0);
    }
    s = Qh({ directions: s, coordinates: o, sizeRestrictions: r, positionRestrictions: i, preserveRatio: !0, compensate: l.compensate });
  }
  return d = Ea(o, s).width, c = Ea(o, s).height, (f = l.preserveRatio ? nt(o) : bu(d / c, a)) && Math.abs(f - d / c) > 1e-3 && Pa.forEach(function(q) {
    u[q] || (s[q] = 0);
  }), ld({ event: new Id({ left: -s.left, top: -s.top }), coordinates: { width: n.width + s.right + s.left, height: n.height + s.top + s.bottom, left: n.left, top: n.top }, positionRestrictions: i });
} }, moveAlgorithm: { type: Function, default: ld }, initStretcher: { type: Function, default: function(e) {
  var t = e.stretcher, n = e.imageSize, a = nt(n);
  t.style.width = n.width + "px", t.style.height = t.clientWidth / a + "px", t.style.width = t.clientWidth + "px";
} }, fitCoordinates: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.coordinates, a = e.aspectRatio, i = e.sizeRestrictions, r = e.positionRestrictions, o = Ye(Ye({}, n), Ja({ width: n.width, height: n.height, aspectRatio: a, sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minHeight: Math.min(t.height, i.minHeight), minWidth: Math.min(t.width, i.minWidth) } }));
  return o = dn(o = Pn(o, Ir(un(n), un(o))), bl(za(t), r));
} }, fitVisibleArea: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.boundaries, a = e.getAreaRestrictions, i = e.coordinates, r = Ye({}, t);
  r.height = r.width / nt(n), r.top += (t.height - r.height) / 2, (i.height - r.height > 0 || i.width - r.width > 0) && (r = oa(r, Math.max(i.height / r.height, i.width / r.width)));
  var o = yl(Nr(i, za(r = oa(r, wl(r, a({ visibleArea: r, type: "resize" }))))));
  return r.width < i.width && (o.left = 0), r.height < i.height && (o.top = 0), r = dn(r = Pn(r, o), a({ visibleArea: r, type: "move" }));
} }, areaRestrictionsAlgorithm: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.boundaries, a = e.imageSize, i = e.imageRestriction, r = e.type, o = {};
  return i === "fill-area" ? o = { left: 0, top: 0, right: a.width, bottom: a.height } : i === "fit-area" && (nt(n) > nt(a) ? (o = { top: 0, bottom: a.height }, t && r === "move" && (t.width > a.width ? (o.left = -(t.width - a.width) / 2, o.right = a.width - o.left) : (o.left = 0, o.right = a.width))) : (o = { left: 0, right: a.width }, t && r === "move" && (t.height > a.height ? (o.top = -(t.height - a.height) / 2, o.bottom = a.height - o.top) : (o.top = 0, o.bottom = a.height)))), o;
} }, sizeRestrictionsAlgorithm: { type: Function, default: function(e) {
  return { minWidth: e.minWidth, minHeight: e.minHeight, maxWidth: e.maxWidth, maxHeight: e.maxHeight };
} }, positionRestrictionsAlgorithm: { type: Function, default: function(e) {
  var t = e.imageSize, n = {};
  return e.imageRestriction !== "none" && (n = { left: 0, top: 0, right: t.width, bottom: t.height }), n;
} } }, data: function() {
  return { transitionsActive: !1, imageLoaded: !1, imageAttributes: { width: null, height: null, crossOrigin: null, src: null }, defaultImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, appliedImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, boundaries: { width: 0, height: 0 }, visibleArea: null, coordinates: tt({}, Gh) };
}, computed: { image: function() {
  return { src: this.imageAttributes.src, width: this.imageAttributes.width, height: this.imageAttributes.height, transforms: this.imageTransforms };
}, imageTransforms: function() {
  return { rotate: this.appliedImageTransforms.rotate, flip: { horizontal: this.appliedImageTransforms.flip.horizontal, vertical: this.appliedImageTransforms.flip.vertical }, translateX: this.visibleArea ? this.visibleArea.left / this.coefficient : 0, translateY: this.visibleArea ? this.visibleArea.top / this.coefficient : 0, scaleX: 1 / this.coefficient, scaleY: 1 / this.coefficient };
}, imageSize: function() {
  var e = function(t) {
    return t * Math.PI / 180;
  }(this.imageTransforms.rotate);
  return { width: Math.abs(this.imageAttributes.width * Math.cos(e)) + Math.abs(this.imageAttributes.height * Math.sin(e)), height: Math.abs(this.imageAttributes.width * Math.sin(e)) + Math.abs(this.imageAttributes.height * Math.cos(e)) };
}, initialized: function() {
  return !!(this.visibleArea && this.imageLoaded);
}, settings: function() {
  var e = od(this.resizeImage, { touch: !0, wheel: { ratio: 0.1 }, adjustStencil: !0 }, { touch: !1, wheel: !1, adjustStencil: !1 });
  return { moveImage: od(this.moveImage, { touch: !0, mouse: !0 }, { touch: !1, mouse: !1 }), resizeImage: e };
}, coefficient: function() {
  return this.visibleArea ? this.visibleArea.width / this.boundaries.width : 0;
}, areaRestrictions: function() {
  return this.imageLoaded ? this.areaRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction, boundaries: this.boundaries }) : {};
}, transitionsOptions: function() {
  return { enabled: this.transitionsActive, timingFunction: "ease-in-out", time: 350 };
}, sizeRestrictions: function() {
  if (this.boundaries.width && this.boundaries.height && this.imageSize.width && this.imageSize.height) {
    var e = this.sizeRestrictionsAlgorithm({ imageSize: this.imageSize, minWidth: en(this.minWidth) ? 0 : Es(this.minWidth), minHeight: en(this.minHeight) ? 0 : Es(this.minHeight), maxWidth: en(this.maxWidth) ? 1 / 0 : Es(this.maxWidth), maxHeight: en(this.maxHeight) ? 1 / 0 : Es(this.maxHeight) });
    if (e = function(a) {
      var i = a.areaRestrictions, r = a.sizeRestrictions;
      a.imageSize;
      var o = a.boundaries, l = a.positionRestrictions;
      a.imageRestriction;
      var s = Ye(Ye({}, r), { minWidth: r.minWidth !== void 0 ? r.minWidth : 0, minHeight: r.minHeight !== void 0 ? r.minHeight : 0, maxWidth: r.maxWidth !== void 0 ? r.maxWidth : 1 / 0, maxHeight: r.maxHeight !== void 0 ? r.maxHeight : 1 / 0 });
      l.left !== void 0 && l.right !== void 0 && (s.maxWidth = Math.min(s.maxWidth, l.right - l.left)), l.bottom !== void 0 && l.top !== void 0 && (s.maxHeight = Math.min(s.maxHeight, l.bottom - l.top));
      var u = sd(i), d = cm(o, u);
      return u.width < 1 / 0 && (!s.maxWidth || s.maxWidth > d.width) && (s.maxWidth = Math.min(s.maxWidth, d.width)), u.height < 1 / 0 && (!s.maxHeight || s.maxHeight > d.height) && (s.maxHeight = Math.min(s.maxHeight, d.height)), s.minWidth > s.maxWidth && (s.minWidth = s.maxWidth, s.widthFrozen = !0), s.minHeight > s.maxHeight && (s.minHeight = s.maxHeight, s.heightFrozen = !0), s;
    }({ sizeRestrictions: e, areaRestrictions: this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }), imageSize: this.imageSize, boundaries: this.boundaries, positionRestrictions: this.positionRestrictions, imageRestriction: this.imageRestriction, visibleArea: this.visibleArea, stencilSize: this.getStencilSize() }), this.visibleArea && this.stencilSize) {
      var t = this.getStencilSize(), n = sd(this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }));
      e.maxWidth = Math.min(e.maxWidth, n.width * t.width / this.boundaries.width), e.maxHeight = Math.min(e.maxHeight, n.height * t.height / this.boundaries.height), e.maxWidth < e.minWidth && (e.minWidth = e.maxWidth), e.maxHeight < e.minHeight && (e.minHeight = e.maxHeight);
    }
    return e;
  }
  return { minWidth: 0, minHeight: 0, maxWidth: 0, maxHeight: 0 };
}, positionRestrictions: function() {
  return this.positionRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction });
}, classes: function() {
  return { cropper: qa(), image: Et(qa("image"), this.imageClass), stencil: qa("stencil"), boundaries: Et(qa("boundaries"), this.boundariesClass), stretcher: Et(qa("stretcher")), background: Et(qa("background"), this.backgroundClass), foreground: Et(qa("foreground"), this.foregroundClass), imageWrapper: Et(qa("image-wrapper")), cropperWrapper: Et(qa("cropper-wrapper")) };
}, stencilCoordinates: function() {
  if (this.initialized) {
    var e = this.coordinates, t = e.width, n = e.height, a = e.left, i = e.top;
    return { width: t / this.coefficient, height: n / this.coefficient, left: (a - this.visibleArea.left) / this.coefficient, top: (i - this.visibleArea.top) / this.coefficient };
  }
  return this.defaultCoordinates();
}, boundariesStyle: function() {
  var e = { width: this.boundaries.width ? "".concat(Math.round(this.boundaries.width), "px") : "auto", height: this.boundaries.height ? "".concat(Math.round(this.boundaries.height), "px") : "auto", transition: "opacity ".concat(this.transitionTime, "ms"), pointerEvents: this.imageLoaded ? "all" : "none" };
  return this.imageLoaded || (e.opacity = "0"), e;
}, imageStyle: function() {
  var e = this.imageAttributes.width > this.imageAttributes.height ? { width: Math.min(1024, this.imageAttributes.width), height: Math.min(1024, this.imageAttributes.width) / (this.imageAttributes.width / this.imageAttributes.height) } : { height: Math.min(1024, this.imageAttributes.height), width: Math.min(1024, this.imageAttributes.height) * (this.imageAttributes.width / this.imageAttributes.height) }, t = { left: (e.width - this.imageSize.width) / (2 * this.coefficient), top: (e.height - this.imageSize.height) / (2 * this.coefficient) }, n = { left: (1 - 1 / this.coefficient) * e.width / 2, top: (1 - 1 / this.coefficient) * e.height / 2 }, a = tt(tt({}, this.imageTransforms), {}, { scaleX: this.imageTransforms.scaleX * (this.imageAttributes.width / e.width), scaleY: this.imageTransforms.scaleY * (this.imageAttributes.height / e.height) }), i = { width: "".concat(e.width, "px"), height: "".concat(e.height, "px"), left: "0px", top: "0px", transform: "translate(".concat(-t.left - n.left - this.imageTransforms.translateX, "px, ").concat(-t.top - n.top - this.imageTransforms.translateY, "px)") + mm(a) };
  return this.transitionsOptions.enabled && (i.transition = "".concat(this.transitionsOptions.time, "ms ").concat(this.transitionsOptions.timingFunction)), i;
} }, watch: { src: function() {
  this.onChangeImage();
}, stencilComponent: function() {
  var e = this;
  this.$nextTick(function() {
    e.resetCoordinates(), e.runAutoZoom("setCoordinates"), e.onChange();
  });
}, minWidth: function() {
  this.onPropsChange();
}, maxWidth: function() {
  this.onPropsChange();
}, minHeight: function() {
  this.onPropsChange();
}, maxHeight: function() {
  this.onPropsChange();
}, imageRestriction: function() {
  this.reset();
}, stencilProps: function(e, t) {
  ["aspectRatio", "minAspectRatio", "maxAspectRatio"].find(function(n) {
    return e[n] !== t[n];
  }) && this.$nextTick(this.onPropsChange);
} }, created: function() {
  this.debouncedUpdate = rd(this.update, this.debounce), this.debouncedDisableTransitions = rd(this.disableTransitions, this.transitionsOptions.time), this.awaiting = !1;
}, mounted: function() {
  this.$refs.image.addEventListener("load", this.onSuccessLoadImage), this.$refs.image.addEventListener("error", this.onFailLoadImage), this.onChangeImage(), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh), this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.debouncedUpdate.clear(), this.debouncedDisableTransitions.clear();
}, methods: { getResult: function() {
  var e = this.initialized ? this.prepareResult(tt({}, this.coordinates)) : this.defaultCoordinates(), t = { rotate: this.imageTransforms.rotate % 360, flip: tt({}, this.imageTransforms.flip) };
  if (this.src && this.imageLoaded) {
    var n = this;
    return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? tt({}, this.visibleArea) : null, imageTransforms: t, get canvas() {
      return n.canvas ? n.getCanvas() : void 0;
    } };
  }
  return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? tt({}, this.visibleArea) : null, canvas: void 0, imageTransforms: t };
}, zoom: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = n.transitions, i = a === void 0 || a;
  this.onManipulateImage(new Ao({}, { factor: 1 / e, center: t }), { normalize: !1, transitions: i });
}, move: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = n.transitions, i = a === void 0 || a;
  this.onManipulateImage(new Ao({ left: e || 0, top: t || 0 }), { normalize: !1, transitions: i });
}, setCoordinates: function(e) {
  var t = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.autoZoom, i = a === void 0 || a, r = n.transitions, o = r === void 0 || r;
  this.$nextTick(function() {
    t.imageLoaded ? (t.transitionsActive || (o && t.enableTransitions(), t.coordinates = t.applyTransform(e), i && t.runAutoZoom("setCoordinates"), o && t.debouncedDisableTransitions()), t.onChange()) : t.delayedTransforms = e;
  });
}, refresh: function() {
  var e = this, t = this.$refs.image;
  if (this.src && t)
    return this.initialized ? this.updateVisibleArea().then(function() {
      e.onChange();
    }) : this.resetVisibleArea().then(function() {
      e.onChange();
    });
}, reset: function() {
  var e = this;
  return this.resetVisibleArea().then(function() {
    e.onChange(!1);
  });
}, awaitRender: function(e) {
  var t = this;
  this.awaiting || (this.awaiting = !0, this.$nextTick(function() {
    e(), t.awaiting = !1;
  }));
}, prepareResult: function(e) {
  return this.roundResult ? function(t) {
    var n = t.coordinates, a = t.sizeRestrictions, i = t.positionRestrictions, r = { width: Math.round(n.width), height: Math.round(n.height), left: Math.round(n.left), top: Math.round(n.top) };
    return r.width > a.maxWidth ? r.width = Math.floor(n.width) : r.width < a.minWidth && (r.width = Math.ceil(n.width)), r.height > a.maxHeight ? r.height = Math.floor(n.height) : r.height < a.minHeight && (r.height = Math.ceil(n.height)), dn(r, i);
  }(tt(tt({}, this.getPublicProperties()), {}, { positionRestrictions: Ps(this.positionRestrictions, this.visibleArea), coordinates: e })) : e;
}, processAutoZoom: function(e, t, n, a) {
  var i = this.autoZoomAlgorithm;
  i || (i = this.stencilSize ? Py : this.autoZoom ? Ry : Iy);
  var r = i({ event: { type: e, params: a }, visibleArea: t, coordinates: n, boundaries: this.boundaries, aspectRatio: this.getAspectRatio(), positionRestrictions: this.positionRestrictions, getAreaRestrictions: this.getAreaRestrictions, sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize() });
  return tt(tt({}, r), {}, { changed: !qh(r.visibleArea, t) || !qh(r.coordinates, n) });
}, runAutoZoom: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transitions, a = n !== void 0 && n, i = _y(t, Qy), r = this.processAutoZoom(e, this.visibleArea, this.coordinates, i), o = r.visibleArea, l = r.coordinates, s = r.changed;
  a && s && this.enableTransitions(), this.visibleArea = o, this.coordinates = l, a && s && this.debouncedDisableTransitions();
}, normalizeEvent: function(e) {
  return function(t) {
    var n = t.event, a = t.visibleArea, i = t.coefficient;
    if (n.type === "manipulateImage")
      return Ye(Ye({}, n), { move: { left: n.move && n.move.left ? i * n.move.left : 0, top: n.move && n.move.top ? i * n.move.top : 0 }, scale: { factor: n.scale && n.scale.factor ? n.scale.factor : 1, center: n.scale && n.scale.center ? { left: n.scale.center.left * i + a.left, top: n.scale.center.top * i + a.top } : null } });
    if (n.type === "resize") {
      var r = Ye(Ye({}, n), { directions: Ye({}, n.directions) });
      return Pa.forEach(function(l) {
        r.directions[l] *= i;
      }), r;
    }
    if (n.type === "move") {
      var o = Ye(Ye({}, n), { directions: Ye({}, n.directions) });
      return Ay.forEach(function(l) {
        o.directions[l] *= i;
      }), o;
    }
    return n;
  }(tt(tt({}, this.getPublicProperties()), {}, { event: e }));
}, getCanvas: function() {
  if (this.$refs.canvas) {
    var e = this.$refs.canvas, t = this.$refs.image, n = this.imageTransforms.rotate !== 0 || this.imageTransforms.flip.horizontal || this.imageTransforms.flip.vertical ? function(l, s, u) {
      var d = u.rotate, c = u.flip, f = { width: s.naturalWidth, height: s.naturalHeight }, v = hm(f, d), k = l.getContext("2d");
      l.height = v.height, l.width = v.width, k.save();
      var b = Mi(un(Ye({ left: 0, top: 0 }, f)), d);
      return k.translate(-(b.left - v.width / 2), -(b.top - v.height / 2)), k.rotate(d * Math.PI / 180), k.translate(c.horizontal ? f.width : 0, c.vertical ? f.height : 0), k.scale(c.horizontal ? -1 : 1, c.vertical ? -1 : 1), k.drawImage(s, 0, 0, f.width, f.height), k.restore(), l;
    }(this.$refs.sourceCanvas, t, this.imageTransforms) : t, a = tt({ minWidth: 0, minHeight: 0, maxWidth: 1 / 0, maxHeight: 1 / 0, maxArea: this.maxCanvasSize, imageSmoothingEnabled: !0, imageSmoothingQuality: "high", fillColor: "transparent" }, this.canvas), i = function(l) {
      return l.find(function(s) {
        return u = s, !Number.isNaN(parseFloat(u)) && isFinite(u);
        var u;
      });
    }, r = Ja({ sizeRestrictions: { minWidth: i([a.width, a.minWidth]) || 0, minHeight: i([a.height, a.minHeight]) || 0, maxWidth: i([a.width, a.maxWidth]) || 1 / 0, maxHeight: i([a.height, a.maxHeight]) || 1 / 0 }, width: this.coordinates.width, height: this.coordinates.height, aspectRatio: { minimum: this.coordinates.width / this.coordinates.height, maximum: this.coordinates.width / this.coordinates.height } });
    if (a.maxArea && r.width * r.height > a.maxArea) {
      var o = Math.sqrt(a.maxArea / (r.width * r.height));
      r = { width: Math.round(o * r.width), height: Math.round(o * r.height) };
    }
    return function(l, s, u, d, c) {
      l.width = d ? d.width : u.width, l.height = d ? d.height : u.height;
      var f = l.getContext("2d");
      f.clearRect(0, 0, l.width, l.height), c && (c.imageSmoothingEnabled && (f.imageSmoothingEnabled = c.imageSmoothingEnabled), c.imageSmoothingQuality && (f.imageSmoothingQuality = c.imageSmoothingQuality), c.fillColor && (f.fillStyle = c.fillColor, f.fillRect(0, 0, l.width, l.height), f.save()));
      var v = u.left < 0 ? -u.left : 0, k = u.top < 0 ? -u.top : 0;
      f.drawImage(s, u.left + v, u.top + k, u.width, u.height, v * (l.width / u.width), k * (l.height / u.height), l.width, l.height);
    }(e, n, this.coordinates, r, a), e;
  }
}, update: function() {
  this.$emit("change", this.getResult());
}, applyTransform: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = this.visibleArea && t ? Cy(this.sizeRestrictions, this.visibleArea) : this.sizeRestrictions, a = this.visibleArea && t ? Ps(this.positionRestrictions, this.visibleArea) : this.positionRestrictions;
  return Ey({ transform: e, coordinates: this.coordinates, imageSize: this.imageSize, sizeRestrictions: n, positionRestrictions: a, aspectRatio: this.getAspectRatio(), visibleArea: this.visibleArea });
}, resetCoordinates: function() {
  var e = this;
  if (this.$refs.image) {
    this.$refs.cropper, this.$refs.image;
    var t = this.defaultSize;
    t || (t = this.stencilSize ? $y : Ny);
    var n = this.sizeRestrictions;
    n.minWidth, n.minHeight, n.maxWidth, n.maxHeight;
    var a = mr(t) ? t({ boundaries: this.boundaries, imageSize: this.imageSize, aspectRatio: this.getAspectRatio(), sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize(), visibleArea: this.visibleArea }) : t, i = this.defaultPosition || Yy, r = [a, function(o) {
      var l = o.coordinates;
      return tt({}, mr(i) ? i({ coordinates: l, imageSize: e.imageSize, visibleArea: e.visibleArea }) : e.defaultPosition);
    }];
    this.delayedTransforms && r.push.apply(r, ir(Array.isArray(this.delayedTransforms) ? this.delayedTransforms : [this.delayedTransforms])), this.coordinates = this.applyTransform(r, !0), this.delayedTransforms = null;
  }
}, clearImage: function() {
  var e = this;
  this.imageLoaded = !1, setTimeout(function() {
    var t = e.$refs.stretcher;
    t && (t.style.height = "auto", t.style.width = "auto"), e.coordinates = e.defaultCoordinates(), e.boundaries = { width: 0, height: 0 };
  }, this.transitionTime);
}, enableTransitions: function() {
  this.transitions && (this.transitionsActive = !0);
}, disableTransitions: function() {
  this.transitionsActive = !1;
}, updateBoundaries: function() {
  var e = this, t = this.$refs.stretcher, n = this.$refs.cropper;
  return this.initStretcher({ cropper: n, stretcher: t, imageSize: this.imageSize }), this.$nextTick().then(function() {
    var a = { cropper: n, imageSize: e.imageSize };
    if (mr(e.defaultBoundaries) ? e.boundaries = e.defaultBoundaries(a) : e.defaultBoundaries === "fit" ? e.boundaries = function(i) {
      var r = i.cropper, o = i.imageSize, l = r.clientHeight, s = r.clientWidth, u = l, d = o.width * l / o.height;
      return d > s && (d = s, u = o.height * s / o.width), { width: d, height: u };
    }(a) : e.boundaries = function(i) {
      var r = i.cropper;
      return { width: r.clientWidth, height: r.clientHeight };
    }(a), !e.boundaries.width || !e.boundaries.height)
      throw new Error("It's impossible to fit the cropper in the current container");
  });
}, resetVisibleArea: function() {
  var e = this;
  return this.appliedImageTransforms = tt(tt({}, this.defaultImageTransforms), {}, { flip: tt({}, this.defaultImageTransforms.flip) }), this.updateBoundaries().then(function() {
    e.priority !== "visible-area" && (e.visibleArea = null, e.resetCoordinates());
    var t, n, a, i, r, o, l = e.defaultVisibleArea || Ly;
    e.visibleArea = mr(l) ? l({ imageSize: e.imageSize, boundaries: e.boundaries, coordinates: e.priority !== "visible-area" ? e.coordinates : null, getAreaRestrictions: e.getAreaRestrictions, stencilSize: e.getStencilSize() }) : e.defaultVisibleArea, e.visibleArea = (t = { visibleArea: e.visibleArea, boundaries: e.boundaries, getAreaRestrictions: e.getAreaRestrictions }, n = t.visibleArea, a = t.boundaries, i = t.getAreaRestrictions, r = Ye({}, n), o = nt(a), r.width / r.height !== o && (r.height = r.width / o), dn(r, i({ visibleArea: r, type: "move" }))), e.priority === "visible-area" ? e.resetCoordinates() : e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("resetVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, updateVisibleArea: function() {
  var e = this;
  return this.updateBoundaries().then(function() {
    e.visibleArea = e.fitVisibleArea({ imageSize: e.imageSize, boundaries: e.boundaries, visibleArea: e.visibleArea, coordinates: e.coordinates, getAreaRestrictions: e.getAreaRestrictions }), e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("updateVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, onChange: function() {
  var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
  e && this.debounce ? this.debouncedUpdate() : this.update();
}, onChangeImage: function() {
  var e, t = this;
  if (this.imageLoaded = !1, this.delayedTransforms = null, this.src) {
    if (function(i) {
      if (jh(i))
        return !1;
      var r = window.location, o = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec(i) || [], l = { protocol: o[1] || "", host: o[2] || "", port: o[3] || "" }, s = function(u) {
        return u.port || ((u.protocol || r.protocol) === "http" ? 80 : 433);
      };
      return !(!l.protocol && !l.host && !l.port || l.protocol && l.protocol == r.protocol && l.host && l.host == r.host && l.host && s(l) == s(r));
    }(this.src)) {
      var n = en(this.crossOrigin) ? this.canvas : this.crossOrigin;
      n === !0 && (n = "anonymous"), this.imageAttributes.crossOrigin = n || null;
    }
    if (this.checkOrientation) {
      var a = (e = this.src, new Promise(function(i) {
        Xy(e).then(function(r) {
          var o = Zy(r);
          i(r ? { source: e, arrayBuffer: r, orientation: o } : { source: e, arrayBuffer: null, orientation: null });
        }).catch(function(r) {
          console.warn(r), i({ source: e, arrayBuffer: null, orientation: null });
        });
      }));
      setTimeout(function() {
        a.then(t.onParseImage);
      }, this.transitionTime);
    } else
      setTimeout(function() {
        t.onParseImage({ source: t.src });
      }, this.transitionTime);
  } else
    this.clearImage();
}, onFailLoadImage: function() {
  this.imageAttributes.src && (this.clearImage(), this.$emit("error"));
}, onSuccessLoadImage: function() {
  var e = this, t = this.$refs.image;
  t && !this.imageLoaded && (this.imageAttributes.height = t.naturalHeight, this.imageAttributes.width = t.naturalWidth, this.imageLoaded = !0, this.resetVisibleArea().then(function() {
    e.$emit("ready"), e.onChange(!1);
  }));
}, onParseImage: function(e) {
  var t = this, n = e.source, a = e.arrayBuffer, i = e.orientation;
  this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.imageAttributes.revoke = !1, a && i && i > 1 ? om(n) || !jh(n) ? (this.imageAttributes.src = URL.createObjectURL(new Blob([a])), this.imageAttributes.revoke = !0) : this.imageAttributes.src = function(r) {
    for (var o = [], l = new Uint8Array(r); l.length > 0; ) {
      var s = l.subarray(0, 8192);
      o.push(String.fromCharCode.apply(null, Array.from ? Array.from(s) : s.slice())), l = l.subarray(8192);
    }
    return "data:image/jpeg;base64," + btoa(o.join(""));
  }(a) : this.imageAttributes.src = n, mr(this.defaultTransforms) ? this.appliedImageTransforms = ku(this.defaultTransforms()) : js(this.defaultTransforms) ? this.appliedImageTransforms = ku(this.defaultTransforms) : this.appliedImageTransforms = function(r) {
    var o = ku({});
    if (r)
      switch (r) {
        case 2:
          o.flip.horizontal = !0;
          break;
        case 3:
          o.rotate = -180;
          break;
        case 4:
          o.flip.vertical = !0;
          break;
        case 5:
          o.rotate = 90, o.flip.vertical = !0;
          break;
        case 6:
          o.rotate = 90;
          break;
        case 7:
          o.rotate = 90, o.flip.horizontal = !0;
          break;
        case 8:
          o.rotate = -90;
      }
    return o;
  }(i), this.defaultImageTransforms = tt(tt({}, this.appliedImageTransforms), {}, { flip: tt({}, this.appliedImageTransforms.flip) }), this.$nextTick(function() {
    var r = t.$refs.image;
    r && r.complete && (function(o) {
      return !!o.naturalWidth;
    }(r) ? t.onSuccessLoadImage() : t.onFailLoadImage());
  });
}, onResizeEnd: function() {
  this.runAutoZoom("resize", { transitions: !0 });
}, onMoveEnd: function() {
  this.runAutoZoom("move", { transitions: !0 });
}, onMove: function(e) {
  var t = this;
  this.transitionsOptions.enabled || this.awaitRender(function() {
    t.coordinates = t.moveAlgorithm(tt(tt({}, t.getPublicProperties()), {}, { positionRestrictions: Ps(t.positionRestrictions, t.visibleArea), coordinates: t.coordinates, event: t.normalizeEvent(e) })), t.onChange();
  });
}, onResize: function(e) {
  var t = this;
  this.transitionsOptions.enabled || this.stencilSize && !this.autoZoom || this.awaitRender(function() {
    var n = t.sizeRestrictions, a = Math.min(t.coordinates.width, t.coordinates.height, 20 * t.coefficient);
    t.coordinates = t.resizeAlgorithm(tt(tt({}, t.getPublicProperties()), {}, { positionRestrictions: Ps(t.positionRestrictions, t.visibleArea), sizeRestrictions: { maxWidth: Math.min(n.maxWidth, t.visibleArea.width), maxHeight: Math.min(n.maxHeight, t.visibleArea.height), minWidth: Math.max(n.minWidth, a), minHeight: Math.max(n.minHeight, a) }, event: t.normalizeEvent(e) })), t.onChange(), t.ticking = !1;
  });
}, onManipulateImage: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!this.transitionsOptions.enabled) {
    var n = t.transitions, a = n !== void 0 && n, i = t.normalize, r = i === void 0 || i;
    a && this.enableTransitions();
    var o = Fy(tt(tt({}, this.getPublicProperties()), {}, { event: r ? this.normalizeEvent(e) : e, getAreaRestrictions: this.getAreaRestrictions, imageRestriction: this.imageRestriction, adjustStencil: !this.stencilSize && this.settings.resizeImage.adjustStencil })), l = o.visibleArea, s = o.coordinates;
    this.visibleArea = l, this.coordinates = s, this.runAutoZoom("manipulateImage"), this.onChange(), a && this.debouncedDisableTransitions();
  }
}, onPropsChange: function() {
  this.coordinates = this.applyTransform(this.coordinates, !0), this.onChange(!1);
}, getAreaRestrictions: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.visibleArea, n = e.type, a = n === void 0 ? "move" : n;
  return this.areaRestrictionsAlgorithm({ boundaries: this.boundaries, imageSize: this.imageSize, imageRestriction: this.imageRestriction, visibleArea: t, type: a });
}, getAspectRatio: function(e) {
  var t, n, a = this.stencilProps, i = a.aspectRatio, r = a.minAspectRatio, o = a.maxAspectRatio;
  if (this.$refs.stencil && this.$refs.stencil.aspectRatios) {
    var l = this.$refs.stencil.aspectRatios();
    t = l.minimum, n = l.maximum;
  }
  if (en(t) && (t = en(i) ? r : i), en(n) && (n = en(i) ? o : i), !e && (en(t) || en(n))) {
    var s = this.getStencilSize(), u = s ? nt(s) : null;
    en(t) && (t = Uh(u) ? u : void 0), en(n) && (n = Uh(u) ? u : void 0);
  }
  return { minimum: t, maximum: n };
}, getStencilSize: function() {
  if (this.stencilSize)
    return e = { currentStencilSize: { width: this.stencilCoordinates.width, height: this.stencilCoordinates.height }, stencilSize: this.stencilSize, boundaries: this.boundaries, coefficient: this.coefficient, coordinates: this.coordinates, aspectRatio: this.getAspectRatio(!0) }, t = e.boundaries, n = e.stencilSize, a = e.aspectRatio, bu(nt(i = mr(n) ? n({ boundaries: t, aspectRatio: a }) : n), a) && (i = Ja({ sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minWidth: 0, minHeight: 0 }, width: i.width, height: i.height, aspectRatio: { minimum: a.minimum, maximum: a.maximum } })), (i.width > t.width || i.height > t.height) && (i = Ja({ sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minWidth: 0, minHeight: 0 }, width: i.width, height: i.height, aspectRatio: { minimum: nt(i), maximum: nt(i) } })), i;
  var e, t, n, a, i;
}, getPublicProperties: function() {
  return { coefficient: this.coefficient, visibleArea: this.visibleArea, coordinates: this.coordinates, boundaries: this.boundaries, sizeRestrictions: this.sizeRestrictions, positionRestrictions: this.positionRestrictions, aspectRatio: this.getAspectRatio(), imageRestriction: this.imageRestriction };
}, defaultCoordinates: function() {
  return tt({}, Gh);
}, flip: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = n.transitions, i = a === void 0 || a;
  if (!this.transitionsActive) {
    i && this.enableTransitions();
    var r = tt({}, this.imageTransforms.flip), o = Hy({ flip: { horizontal: e ? !r.horizontal : r.horizontal, vertical: t ? !r.vertical : r.vertical }, previousFlip: r, rotate: this.imageTransforms.rotate, visibleArea: this.visibleArea, coordinates: this.coordinates, imageSize: this.imageSize, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), l = o.visibleArea, s = o.coordinates;
    e && (this.appliedImageTransforms.flip.horizontal = !this.appliedImageTransforms.flip.horizontal), t && (this.appliedImageTransforms.flip.vertical = !this.appliedImageTransforms.flip.vertical), this.visibleArea = l, this.coordinates = s, this.onChange(), i && this.debouncedDisableTransitions();
  }
}, rotate: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transitions, a = n === void 0 || n;
  if (!this.transitionsActive) {
    a && this.enableTransitions();
    var i = tt({}, this.imageSize);
    this.appliedImageTransforms.rotate += e;
    var r = zy({ visibleArea: this.visibleArea, coordinates: this.coordinates, previousImageSize: i, imageSize: this.imageSize, angle: e, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), o = r.visibleArea, l = r.coordinates, s = this.processAutoZoom("rotateImage", o, l);
    o = s.visibleArea, l = s.coordinates, this.visibleArea = o, this.coordinates = l, this.onChange(), a && this.debouncedDisableTransitions();
  }
} }, emits: ["change", "error", "ready"] }, Ky = { key: 0, ref: "canvas", style: { display: "none" } }, Jy = { key: 1, ref: "sourceCanvas", style: { display: "none" } };
ym.render = function(e, t, n, a, i, r) {
  return y(), le("div", { ref: "cropper", class: r.classes.cropper }, [Pe("div", { ref: "stretcher", class: r.classes.stretcher }, null, 2), Pe("div", { class: r.classes.boundaries, style: r.boundariesStyle }, [(y(), le(li(n.backgroundWrapperComponent), { class: r.classes.cropperWrapper, "wheel-resize": r.settings.resizeImage.wheel, "touch-resize": r.settings.resizeImage.touch, "touch-move": r.settings.moveImage.touch, "mouse-move": r.settings.moveImage.mouse, onMove: r.onManipulateImage, onResize: r.onManipulateImage }, { default: De(function() {
    return [Pe("div", { class: r.classes.background, style: r.boundariesStyle }, null, 6), Pe("div", { class: r.classes.imageWrapper }, [Pe("img", { ref: "image", crossorigin: i.imageAttributes.crossOrigin, src: i.imageAttributes.src, class: r.classes.image, style: r.imageStyle, onMousedown: t[1] || (t[1] = ii(function() {
    }, ["prevent"])) }, null, 46, ["crossorigin", "src"])], 2), Pe("div", { class: r.classes.foreground, style: r.boundariesStyle }, null, 6), ai((y(), le(li(n.stencilComponent), Ft({ ref: "stencil", image: r.image, coordinates: i.coordinates, "stencil-coordinates": r.stencilCoordinates, transitions: r.transitionsOptions }, n.stencilProps, { onResize: r.onResize, onResizeEnd: r.onResizeEnd, onMove: r.onMove, onMoveEnd: r.onMoveEnd }), null, 16, ["image", "coordinates", "stencil-coordinates", "transitions", "onResize", "onResizeEnd", "onMove", "onMoveEnd"])), [[Sr, i.imageLoaded]]), n.canvas ? (y(), le("canvas", Ky, null, 512)) : F("", !0), n.canvas ? (y(), le("canvas", Jy, null, 512)) : F("", !0)];
  }), _: 1 }, 8, ["class", "wheel-resize", "touch-resize", "touch-move", "mouse-move", "onMove", "onResize"]))], 6)], 2);
};
const e0 = {
  components: {
    LayoutModal: Xf,
    ButtonCloseSm: ug,
    ButtonPrimaryLg: dg,
    ButtonSecondaryLg: cg
  },
  props: {
    // @deprecated - use showXButton instead
    closeButton: {
      type: Boolean,
      default: !0
    },
    modalData: {
      type: Object,
      default: () => ({})
    },
    modelValue: Boolean,
    showXButton: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "md"
    },
    vertical: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "cta", "cancel"],
  data() {
    return {
      isOpen: this.modelValue
    };
  },
  computed: {
    showTheXClose() {
      return !(!this.closeButton || !this.showXButton);
    }
  },
  watch: {
    modelValue(e) {
      this.isOpen = e;
    }
  }
}, t0 = { class: "w-full flex items-start space-x-2" }, n0 = { class: "w-full space-y-4" }, a0 = { class: "text-left flex-grow ct-text-1 text-lg font-semibold" }, i0 = { class: "text-left mt-1 ct-text-3 text-sm" }, r0 = ["innerHTML"];
function o0(e, t, n, a, i, r) {
  const o = _e("ButtonCloseSm"), l = _e("ButtonSecondaryLg"), s = _e("ButtonPrimaryLg"), u = _e("LayoutModal");
  return y(), le(u, {
    modelValue: i.isOpen,
    "onUpdate:modelValue": t[3] || (t[3] = (d) => i.isOpen = d),
    onClose: t[4] || (t[4] = (d) => e.$emit("update:modelValue", !1))
  }, {
    default: De(() => [
      ee("div", {
        class: Ne(["max-h-screen w-full border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col shadow-xl p-6 max-w-", `max-w-${n.size}`])
      }, [
        ee("div", t0, [
          ee("div", n0, [
            me(e.$slots, "icon"),
            ee("h2", a0, et(n.modalData.title), 1)
          ]),
          r.showTheXClose ? (y(), le(o, {
            key: 0,
            class: "flex-shrink-0",
            onClick: t[0] || (t[0] = (d) => i.isOpen = !1)
          })) : F("", !0)
        ]),
        ee("div", i0, [
          n.modalData.description ? (y(), O("p", {
            key: 0,
            innerHTML: n.modalData.description
          }, null, 8, r0)) : F("", !0),
          me(e.$slots, "default")
        ]),
        n.modalData.cancelLabel || n.modalData.ctaLabel ? (y(), O("div", {
          key: 0,
          class: Ne(["grid gap-3 mt-8", [n.modalData.cancelLabel && !n.vertical ? "grid-cols-2" : "grid-cols-1"]])
        }, [
          n.modalData.cancelLabel ? (y(), le(l, {
            key: 0,
            onClick: t[1] || (t[1] = (d) => e.$emit("cancel"))
          }, {
            default: De(() => [
              sa(et(n.modalData.cancelLabel), 1)
            ]),
            _: 1
          })) : F("", !0),
          n.modalData.ctaLabel ? (y(), le(s, {
            key: 1,
            loading: n.modalData.ctaLoading,
            onClick: t[2] || (t[2] = (d) => e.$emit("cta"))
          }, {
            default: De(() => [
              sa(et(n.modalData.ctaLabel), 1)
            ]),
            _: 1
          }, 8, ["loading"])) : F("", !0)
        ], 2)) : F("", !0)
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue"]);
}
const s0 = /* @__PURE__ */ an(e0, [["render", o0]]), l0 = {
  name: "FormFilesCropper",
  components: {
    ModalDefault: s0,
    Cropper: ym
  },
  props: {
    fileToCrop: {
      type: [File, null],
      required: !0
    },
    cropLabel: {
      type: String,
      default: "Crop image"
    },
    discardLabel: {
      type: String,
      default: "Cancel uploading"
    },
    config: {
      type: Object,
      default: () => ({
        minWidth: 300,
        minHeight: 300,
        maxWidth: 500,
        maxHeight: 500,
        ratio: 1,
        canResize: !0,
        canMove: !0,
        type: nl.rectangle
      })
    }
  },
  emits: ["cropped"],
  data() {
    return {
      showCropperModal: !1
    };
  },
  computed: {
    resolvedConfig() {
      return this.config || {};
    },
    fileName() {
      var e;
      return ((e = this.fileToCrop) == null ? void 0 : e.name) || "";
    },
    // computed <Cropper> props:
    src() {
      return this.fileToCrop ? URL.createObjectURL(this.fileToCrop) : "";
    },
    stencilProps() {
      const { ratio: e, canResize: t, canMove: n = !0, minWidth: a, maxWidth: i } = this.resolvedConfig;
      let r = t;
      t === void 0 && (a || i) && (r = a !== i);
      let o = e;
      if (typeof e == "string") {
        const [l = 1, s = 1] = e.split(":");
        o = Number(l) / Number(s);
      }
      return {
        aspectRatio: o,
        // minAspectRatio: ratio,
        // maxAspectRatio: ratio,
        moveable: n,
        resizable: r
      };
    },
    stencilSize() {
    },
    sizeRestrictionsAlgorithm() {
      const { maxHeight: e, minHeight: t, maxWidth: n, minWidth: a } = this.resolvedConfig;
      return ({ imageSize: i }) => ({
        minWidth: a,
        maxWidth: n || i.width,
        minHeight: t,
        maxHeight: e || i.height
      });
    },
    defaultBoundaries() {
      return "fill";
    },
    StencilComponent() {
      var e;
      return ((e = this.resolvedConfig) == null ? void 0 : e.type) === nl.circle ? gm : Fd;
    }
  },
  watch: {
    fileToCrop: {
      handler(e) {
        e === null && (this.showCropperModal = !1), e instanceof File && (this.showCropperModal = !0);
      },
      immediate: !0
    }
    // showCropperModal(value) {
    //     if (value) {
    //         this.$nextTick(() => {
    //             const stencil = this.$refs.cropper.$el.querySelector(".vue-rectangle-stencil");
    //             if (stencil) {
    //                 this.$refs.area.scrollTo(0, 300);
    //                 stencil.scrollIntoView();
    //             }
    //             console.log("this.$refs.area", this.$refs.area);
    //         });
    //     }
    // },
  },
  methods: {
    handleImgCropped() {
      const {
        /*coordinates,*/
        canvas: e
      } = this.$refs.cropper.getResult();
      e.toBlob((t) => {
        this.showCropperModal = !1, this.$emit("cropped", new File([t], this.fileName, { type: t.type }));
      });
    },
    discardImage() {
      this.showCropperModal = !1, this.$emit("cropped", null);
    }
  }
}, u0 = {
  ref: "area",
  style: { maxHeight: "65vh", overflow: "auto" }
};
function d0(e, t, n, a, i, r) {
  const o = _e("Cropper"), l = _e("ModalDefault");
  return i.showCropperModal ? (y(), le(l, {
    key: 0,
    modelValue: i.showCropperModal,
    "onUpdate:modelValue": t[0] || (t[0] = (s) => i.showCropperModal = s),
    size: "7xl",
    "close-button": !1,
    "modal-data": { ctaLabel: n.cropLabel, title: r.fileName, cancelLabel: n.discardLabel },
    onCta: r.handleImgCropped,
    onCancel: r.discardImage
  }, {
    default: De(() => [
      ee("div", u0, [
        Pe(o, {
          ref: "cropper",
          src: r.src,
          "stencil-props": r.stencilProps,
          "stencil-component": r.StencilComponent,
          "stencil-size": r.stencilSize,
          "size-restrictions-algorithm": r.sizeRestrictionsAlgorithm,
          "default-boundaries": r.defaultBoundaries
        }, null, 8, ["src", "stencil-props", "stencil-component", "stencil-size", "size-restrictions-algorithm", "default-boundaries"])
      ], 512)
    ]),
    _: 1
  }, 8, ["modelValue", "modal-data", "onCta", "onCancel"])) : F("", !0);
}
const c0 = /* @__PURE__ */ an(l0, [["render", d0]]);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var wm;
function ke() {
  return wm.apply(null, arguments);
}
function h0(e) {
  wm = e;
}
function ka(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function er(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function at(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function zd(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (at(e, t))
      return !1;
  return !0;
}
function On(e) {
  return e === void 0;
}
function ui(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function qo(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function bm(e, t) {
  var n = [], a, i = e.length;
  for (a = 0; a < i; ++a)
    n.push(t(e[a], a));
  return n;
}
function Si(e, t) {
  for (var n in t)
    at(t, n) && (e[n] = t[n]);
  return at(t, "toString") && (e.toString = t.toString), at(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function Ba(e, t, n, a) {
  return Bm(e, t, n, a, !0).utc();
}
function f0() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Ve(e) {
  return e._pf == null && (e._pf = f0()), e._pf;
}
var dd;
Array.prototype.some ? dd = Array.prototype.some : dd = function(e) {
  var t = Object(this), n = t.length >>> 0, a;
  for (a = 0; a < n; a++)
    if (a in t && e.call(this, t[a], a, t))
      return !0;
  return !1;
};
function Hd(e) {
  var t = null, n = !1, a = e._d && !isNaN(e._d.getTime());
  if (a && (t = Ve(e), n = dd.call(t.parsedDateParts, function(i) {
    return i != null;
  }), a = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n), e._strict && (a = a && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = a;
  else
    return a;
  return e._isValid;
}
function xl(e) {
  var t = Ba(NaN);
  return e != null ? Si(Ve(t), e) : Ve(t).userInvalidated = !0, t;
}
var Jh = ke.momentProperties = [], Du = !1;
function Wd(e, t) {
  var n, a, i, r = Jh.length;
  if (On(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), On(t._i) || (e._i = t._i), On(t._f) || (e._f = t._f), On(t._l) || (e._l = t._l), On(t._strict) || (e._strict = t._strict), On(t._tzm) || (e._tzm = t._tzm), On(t._isUTC) || (e._isUTC = t._isUTC), On(t._offset) || (e._offset = t._offset), On(t._pf) || (e._pf = Ve(t)), On(t._locale) || (e._locale = t._locale), r > 0)
    for (n = 0; n < r; n++)
      a = Jh[n], i = t[a], On(i) || (e[a] = i);
  return e;
}
function Xo(e) {
  Wd(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Du === !1 && (Du = !0, ke.updateOffset(this), Du = !1);
}
function xa(e) {
  return e instanceof Xo || e != null && e._isAMomentObject != null;
}
function _m(e) {
  ke.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function ua(e, t) {
  var n = !0;
  return Si(function() {
    if (ke.deprecationHandler != null && ke.deprecationHandler(null, e), n) {
      var a = [], i, r, o, l = arguments.length;
      for (r = 0; r < l; r++) {
        if (i = "", typeof arguments[r] == "object") {
          i += `
[` + r + "] ";
          for (o in arguments[0])
            at(arguments[0], o) && (i += o + ": " + arguments[0][o] + ", ");
          i = i.slice(0, -2);
        } else
          i = arguments[r];
        a.push(i);
      }
      _m(
        e + `
Arguments: ` + Array.prototype.slice.call(a).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var ef = {};
function km(e, t) {
  ke.deprecationHandler != null && ke.deprecationHandler(e, t), ef[e] || (_m(t), ef[e] = !0);
}
ke.suppressDeprecationWarnings = !1;
ke.deprecationHandler = null;
function Va(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function m0(e) {
  var t, n;
  for (n in e)
    at(e, n) && (t = e[n], Va(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function cd(e, t) {
  var n = Si({}, e), a;
  for (a in t)
    at(t, a) && (er(e[a]) && er(t[a]) ? (n[a] = {}, Si(n[a], e[a]), Si(n[a], t[a])) : t[a] != null ? n[a] = t[a] : delete n[a]);
  for (a in e)
    at(e, a) && !at(t, a) && er(e[a]) && (n[a] = Si({}, n[a]));
  return n;
}
function Bd(e) {
  e != null && this.set(e);
}
var hd;
Object.keys ? hd = Object.keys : hd = function(e) {
  var t, n = [];
  for (t in e)
    at(e, t) && n.push(t);
  return n;
};
var p0 = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function v0(e, t, n) {
  var a = this._calendar[e] || this._calendar.sameElse;
  return Va(a) ? a.call(t, n) : a;
}
function Ha(e, t, n) {
  var a = "" + Math.abs(e), i = t - a.length, r = e >= 0;
  return (r ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + a;
}
var Vd = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Ys = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Su = {}, Tr = {};
function Re(e, t, n, a) {
  var i = a;
  typeof a == "string" && (i = function() {
    return this[a]();
  }), e && (Tr[e] = i), t && (Tr[t[0]] = function() {
    return Ha(i.apply(this, arguments), t[1], t[2]);
  }), n && (Tr[n] = function() {
    return this.localeData().ordinal(
      i.apply(this, arguments),
      e
    );
  });
}
function g0(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function y0(e) {
  var t = e.match(Vd), n, a;
  for (n = 0, a = t.length; n < a; n++)
    Tr[t[n]] ? t[n] = Tr[t[n]] : t[n] = g0(t[n]);
  return function(i) {
    var r = "", o;
    for (o = 0; o < a; o++)
      r += Va(t[o]) ? t[o].call(i, e) : t[o];
    return r;
  };
}
function Us(e, t) {
  return e.isValid() ? (t = xm(t, e.localeData()), Su[t] = Su[t] || y0(t), Su[t](e)) : e.localeData().invalidDate();
}
function xm(e, t) {
  var n = 5;
  function a(i) {
    return t.longDateFormat(i) || i;
  }
  for (Ys.lastIndex = 0; n >= 0 && Ys.test(e); )
    e = e.replace(
      Ys,
      a
    ), Ys.lastIndex = 0, n -= 1;
  return e;
}
var w0 = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function b0(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(Vd).map(function(a) {
    return a === "MMMM" || a === "MM" || a === "DD" || a === "dddd" ? a.slice(1) : a;
  }).join(""), this._longDateFormat[e]);
}
var _0 = "Invalid date";
function k0() {
  return this._invalidDate;
}
var x0 = "%d", M0 = /\d{1,2}/;
function D0(e) {
  return this._ordinal.replace("%d", e);
}
var S0 = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function T0(e, t, n, a) {
  var i = this._relativeTime[n];
  return Va(i) ? i(e, t, n, a) : i.replace(/%d/i, e);
}
function A0(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return Va(n) ? n(t) : n.replace(/%s/i, t);
}
var tf = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function da(e) {
  return typeof e == "string" ? tf[e] || tf[e.toLowerCase()] : void 0;
}
function jd(e) {
  var t = {}, n, a;
  for (a in e)
    at(e, a) && (n = da(a), n && (t[n] = e[a]));
  return t;
}
var O0 = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function C0(e) {
  var t = [], n;
  for (n in e)
    at(e, n) && t.push({ unit: n, priority: O0[n] });
  return t.sort(function(a, i) {
    return a.priority - i.priority;
  }), t;
}
var Mm = /\d/, Gn = /\d\d/, Dm = /\d{3}/, Ud = /\d{4}/, Ml = /[+-]?\d{6}/, vt = /\d\d?/, Sm = /\d\d\d\d?/, Tm = /\d\d\d\d\d\d?/, Dl = /\d{1,3}/, Gd = /\d{1,4}/, Sl = /[+-]?\d{1,6}/, Gr = /\d+/, Tl = /[+-]?\d+/, E0 = /Z|[+-]\d\d:?\d\d/gi, Al = /Z|[+-]\d\d(?::?\d\d)?/gi, P0 = /[+-]?\d+(\.\d{1,3})?/, Zo = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, qr = /^[1-9]\d?/, qd = /^([1-9]\d|\d)/, al;
al = {};
function Ae(e, t, n) {
  al[e] = Va(t) ? t : function(a, i) {
    return a && n ? n : t;
  };
}
function R0(e, t) {
  return at(al, e) ? al[e](t._strict, t._locale) : new RegExp(I0(e));
}
function I0(e) {
  return ri(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, a, i, r) {
        return n || a || i || r;
      }
    )
  );
}
function ri(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function na(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function qe(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = na(t)), n;
}
var fd = {};
function dt(e, t) {
  var n, a = t, i;
  for (typeof e == "string" && (e = [e]), ui(t) && (a = function(r, o) {
    o[t] = qe(r);
  }), i = e.length, n = 0; n < i; n++)
    fd[e[n]] = a;
}
function Qo(e, t) {
  dt(e, function(n, a, i, r) {
    i._w = i._w || {}, t(n, i._w, i, r);
  });
}
function Y0(e, t, n) {
  t != null && at(fd, e) && fd[e](t, n._a, n, e);
}
function Ol(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var yn = 0, ei = 1, Ra = 2, Qt = 3, ba = 4, ti = 5, Ki = 6, N0 = 7, $0 = 8;
Re("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Ha(e, 4) : "+" + e;
});
Re(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Re(0, ["YYYY", 4], 0, "year");
Re(0, ["YYYYY", 5], 0, "year");
Re(0, ["YYYYYY", 6, !0], 0, "year");
Ae("Y", Tl);
Ae("YY", vt, Gn);
Ae("YYYY", Gd, Ud);
Ae("YYYYY", Sl, Ml);
Ae("YYYYYY", Sl, Ml);
dt(["YYYYY", "YYYYYY"], yn);
dt("YYYY", function(e, t) {
  t[yn] = e.length === 2 ? ke.parseTwoDigitYear(e) : qe(e);
});
dt("YY", function(e, t) {
  t[yn] = ke.parseTwoDigitYear(e);
});
dt("Y", function(e, t) {
  t[yn] = parseInt(e, 10);
});
function Oo(e) {
  return Ol(e) ? 366 : 365;
}
ke.parseTwoDigitYear = function(e) {
  return qe(e) + (qe(e) > 68 ? 1900 : 2e3);
};
var Am = Xr("FullYear", !0);
function L0() {
  return Ol(this.year());
}
function Xr(e, t) {
  return function(n) {
    return n != null ? (Om(this, e, n), ke.updateOffset(this, t), this) : zo(this, e);
  };
}
function zo(e, t) {
  if (!e.isValid())
    return NaN;
  var n = e._d, a = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return a ? n.getUTCMilliseconds() : n.getMilliseconds();
    case "Seconds":
      return a ? n.getUTCSeconds() : n.getSeconds();
    case "Minutes":
      return a ? n.getUTCMinutes() : n.getMinutes();
    case "Hours":
      return a ? n.getUTCHours() : n.getHours();
    case "Date":
      return a ? n.getUTCDate() : n.getDate();
    case "Day":
      return a ? n.getUTCDay() : n.getDay();
    case "Month":
      return a ? n.getUTCMonth() : n.getMonth();
    case "FullYear":
      return a ? n.getUTCFullYear() : n.getFullYear();
    default:
      return NaN;
  }
}
function Om(e, t, n) {
  var a, i, r, o, l;
  if (!(!e.isValid() || isNaN(n))) {
    switch (a = e._d, i = e._isUTC, t) {
      case "Milliseconds":
        return void (i ? a.setUTCMilliseconds(n) : a.setMilliseconds(n));
      case "Seconds":
        return void (i ? a.setUTCSeconds(n) : a.setSeconds(n));
      case "Minutes":
        return void (i ? a.setUTCMinutes(n) : a.setMinutes(n));
      case "Hours":
        return void (i ? a.setUTCHours(n) : a.setHours(n));
      case "Date":
        return void (i ? a.setUTCDate(n) : a.setDate(n));
      case "FullYear":
        break;
      default:
        return;
    }
    r = n, o = e.month(), l = e.date(), l = l === 29 && o === 1 && !Ol(r) ? 28 : l, i ? a.setUTCFullYear(r, o, l) : a.setFullYear(r, o, l);
  }
}
function F0(e) {
  return e = da(e), Va(this[e]) ? this[e]() : this;
}
function z0(e, t) {
  if (typeof e == "object") {
    e = jd(e);
    var n = C0(e), a, i = n.length;
    for (a = 0; a < i; a++)
      this[n[a].unit](e[n[a].unit]);
  } else if (e = da(e), Va(this[e]))
    return this[e](t);
  return this;
}
function H0(e, t) {
  return (e % t + t) % t;
}
var Nt;
Array.prototype.indexOf ? Nt = Array.prototype.indexOf : Nt = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Xd(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = H0(t, 12);
  return e += (t - n) / 12, n === 1 ? Ol(e) ? 29 : 28 : 31 - n % 7 % 2;
}
Re("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Re("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Re("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
Ae("M", vt, qr);
Ae("MM", vt, Gn);
Ae("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
Ae("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
dt(["M", "MM"], function(e, t) {
  t[ei] = qe(e) - 1;
});
dt(["MMM", "MMMM"], function(e, t, n, a) {
  var i = n._locale.monthsParse(e, a, n._strict);
  i != null ? t[ei] = i : Ve(n).invalidMonth = e;
});
var W0 = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Cm = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Em = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, B0 = Zo, V0 = Zo;
function j0(e, t) {
  return e ? ka(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Em).test(t) ? "format" : "standalone"][e.month()] : ka(this._months) ? this._months : this._months.standalone;
}
function U0(e, t) {
  return e ? ka(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Em.test(t) ? "format" : "standalone"][e.month()] : ka(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function G0(e, t, n) {
  var a, i, r, o = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], a = 0; a < 12; ++a)
      r = Ba([2e3, a]), this._shortMonthsParse[a] = this.monthsShort(
        r,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[a] = this.months(r, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (i = Nt.call(this._shortMonthsParse, o), i !== -1 ? i : null) : (i = Nt.call(this._longMonthsParse, o), i !== -1 ? i : null) : t === "MMM" ? (i = Nt.call(this._shortMonthsParse, o), i !== -1 ? i : (i = Nt.call(this._longMonthsParse, o), i !== -1 ? i : null)) : (i = Nt.call(this._longMonthsParse, o), i !== -1 ? i : (i = Nt.call(this._shortMonthsParse, o), i !== -1 ? i : null));
}
function q0(e, t, n) {
  var a, i, r;
  if (this._monthsParseExact)
    return G0.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), a = 0; a < 12; a++) {
    if (i = Ba([2e3, a]), n && !this._longMonthsParse[a] && (this._longMonthsParse[a] = new RegExp(
      "^" + this.months(i, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[a] = new RegExp(
      "^" + this.monthsShort(i, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[a] && (r = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[a] = new RegExp(r.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[a].test(e))
      return a;
    if (n && t === "MMM" && this._shortMonthsParse[a].test(e))
      return a;
    if (!n && this._monthsParse[a].test(e))
      return a;
  }
}
function Pm(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = qe(t);
    else if (t = e.localeData().monthsParse(t), !ui(t))
      return e;
  }
  var n = t, a = e.date();
  return a = a < 29 ? a : Math.min(a, Xd(e.year(), n)), e._isUTC ? e._d.setUTCMonth(n, a) : e._d.setMonth(n, a), e;
}
function Rm(e) {
  return e != null ? (Pm(this, e), ke.updateOffset(this, !0), this) : zo(this, "Month");
}
function X0() {
  return Xd(this.year(), this.month());
}
function Z0(e) {
  return this._monthsParseExact ? (at(this, "_monthsRegex") || Im.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (at(this, "_monthsShortRegex") || (this._monthsShortRegex = B0), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Q0(e) {
  return this._monthsParseExact ? (at(this, "_monthsRegex") || Im.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (at(this, "_monthsRegex") || (this._monthsRegex = V0), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Im() {
  function e(s, u) {
    return u.length - s.length;
  }
  var t = [], n = [], a = [], i, r, o, l;
  for (i = 0; i < 12; i++)
    r = Ba([2e3, i]), o = ri(this.monthsShort(r, "")), l = ri(this.months(r, "")), t.push(o), n.push(l), a.push(l), a.push(o);
  t.sort(e), n.sort(e), a.sort(e), this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function K0(e, t, n, a, i, r, o) {
  var l;
  return e < 100 && e >= 0 ? (l = new Date(e + 400, t, n, a, i, r, o), isFinite(l.getFullYear()) && l.setFullYear(e)) : l = new Date(e, t, n, a, i, r, o), l;
}
function Ho(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function il(e, t, n) {
  var a = 7 + t - n, i = (7 + Ho(e, 0, a).getUTCDay() - t) % 7;
  return -i + a - 1;
}
function Ym(e, t, n, a, i) {
  var r = (7 + n - a) % 7, o = il(e, a, i), l = 1 + 7 * (t - 1) + r + o, s, u;
  return l <= 0 ? (s = e - 1, u = Oo(s) + l) : l > Oo(e) ? (s = e + 1, u = l - Oo(e)) : (s = e, u = l), {
    year: s,
    dayOfYear: u
  };
}
function Wo(e, t, n) {
  var a = il(e.year(), t, n), i = Math.floor((e.dayOfYear() - a - 1) / 7) + 1, r, o;
  return i < 1 ? (o = e.year() - 1, r = i + oi(o, t, n)) : i > oi(e.year(), t, n) ? (r = i - oi(e.year(), t, n), o = e.year() + 1) : (o = e.year(), r = i), {
    week: r,
    year: o
  };
}
function oi(e, t, n) {
  var a = il(e, t, n), i = il(e + 1, t, n);
  return (Oo(e) - a + i) / 7;
}
Re("w", ["ww", 2], "wo", "week");
Re("W", ["WW", 2], "Wo", "isoWeek");
Ae("w", vt, qr);
Ae("ww", vt, Gn);
Ae("W", vt, qr);
Ae("WW", vt, Gn);
Qo(
  ["w", "ww", "W", "WW"],
  function(e, t, n, a) {
    t[a.substr(0, 1)] = qe(e);
  }
);
function J0(e) {
  return Wo(e, this._week.dow, this._week.doy).week;
}
var ew = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function tw() {
  return this._week.dow;
}
function nw() {
  return this._week.doy;
}
function aw(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function iw(e) {
  var t = Wo(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
Re("d", 0, "do", "day");
Re("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Re("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Re("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Re("e", 0, 0, "weekday");
Re("E", 0, 0, "isoWeekday");
Ae("d", vt);
Ae("e", vt);
Ae("E", vt);
Ae("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
Ae("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
Ae("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Qo(["dd", "ddd", "dddd"], function(e, t, n, a) {
  var i = n._locale.weekdaysParse(e, a, n._strict);
  i != null ? t.d = i : Ve(n).invalidWeekday = e;
});
Qo(["d", "e", "E"], function(e, t, n, a) {
  t[a] = qe(e);
});
function rw(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function ow(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Zd(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var sw = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Nm = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), lw = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), uw = Zo, dw = Zo, cw = Zo;
function hw(e, t) {
  var n = ka(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? Zd(n, this._week.dow) : e ? n[e.day()] : n;
}
function fw(e) {
  return e === !0 ? Zd(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function mw(e) {
  return e === !0 ? Zd(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function pw(e, t, n) {
  var a, i, r, o = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], a = 0; a < 7; ++a)
      r = Ba([2e3, 1]).day(a), this._minWeekdaysParse[a] = this.weekdaysMin(
        r,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[a] = this.weekdaysShort(
        r,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[a] = this.weekdays(r, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (i = Nt.call(this._weekdaysParse, o), i !== -1 ? i : null) : t === "ddd" ? (i = Nt.call(this._shortWeekdaysParse, o), i !== -1 ? i : null) : (i = Nt.call(this._minWeekdaysParse, o), i !== -1 ? i : null) : t === "dddd" ? (i = Nt.call(this._weekdaysParse, o), i !== -1 || (i = Nt.call(this._shortWeekdaysParse, o), i !== -1) ? i : (i = Nt.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : t === "ddd" ? (i = Nt.call(this._shortWeekdaysParse, o), i !== -1 || (i = Nt.call(this._weekdaysParse, o), i !== -1) ? i : (i = Nt.call(this._minWeekdaysParse, o), i !== -1 ? i : null)) : (i = Nt.call(this._minWeekdaysParse, o), i !== -1 || (i = Nt.call(this._weekdaysParse, o), i !== -1) ? i : (i = Nt.call(this._shortWeekdaysParse, o), i !== -1 ? i : null));
}
function vw(e, t, n) {
  var a, i, r;
  if (this._weekdaysParseExact)
    return pw.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), a = 0; a < 7; a++) {
    if (i = Ba([2e3, 1]).day(a), n && !this._fullWeekdaysParse[a] && (this._fullWeekdaysParse[a] = new RegExp(
      "^" + this.weekdays(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[a] = new RegExp(
      "^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[a] = new RegExp(
      "^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[a] || (r = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[a] = new RegExp(r.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[a].test(e))
      return a;
    if (n && t === "ddd" && this._shortWeekdaysParse[a].test(e))
      return a;
    if (n && t === "dd" && this._minWeekdaysParse[a].test(e))
      return a;
    if (!n && this._weekdaysParse[a].test(e))
      return a;
  }
}
function gw(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = zo(this, "Day");
  return e != null ? (e = rw(e, this.localeData()), this.add(e - t, "d")) : t;
}
function yw(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function ww(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = ow(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function bw(e) {
  return this._weekdaysParseExact ? (at(this, "_weekdaysRegex") || Qd.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (at(this, "_weekdaysRegex") || (this._weekdaysRegex = uw), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function _w(e) {
  return this._weekdaysParseExact ? (at(this, "_weekdaysRegex") || Qd.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (at(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = dw), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function kw(e) {
  return this._weekdaysParseExact ? (at(this, "_weekdaysRegex") || Qd.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (at(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = cw), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Qd() {
  function e(d, c) {
    return c.length - d.length;
  }
  var t = [], n = [], a = [], i = [], r, o, l, s, u;
  for (r = 0; r < 7; r++)
    o = Ba([2e3, 1]).day(r), l = ri(this.weekdaysMin(o, "")), s = ri(this.weekdaysShort(o, "")), u = ri(this.weekdays(o, "")), t.push(l), n.push(s), a.push(u), i.push(l), i.push(s), i.push(u);
  t.sort(e), n.sort(e), a.sort(e), i.sort(e), this._weekdaysRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Kd() {
  return this.hours() % 12 || 12;
}
function xw() {
  return this.hours() || 24;
}
Re("H", ["HH", 2], 0, "hour");
Re("h", ["hh", 2], 0, Kd);
Re("k", ["kk", 2], 0, xw);
Re("hmm", 0, 0, function() {
  return "" + Kd.apply(this) + Ha(this.minutes(), 2);
});
Re("hmmss", 0, 0, function() {
  return "" + Kd.apply(this) + Ha(this.minutes(), 2) + Ha(this.seconds(), 2);
});
Re("Hmm", 0, 0, function() {
  return "" + this.hours() + Ha(this.minutes(), 2);
});
Re("Hmmss", 0, 0, function() {
  return "" + this.hours() + Ha(this.minutes(), 2) + Ha(this.seconds(), 2);
});
function $m(e, t) {
  Re(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
$m("a", !0);
$m("A", !1);
function Lm(e, t) {
  return t._meridiemParse;
}
Ae("a", Lm);
Ae("A", Lm);
Ae("H", vt, qd);
Ae("h", vt, qr);
Ae("k", vt, qr);
Ae("HH", vt, Gn);
Ae("hh", vt, Gn);
Ae("kk", vt, Gn);
Ae("hmm", Sm);
Ae("hmmss", Tm);
Ae("Hmm", Sm);
Ae("Hmmss", Tm);
dt(["H", "HH"], Qt);
dt(["k", "kk"], function(e, t, n) {
  var a = qe(e);
  t[Qt] = a === 24 ? 0 : a;
});
dt(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
dt(["h", "hh"], function(e, t, n) {
  t[Qt] = qe(e), Ve(n).bigHour = !0;
});
dt("hmm", function(e, t, n) {
  var a = e.length - 2;
  t[Qt] = qe(e.substr(0, a)), t[ba] = qe(e.substr(a)), Ve(n).bigHour = !0;
});
dt("hmmss", function(e, t, n) {
  var a = e.length - 4, i = e.length - 2;
  t[Qt] = qe(e.substr(0, a)), t[ba] = qe(e.substr(a, 2)), t[ti] = qe(e.substr(i)), Ve(n).bigHour = !0;
});
dt("Hmm", function(e, t, n) {
  var a = e.length - 2;
  t[Qt] = qe(e.substr(0, a)), t[ba] = qe(e.substr(a));
});
dt("Hmmss", function(e, t, n) {
  var a = e.length - 4, i = e.length - 2;
  t[Qt] = qe(e.substr(0, a)), t[ba] = qe(e.substr(a, 2)), t[ti] = qe(e.substr(i));
});
function Mw(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Dw = /[ap]\.?m?\.?/i, Sw = Xr("Hours", !0);
function Tw(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var Fm = {
  calendar: p0,
  longDateFormat: w0,
  invalidDate: _0,
  ordinal: x0,
  dayOfMonthOrdinalParse: M0,
  relativeTime: S0,
  months: W0,
  monthsShort: Cm,
  week: ew,
  weekdays: sw,
  weekdaysMin: lw,
  weekdaysShort: Nm,
  meridiemParse: Dw
}, bt = {}, go = {}, Bo;
function Aw(e, t) {
  var n, a = Math.min(e.length, t.length);
  for (n = 0; n < a; n += 1)
    if (e[n] !== t[n])
      return n;
  return a;
}
function nf(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Ow(e) {
  for (var t = 0, n, a, i, r; t < e.length; ) {
    for (r = nf(e[t]).split("-"), n = r.length, a = nf(e[t + 1]), a = a ? a.split("-") : null; n > 0; ) {
      if (i = Cl(r.slice(0, n).join("-")), i)
        return i;
      if (a && a.length >= n && Aw(r, a) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return Bo;
}
function Cw(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function Cl(e) {
  var t = null, n;
  if (bt[e] === void 0 && typeof module < "u" && module && module.exports && Cw(e))
    try {
      t = Bo._abbr, n = require, n("./locale/" + e), Ci(t);
    } catch {
      bt[e] = null;
    }
  return bt[e];
}
function Ci(e, t) {
  var n;
  return e && (On(t) ? n = hi(e) : n = Jd(e, t), n ? Bo = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Bo._abbr;
}
function Jd(e, t) {
  if (t !== null) {
    var n, a = Fm;
    if (t.abbr = e, bt[e] != null)
      km(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), a = bt[e]._config;
    else if (t.parentLocale != null)
      if (bt[t.parentLocale] != null)
        a = bt[t.parentLocale]._config;
      else if (n = Cl(t.parentLocale), n != null)
        a = n._config;
      else
        return go[t.parentLocale] || (go[t.parentLocale] = []), go[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return bt[e] = new Bd(cd(a, t)), go[e] && go[e].forEach(function(i) {
      Jd(i.name, i.config);
    }), Ci(e), bt[e];
  } else
    return delete bt[e], null;
}
function Ew(e, t) {
  if (t != null) {
    var n, a, i = Fm;
    bt[e] != null && bt[e].parentLocale != null ? bt[e].set(cd(bt[e]._config, t)) : (a = Cl(e), a != null && (i = a._config), t = cd(i, t), a == null && (t.abbr = e), n = new Bd(t), n.parentLocale = bt[e], bt[e] = n), Ci(e);
  } else
    bt[e] != null && (bt[e].parentLocale != null ? (bt[e] = bt[e].parentLocale, e === Ci() && Ci(e)) : bt[e] != null && delete bt[e]);
  return bt[e];
}
function hi(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Bo;
  if (!ka(e)) {
    if (t = Cl(e), t)
      return t;
    e = [e];
  }
  return Ow(e);
}
function Pw() {
  return hd(bt);
}
function ec(e) {
  var t, n = e._a;
  return n && Ve(e).overflow === -2 && (t = n[ei] < 0 || n[ei] > 11 ? ei : n[Ra] < 1 || n[Ra] > Xd(n[yn], n[ei]) ? Ra : n[Qt] < 0 || n[Qt] > 24 || n[Qt] === 24 && (n[ba] !== 0 || n[ti] !== 0 || n[Ki] !== 0) ? Qt : n[ba] < 0 || n[ba] > 59 ? ba : n[ti] < 0 || n[ti] > 59 ? ti : n[Ki] < 0 || n[Ki] > 999 ? Ki : -1, Ve(e)._overflowDayOfYear && (t < yn || t > Ra) && (t = Ra), Ve(e)._overflowWeeks && t === -1 && (t = N0), Ve(e)._overflowWeekday && t === -1 && (t = $0), Ve(e).overflow = t), e;
}
var Rw = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Iw = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Yw = /Z|[+-]\d\d(?::?\d\d)?/, Ns = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Tu = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Nw = /^\/?Date\((-?\d+)/i, $w = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Lw = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function zm(e) {
  var t, n, a = e._i, i = Rw.exec(a) || Iw.exec(a), r, o, l, s, u = Ns.length, d = Tu.length;
  if (i) {
    for (Ve(e).iso = !0, t = 0, n = u; t < n; t++)
      if (Ns[t][1].exec(i[1])) {
        o = Ns[t][0], r = Ns[t][2] !== !1;
        break;
      }
    if (o == null) {
      e._isValid = !1;
      return;
    }
    if (i[3]) {
      for (t = 0, n = d; t < n; t++)
        if (Tu[t][1].exec(i[3])) {
          l = (i[2] || " ") + Tu[t][0];
          break;
        }
      if (l == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!r && l != null) {
      e._isValid = !1;
      return;
    }
    if (i[4])
      if (Yw.exec(i[4]))
        s = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = o + (l || "") + (s || ""), nc(e);
  } else
    e._isValid = !1;
}
function Fw(e, t, n, a, i, r) {
  var o = [
    zw(e),
    Cm.indexOf(t),
    parseInt(n, 10),
    parseInt(a, 10),
    parseInt(i, 10)
  ];
  return r && o.push(parseInt(r, 10)), o;
}
function zw(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function Hw(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Ww(e, t, n) {
  if (e) {
    var a = Nm.indexOf(e), i = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (a !== i)
      return Ve(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function Bw(e, t, n) {
  if (e)
    return Lw[e];
  if (t)
    return 0;
  var a = parseInt(n, 10), i = a % 100, r = (a - i) / 100;
  return r * 60 + i;
}
function Hm(e) {
  var t = $w.exec(Hw(e._i)), n;
  if (t) {
    if (n = Fw(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !Ww(t[1], n, e))
      return;
    e._a = n, e._tzm = Bw(t[8], t[9], t[10]), e._d = Ho.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Ve(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Vw(e) {
  var t = Nw.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (zm(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Hm(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : ke.createFromInputFallback(e);
}
ke.createFromInputFallback = ua(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function br(e, t, n) {
  return e ?? t ?? n;
}
function jw(e) {
  var t = new Date(ke.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function tc(e) {
  var t, n, a = [], i, r, o;
  if (!e._d) {
    for (i = jw(e), e._w && e._a[Ra] == null && e._a[ei] == null && Uw(e), e._dayOfYear != null && (o = br(e._a[yn], i[yn]), (e._dayOfYear > Oo(o) || e._dayOfYear === 0) && (Ve(e)._overflowDayOfYear = !0), n = Ho(o, 0, e._dayOfYear), e._a[ei] = n.getUTCMonth(), e._a[Ra] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = a[t] = i[t];
    for (; t < 7; t++)
      e._a[t] = a[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Qt] === 24 && e._a[ba] === 0 && e._a[ti] === 0 && e._a[Ki] === 0 && (e._nextDay = !0, e._a[Qt] = 0), e._d = (e._useUTC ? Ho : K0).apply(
      null,
      a
    ), r = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Qt] = 24), e._w && typeof e._w.d < "u" && e._w.d !== r && (Ve(e).weekdayMismatch = !0);
  }
}
function Uw(e) {
  var t, n, a, i, r, o, l, s, u;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (r = 1, o = 4, n = br(
    t.GG,
    e._a[yn],
    Wo(pt(), 1, 4).year
  ), a = br(t.W, 1), i = br(t.E, 1), (i < 1 || i > 7) && (s = !0)) : (r = e._locale._week.dow, o = e._locale._week.doy, u = Wo(pt(), r, o), n = br(t.gg, e._a[yn], u.year), a = br(t.w, u.week), t.d != null ? (i = t.d, (i < 0 || i > 6) && (s = !0)) : t.e != null ? (i = t.e + r, (t.e < 0 || t.e > 6) && (s = !0)) : i = r), a < 1 || a > oi(n, r, o) ? Ve(e)._overflowWeeks = !0 : s != null ? Ve(e)._overflowWeekday = !0 : (l = Ym(n, a, i, r, o), e._a[yn] = l.year, e._dayOfYear = l.dayOfYear);
}
ke.ISO_8601 = function() {
};
ke.RFC_2822 = function() {
};
function nc(e) {
  if (e._f === ke.ISO_8601) {
    zm(e);
    return;
  }
  if (e._f === ke.RFC_2822) {
    Hm(e);
    return;
  }
  e._a = [], Ve(e).empty = !0;
  var t = "" + e._i, n, a, i, r, o, l = t.length, s = 0, u, d;
  for (i = xm(e._f, e._locale).match(Vd) || [], d = i.length, n = 0; n < d; n++)
    r = i[n], a = (t.match(R0(r, e)) || [])[0], a && (o = t.substr(0, t.indexOf(a)), o.length > 0 && Ve(e).unusedInput.push(o), t = t.slice(
      t.indexOf(a) + a.length
    ), s += a.length), Tr[r] ? (a ? Ve(e).empty = !1 : Ve(e).unusedTokens.push(r), Y0(r, a, e)) : e._strict && !a && Ve(e).unusedTokens.push(r);
  Ve(e).charsLeftOver = l - s, t.length > 0 && Ve(e).unusedInput.push(t), e._a[Qt] <= 12 && Ve(e).bigHour === !0 && e._a[Qt] > 0 && (Ve(e).bigHour = void 0), Ve(e).parsedDateParts = e._a.slice(0), Ve(e).meridiem = e._meridiem, e._a[Qt] = Gw(
    e._locale,
    e._a[Qt],
    e._meridiem
  ), u = Ve(e).era, u !== null && (e._a[yn] = e._locale.erasConvertYear(u, e._a[yn])), tc(e), ec(e);
}
function Gw(e, t, n) {
  var a;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (a = e.isPM(n), a && t < 12 && (t += 12), !a && t === 12 && (t = 0)), t);
}
function qw(e) {
  var t, n, a, i, r, o, l = !1, s = e._f.length;
  if (s === 0) {
    Ve(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < s; i++)
    r = 0, o = !1, t = Wd({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[i], nc(t), Hd(t) && (o = !0), r += Ve(t).charsLeftOver, r += Ve(t).unusedTokens.length * 10, Ve(t).score = r, l ? r < a && (a = r, n = t) : (a == null || r < a || o) && (a = r, n = t, o && (l = !0));
  Si(e, n || t);
}
function Xw(e) {
  if (!e._d) {
    var t = jd(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = bm(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(a) {
        return a && parseInt(a, 10);
      }
    ), tc(e);
  }
}
function Zw(e) {
  var t = new Xo(ec(Wm(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function Wm(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || hi(e._l), t === null || n === void 0 && t === "" ? xl({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), xa(t) ? new Xo(ec(t)) : (qo(t) ? e._d = t : ka(n) ? qw(e) : n ? nc(e) : Qw(e), Hd(e) || (e._d = null), e));
}
function Qw(e) {
  var t = e._i;
  On(t) ? e._d = new Date(ke.now()) : qo(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Vw(e) : ka(t) ? (e._a = bm(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), tc(e)) : er(t) ? Xw(e) : ui(t) ? e._d = new Date(t) : ke.createFromInputFallback(e);
}
function Bm(e, t, n, a, i) {
  var r = {};
  return (t === !0 || t === !1) && (a = t, t = void 0), (n === !0 || n === !1) && (a = n, n = void 0), (er(e) && zd(e) || ka(e) && e.length === 0) && (e = void 0), r._isAMomentObject = !0, r._useUTC = r._isUTC = i, r._l = n, r._i = e, r._f = t, r._strict = a, Zw(r);
}
function pt(e, t, n, a) {
  return Bm(e, t, n, a, !1);
}
var Kw = ua(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = pt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : xl();
  }
), Jw = ua(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = pt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : xl();
  }
);
function Vm(e, t) {
  var n, a;
  if (t.length === 1 && ka(t[0]) && (t = t[0]), !t.length)
    return pt();
  for (n = t[0], a = 1; a < t.length; ++a)
    (!t[a].isValid() || t[a][e](n)) && (n = t[a]);
  return n;
}
function eb() {
  var e = [].slice.call(arguments, 0);
  return Vm("isBefore", e);
}
function tb() {
  var e = [].slice.call(arguments, 0);
  return Vm("isAfter", e);
}
var nb = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, yo = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function ab(e) {
  var t, n = !1, a, i = yo.length;
  for (t in e)
    if (at(e, t) && !(Nt.call(yo, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (a = 0; a < i; ++a)
    if (e[yo[a]]) {
      if (n)
        return !1;
      parseFloat(e[yo[a]]) !== qe(e[yo[a]]) && (n = !0);
    }
  return !0;
}
function ib() {
  return this._isValid;
}
function rb() {
  return Da(NaN);
}
function El(e) {
  var t = jd(e), n = t.year || 0, a = t.quarter || 0, i = t.month || 0, r = t.week || t.isoWeek || 0, o = t.day || 0, l = t.hour || 0, s = t.minute || 0, u = t.second || 0, d = t.millisecond || 0;
  this._isValid = ab(t), this._milliseconds = +d + u * 1e3 + // 1000
  s * 6e4 + // 1000 * 60
  l * 1e3 * 60 * 60, this._days = +o + r * 7, this._months = +i + a * 3 + n * 12, this._data = {}, this._locale = hi(), this._bubble();
}
function Gs(e) {
  return e instanceof El;
}
function md(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function ob(e, t, n) {
  var a = Math.min(e.length, t.length), i = Math.abs(e.length - t.length), r = 0, o;
  for (o = 0; o < a; o++)
    (n && e[o] !== t[o] || !n && qe(e[o]) !== qe(t[o])) && r++;
  return r + i;
}
function jm(e, t) {
  Re(e, 0, 0, function() {
    var n = this.utcOffset(), a = "+";
    return n < 0 && (n = -n, a = "-"), a + Ha(~~(n / 60), 2) + t + Ha(~~n % 60, 2);
  });
}
jm("Z", ":");
jm("ZZ", "");
Ae("Z", Al);
Ae("ZZ", Al);
dt(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = ac(Al, e);
});
var sb = /([\+\-]|\d\d)/gi;
function ac(e, t) {
  var n = (t || "").match(e), a, i, r;
  return n === null ? null : (a = n[n.length - 1] || [], i = (a + "").match(sb) || ["-", 0, 0], r = +(i[1] * 60) + qe(i[2]), r === 0 ? 0 : i[0] === "+" ? r : -r);
}
function ic(e, t) {
  var n, a;
  return t._isUTC ? (n = t.clone(), a = (xa(e) || qo(e) ? e.valueOf() : pt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + a), ke.updateOffset(n, !1), n) : pt(e).local();
}
function pd(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
ke.updateOffset = function() {
};
function lb(e, t, n) {
  var a = this._offset || 0, i;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = ac(Al, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (i = pd(this)), this._offset = e, this._isUTC = !0, i != null && this.add(i, "m"), a !== e && (!t || this._changeInProgress ? qm(
      this,
      Da(e - a, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, ke.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? a : pd(this);
}
function ub(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function db(e) {
  return this.utcOffset(0, e);
}
function cb(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(pd(this), "m")), this;
}
function hb() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = ac(E0, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function fb(e) {
  return this.isValid() ? (e = e ? pt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function mb() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function pb() {
  if (!On(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return Wd(e, this), e = Wm(e), e._a ? (t = e._isUTC ? Ba(e._a) : pt(e._a), this._isDSTShifted = this.isValid() && ob(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function vb() {
  return this.isValid() ? !this._isUTC : !1;
}
function gb() {
  return this.isValid() ? this._isUTC : !1;
}
function Um() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var yb = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, wb = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Da(e, t) {
  var n = e, a = null, i, r, o;
  return Gs(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : ui(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (a = yb.exec(e)) ? (i = a[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: qe(a[Ra]) * i,
    h: qe(a[Qt]) * i,
    m: qe(a[ba]) * i,
    s: qe(a[ti]) * i,
    ms: qe(md(a[Ki] * 1e3)) * i
    // the millisecond decimal point is included in the match
  }) : (a = wb.exec(e)) ? (i = a[1] === "-" ? -1 : 1, n = {
    y: Ui(a[2], i),
    M: Ui(a[3], i),
    w: Ui(a[4], i),
    d: Ui(a[5], i),
    h: Ui(a[6], i),
    m: Ui(a[7], i),
    s: Ui(a[8], i)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (o = bb(
    pt(n.from),
    pt(n.to)
  ), n = {}, n.ms = o.milliseconds, n.M = o.months), r = new El(n), Gs(e) && at(e, "_locale") && (r._locale = e._locale), Gs(e) && at(e, "_isValid") && (r._isValid = e._isValid), r;
}
Da.fn = El.prototype;
Da.invalid = rb;
function Ui(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function af(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function bb(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = ic(t, e), e.isBefore(t) ? n = af(e, t) : (n = af(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function Gm(e, t) {
  return function(n, a) {
    var i, r;
    return a !== null && !isNaN(+a) && (km(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), r = n, n = a, a = r), i = Da(n, a), qm(this, i, e), this;
  };
}
function qm(e, t, n, a) {
  var i = t._milliseconds, r = md(t._days), o = md(t._months);
  e.isValid() && (a = a ?? !0, o && Pm(e, zo(e, "Month") + o * n), r && Om(e, "Date", zo(e, "Date") + r * n), i && e._d.setTime(e._d.valueOf() + i * n), a && ke.updateOffset(e, r || o));
}
var _b = Gm(1, "add"), kb = Gm(-1, "subtract");
function Xm(e) {
  return typeof e == "string" || e instanceof String;
}
function xb(e) {
  return xa(e) || qo(e) || Xm(e) || ui(e) || Db(e) || Mb(e) || e === null || e === void 0;
}
function Mb(e) {
  var t = er(e) && !zd(e), n = !1, a = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, r, o = a.length;
  for (i = 0; i < o; i += 1)
    r = a[i], n = n || at(e, r);
  return t && n;
}
function Db(e) {
  var t = ka(e), n = !1;
  return t && (n = e.filter(function(a) {
    return !ui(a) && Xm(e);
  }).length === 0), t && n;
}
function Sb(e) {
  var t = er(e) && !zd(e), n = !1, a = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, r;
  for (i = 0; i < a.length; i += 1)
    r = a[i], n = n || at(e, r);
  return t && n;
}
function Tb(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function Ab(e, t) {
  arguments.length === 1 && (arguments[0] ? xb(arguments[0]) ? (e = arguments[0], t = void 0) : Sb(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || pt(), a = ic(n, this).startOf("day"), i = ke.calendarFormat(this, a) || "sameElse", r = t && (Va(t[i]) ? t[i].call(this, n) : t[i]);
  return this.format(
    r || this.localeData().calendar(i, this, pt(n))
  );
}
function Ob() {
  return new Xo(this);
}
function Cb(e, t) {
  var n = xa(e) ? e : pt(e);
  return this.isValid() && n.isValid() ? (t = da(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function Eb(e, t) {
  var n = xa(e) ? e : pt(e);
  return this.isValid() && n.isValid() ? (t = da(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function Pb(e, t, n, a) {
  var i = xa(e) ? e : pt(e), r = xa(t) ? t : pt(t);
  return this.isValid() && i.isValid() && r.isValid() ? (a = a || "()", (a[0] === "(" ? this.isAfter(i, n) : !this.isBefore(i, n)) && (a[1] === ")" ? this.isBefore(r, n) : !this.isAfter(r, n))) : !1;
}
function Rb(e, t) {
  var n = xa(e) ? e : pt(e), a;
  return this.isValid() && n.isValid() ? (t = da(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (a = n.valueOf(), this.clone().startOf(t).valueOf() <= a && a <= this.clone().endOf(t).valueOf())) : !1;
}
function Ib(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Yb(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function Nb(e, t, n) {
  var a, i, r;
  if (!this.isValid())
    return NaN;
  if (a = ic(e, this), !a.isValid())
    return NaN;
  switch (i = (a.utcOffset() - this.utcOffset()) * 6e4, t = da(t), t) {
    case "year":
      r = qs(this, a) / 12;
      break;
    case "month":
      r = qs(this, a);
      break;
    case "quarter":
      r = qs(this, a) / 3;
      break;
    case "second":
      r = (this - a) / 1e3;
      break;
    case "minute":
      r = (this - a) / 6e4;
      break;
    case "hour":
      r = (this - a) / 36e5;
      break;
    case "day":
      r = (this - a - i) / 864e5;
      break;
    case "week":
      r = (this - a - i) / 6048e5;
      break;
    default:
      r = this - a;
  }
  return n ? r : na(r);
}
function qs(e, t) {
  if (e.date() < t.date())
    return -qs(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), a = e.clone().add(n, "months"), i, r;
  return t - a < 0 ? (i = e.clone().add(n - 1, "months"), r = (t - a) / (a - i)) : (i = e.clone().add(n + 1, "months"), r = (t - a) / (i - a)), -(n + r) || 0;
}
ke.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
ke.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function $b() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Lb(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? Us(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Va(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Us(n, "Z")) : Us(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Fb() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, a, i, r;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', a = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", r = t + '[")]', this.format(n + a + i + r);
}
function zb(e) {
  e || (e = this.isUtc() ? ke.defaultFormatUtc : ke.defaultFormat);
  var t = Us(this, e);
  return this.localeData().postformat(t);
}
function Hb(e, t) {
  return this.isValid() && (xa(e) && e.isValid() || pt(e).isValid()) ? Da({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Wb(e) {
  return this.from(pt(), e);
}
function Bb(e, t) {
  return this.isValid() && (xa(e) && e.isValid() || pt(e).isValid()) ? Da({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Vb(e) {
  return this.to(pt(), e);
}
function Zm(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = hi(e), t != null && (this._locale = t), this);
}
var Qm = ua(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Km() {
  return this._locale;
}
var rl = 1e3, Ar = 60 * rl, ol = 60 * Ar, Jm = (365 * 400 + 97) * 24 * ol;
function Or(e, t) {
  return (e % t + t) % t;
}
function ep(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - Jm : new Date(e, t, n).valueOf();
}
function tp(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - Jm : Date.UTC(e, t, n);
}
function jb(e) {
  var t, n;
  if (e = da(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? tp : ep, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Or(
        t + (this._isUTC ? 0 : this.utcOffset() * Ar),
        ol
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Or(t, Ar);
      break;
    case "second":
      t = this._d.valueOf(), t -= Or(t, rl);
      break;
  }
  return this._d.setTime(t), ke.updateOffset(this, !0), this;
}
function Ub(e) {
  var t, n;
  if (e = da(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? tp : ep, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += ol - Or(
        t + (this._isUTC ? 0 : this.utcOffset() * Ar),
        ol
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Ar - Or(t, Ar) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += rl - Or(t, rl) - 1;
      break;
  }
  return this._d.setTime(t), ke.updateOffset(this, !0), this;
}
function Gb() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function qb() {
  return Math.floor(this.valueOf() / 1e3);
}
function Xb() {
  return new Date(this.valueOf());
}
function Zb() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Qb() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Kb() {
  return this.isValid() ? this.toISOString() : null;
}
function Jb() {
  return Hd(this);
}
function e1() {
  return Si({}, Ve(this));
}
function t1() {
  return Ve(this).overflow;
}
function n1() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Re("N", 0, 0, "eraAbbr");
Re("NN", 0, 0, "eraAbbr");
Re("NNN", 0, 0, "eraAbbr");
Re("NNNN", 0, 0, "eraName");
Re("NNNNN", 0, 0, "eraNarrow");
Re("y", ["y", 1], "yo", "eraYear");
Re("y", ["yy", 2], 0, "eraYear");
Re("y", ["yyy", 3], 0, "eraYear");
Re("y", ["yyyy", 4], 0, "eraYear");
Ae("N", rc);
Ae("NN", rc);
Ae("NNN", rc);
Ae("NNNN", f1);
Ae("NNNNN", m1);
dt(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, a) {
    var i = n._locale.erasParse(e, a, n._strict);
    i ? Ve(n).era = i : Ve(n).invalidEra = e;
  }
);
Ae("y", Gr);
Ae("yy", Gr);
Ae("yyy", Gr);
Ae("yyyy", Gr);
Ae("yo", p1);
dt(["y", "yy", "yyy", "yyyy"], yn);
dt(["yo"], function(e, t, n, a) {
  var i;
  n._locale._eraYearOrdinalRegex && (i = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[yn] = n._locale.eraYearOrdinalParse(e, i) : t[yn] = parseInt(e, 10);
});
function a1(e, t) {
  var n, a, i, r = this._eras || hi("en")._eras;
  for (n = 0, a = r.length; n < a; ++n) {
    switch (typeof r[n].since) {
      case "string":
        i = ke(r[n].since).startOf("day"), r[n].since = i.valueOf();
        break;
    }
    switch (typeof r[n].until) {
      case "undefined":
        r[n].until = 1 / 0;
        break;
      case "string":
        i = ke(r[n].until).startOf("day").valueOf(), r[n].until = i.valueOf();
        break;
    }
  }
  return r;
}
function i1(e, t, n) {
  var a, i, r = this.eras(), o, l, s;
  for (e = e.toUpperCase(), a = 0, i = r.length; a < i; ++a)
    if (o = r[a].name.toUpperCase(), l = r[a].abbr.toUpperCase(), s = r[a].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (l === e)
            return r[a];
          break;
        case "NNNN":
          if (o === e)
            return r[a];
          break;
        case "NNNNN":
          if (s === e)
            return r[a];
          break;
      }
    else if ([o, l, s].indexOf(e) >= 0)
      return r[a];
}
function r1(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? ke(e.since).year() : ke(e.since).year() + (t - e.offset) * n;
}
function o1() {
  var e, t, n, a = this.localeData().eras();
  for (e = 0, t = a.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until || a[e].until <= n && n <= a[e].since)
      return a[e].name;
  return "";
}
function s1() {
  var e, t, n, a = this.localeData().eras();
  for (e = 0, t = a.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until || a[e].until <= n && n <= a[e].since)
      return a[e].narrow;
  return "";
}
function l1() {
  var e, t, n, a = this.localeData().eras();
  for (e = 0, t = a.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until || a[e].until <= n && n <= a[e].since)
      return a[e].abbr;
  return "";
}
function u1() {
  var e, t, n, a, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (n = i[e].since <= i[e].until ? 1 : -1, a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since)
      return (this.year() - ke(i[e].since).year()) * n + i[e].offset;
  return this.year();
}
function d1(e) {
  return at(this, "_erasNameRegex") || oc.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function c1(e) {
  return at(this, "_erasAbbrRegex") || oc.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function h1(e) {
  return at(this, "_erasNarrowRegex") || oc.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function rc(e, t) {
  return t.erasAbbrRegex(e);
}
function f1(e, t) {
  return t.erasNameRegex(e);
}
function m1(e, t) {
  return t.erasNarrowRegex(e);
}
function p1(e, t) {
  return t._eraYearOrdinalRegex || Gr;
}
function oc() {
  var e = [], t = [], n = [], a = [], i, r, o, l, s, u = this.eras();
  for (i = 0, r = u.length; i < r; ++i)
    o = ri(u[i].name), l = ri(u[i].abbr), s = ri(u[i].narrow), t.push(o), e.push(l), n.push(s), a.push(o), a.push(l), a.push(s);
  this._erasRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
Re(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Re(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Pl(e, t) {
  Re(0, [e, e.length], 0, t);
}
Pl("gggg", "weekYear");
Pl("ggggg", "weekYear");
Pl("GGGG", "isoWeekYear");
Pl("GGGGG", "isoWeekYear");
Ae("G", Tl);
Ae("g", Tl);
Ae("GG", vt, Gn);
Ae("gg", vt, Gn);
Ae("GGGG", Gd, Ud);
Ae("gggg", Gd, Ud);
Ae("GGGGG", Sl, Ml);
Ae("ggggg", Sl, Ml);
Qo(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, a) {
    t[a.substr(0, 2)] = qe(e);
  }
);
Qo(["gg", "GG"], function(e, t, n, a) {
  t[a] = ke.parseTwoDigitYear(e);
});
function v1(e) {
  return np.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function g1(e) {
  return np.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function y1() {
  return oi(this.year(), 1, 4);
}
function w1() {
  return oi(this.isoWeekYear(), 1, 4);
}
function b1() {
  var e = this.localeData()._week;
  return oi(this.year(), e.dow, e.doy);
}
function _1() {
  var e = this.localeData()._week;
  return oi(this.weekYear(), e.dow, e.doy);
}
function np(e, t, n, a, i) {
  var r;
  return e == null ? Wo(this, a, i).year : (r = oi(e, a, i), t > r && (t = r), k1.call(this, e, t, n, a, i));
}
function k1(e, t, n, a, i) {
  var r = Ym(e, t, n, a, i), o = Ho(r.year, 0, r.dayOfYear);
  return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
}
Re("Q", 0, "Qo", "quarter");
Ae("Q", Mm);
dt("Q", function(e, t) {
  t[ei] = (qe(e) - 1) * 3;
});
function x1(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Re("D", ["DD", 2], "Do", "date");
Ae("D", vt, qr);
Ae("DD", vt, Gn);
Ae("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
dt(["D", "DD"], Ra);
dt("Do", function(e, t) {
  t[Ra] = qe(e.match(vt)[0]);
});
var ap = Xr("Date", !0);
Re("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Ae("DDD", Dl);
Ae("DDDD", Dm);
dt(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = qe(e);
});
function M1(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
Re("m", ["mm", 2], 0, "minute");
Ae("m", vt, qd);
Ae("mm", vt, Gn);
dt(["m", "mm"], ba);
var D1 = Xr("Minutes", !1);
Re("s", ["ss", 2], 0, "second");
Ae("s", vt, qd);
Ae("ss", vt, Gn);
dt(["s", "ss"], ti);
var S1 = Xr("Seconds", !1);
Re("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Re(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Re(0, ["SSS", 3], 0, "millisecond");
Re(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Re(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Re(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Re(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Re(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Re(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Ae("S", Dl, Mm);
Ae("SS", Dl, Gn);
Ae("SSS", Dl, Dm);
var Ti, ip;
for (Ti = "SSSS"; Ti.length <= 9; Ti += "S")
  Ae(Ti, Gr);
function T1(e, t) {
  t[Ki] = qe(("0." + e) * 1e3);
}
for (Ti = "S"; Ti.length <= 9; Ti += "S")
  dt(Ti, T1);
ip = Xr("Milliseconds", !1);
Re("z", 0, 0, "zoneAbbr");
Re("zz", 0, 0, "zoneName");
function A1() {
  return this._isUTC ? "UTC" : "";
}
function O1() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var ue = Xo.prototype;
ue.add = _b;
ue.calendar = Ab;
ue.clone = Ob;
ue.diff = Nb;
ue.endOf = Ub;
ue.format = zb;
ue.from = Hb;
ue.fromNow = Wb;
ue.to = Bb;
ue.toNow = Vb;
ue.get = F0;
ue.invalidAt = t1;
ue.isAfter = Cb;
ue.isBefore = Eb;
ue.isBetween = Pb;
ue.isSame = Rb;
ue.isSameOrAfter = Ib;
ue.isSameOrBefore = Yb;
ue.isValid = Jb;
ue.lang = Qm;
ue.locale = Zm;
ue.localeData = Km;
ue.max = Jw;
ue.min = Kw;
ue.parsingFlags = e1;
ue.set = z0;
ue.startOf = jb;
ue.subtract = kb;
ue.toArray = Zb;
ue.toObject = Qb;
ue.toDate = Xb;
ue.toISOString = Lb;
ue.inspect = Fb;
typeof Symbol < "u" && Symbol.for != null && (ue[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
ue.toJSON = Kb;
ue.toString = $b;
ue.unix = qb;
ue.valueOf = Gb;
ue.creationData = n1;
ue.eraName = o1;
ue.eraNarrow = s1;
ue.eraAbbr = l1;
ue.eraYear = u1;
ue.year = Am;
ue.isLeapYear = L0;
ue.weekYear = v1;
ue.isoWeekYear = g1;
ue.quarter = ue.quarters = x1;
ue.month = Rm;
ue.daysInMonth = X0;
ue.week = ue.weeks = aw;
ue.isoWeek = ue.isoWeeks = iw;
ue.weeksInYear = b1;
ue.weeksInWeekYear = _1;
ue.isoWeeksInYear = y1;
ue.isoWeeksInISOWeekYear = w1;
ue.date = ap;
ue.day = ue.days = gw;
ue.weekday = yw;
ue.isoWeekday = ww;
ue.dayOfYear = M1;
ue.hour = ue.hours = Sw;
ue.minute = ue.minutes = D1;
ue.second = ue.seconds = S1;
ue.millisecond = ue.milliseconds = ip;
ue.utcOffset = lb;
ue.utc = db;
ue.local = cb;
ue.parseZone = hb;
ue.hasAlignedHourOffset = fb;
ue.isDST = mb;
ue.isLocal = vb;
ue.isUtcOffset = gb;
ue.isUtc = Um;
ue.isUTC = Um;
ue.zoneAbbr = A1;
ue.zoneName = O1;
ue.dates = ua(
  "dates accessor is deprecated. Use date instead.",
  ap
);
ue.months = ua(
  "months accessor is deprecated. Use month instead",
  Rm
);
ue.years = ua(
  "years accessor is deprecated. Use year instead",
  Am
);
ue.zone = ua(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  ub
);
ue.isDSTShifted = ua(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  pb
);
function C1(e) {
  return pt(e * 1e3);
}
function E1() {
  return pt.apply(null, arguments).parseZone();
}
function rp(e) {
  return e;
}
var it = Bd.prototype;
it.calendar = v0;
it.longDateFormat = b0;
it.invalidDate = k0;
it.ordinal = D0;
it.preparse = rp;
it.postformat = rp;
it.relativeTime = T0;
it.pastFuture = A0;
it.set = m0;
it.eras = a1;
it.erasParse = i1;
it.erasConvertYear = r1;
it.erasAbbrRegex = c1;
it.erasNameRegex = d1;
it.erasNarrowRegex = h1;
it.months = j0;
it.monthsShort = U0;
it.monthsParse = q0;
it.monthsRegex = Q0;
it.monthsShortRegex = Z0;
it.week = J0;
it.firstDayOfYear = nw;
it.firstDayOfWeek = tw;
it.weekdays = hw;
it.weekdaysMin = mw;
it.weekdaysShort = fw;
it.weekdaysParse = vw;
it.weekdaysRegex = bw;
it.weekdaysShortRegex = _w;
it.weekdaysMinRegex = kw;
it.isPM = Mw;
it.meridiem = Tw;
function sl(e, t, n, a) {
  var i = hi(), r = Ba().set(a, t);
  return i[n](r, e);
}
function op(e, t, n) {
  if (ui(e) && (t = e, e = void 0), e = e || "", t != null)
    return sl(e, t, n, "month");
  var a, i = [];
  for (a = 0; a < 12; a++)
    i[a] = sl(e, a, n, "month");
  return i;
}
function sc(e, t, n, a) {
  typeof e == "boolean" ? (ui(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, ui(t) && (n = t, t = void 0), t = t || "");
  var i = hi(), r = e ? i._week.dow : 0, o, l = [];
  if (n != null)
    return sl(t, (n + r) % 7, a, "day");
  for (o = 0; o < 7; o++)
    l[o] = sl(t, (o + r) % 7, a, "day");
  return l;
}
function P1(e, t) {
  return op(e, t, "months");
}
function R1(e, t) {
  return op(e, t, "monthsShort");
}
function I1(e, t, n) {
  return sc(e, t, n, "weekdays");
}
function Y1(e, t, n) {
  return sc(e, t, n, "weekdaysShort");
}
function N1(e, t, n) {
  return sc(e, t, n, "weekdaysMin");
}
Ci("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = qe(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
ke.lang = ua(
  "moment.lang is deprecated. Use moment.locale instead.",
  Ci
);
ke.langData = ua(
  "moment.langData is deprecated. Use moment.localeData instead.",
  hi
);
var Xa = Math.abs;
function $1() {
  var e = this._data;
  return this._milliseconds = Xa(this._milliseconds), this._days = Xa(this._days), this._months = Xa(this._months), e.milliseconds = Xa(e.milliseconds), e.seconds = Xa(e.seconds), e.minutes = Xa(e.minutes), e.hours = Xa(e.hours), e.months = Xa(e.months), e.years = Xa(e.years), this;
}
function sp(e, t, n, a) {
  var i = Da(t, n);
  return e._milliseconds += a * i._milliseconds, e._days += a * i._days, e._months += a * i._months, e._bubble();
}
function L1(e, t) {
  return sp(this, e, t, 1);
}
function F1(e, t) {
  return sp(this, e, t, -1);
}
function rf(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function z1() {
  var e = this._milliseconds, t = this._days, n = this._months, a = this._data, i, r, o, l, s;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += rf(vd(n) + t) * 864e5, t = 0, n = 0), a.milliseconds = e % 1e3, i = na(e / 1e3), a.seconds = i % 60, r = na(i / 60), a.minutes = r % 60, o = na(r / 60), a.hours = o % 24, t += na(o / 24), s = na(lp(t)), n += s, t -= rf(vd(s)), l = na(n / 12), n %= 12, a.days = t, a.months = n, a.years = l, this;
}
function lp(e) {
  return e * 4800 / 146097;
}
function vd(e) {
  return e * 146097 / 4800;
}
function H1(e) {
  if (!this.isValid())
    return NaN;
  var t, n, a = this._milliseconds;
  if (e = da(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + a / 864e5, n = this._months + lp(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(vd(this._months)), e) {
      case "week":
        return t / 7 + a / 6048e5;
      case "day":
        return t + a / 864e5;
      case "hour":
        return t * 24 + a / 36e5;
      case "minute":
        return t * 1440 + a / 6e4;
      case "second":
        return t * 86400 + a / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + a;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function fi(e) {
  return function() {
    return this.as(e);
  };
}
var up = fi("ms"), W1 = fi("s"), B1 = fi("m"), V1 = fi("h"), j1 = fi("d"), U1 = fi("w"), G1 = fi("M"), q1 = fi("Q"), X1 = fi("y"), Z1 = up;
function Q1() {
  return Da(this);
}
function K1(e) {
  return e = da(e), this.isValid() ? this[e + "s"]() : NaN;
}
function or(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var J1 = or("milliseconds"), e_ = or("seconds"), t_ = or("minutes"), n_ = or("hours"), a_ = or("days"), i_ = or("months"), r_ = or("years");
function o_() {
  return na(this.days() / 7);
}
var Qa = Math.round, xr = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function s_(e, t, n, a, i) {
  return i.relativeTime(t || 1, !!n, e, a);
}
function l_(e, t, n, a) {
  var i = Da(e).abs(), r = Qa(i.as("s")), o = Qa(i.as("m")), l = Qa(i.as("h")), s = Qa(i.as("d")), u = Qa(i.as("M")), d = Qa(i.as("w")), c = Qa(i.as("y")), f = r <= n.ss && ["s", r] || r < n.s && ["ss", r] || o <= 1 && ["m"] || o < n.m && ["mm", o] || l <= 1 && ["h"] || l < n.h && ["hh", l] || s <= 1 && ["d"] || s < n.d && ["dd", s];
  return n.w != null && (f = f || d <= 1 && ["w"] || d < n.w && ["ww", d]), f = f || u <= 1 && ["M"] || u < n.M && ["MM", u] || c <= 1 && ["y"] || ["yy", c], f[2] = t, f[3] = +e > 0, f[4] = a, s_.apply(null, f);
}
function u_(e) {
  return e === void 0 ? Qa : typeof e == "function" ? (Qa = e, !0) : !1;
}
function d_(e, t) {
  return xr[e] === void 0 ? !1 : t === void 0 ? xr[e] : (xr[e] = t, e === "s" && (xr.ss = t - 1), !0);
}
function c_(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, a = xr, i, r;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (a = Object.assign({}, xr, t), t.s != null && t.ss == null && (a.ss = t.s - 1)), i = this.localeData(), r = l_(this, !n, a, i), n && (r = i.pastFuture(+this, r)), i.postformat(r);
}
var Au = Math.abs;
function pr(e) {
  return (e > 0) - (e < 0) || +e;
}
function Rl() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Au(this._milliseconds) / 1e3, t = Au(this._days), n = Au(this._months), a, i, r, o, l = this.asSeconds(), s, u, d, c;
  return l ? (a = na(e / 60), i = na(a / 60), e %= 60, a %= 60, r = na(n / 12), n %= 12, o = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", s = l < 0 ? "-" : "", u = pr(this._months) !== pr(l) ? "-" : "", d = pr(this._days) !== pr(l) ? "-" : "", c = pr(this._milliseconds) !== pr(l) ? "-" : "", s + "P" + (r ? u + r + "Y" : "") + (n ? u + n + "M" : "") + (t ? d + t + "D" : "") + (i || a || e ? "T" : "") + (i ? c + i + "H" : "") + (a ? c + a + "M" : "") + (e ? c + o + "S" : "")) : "P0D";
}
var Ze = El.prototype;
Ze.isValid = ib;
Ze.abs = $1;
Ze.add = L1;
Ze.subtract = F1;
Ze.as = H1;
Ze.asMilliseconds = up;
Ze.asSeconds = W1;
Ze.asMinutes = B1;
Ze.asHours = V1;
Ze.asDays = j1;
Ze.asWeeks = U1;
Ze.asMonths = G1;
Ze.asQuarters = q1;
Ze.asYears = X1;
Ze.valueOf = Z1;
Ze._bubble = z1;
Ze.clone = Q1;
Ze.get = K1;
Ze.milliseconds = J1;
Ze.seconds = e_;
Ze.minutes = t_;
Ze.hours = n_;
Ze.days = a_;
Ze.weeks = o_;
Ze.months = i_;
Ze.years = r_;
Ze.humanize = c_;
Ze.toISOString = Rl;
Ze.toString = Rl;
Ze.toJSON = Rl;
Ze.locale = Zm;
Ze.localeData = Km;
Ze.toIsoString = ua(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Rl
);
Ze.lang = Qm;
Re("X", 0, 0, "unix");
Re("x", 0, 0, "valueOf");
Ae("x", Tl);
Ae("X", P0);
dt("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
dt("x", function(e, t, n) {
  n._d = new Date(qe(e));
});
//! moment.js
ke.version = "2.30.1";
h0(pt);
ke.fn = ue;
ke.min = eb;
ke.max = tb;
ke.now = nb;
ke.utc = Ba;
ke.unix = C1;
ke.months = P1;
ke.isDate = qo;
ke.locale = Ci;
ke.invalid = xl;
ke.duration = Da;
ke.isMoment = xa;
ke.weekdays = I1;
ke.parseZone = E1;
ke.localeData = hi;
ke.isDuration = Gs;
ke.monthsShort = R1;
ke.weekdaysMin = N1;
ke.defineLocale = Jd;
ke.updateLocale = Ew;
ke.locales = Pw;
ke.weekdaysShort = Y1;
ke.normalizeUnits = da;
ke.relativeTimeRounding = u_;
ke.relativeTimeThreshold = d_;
ke.calendarFormat = Tb;
ke.prototype = ue;
ke.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
function Ce(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function ot(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ya(e, t) {
  const n = Ce(e);
  return isNaN(t) ? ot(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function _a(e, t) {
  const n = Ce(e);
  if (isNaN(t))
    return ot(e, NaN);
  if (!t)
    return n;
  const a = n.getDate(), i = ot(e, n.getTime());
  i.setMonth(n.getMonth() + t + 1, 0);
  const r = i.getDate();
  return a >= r ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    a
  ), n);
}
function dp(e, t) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: r = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: s = 0
  } = t, u = Ce(e), d = a || n ? _a(u, a + n * 12) : u, c = r || i ? ya(d, r + i * 7) : d, f = l + o * 60, k = (s + f * 60) * 1e3;
  return ot(e, c.getTime() + k);
}
function h_(e, t) {
  const n = +Ce(e);
  return ot(e, n + t);
}
const cp = 6048e5, f_ = 864e5, m_ = 6e4, hp = 36e5, p_ = 1e3;
function v_(e, t) {
  return h_(e, t * hp);
}
let g_ = {};
function sr() {
  return g_;
}
function Ma(e, t) {
  var l, s, u, d;
  const n = sr(), a = (t == null ? void 0 : t.weekStartsOn) ?? ((s = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : s.weekStartsOn) ?? n.weekStartsOn ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, i = Ce(e), r = i.getDay(), o = (r < a ? 7 : 0) + r - a;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function $r(e) {
  return Ma(e, { weekStartsOn: 1 });
}
function fp(e) {
  const t = Ce(e), n = t.getFullYear(), a = ot(e, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = $r(a), r = ot(e, 0);
  r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0);
  const o = $r(r);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function of(e) {
  const t = Ce(e);
  return t.setHours(0, 0, 0, 0), t;
}
function ll(e) {
  const t = Ce(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function mp(e, t) {
  const n = of(e), a = of(t), i = +n - ll(n), r = +a - ll(a);
  return Math.round((i - r) / f_);
}
function y_(e) {
  const t = fp(e), n = ot(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), $r(n);
}
function w_(e, t) {
  const n = t * 3;
  return _a(e, n);
}
function lc(e, t) {
  return _a(e, t * 12);
}
function sf(e, t) {
  const n = Ce(e), a = Ce(t), i = n.getTime() - a.getTime();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
function pp(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Co(e) {
  if (!pp(e) && typeof e != "number")
    return !1;
  const t = Ce(e);
  return !isNaN(Number(t));
}
function lf(e) {
  const t = Ce(e);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function b_(e, t) {
  const n = Ce(e), a = Ce(t);
  return n.getFullYear() - a.getFullYear();
}
function __(e, t) {
  const n = Ce(e), a = Ce(t), i = sf(n, a), r = Math.abs(b_(n, a));
  n.setFullYear(1584), a.setFullYear(1584);
  const o = sf(n, a) === -i, l = i * (r - +o);
  return l === 0 ? 0 : l;
}
function vp(e, t) {
  const n = Ce(e.start), a = Ce(e.end);
  let i = +n > +a;
  const r = i ? +n : +a, o = i ? a : n;
  o.setHours(0, 0, 0, 0);
  let l = (t == null ? void 0 : t.step) ?? 1;
  if (!l)
    return [];
  l < 0 && (l = -l, i = !i);
  const s = [];
  for (; +o <= r; )
    s.push(Ce(o)), o.setDate(o.getDate() + l), o.setHours(0, 0, 0, 0);
  return i ? s.reverse() : s;
}
function Ji(e) {
  const t = Ce(e), n = t.getMonth(), a = n - n % 3;
  return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
}
function k_(e, t) {
  const n = Ce(e.start), a = Ce(e.end);
  let i = +n > +a;
  const r = i ? +Ji(n) : +Ji(a);
  let o = Ji(i ? a : n), l = (t == null ? void 0 : t.step) ?? 1;
  if (!l)
    return [];
  l < 0 && (l = -l, i = !i);
  const s = [];
  for (; +o <= r; )
    s.push(Ce(o)), o = w_(o, l);
  return i ? s.reverse() : s;
}
function x_(e) {
  const t = Ce(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function gp(e) {
  const t = Ce(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Vo(e) {
  const t = Ce(e), n = ot(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function yp(e, t) {
  var l, s, u, d;
  const n = sr(), a = (t == null ? void 0 : t.weekStartsOn) ?? ((s = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : s.weekStartsOn) ?? n.weekStartsOn ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, i = Ce(e), r = i.getDay(), o = (r < a ? -7 : 0) + 6 - (r - a);
  return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
function uf(e) {
  const t = Ce(e), n = t.getMonth(), a = n - n % 3 + 3;
  return t.setMonth(a, 0), t.setHours(23, 59, 59, 999), t;
}
const M_ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, D_ = (e, t, n) => {
  let a;
  const i = M_[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function Ou(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const S_ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, T_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, A_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, O_ = {
  date: Ou({
    formats: S_,
    defaultWidth: "full"
  }),
  time: Ou({
    formats: T_,
    defaultWidth: "full"
  }),
  dateTime: Ou({
    formats: A_,
    defaultWidth: "full"
  })
}, C_ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, E_ = (e, t, n, a) => C_[e];
function wo(e) {
  return (t, n) => {
    const a = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (a === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, l = n != null && n.width ? String(n.width) : o;
      i = e.formattingValues[l] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[l] || e.values[o];
    }
    const r = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[r];
  };
}
const P_ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, R_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, I_ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Y_ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, N_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, $_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, L_ = (e, t) => {
  const n = Number(e), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, F_ = {
  ordinalNumber: L_,
  era: wo({
    values: P_,
    defaultWidth: "wide"
  }),
  quarter: wo({
    values: R_,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: wo({
    values: I_,
    defaultWidth: "wide"
  }),
  day: wo({
    values: Y_,
    defaultWidth: "wide"
  }),
  dayPeriod: wo({
    values: N_,
    defaultWidth: "wide",
    formattingValues: $_,
    defaultFormattingWidth: "wide"
  })
};
function bo(e) {
  return (t, n = {}) => {
    const a = n.width, i = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], r = t.match(i);
    if (!r)
      return null;
    const o = r[0], l = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(l) ? H_(l, (c) => c.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      z_(l, (c) => c.test(o))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(s) : s, u = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(u)
    ) : u;
    const d = t.slice(o.length);
    return { value: u, rest: d };
  };
}
function z_(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function H_(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function W_(e) {
  return (t, n = {}) => {
    const a = t.match(e.matchPattern);
    if (!a)
      return null;
    const i = a[0], r = t.match(e.parsePattern);
    if (!r)
      return null;
    let o = e.valueCallback ? e.valueCallback(r[0]) : r[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const l = t.slice(i.length);
    return { value: o, rest: l };
  };
}
const B_ = /^(\d+)(th|st|nd|rd)?/i, V_ = /\d+/i, j_ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, U_ = {
  any: [/^b/i, /^(a|c)/i]
}, G_ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, q_ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, X_ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Z_ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Q_ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, K_ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, J_ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ek = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, tk = {
  ordinalNumber: W_({
    matchPattern: B_,
    parsePattern: V_,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: bo({
    matchPatterns: j_,
    defaultMatchWidth: "wide",
    parsePatterns: U_,
    defaultParseWidth: "any"
  }),
  quarter: bo({
    matchPatterns: G_,
    defaultMatchWidth: "wide",
    parsePatterns: q_,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: bo({
    matchPatterns: X_,
    defaultMatchWidth: "wide",
    parsePatterns: Z_,
    defaultParseWidth: "any"
  }),
  day: bo({
    matchPatterns: Q_,
    defaultMatchWidth: "wide",
    parsePatterns: K_,
    defaultParseWidth: "any"
  }),
  dayPeriod: bo({
    matchPatterns: J_,
    defaultMatchWidth: "any",
    parsePatterns: ek,
    defaultParseWidth: "any"
  })
}, wp = {
  code: "en-US",
  formatDistance: D_,
  formatLong: O_,
  formatRelative: E_,
  localize: F_,
  match: tk,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function nk(e) {
  const t = Ce(e);
  return mp(t, Vo(t)) + 1;
}
function uc(e) {
  const t = Ce(e), n = +$r(t) - +y_(t);
  return Math.round(n / cp) + 1;
}
function dc(e, t) {
  var d, c, f, v;
  const n = Ce(e), a = n.getFullYear(), i = sr(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : c.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((v = (f = i.locale) == null ? void 0 : f.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, o = ot(e, 0);
  o.setFullYear(a + 1, 0, r), o.setHours(0, 0, 0, 0);
  const l = Ma(o, t), s = ot(e, 0);
  s.setFullYear(a, 0, r), s.setHours(0, 0, 0, 0);
  const u = Ma(s, t);
  return n.getTime() >= l.getTime() ? a + 1 : n.getTime() >= u.getTime() ? a : a - 1;
}
function ak(e, t) {
  var l, s, u, d;
  const n = sr(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((s = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : s.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, i = dc(e, t), r = ot(e, 0);
  return r.setFullYear(i, 0, a), r.setHours(0, 0, 0, 0), Ma(r, t);
}
function cc(e, t) {
  const n = Ce(e), a = +Ma(n, t) - +ak(n, t);
  return Math.round(a / cp) + 1;
}
function ut(e, t) {
  const n = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(t, "0");
  return n + a;
}
const yi = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
    return ut(t === "yy" ? a % 100 : a, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ut(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ut(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ut(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ut(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ut(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ut(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, a = e.getMilliseconds(), i = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return ut(i, t.length);
  }
}, vr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, df = {
  // Era
  G: function(e, t, n) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const a = e.getFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return yi.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, a) {
    const i = dc(e, a), r = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const o = r % 100;
      return ut(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(r, { unit: "year" }) : ut(r, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = fp(e);
    return ut(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ut(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(a);
      case "QQ":
        return ut(a, 2);
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(a);
      case "qq":
        return ut(a, 2);
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return yi.M(e, t);
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      case "L":
        return String(a + 1);
      case "LL":
        return ut(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, a) {
    const i = cc(e, a);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : ut(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const a = uc(e);
    return t === "Io" ? n.ordinalNumber(a, { unit: "week" }) : ut(a, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : yi.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const a = nk(e);
    return t === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : ut(a, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const a = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, a) {
    const i = e.getDay(), r = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(r);
      case "ee":
        return ut(r, 2);
      case "eo":
        return n.ordinalNumber(r, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, a) {
    const i = e.getDay(), r = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(r);
      case "cc":
        return ut(r, t.length);
      case "co":
        return n.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const a = e.getDay(), i = a === 0 ? 7 : a;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return ut(i, t.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const a = e.getHours();
    let i;
    switch (a === 12 ? i = vr.noon : a === 0 ? i = vr.midnight : i = a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const a = e.getHours();
    let i;
    switch (a >= 17 ? i = vr.evening : a >= 12 ? i = vr.afternoon : a >= 4 ? i = vr.morning : i = vr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return yi.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : yi.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const a = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : ut(a, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let a = e.getHours();
    return a === 0 && (a = 24), t === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : ut(a, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : yi.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : yi.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return yi.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (t) {
      case "X":
        return hf(a);
      case "XXXX":
      case "XX":
        return Xi(a);
      case "XXXXX":
      case "XXX":
      default:
        return Xi(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return hf(a);
      case "xxxx":
      case "xx":
        return Xi(a);
      case "xxxxx":
      case "xxx":
      default:
        return Xi(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + cf(a, ":");
      case "OOOO":
      default:
        return "GMT" + Xi(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + cf(a, ":");
      case "zzzz":
      default:
        return "GMT" + Xi(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const a = Math.trunc(e.getTime() / 1e3);
    return ut(a, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const a = e.getTime();
    return ut(a, t.length);
  }
};
function cf(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), i = Math.trunc(a / 60), r = a % 60;
  return r === 0 ? n + String(i) : n + String(i) + t + ut(r, 2);
}
function hf(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ut(Math.abs(e) / 60, 2) : Xi(e, t);
}
function Xi(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), i = ut(Math.trunc(a / 60), 2), r = ut(a % 60, 2);
  return n + i + t + r;
}
const ff = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, bp = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, ik = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return ff(e, t);
  let r;
  switch (a) {
    case "P":
      r = t.dateTime({ width: "short" });
      break;
    case "PP":
      r = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = t.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", ff(a, t)).replace("{{time}}", bp(i, t));
}, gd = {
  p: bp,
  P: ik
}, rk = /^D+$/, ok = /^Y+$/, sk = ["D", "DD", "YY", "YYYY"];
function _p(e) {
  return rk.test(e);
}
function kp(e) {
  return ok.test(e);
}
function yd(e, t, n) {
  const a = lk(e, t, n);
  if (console.warn(a), sk.includes(e))
    throw new RangeError(a);
}
function lk(e, t, n) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const uk = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, dk = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ck = /^'([^]*?)'?$/, hk = /''/g, fk = /[a-zA-Z]/;
function La(e, t, n) {
  var d, c, f, v, k, b, R, V;
  const a = sr(), i = (n == null ? void 0 : n.locale) ?? a.locale ?? wp, r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((c = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : c.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((v = (f = a.locale) == null ? void 0 : f.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, o = (n == null ? void 0 : n.weekStartsOn) ?? ((b = (k = n == null ? void 0 : n.locale) == null ? void 0 : k.options) == null ? void 0 : b.weekStartsOn) ?? a.weekStartsOn ?? ((V = (R = a.locale) == null ? void 0 : R.options) == null ? void 0 : V.weekStartsOn) ?? 0, l = Ce(e);
  if (!Co(l))
    throw new RangeError("Invalid time value");
  let s = t.match(dk).map((G) => {
    const C = G[0];
    if (C === "p" || C === "P") {
      const q = gd[C];
      return q(G, i.formatLong);
    }
    return G;
  }).join("").match(uk).map((G) => {
    if (G === "''")
      return { isToken: !1, value: "'" };
    const C = G[0];
    if (C === "'")
      return { isToken: !1, value: mk(G) };
    if (df[C])
      return { isToken: !0, value: G };
    if (C.match(fk))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + C + "`"
      );
    return { isToken: !1, value: G };
  });
  i.localize.preprocessor && (s = i.localize.preprocessor(l, s));
  const u = {
    firstWeekContainsDate: r,
    weekStartsOn: o,
    locale: i
  };
  return s.map((G) => {
    if (!G.isToken)
      return G.value;
    const C = G.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && kp(C) || !(n != null && n.useAdditionalDayOfYearTokens) && _p(C)) && yd(C, t, String(e));
    const q = df[C[0]];
    return q(l, C, i.localize, u);
  }).join("");
}
function mk(e) {
  const t = e.match(ck);
  return t ? t[1].replace(hk, "'") : e;
}
function pk(e) {
  return Ce(e).getDay();
}
function vk(e) {
  const t = Ce(e), n = t.getFullYear(), a = t.getMonth(), i = ot(e, 0);
  return i.setFullYear(n, a + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function gk() {
  return Object.assign({}, sr());
}
function di(e) {
  return Ce(e).getHours();
}
function yk(e) {
  let n = Ce(e).getDay();
  return n === 0 && (n = 7), n;
}
function Ii(e) {
  return Ce(e).getMinutes();
}
function Ue(e) {
  return Ce(e).getMonth();
}
function Lr(e) {
  return Ce(e).getSeconds();
}
function We(e) {
  return Ce(e).getFullYear();
}
function Fr(e, t) {
  const n = Ce(e), a = Ce(t);
  return n.getTime() > a.getTime();
}
function jo(e, t) {
  const n = Ce(e), a = Ce(t);
  return +n < +a;
}
function Mr(e, t) {
  const n = Ce(e), a = Ce(t);
  return +n == +a;
}
function wk(e, t) {
  const n = t instanceof Date ? ot(t, 0) : new t(0);
  return n.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
const bk = 10;
class xp {
  constructor() {
    Te(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class _k extends xp {
  constructor(t, n, a, i, r) {
    super(), this.value = t, this.validateValue = n, this.setValue = a, this.priority = i, r && (this.subPriority = r);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, a) {
    return this.setValue(t, n, this.value, a);
  }
}
class kk extends xp {
  constructor() {
    super(...arguments);
    Te(this, "priority", bk);
    Te(this, "subPriority", -1);
  }
  set(n, a) {
    return a.timestampIsSet ? n : ot(n, wk(n, Date));
  }
}
class st {
  run(t, n, a, i) {
    const r = this.parse(t, n, a, i);
    return r ? {
      setter: new _k(
        r.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: r.rest
    } : null;
  }
  validate(t, n, a) {
    return !0;
  }
}
class xk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 140);
    Te(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
      case "GGGGG":
        return i.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return i.era(n, { width: "wide" }) || i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
    }
  }
  set(n, a, i) {
    return a.era = i, n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const zt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ia = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ht(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function xt(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Ya(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const a = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, r = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: a * (i * hp + r * m_ + o * p_),
    rest: t.slice(n[0].length)
  };
}
function Mp(e) {
  return xt(zt.anyDigitsSigned, e);
}
function Pt(e, t) {
  switch (e) {
    case 1:
      return xt(zt.singleDigit, t);
    case 2:
      return xt(zt.twoDigits, t);
    case 3:
      return xt(zt.threeDigits, t);
    case 4:
      return xt(zt.fourDigits, t);
    default:
      return xt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function ul(e, t) {
  switch (e) {
    case 1:
      return xt(zt.singleDigitSigned, t);
    case 2:
      return xt(zt.twoDigitsSigned, t);
    case 3:
      return xt(zt.threeDigitsSigned, t);
    case 4:
      return xt(zt.fourDigitsSigned, t);
    default:
      return xt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function hc(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Dp(e, t) {
  const n = t > 0, a = n ? t : 1 - t;
  let i;
  if (a <= 50)
    i = e || 100;
  else {
    const r = a + 50, o = Math.trunc(r / 100) * 100, l = e >= r % 100;
    i = e + o - (l ? 100 : 0);
  }
  return n ? i : 1 - i;
}
function Sp(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Mk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 130);
    Te(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, a, i) {
    const r = (o) => ({
      year: o,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return Ht(Pt(4, n), r);
      case "yo":
        return Ht(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return Ht(Pt(a.length, n), r);
    }
  }
  validate(n, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(n, a, i) {
    const r = n.getFullYear();
    if (i.isTwoDigitYear) {
      const l = Dp(
        i.year,
        r
      );
      return n.setFullYear(l, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const o = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class Dk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 130);
    Te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (o) => ({
      year: o,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return Ht(Pt(4, n), r);
      case "Yo":
        return Ht(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return Ht(Pt(a.length, n), r);
    }
  }
  validate(n, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(n, a, i, r) {
    const o = dc(n, r);
    if (i.isTwoDigitYear) {
      const s = Dp(
        i.year,
        o
      );
      return n.setFullYear(
        s,
        0,
        r.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Ma(n, r);
    }
    const l = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(l, 0, r.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Ma(n, r);
  }
}
class Sk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 130);
    Te(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a) {
    return ul(a === "R" ? 4 : a.length, n);
  }
  set(n, a, i) {
    const r = ot(n, 0);
    return r.setFullYear(i, 0, 4), r.setHours(0, 0, 0, 0), $r(r);
  }
}
class Tk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 130);
    Te(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, a) {
    return ul(a === "u" ? 4 : a.length, n);
  }
  set(n, a, i) {
    return n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class Ak extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 120);
    Te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "Q":
      case "QQ":
        return Pt(a.length, n);
      case "Qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 4;
  }
  set(n, a, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class Ok extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 120);
    Te(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "q":
      case "qq":
        return Pt(a.length, n);
      case "qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 4;
  }
  set(n, a, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class Ck extends st {
  constructor() {
    super(...arguments);
    Te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Te(this, "priority", 110);
  }
  parse(n, a, i) {
    const r = (o) => o - 1;
    switch (a) {
      case "M":
        return Ht(
          xt(zt.month, n),
          r
        );
      case "MM":
        return Ht(Pt(2, n), r);
      case "Mo":
        return Ht(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      case "MMM":
        return i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return i.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return i.month(n, { width: "wide", context: "formatting" }) || i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class Ek extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 110);
    Te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (o) => o - 1;
    switch (a) {
      case "L":
        return Ht(
          xt(zt.month, n),
          r
        );
      case "LL":
        return Ht(Pt(2, n), r);
      case "Lo":
        return Ht(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      case "LLL":
        return i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return i.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return i.month(n, { width: "wide", context: "standalone" }) || i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function Pk(e, t, n) {
  const a = Ce(e), i = cc(a, n) - t;
  return a.setDate(a.getDate() - i * 7), a;
}
class Rk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 100);
    Te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "w":
        return xt(zt.week, n);
      case "wo":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 53;
  }
  set(n, a, i, r) {
    return Ma(Pk(n, i, r), r);
  }
}
function Ik(e, t) {
  const n = Ce(e), a = uc(n) - t;
  return n.setDate(n.getDate() - a * 7), n;
}
class Yk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 100);
    Te(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "I":
        return xt(zt.week, n);
      case "Io":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 53;
  }
  set(n, a, i) {
    return $r(Ik(n, i));
  }
}
const Nk = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], $k = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Lk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 90);
    Te(this, "subPriority", 1);
    Te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "d":
        return xt(zt.date, n);
      case "do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    const i = n.getFullYear(), r = Sp(i), o = n.getMonth();
    return r ? a >= 1 && a <= $k[o] : a >= 1 && a <= Nk[o];
  }
  set(n, a, i) {
    return n.setDate(i), n.setHours(0, 0, 0, 0), n;
  }
}
class Fk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 90);
    Te(this, "subpriority", 1);
    Te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "D":
      case "DD":
        return xt(zt.dayOfYear, n);
      case "Do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    const i = n.getFullYear();
    return Sp(i) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(n, a, i) {
    return n.setMonth(0, i), n.setHours(0, 0, 0, 0), n;
  }
}
function fc(e, t, n) {
  var c, f, v, k;
  const a = sr(), i = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? a.weekStartsOn ?? ((k = (v = a.locale) == null ? void 0 : v.options) == null ? void 0 : k.weekStartsOn) ?? 0, r = Ce(e), o = r.getDay(), s = (t % 7 + 7) % 7, u = 7 - i, d = t < 0 || t > 6 ? t - (o + u) % 7 : (s + u) % 7 - (o + u) % 7;
  return ya(r, d);
}
class zk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 90);
    Te(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = fc(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
class Hk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 90);
    Te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i, r) {
    const o = (l) => {
      const s = Math.floor((l - 1) / 7) * 7;
      return (l + r.weekStartsOn + 6) % 7 + s;
    };
    switch (a) {
      case "e":
      case "ee":
        return Ht(Pt(a.length, n), o);
      case "eo":
        return Ht(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          o
        );
      case "eee":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = fc(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
class Wk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 90);
    Te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, a, i, r) {
    const o = (l) => {
      const s = Math.floor((l - 1) / 7) * 7;
      return (l + r.weekStartsOn + 6) % 7 + s;
    };
    switch (a) {
      case "c":
      case "cc":
        return Ht(Pt(a.length, n), o);
      case "co":
        return Ht(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          o
        );
      case "ccc":
        return i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return i.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return i.day(n, { width: "wide", context: "standalone" }) || i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = fc(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
function Bk(e, t) {
  const n = Ce(e), a = yk(n), i = t - a;
  return ya(n, i);
}
class Vk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 90);
    Te(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (o) => o === 0 ? 7 : o;
    switch (a) {
      case "i":
      case "ii":
        return Pt(a.length, n);
      case "io":
        return i.ordinalNumber(n, { unit: "day" });
      case "iii":
        return Ht(
          i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiii":
        return Ht(
          i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiiii":
        return Ht(
          i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiii":
      default:
        return Ht(
          i.day(n, {
            width: "wide",
            context: "formatting"
          }) || i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 7;
  }
  set(n, a, i) {
    return n = Bk(n, i), n.setHours(0, 0, 0, 0), n;
  }
}
class jk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 80);
    Te(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(hc(i), 0, 0, 0), n;
  }
}
class Uk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 80);
    Te(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(hc(i), 0, 0, 0), n;
  }
}
class Gk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 80);
    Te(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(hc(i), 0, 0, 0), n;
  }
}
class qk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 70);
    Te(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "h":
        return xt(zt.hour12h, n);
      case "ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 12;
  }
  set(n, a, i) {
    const r = n.getHours() >= 12;
    return r && i < 12 ? n.setHours(i + 12, 0, 0, 0) : !r && i === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class Xk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 70);
    Te(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "H":
        return xt(zt.hour23h, n);
      case "Ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 23;
  }
  set(n, a, i) {
    return n.setHours(i, 0, 0, 0), n;
  }
}
class Zk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 70);
    Te(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "K":
        return xt(zt.hour11h, n);
      case "Ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.getHours() >= 12 && i < 12 ? n.setHours(i + 12, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class Qk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 70);
    Te(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "k":
        return xt(zt.hour24h, n);
      case "ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 24;
  }
  set(n, a, i) {
    const r = i <= 24 ? i % 24 : i;
    return n.setHours(r, 0, 0, 0), n;
  }
}
class Kk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 60);
    Te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "m":
        return xt(zt.minute, n);
      case "mo":
        return i.ordinalNumber(n, { unit: "minute" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 59;
  }
  set(n, a, i) {
    return n.setMinutes(i, 0, 0), n;
  }
}
class Jk extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 50);
    Te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "s":
        return xt(zt.second, n);
      case "so":
        return i.ordinalNumber(n, { unit: "second" });
      default:
        return Pt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 59;
  }
  set(n, a, i) {
    return n.setSeconds(i, 0), n;
  }
}
class ex extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 30);
    Te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a) {
    const i = (r) => Math.trunc(r * Math.pow(10, -a.length + 3));
    return Ht(Pt(a.length, n), i);
  }
  set(n, a, i) {
    return n.setMilliseconds(i), n;
  }
}
class tx extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 10);
    Te(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, a) {
    switch (a) {
      case "X":
        return Ya(
          Ia.basicOptionalMinutes,
          n
        );
      case "XX":
        return Ya(Ia.basic, n);
      case "XXXX":
        return Ya(
          Ia.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Ya(
          Ia.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Ya(Ia.extended, n);
    }
  }
  set(n, a, i) {
    return a.timestampIsSet ? n : ot(
      n,
      n.getTime() - ll(n) - i
    );
  }
}
class nx extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 10);
    Te(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, a) {
    switch (a) {
      case "x":
        return Ya(
          Ia.basicOptionalMinutes,
          n
        );
      case "xx":
        return Ya(Ia.basic, n);
      case "xxxx":
        return Ya(
          Ia.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Ya(
          Ia.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Ya(Ia.extended, n);
    }
  }
  set(n, a, i) {
    return a.timestampIsSet ? n : ot(
      n,
      n.getTime() - ll(n) - i
    );
  }
}
class ax extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 40);
    Te(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Mp(n);
  }
  set(n, a, i) {
    return [ot(n, i * 1e3), { timestampIsSet: !0 }];
  }
}
class ix extends st {
  constructor() {
    super(...arguments);
    Te(this, "priority", 20);
    Te(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Mp(n);
  }
  set(n, a, i) {
    return [ot(n, i), { timestampIsSet: !0 }];
  }
}
const rx = {
  G: new xk(),
  y: new Mk(),
  Y: new Dk(),
  R: new Sk(),
  u: new Tk(),
  Q: new Ak(),
  q: new Ok(),
  M: new Ck(),
  L: new Ek(),
  w: new Rk(),
  I: new Yk(),
  d: new Lk(),
  D: new Fk(),
  E: new zk(),
  e: new Hk(),
  c: new Wk(),
  i: new Vk(),
  a: new jk(),
  b: new Uk(),
  B: new Gk(),
  h: new qk(),
  H: new Xk(),
  K: new Zk(),
  k: new Qk(),
  m: new Kk(),
  s: new Jk(),
  S: new ex(),
  X: new tx(),
  x: new nx(),
  t: new ax(),
  T: new ix()
}, ox = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, sx = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, lx = /^'([^]*?)'?$/, ux = /''/g, dx = /\S/, cx = /[a-zA-Z]/;
function wd(e, t, n, a) {
  var b, R, V, G, C, q, re, $;
  const i = gk(), r = (a == null ? void 0 : a.locale) ?? i.locale ?? wp, o = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((R = (b = a == null ? void 0 : a.locale) == null ? void 0 : b.options) == null ? void 0 : R.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((G = (V = i.locale) == null ? void 0 : V.options) == null ? void 0 : G.firstWeekContainsDate) ?? 1, l = (a == null ? void 0 : a.weekStartsOn) ?? ((q = (C = a == null ? void 0 : a.locale) == null ? void 0 : C.options) == null ? void 0 : q.weekStartsOn) ?? i.weekStartsOn ?? (($ = (re = i.locale) == null ? void 0 : re.options) == null ? void 0 : $.weekStartsOn) ?? 0;
  if (t === "")
    return e === "" ? Ce(n) : ot(n, NaN);
  const s = {
    firstWeekContainsDate: o,
    weekStartsOn: l,
    locale: r
  }, u = [new kk()], d = t.match(sx).map((A) => {
    const I = A[0];
    if (I in gd) {
      const X = gd[I];
      return X(A, r.formatLong);
    }
    return A;
  }).join("").match(ox), c = [];
  for (let A of d) {
    !(a != null && a.useAdditionalWeekYearTokens) && kp(A) && yd(A, t, e), !(a != null && a.useAdditionalDayOfYearTokens) && _p(A) && yd(A, t, e);
    const I = A[0], X = rx[I];
    if (X) {
      const { incompatibleTokens: j } = X;
      if (Array.isArray(j)) {
        const xe = c.find(
          (be) => j.includes(be.token) || be.token === I
        );
        if (xe)
          throw new RangeError(
            `The format string mustn't contain \`${xe.fullToken}\` and \`${A}\` at the same time`
          );
      } else if (X.incompatibleTokens === "*" && c.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${A}\` and any other token at the same time`
        );
      c.push({ token: I, fullToken: A });
      const oe = X.run(
        e,
        A,
        r.match,
        s
      );
      if (!oe)
        return ot(n, NaN);
      u.push(oe.setter), e = oe.rest;
    } else {
      if (I.match(cx))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + I + "`"
        );
      if (A === "''" ? A = "'" : I === "'" && (A = hx(A)), e.indexOf(A) === 0)
        e = e.slice(A.length);
      else
        return ot(n, NaN);
    }
  }
  if (e.length > 0 && dx.test(e))
    return ot(n, NaN);
  const f = u.map((A) => A.priority).sort((A, I) => I - A).filter((A, I, X) => X.indexOf(A) === I).map(
    (A) => u.filter((I) => I.priority === A).sort((I, X) => X.subPriority - I.subPriority)
  ).map((A) => A[0]);
  let v = Ce(n);
  if (isNaN(v.getTime()))
    return ot(n, NaN);
  const k = {};
  for (const A of f) {
    if (!A.validate(v, s))
      return ot(n, NaN);
    const I = A.set(v, k, s);
    Array.isArray(I) ? (v = I[0], Object.assign(k, I[1])) : v = I;
  }
  return ot(n, v);
}
function hx(e) {
  return e.match(lx)[1].replace(ux, "'");
}
function mf(e, t) {
  const n = Ji(e), a = Ji(t);
  return +n == +a;
}
function fx(e, t) {
  return ya(e, -t);
}
function Tp(e, t) {
  const n = Ce(e), a = n.getFullYear(), i = n.getDate(), r = ot(e, 0);
  r.setFullYear(a, t, 15), r.setHours(0, 0, 0, 0);
  const o = vk(r);
  return n.setMonth(t, Math.min(i, o)), n;
}
function ct(e, t) {
  let n = Ce(e);
  return isNaN(+n) ? ot(e, NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = Tp(n, t.month)), t.date != null && n.setDate(t.date), t.hours != null && n.setHours(t.hours), t.minutes != null && n.setMinutes(t.minutes), t.seconds != null && n.setSeconds(t.seconds), t.milliseconds != null && n.setMilliseconds(t.milliseconds), n);
}
function mx(e, t) {
  const n = Ce(e);
  return n.setHours(t), n;
}
function Ap(e, t) {
  const n = Ce(e);
  return n.setMilliseconds(t), n;
}
function px(e, t) {
  const n = Ce(e);
  return n.setMinutes(t), n;
}
function Op(e, t) {
  const n = Ce(e);
  return n.setSeconds(t), n;
}
function Na(e, t) {
  const n = Ce(e);
  return isNaN(+n) ? ot(e, NaN) : (n.setFullYear(t), n);
}
function zr(e, t) {
  return _a(e, -t);
}
function vx(e, t) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: r = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: s = 0
  } = t, u = zr(e, a + n * 12), d = fx(u, r + i * 7), c = l + o * 60, v = (s + c * 60) * 1e3;
  return ot(e, d.getTime() - v);
}
function Cp(e, t) {
  return lc(e, -t);
}
function Zr() {
  return y(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ee("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      ee("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ee("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ee("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Zr.compatConfig = {
  MODE: 3
};
function Ep() {
  return y(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ee("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      ee("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Ep.compatConfig = {
  MODE: 3
};
function mc() {
  return y(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ee("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
mc.compatConfig = {
  MODE: 3
};
function pc() {
  return y(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ee("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
pc.compatConfig = {
  MODE: 3
};
function vc() {
  return y(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ee("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      ee("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
vc.compatConfig = {
  MODE: 3
};
function gc() {
  return y(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ee("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
gc.compatConfig = {
  MODE: 3
};
function yc() {
  return y(), O(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ee("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
yc.compatConfig = {
  MODE: 3
};
const Rn = (e, t) => t ? new Date(e.toLocaleString("en-US", { timeZone: t })) : new Date(e), wc = (e, t, n) => bd(e, t, n) || ne(), gx = (e, t, n) => {
  const a = t.dateInTz ? Rn(new Date(e), t.dateInTz) : ne(e);
  return n ? xn(a, !0) : a;
}, bd = (e, t, n) => {
  if (!e)
    return null;
  const a = n ? xn(ne(e), !0) : ne(e);
  return t ? t.exactMatch ? gx(e, t, n) : Rn(a, t.timezone) : a;
}, yx = (e) => {
  if (!e)
    return 0;
  const t = /* @__PURE__ */ new Date(), n = new Date(t.toLocaleString("en-US", { timeZone: "UTC" })), a = new Date(t.toLocaleString("en-US", { timeZone: e })), i = a.getTimezoneOffset() / 60;
  return (+n - +a) / (1e3 * 60 * 60) - i;
};
var ga = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(ga || {}), Zi = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(Zi || {}), tr = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(tr || {}), vn = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(vn || {});
const wx = ["timestamp", "date", "iso"];
var bn = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(bn || {}), kt = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(kt || {});
function pf(e) {
  return (t) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`)).slice(0, 2);
}
function bx(e) {
  return (t) => La(Rn(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const _x = (e, t, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let i;
  if (e !== null)
    try {
      i = a.map(bx(e));
    } catch {
      i = a.map(pf(t));
    }
  else
    i = a.map(pf(t));
  const r = i.slice(0, n), o = i.slice(n + 1, i.length);
  return [i[n]].concat(...o).concat(...r);
}, bc = (e, t, n) => {
  const a = [];
  for (let i = +e[0]; i <= +e[1]; i++)
    a.push({ value: +i, text: Yp(i, t) });
  return n ? a.reverse() : a;
}, Pp = (e, t, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((r) => {
    const o = r < 10 ? `0${r}` : r;
    return /* @__PURE__ */ new Date(`2017-${o}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const r = n === "long" ? "LLLL" : "LLL";
      return a.map((o, l) => {
        const s = La(Rn(o, "UTC"), r, { locale: e });
        return {
          text: s.charAt(0).toUpperCase() + s.substring(1),
          value: l
        };
      });
    } catch {
    }
  const i = new Intl.DateTimeFormat(t, { month: n, timeZone: "UTC" });
  return a.map((r, o) => {
    const l = i.format(r);
    return {
      text: l.charAt(0).toUpperCase() + l.substring(1),
      value: o
    };
  });
}, kx = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], Zt = (e) => {
  const t = x(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, xx = (e) => ({ type: "dot", ...e ?? {} }), Rp = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, _c = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Jt = (e) => e, vf = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, gf = (e) => e === null, Ip = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, Mx = (e) => {
  const t = [], n = (a) => a.filter((i) => i);
  for (let a = 0; a < e.length; a += 3) {
    const i = [e[a], e[a + 1], e[a + 2]];
    t.push(n(i));
  }
  return t;
}, Uo = (e, t, n) => {
  const a = n != null, i = t != null;
  if (!a && !i)
    return !1;
  const r = +n, o = +t;
  return a && i ? +e > r || +e < o : a ? +e > r : i ? +e < o : !1;
}, Hr = (e, t) => Mx(e).map((n) => n.map((a) => {
  const { active: i, disabled: r, isBetween: o, highlighted: l } = t(a);
  return {
    ...a,
    active: i,
    disabled: r,
    className: {
      dp__overlay_cell_active: i,
      dp__overlay_cell: !i,
      dp__overlay_cell_disabled: r,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: r && i,
      dp__cell_in_between: o,
      "dp--highlighted": l
    }
  };
})), Ei = (e, t, n = !1) => {
  e && t.allowStopPropagation && (n && e.stopImmediatePropagation(), e.stopPropagation());
}, Dx = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function Sx(e, t) {
  let n = [...document.querySelectorAll(Dx())];
  n = n.filter((i) => !e.contains(i) || i.hasAttribute("data-datepicker-instance"));
  const a = n.indexOf(e);
  if (a >= 0 && (t ? a - 1 >= 0 : a + 1 <= n.length))
    return n[a + (t ? -1 : 1)];
}
const Tx = (e, t) => e == null ? void 0 : e.querySelector(`[data-dp-element="${t}"]`), Yp = (e, t) => new Intl.NumberFormat(t, { useGrouping: !1, style: "decimal" }).format(e), kc = (e) => La(e, "dd-MM-yyyy"), Cu = (e) => Array.isArray(e), dl = (e, t) => t.get(kc(e)), Ax = (e, t) => e ? t ? t instanceof Map ? !!dl(e, t) : t(ne(e)) : !1 : !0, En = (e, t, n = !1) => {
  if (e.key === kt.enter || e.key === kt.space)
    return n && e.preventDefault(), t();
}, yf = (e, t, n, a, i, r) => {
  const o = wd(e, t.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: r });
  return Co(o) && pp(o) ? a || i ? o : ct(o, {
    hours: +n.hours,
    minutes: +(n == null ? void 0 : n.minutes),
    seconds: +(n == null ? void 0 : n.seconds),
    milliseconds: 0
  }) : null;
}, Ox = (e, t, n, a, i, r) => {
  const o = Array.isArray(n) ? n[0] : n;
  if (typeof t == "string")
    return yf(e, t, o, a, i, r);
  if (Array.isArray(t)) {
    let l = null;
    for (const s of t)
      if (l = yf(e, s, o, a, i, r), l)
        break;
    return l;
  }
  return typeof t == "function" ? t(e) : null;
}, ne = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), Cx = (e, t, n) => {
  if (t) {
    const i = (e.getMonth() + 1).toString().padStart(2, "0"), r = e.getDate().toString().padStart(2, "0"), o = e.getHours().toString().padStart(2, "0"), l = e.getMinutes().toString().padStart(2, "0"), s = n ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${i}-${r}T${o}:${l}:${s}.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, xn = (e, t) => {
  const n = ne(JSON.parse(JSON.stringify(e))), a = ct(n, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return t ? x_(a) : a;
}, Pi = (e, t, n, a) => {
  let i = e ? ne(e) : ne();
  return (t || t === 0) && (i = mx(i, +t)), (n || n === 0) && (i = px(i, +n)), (a || a === 0) && (i = Op(i, +a)), Ap(i, 0);
}, Ct = (e, t) => !e || !t ? !1 : jo(xn(e), xn(t)), Ge = (e, t) => !e || !t ? !1 : Mr(xn(e), xn(t)), $t = (e, t) => !e || !t ? !1 : Fr(xn(e), xn(t)), Il = (e, t, n) => e != null && e[0] && e != null && e[1] ? $t(n, e[0]) && Ct(n, e[1]) : e != null && e[0] && t ? $t(n, e[0]) && Ct(n, t) || Ct(n, e[0]) && $t(n, t) : !1, wa = (e) => {
  const t = ct(new Date(e), { date: 1 });
  return xn(t);
}, Eu = (e, t, n) => t && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === t ? [a, n] : [a, isNaN(+e[a]) ? void 0 : +e[a]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, nr = (e) => ({
  hours: di(e),
  minutes: Ii(e),
  seconds: Lr(e)
}), Np = (e, t) => {
  if (t) {
    const n = We(ne(t));
    if (n > e)
      return 12;
    if (n === e)
      return Ue(ne(t));
  }
}, $p = (e, t) => {
  if (t) {
    const n = We(ne(t));
    return n < e ? -1 : n === e ? Ue(ne(t)) : void 0;
  }
}, Wr = (e) => {
  if (e)
    return We(ne(e));
}, Lp = (e, t) => {
  const n = $t(e, t) ? t : e, a = $t(t, e) ? t : e;
  return vp({ start: n, end: a });
}, Ex = (e) => {
  const t = _a(e, 1);
  return { month: Ue(t), year: We(t) };
}, Ka = (e, t) => {
  const n = Ma(e, { weekStartsOn: +t }), a = yp(e, { weekStartsOn: +t });
  return [n, a];
}, Fp = (e, t) => {
  const n = {
    hours: di(ne()),
    minutes: Ii(ne()),
    seconds: t ? Lr(ne()) : 0
  };
  return Object.assign(n, e);
}, Ai = (e, t, n) => [ct(ne(e), { date: 1 }), ct(ne(), { month: t, year: n, date: 1 })], ni = (e, t, n) => {
  let a = e ? ne(e) : ne();
  return (t || t === 0) && (a = Tp(a, t)), n && (a = Na(a, n)), a;
}, zp = (e, t, n, a, i) => {
  if (!a || i && !t || !i && !n)
    return !1;
  const r = i ? _a(e, 1) : zr(e, 1), o = [Ue(r), We(r)];
  return i ? !Rx(...o, t) : !Px(...o, n);
}, Px = (e, t, n) => Ct(...Ai(n, e, t)) || Ge(...Ai(n, e, t)), Rx = (e, t, n) => $t(...Ai(n, e, t)) || Ge(...Ai(n, e, t)), Hp = (e, t, n, a, i, r, o) => {
  if (typeof t == "function" && !o)
    return t(e);
  const l = n ? { locale: n } : void 0;
  return Array.isArray(e) ? `${La(e[0], r, l)}${i && !e[1] ? "" : a}${e[1] ? La(e[1], r, l) : ""}` : La(e, r, l);
}, gr = (e) => {
  if (e)
    return null;
  throw new Error(_c.prop("partial-range"));
}, $s = (e, t) => {
  if (t)
    return e();
  throw new Error(_c.prop("range"));
}, _d = (e) => Array.isArray(e) ? Co(e[0]) && (e[1] ? Co(e[1]) : !0) : e ? Co(e) : !1, Ix = (e, t) => ct(t ?? ne(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), Pu = (e, t, n, a) => {
  if (!e)
    return !0;
  if (a) {
    const i = n === "max" ? jo(e, t) : Fr(e, t), r = { seconds: 0, milliseconds: 0 };
    return i || Mr(ct(e, r), ct(t, r));
  }
  return n === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, Ru = (e, t, n) => e ? Ix(e, t) : ne(n ?? t), wf = (e, t, n, a, i) => {
  if (Array.isArray(a)) {
    const o = Ru(e, a[0], t), l = Ru(e, a[1], t);
    return Pu(a[0], o, n, !!t) && Pu(a[1], l, n, !!t) && i;
  }
  const r = Ru(e, a, t);
  return Pu(a, r, n, !!t) && i;
}, Iu = (e) => ct(ne(), nr(e)), Yx = (e, t) => e instanceof Map ? Array.from(e.values()).filter((n) => We(ne(n)) === t).map((n) => Ue(n)) : [], Wp = (e, t, n) => typeof e == "function" ? e({ month: t, year: n }) : !!e.months.find((a) => a.month === t && a.year === n), xc = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), Bp = (e) => La(e, "yyyy-MM-dd"), _o = Go({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Vp = () => {
  const e = (n) => {
    _o.menuFocused = n;
  }, t = (n) => {
    _o.shiftKeyInMenu !== n && (_o.shiftKeyInMenu = n);
  };
  return {
    control: ae(() => ({ shiftKeyInMenu: _o.shiftKeyInMenu, menuFocused: _o.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, mt = Go({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Yu = he(null), Ls = he(!1), Nu = he(!1), $u = he(!1), Lu = he(!1), mn = he(0), It = he(0), Ni = () => {
  const e = ae(() => Ls.value ? [...mt.selectionGrid, mt.actionRow].filter((c) => c.length) : Nu.value ? [
    ...mt.timePicker[0],
    ...mt.timePicker[1],
    Lu.value ? [] : [Yu.value],
    mt.actionRow
  ].filter((c) => c.length) : $u.value ? [...mt.monthPicker, mt.actionRow] : [mt.monthYear, ...mt.calendar, mt.time, mt.actionRow].filter((c) => c.length)), t = (c) => {
    mn.value = c ? mn.value + 1 : mn.value - 1;
    let f = null;
    e.value[It.value] && (f = e.value[It.value][mn.value]), !f && e.value[It.value + (c ? 1 : -1)] ? (It.value = It.value + (c ? 1 : -1), mn.value = c ? 0 : e.value[It.value].length - 1) : f || (mn.value = c ? mn.value - 1 : mn.value + 1);
  }, n = (c) => {
    It.value === 0 && !c || It.value === e.value.length && c || (It.value = c ? It.value + 1 : It.value - 1, e.value[It.value] ? e.value[It.value] && !e.value[It.value][mn.value] && mn.value !== 0 && (mn.value = e.value[It.value].length - 1) : It.value = c ? It.value - 1 : It.value + 1);
  }, a = (c) => {
    let f = null;
    e.value[It.value] && (f = e.value[It.value][mn.value]), f ? f.focus({ preventScroll: !Ls.value }) : mn.value = c ? mn.value - 1 : mn.value + 1;
  }, i = () => {
    t(!0), a(!0);
  }, r = () => {
    t(!1), a(!1);
  }, o = () => {
    n(!1), a(!0);
  }, l = () => {
    n(!0), a(!0);
  }, s = (c, f) => {
    mt[f] = c;
  }, u = (c, f) => {
    mt[f] = c;
  }, d = () => {
    mn.value = 0, It.value = 0;
  };
  return {
    buildMatrix: s,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (c) => {
      Yu.value = c;
    },
    setSelectionGrid: (c) => {
      Ls.value = c, d(), c || (mt.selectionGrid = []);
    },
    setTimePicker: (c, f = !1) => {
      Nu.value = c, Lu.value = f, d(), c || (mt.timePicker[0] = [], mt.timePicker[1] = []);
    },
    setTimePickerElements: (c, f = 0) => {
      mt.timePicker[f] = c;
    },
    arrowRight: i,
    arrowLeft: r,
    arrowUp: o,
    arrowDown: l,
    clearArrowNav: () => {
      mt.monthYear = [], mt.calendar = [], mt.time = [], mt.actionRow = [], mt.selectionGrid = [], mt.timePicker[0] = [], mt.timePicker[1] = [], Ls.value = !1, Nu.value = !1, Lu.value = !1, $u.value = !1, d(), Yu.value = null;
    },
    setMonthPicker: (c) => {
      $u.value = c, d();
    },
    refSets: mt
    // exposed for testing
  };
}, bf = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), Nx = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  ...e ?? {}
}), _f = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, $x = (e) => {
  const t = typeof e == "object" && e, n = {
    static: !0,
    solo: !1
  };
  if (!e)
    return { ...n, count: _f(!1) };
  const a = t ? e : {}, i = t ? a.count ?? !0 : e, r = _f(i);
  return Object.assign(n, a, { count: r });
}, Lx = (e, t, n) => e || (typeof n == "string" ? n : t), Fx = (e) => typeof e == "boolean" ? e ? bf({}) : !1 : bf(e), zx = (e) => {
  const t = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : { ...t, enabled: e };
}, Hx = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), Wx = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), Bx = (e) => {
  const t = { input: !1 };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...t
  };
}, Vx = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, ...e ?? {} }), jx = (e) => {
  const t = {
    dates: Array.isArray(e) ? e.map((n) => ne(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...t, ...e ?? {} };
}, Ux = (e) => typeof e == "object" ? {
  type: (e == null ? void 0 : e.type) ?? "local",
  hideOnOffsetDates: (e == null ? void 0 : e.hideOnOffsetDates) ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, Gx = (e, t) => typeof e == "object" ? { enabled: !0, ...{
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1
}, ...e } : {
  enabled: e,
  noDisabledRange: t.noDisabledRange,
  showLastInRange: t.showLastInRange,
  minMaxRawRange: t.minMaxRawRange,
  partialRange: t.partialRange,
  disableTimeRangeValidation: t.disableTimeRangeValidation,
  maxRange: t.maxRange,
  minRange: t.minRange,
  autoRange: t.autoRange,
  fixedStart: t.fixedStart,
  fixedEnd: t.fixedEnd
}, qx = (e, t) => e ? typeof e == "string" ? { timezone: e, exactMatch: !1, dateInTz: void 0, emitTimezone: t, convertModel: !0 } : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? !1,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: t ?? e.emitTimezone,
  convertModel: e.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: t }, Fu = (e, t, n) => new Map(
  e.map((a) => {
    const i = wc(a, t, n);
    return [kc(i), i];
  })
), Xx = (e, t) => e.length ? new Map(
  e.map((n) => {
    const a = wc(n.date, t);
    return [kc(a), n];
  })
) : null, Zx = (e) => {
  var t;
  return {
    minDate: bd(e.minDate, e.timezone, e.isSpecific),
    maxDate: bd(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: Cu(e.disabledDates) ? Fu(e.disabledDates, e.timezone, e.isSpecific) : e.disabledDates,
    allowedDates: Cu(e.allowedDates) ? Fu(e.allowedDates, e.timezone, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && Cu((t = e.highlight) == null ? void 0 : t.dates) ? Fu(e.highlight.dates, e.timezone) : e.highlight,
    markers: Xx(e.markers, e.timezone)
  };
}, Qx = (e, t) => typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: +t } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? !0
}, Kx = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((t) => {
      const n = t, a = e[n], i = typeof e[n] == "string" ? { [a]: !0 } : Object.fromEntries(a.map((r) => [r, !0]));
      return [t, i];
    })
  )
}), Mt = (e) => {
  const t = () => {
    const $ = e.enableSeconds ? ":ss" : "", A = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${A}${$}` : `hh${A}${$} aa`;
  }, n = () => {
    var $;
    return e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? `${(($ = R.value) == null ? void 0 : $.type) === "iso" ? "RR" : "ww"}-yyyy` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy";
  }, a = ($) => Fp($, e.enableSeconds), i = () => q.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [a(e.startTime[0]), a(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? a(e.startTime) : null, r = ae(() => $x(e.multiCalendars)), o = ae(() => i()), l = ae(() => Nx(e.ariaLabels)), s = ae(() => Hx(e.filters)), u = ae(() => Fx(e.transitions)), d = ae(() => Wx(e.actionRow)), c = ae(
    () => Lx(e.previewFormat, e.format, n())
  ), f = ae(() => zx(e.textInput)), v = ae(() => Bx(e.inline)), k = ae(() => Vx(e.config)), b = ae(() => jx(e.highlight)), R = ae(() => Ux(e.weekNumbers)), V = ae(() => qx(e.timezone, e.emitTimezone)), G = ae(() => Qx(e.multiDates, e.multiDatesLimit)), C = ae(
    () => Zx({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: b.value,
      markers: e.markers,
      timezone: V.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker
    })
  ), q = ae(
    () => Gx(e.range, {
      minMaxRawRange: !1,
      maxRange: e.maxRange,
      minRange: e.minRange,
      noDisabledRange: e.noDisabledRange,
      showLastInRange: e.showLastInRange,
      partialRange: e.partialRange,
      disableTimeRangeValidation: e.disableTimeRangeValidation,
      autoRange: e.autoRange,
      fixedStart: e.fixedStart,
      fixedEnd: e.fixedEnd
    })
  ), re = ae(() => Kx(e.ui));
  return {
    defaultedTransitions: u,
    defaultedMultiCalendars: r,
    defaultedStartTime: o,
    defaultedAriaLabels: l,
    defaultedFilters: s,
    defaultedActionRow: d,
    defaultedPreviewFormat: c,
    defaultedTextInput: f,
    defaultedInline: v,
    defaultedConfig: k,
    defaultedHighlight: b,
    defaultedWeekNumbers: R,
    defaultedRange: q,
    propDates: C,
    defaultedTz: V,
    defaultedMultiDates: G,
    defaultedUI: re,
    getDefaultPattern: n,
    getDefaultStartTime: i
  };
}, Jx = (e, t, n) => {
  const a = he(), { defaultedTextInput: i, defaultedRange: r, defaultedTz: o, defaultedMultiDates: l, getDefaultPattern: s } = Mt(t), u = he(""), d = Lo(t, "format"), c = Lo(t, "formatLocale");
  ra(
    a,
    () => {
      typeof t.onInternalModelChange == "function" && e("internal-model-change", a.value, pe(!0));
    },
    { deep: !0 }
  ), ra(r, (M, ye) => {
    M.enabled !== ye.enabled && (a.value = null);
  }), ra(d, () => {
    U();
  });
  const f = (M) => o.value.timezone && o.value.convertModel ? Rn(M, o.value.timezone) : M, v = (M) => {
    if (o.value.timezone && o.value.convertModel) {
      const ye = yx(o.value.timezone);
      return v_(M, ye);
    }
    return M;
  }, k = (M, ye, ce = !1) => Hp(
    M,
    t.format,
    t.formatLocale,
    i.value.rangeSeparator,
    t.modelAuto,
    ye ?? s(),
    ce
  ), b = (M) => M ? t.modelType ? fe(M) : {
    hours: di(M),
    minutes: Ii(M),
    seconds: t.enableSeconds ? Lr(M) : 0
  } : null, R = (M) => t.modelType ? fe(M) : { month: Ue(M), year: We(M) }, V = (M) => Array.isArray(M) ? l.value.enabled ? M.map((ye) => G(ye, Na(ne(), ye))) : $s(
    () => [
      Na(ne(), M[0]),
      M[1] ? Na(ne(), M[1]) : gr(r.value.partialRange)
    ],
    r.value.enabled
  ) : Na(ne(), +M), G = (M, ye) => (typeof M == "string" || typeof M == "number") && t.modelType ? ie(M) : ye, C = (M) => Array.isArray(M) ? [
    G(
      M[0],
      Pi(null, +M[0].hours, +M[0].minutes, M[0].seconds)
    ),
    G(
      M[1],
      Pi(null, +M[1].hours, +M[1].minutes, M[1].seconds)
    )
  ] : G(M, Pi(null, M.hours, M.minutes, M.seconds)), q = (M) => {
    const ye = ct(ne(), { date: 1 });
    return Array.isArray(M) ? l.value.enabled ? M.map((ce) => G(ce, ni(ye, +ce.month, +ce.year))) : $s(
      () => [
        G(M[0], ni(ye, +M[0].month, +M[0].year)),
        G(
          M[1],
          M[1] ? ni(ye, +M[1].month, +M[1].year) : gr(r.value.partialRange)
        )
      ],
      r.value.enabled
    ) : G(M, ni(ye, +M.month, +M.year));
  }, re = (M) => {
    if (Array.isArray(M))
      return M.map((ye) => ie(ye));
    throw new Error(_c.dateArr("multi-dates"));
  }, $ = (M) => {
    if (Array.isArray(M) && r.value.enabled) {
      const ye = M[0], ce = M[1];
      return [
        ne(Array.isArray(ye) ? ye[0] : null),
        ne(Array.isArray(ce) ? ce[0] : null)
      ];
    }
    return ne(M[0]);
  }, A = (M) => t.modelAuto ? Array.isArray(M) ? [ie(M[0]), ie(M[1])] : t.autoApply ? [ie(M)] : [ie(M), null] : Array.isArray(M) ? $s(
    () => M[1] ? [
      ie(M[0]),
      M[1] ? ie(M[1]) : gr(r.value.partialRange)
    ] : [ie(M[0])],
    r.value.enabled
  ) : ie(M), I = () => {
    Array.isArray(a.value) && r.value.enabled && a.value.length === 1 && a.value.push(gr(r.value.partialRange));
  }, X = () => {
    const M = a.value;
    return [
      fe(M[0]),
      M[1] ? fe(M[1]) : gr(r.value.partialRange)
    ];
  }, j = () => a.value[1] ? X() : fe(Jt(a.value[0])), oe = () => (a.value || []).map((M) => fe(M)), xe = (M = !1) => (M || I(), t.modelAuto ? j() : l.value.enabled ? oe() : Array.isArray(a.value) ? $s(() => X(), r.value.enabled) : fe(Jt(a.value))), be = (M) => !M || Array.isArray(M) && !M.length ? null : t.timePicker ? C(Jt(M)) : t.monthPicker ? q(Jt(M)) : t.yearPicker ? V(Jt(M)) : l.value.enabled ? re(Jt(M)) : t.weekPicker ? $(Jt(M)) : A(Jt(M)), H = (M) => {
    const ye = be(M);
    _d(Jt(ye)) ? (a.value = Jt(ye), U()) : (a.value = null, u.value = "");
  }, _ = () => {
    const M = (ye) => La(ye, i.value.format);
    return `${M(a.value[0])} ${i.value.rangeSeparator} ${a.value[1] ? M(a.value[1]) : ""}`;
  }, Y = () => n.value && a.value ? Array.isArray(a.value) ? _() : La(a.value, i.value.format) : k(a.value), p = () => a.value ? l.value.enabled ? a.value.map((M) => k(M)).join("; ") : i.value.enabled && typeof i.value.format == "string" ? Y() : k(a.value) : "", U = () => {
    !t.format || typeof t.format == "string" || i.value.enabled && typeof i.value.format == "string" ? u.value = p() : u.value = t.format(a.value);
  }, ie = (M) => {
    if (t.utc) {
      const ye = new Date(M);
      return t.utc === "preserve" ? new Date(ye.getTime() + ye.getTimezoneOffset() * 6e4) : ye;
    }
    return t.modelType ? wx.includes(t.modelType) ? f(new Date(M)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? f(
      wd(M, s(), /* @__PURE__ */ new Date(), { locale: c.value })
    ) : f(
      wd(M, t.modelType, /* @__PURE__ */ new Date(), { locale: c.value })
    ) : f(new Date(M));
  }, fe = (M) => M ? t.utc ? Cx(M, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +v(M) : t.modelType === "iso" ? v(M).toISOString() : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? k(v(M)) : k(v(M), t.modelType, !0) : v(M) : "", J = (M, ye = !1, ce = !1) => {
    if (ce)
      return M;
    if (e("update:model-value", M), o.value.emitTimezone && ye) {
      const T = Array.isArray(M) ? M.map((Me) => Rn(Jt(Me), o.value.emitTimezone)) : Rn(Jt(M), o.value.emitTimezone);
      e("update:model-timezone-value", T);
    }
  }, D = (M) => Array.isArray(a.value) ? l.value.enabled ? a.value.map((ye) => M(ye)) : [
    M(a.value[0]),
    a.value[1] ? M(a.value[1]) : gr(r.value.partialRange)
  ] : M(Jt(a.value)), Q = () => {
    if (Array.isArray(a.value)) {
      const M = Ka(a.value[0], t.weekStart), ye = a.value[1] ? Ka(a.value[1], t.weekStart) : [];
      return [M.map((ce) => ne(ce)), ye.map((ce) => ne(ce))];
    }
    return Ka(a.value, t.weekStart).map((M) => ne(M));
  }, m = (M, ye) => J(Jt(D(M)), !1, ye), S = (M) => {
    const ye = Q();
    return M ? ye : e("update:model-value", Q());
  }, pe = (M = !1) => (M || U(), t.monthPicker ? m(R, M) : t.timePicker ? m(b, M) : t.yearPicker ? m(We, M) : t.weekPicker ? S(M) : J(xe(M), !0, M));
  return {
    inputValue: u,
    internalModelValue: a,
    checkBeforeEmit: () => a.value ? r.value.enabled ? r.value.partialRange ? a.value.length >= 1 : a.value.length === 2 : !!a.value : !1,
    parseExternalModelValue: H,
    formatInputValue: U,
    emitModelValue: pe
  };
}, eM = (e, t) => {
  const { defaultedFilters: n, propDates: a } = Mt(e), { validateMonthYearInRange: i } = $i(e), r = (d, c) => {
    let f = d;
    return n.value.months.includes(Ue(f)) ? (f = c ? _a(d, 1) : zr(d, 1), r(f, c)) : f;
  }, o = (d, c) => {
    let f = d;
    return n.value.years.includes(We(f)) ? (f = c ? lc(d, 1) : Cp(d, 1), o(f, c)) : f;
  }, l = (d, c = !1) => {
    const f = ct(ne(), { month: e.month, year: e.year });
    let v = d ? _a(f, 1) : zr(f, 1);
    e.disableYearSelect && (v = Na(v, e.year));
    let k = Ue(v), b = We(v);
    n.value.months.includes(k) && (v = r(v, d), k = Ue(v), b = We(v)), n.value.years.includes(b) && (v = o(v, d), b = We(v)), i(k, b, d, e.preventMinMaxNavigation) && s(k, b, c);
  }, s = (d, c, f) => {
    t("update-month-year", { month: d, year: c, fromNav: f });
  }, u = ae(() => (d) => zp(
    ct(ne(), { month: e.month, year: e.year }),
    a.value.maxDate,
    a.value.minDate,
    e.preventMinMaxNavigation,
    d
  ));
  return { handleMonthYearChange: l, isDisabled: u, updateMonthYear: s };
}, Yl = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, Sa = {
  ...Yl,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 }
}, tM = ["title"], nM = ["disabled"], aM = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Sa
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const n = t, a = e, {
      defaultedActionRow: i,
      defaultedPreviewFormat: r,
      defaultedMultiCalendars: o,
      defaultedTextInput: l,
      defaultedInline: s,
      defaultedRange: u,
      defaultedMultiDates: d,
      getDefaultPattern: c
    } = Mt(a), { isTimeValid: f, isMonthValid: v } = $i(a), { buildMatrix: k } = Ni(), b = he(null), R = he(null), V = he(!1), G = he({}), C = he(null), q = he(null);
    wn(() => {
      a.arrowNavigation && k([Zt(b), Zt(R)], "actionRow"), re(), window.addEventListener("resize", re);
    }), vl(() => {
      window.removeEventListener("resize", re);
    });
    const re = () => {
      V.value = !1, setTimeout(() => {
        var _, Y;
        const p = (_ = C.value) == null ? void 0 : _.getBoundingClientRect(), U = (Y = q.value) == null ? void 0 : Y.getBoundingClientRect();
        p && U && (G.value.maxWidth = `${U.width - p.width - 20}px`), V.value = !0;
      }, 0);
    }, $ = ae(() => u.value.enabled && !u.value.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), A = ae(
      () => !f.value(a.internalModelValue) || !v.value(a.internalModelValue) || !$.value
    ), I = () => {
      const _ = r.value;
      return a.timePicker || a.monthPicker, _(Jt(a.internalModelValue));
    }, X = () => {
      const _ = a.internalModelValue;
      return o.value.count > 0 ? `${j(_[0])} - ${j(_[1])}` : [j(_[0]), j(_[1])];
    }, j = (_) => Hp(
      _,
      r.value,
      a.formatLocale,
      l.value.rangeSeparator,
      a.modelAuto,
      c()
    ), oe = ae(() => !a.internalModelValue || !a.menuMount ? "" : typeof r.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? X() : d.value.enabled ? a.internalModelValue.map((_) => `${j(_)}`) : a.modelAuto ? `${j(a.internalModelValue[0])}` : `${j(a.internalModelValue[0])} -` : j(a.internalModelValue) : I()), xe = () => d.value.enabled ? "; " : " - ", be = ae(
      () => Array.isArray(oe.value) ? oe.value.join(xe()) : oe.value
    ), H = () => {
      f.value(a.internalModelValue) && v.value(a.internalModelValue) && $.value ? n("select-date") : n("invalid-select");
    };
    return (_, Y) => (y(), O("div", {
      ref_key: "actionRowRef",
      ref: q,
      class: "dp__action_row"
    }, [
      _.$slots["action-row"] ? me(_.$slots, "action-row", tn(Ft({ key: 0 }, {
        internalModelValue: _.internalModelValue,
        disabled: A.value,
        selectDate: () => _.$emit("select-date"),
        closePicker: () => _.$emit("close-picker")
      }))) : (y(), O(Fe, { key: 1 }, [
        x(i).showPreview ? (y(), O("div", {
          key: 0,
          class: "dp__selection_preview",
          title: be.value,
          style: kn(G.value)
        }, [
          _.$slots["action-preview"] && V.value ? me(_.$slots, "action-preview", {
            key: 0,
            value: _.internalModelValue
          }) : F("", !0),
          !_.$slots["action-preview"] && V.value ? (y(), O(Fe, { key: 1 }, [
            sa(et(be.value), 1)
          ], 64)) : F("", !0)
        ], 12, tM)) : F("", !0),
        ee("div", {
          ref_key: "actionBtnContainer",
          ref: C,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          _.$slots["action-buttons"] ? me(_.$slots, "action-buttons", {
            key: 0,
            value: _.internalModelValue
          }) : F("", !0),
          _.$slots["action-buttons"] ? F("", !0) : (y(), O(Fe, { key: 1 }, [
            !x(s).enabled && x(i).showCancel ? (y(), O("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: b,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: Y[0] || (Y[0] = (p) => _.$emit("close-picker")),
              onKeydown: Y[1] || (Y[1] = (p) => x(En)(p, () => _.$emit("close-picker")))
            }, et(_.cancelText), 545)) : F("", !0),
            x(i).showNow ? (y(), O("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: Y[2] || (Y[2] = (p) => _.$emit("select-now")),
              onKeydown: Y[3] || (Y[3] = (p) => x(En)(p, () => _.$emit("select-now")))
            }, et(_.nowButtonLabel), 33)) : F("", !0),
            x(i).showSelect ? (y(), O("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: R,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: A.value,
              "data-test": "select-button",
              onKeydown: Y[4] || (Y[4] = (p) => x(En)(p, () => H())),
              onClick: H
            }, et(_.selectText), 41, nM)) : F("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), iM = { class: "dp__selection_grid_header" }, rM = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], oM = ["aria-label"], Ko = /* @__PURE__ */ nn({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: n }) {
    const { setSelectionGrid: a, buildMultiLevelMatrix: i, setMonthPicker: r } = Ni(), o = n, l = e, { defaultedAriaLabels: s, defaultedTextInput: u, defaultedConfig: d } = Mt(
      l
    ), { hideNavigationButtons: c } = Ll(), f = he(!1), v = he(null), k = he(null), b = he([]), R = he(), V = he(null), G = he(0), C = he(null);
    Kv(() => {
      v.value = null;
    }), wn(() => {
      Un().then(() => oe()), l.noOverlayFocus || re(), q(!0);
    }), vl(() => q(!1));
    const q = (D) => {
      var Q;
      l.arrowNavigation && ((Q = l.headerRefs) != null && Q.length ? r(D) : a(D));
    }, re = () => {
      var D;
      const Q = Zt(k);
      Q && (u.value.enabled || (v.value ? (D = v.value) == null || D.focus({ preventScroll: !0 }) : Q.focus({ preventScroll: !0 })), f.value = Q.clientHeight < Q.scrollHeight);
    }, $ = ae(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !l.useRelative,
        "dp--overlay-relative": l.useRelative
      })
    ), A = ae(
      () => l.useRelative ? { height: `${l.height}px`, width: "260px" } : void 0
    ), I = ae(() => ({
      dp__overlay_col: !0
    })), X = ae(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: f.value,
        dp__button_bottom: l.isLast
      })
    ), j = ae(() => {
      var D, Q;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((D = l.items) == null ? void 0 : D.length) <= 6,
        dp__container_block: ((Q = l.items) == null ? void 0 : Q.length) > 6
      };
    });
    ra(
      () => l.items,
      () => oe(!1),
      { deep: !0 }
    );
    const oe = (D = !0) => {
      Un().then(() => {
        const Q = Zt(v), m = Zt(k), S = Zt(V), pe = Zt(C), M = S ? S.getBoundingClientRect().height : 0;
        m && (m.getBoundingClientRect().height ? G.value = m.getBoundingClientRect().height - M : G.value = d.value.modeHeight - M), Q && pe && D && (pe.scrollTop = Q.offsetTop - pe.offsetTop - (G.value / 2 - Q.getBoundingClientRect().height) - M);
      });
    }, xe = (D) => {
      D.disabled || o("selected", D.value);
    }, be = () => {
      o("toggle"), o("reset-flow");
    }, H = () => {
      l.escClose && be();
    }, _ = (D, Q, m, S) => {
      D && ((Q.active || Q.value === l.focusValue) && (v.value = D), l.arrowNavigation && (Array.isArray(b.value[m]) ? b.value[m][S] = D : b.value[m] = [D], Y()));
    }, Y = () => {
      var D, Q;
      const m = (D = l.headerRefs) != null && D.length ? [l.headerRefs].concat(b.value) : b.value.concat([l.skipButtonRef ? [] : [V.value]]);
      i(Jt(m), (Q = l.headerRefs) != null && Q.length ? "monthPicker" : "selectionGrid");
    }, p = (D) => {
      l.arrowNavigation || Ei(D, d.value, !0);
    }, U = (D) => {
      R.value = D, o("hover-value", D);
    }, ie = () => {
      if (be(), !l.isLast) {
        const D = Tx(l.menuWrapRef ?? null, "action-row");
        if (D) {
          const Q = Ip(D);
          Q == null || Q.focus();
        }
      }
    }, fe = (D) => {
      switch (D.key) {
        case kt.esc:
          return H();
        case kt.arrowLeft:
          return p(D);
        case kt.arrowRight:
          return p(D);
        case kt.arrowUp:
          return p(D);
        case kt.arrowDown:
          return p(D);
        default:
          return;
      }
    }, J = (D) => {
      if (D.key === kt.enter)
        return be();
      if (D.key === kt.tab)
        return ie();
    };
    return t({ focusGrid: re }), (D, Q) => {
      var m;
      return y(), O("div", {
        ref_key: "gridWrapRef",
        ref: k,
        class: Ne($.value),
        style: kn(A.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: fe,
        onClick: Q[0] || (Q[0] = ii(() => {
        }, ["prevent"]))
      }, [
        ee("div", {
          ref_key: "containerRef",
          ref: C,
          class: Ne(j.value),
          role: "grid",
          style: kn({ "--dp-overlay-height": `${G.value}px` })
        }, [
          ee("div", iM, [
            me(D.$slots, "header")
          ]),
          D.$slots.overlay ? me(D.$slots, "overlay", { key: 0 }) : (y(!0), O(Fe, { key: 1 }, Xe(D.items, (S, pe) => (y(), O("div", {
            key: pe,
            class: Ne(["dp__overlay_row", { dp__flex_row: D.items.length >= 3 }]),
            role: "row"
          }, [
            (y(!0), O(Fe, null, Xe(S, (M, ye) => (y(), O("div", {
              key: M.value,
              ref_for: !0,
              ref: (ce) => _(ce, M, pe, ye),
              role: "gridcell",
              class: Ne(I.value),
              "aria-selected": M.active || void 0,
              "aria-disabled": M.disabled || void 0,
              tabindex: "0",
              "data-test": M.text,
              onClick: ii((ce) => xe(M), ["prevent"]),
              onKeydown: (ce) => x(En)(ce, () => xe(M), !0),
              onMouseover: (ce) => U(M.value)
            }, [
              ee("div", {
                class: Ne(M.className)
              }, [
                D.$slots.item ? me(D.$slots, "item", {
                  key: 0,
                  item: M
                }) : F("", !0),
                D.$slots.item ? F("", !0) : (y(), O(Fe, { key: 1 }, [
                  sa(et(M.text), 1)
                ], 64))
              ], 2)
            ], 42, rM))), 128))
          ], 2))), 128))
        ], 6),
        D.$slots["button-icon"] ? ai((y(), O("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: V,
          type: "button",
          "aria-label": (m = x(s)) == null ? void 0 : m.toggleOverlay,
          class: Ne(X.value),
          tabindex: "0",
          onClick: be,
          onKeydown: J
        }, [
          me(D.$slots, "button-icon")
        ], 42, oM)), [
          [Sr, !x(c)(D.hideNavigation, D.type)]
        ]) : F("", !0)
      ], 38);
    };
  }
}), Nl = /* @__PURE__ */ nn({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ae(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), a = ae(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (i, r) => (y(), O("div", {
      class: Ne({
        dp__menu_inner: !i.stretch,
        "dp--menu--inner-stretched": i.stretch,
        dp__flex_display: i.multiCalendars > 0,
        "dp--flex-display-collapsed": i.collapse
      })
    }, [
      (y(!0), O(Fe, null, Xe(n.value, (o, l) => (y(), O("div", {
        key: o,
        class: Ne(a.value)
      }, [
        me(i.$slots, "default", {
          instance: o,
          index: l
        })
      ], 2))), 128))
    ], 2));
  }
}), sM = ["aria-label", "aria-disabled"], Eo = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const n = t, a = he(null);
    return wn(() => n("set-ref", a)), (i, r) => (y(), O("button", {
      ref_key: "elRef",
      ref: a,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": i.ariaLabel,
      "aria-disabled": i.disabled || void 0,
      onClick: r[0] || (r[0] = (o) => i.$emit("activate")),
      onKeydown: r[1] || (r[1] = (o) => x(En)(o, () => i.$emit("activate"), !0))
    }, [
      ee("span", {
        class: Ne(["dp__inner_nav", { dp__inner_nav_disabled: i.disabled }])
      }, [
        me(i.$slots, "default")
      ], 2)
    ], 40, sM));
  }
}), lM = { class: "dp--year-mode-picker" }, uM = ["aria-label", "data-test"], jp = /* @__PURE__ */ nn({
  __name: "YearModePicker",
  props: {
    ...Sa,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const n = t, a = e, { showRightIcon: i, showLeftIcon: r } = Ll(), { defaultedConfig: o, defaultedMultiCalendars: l, defaultedAriaLabels: s, defaultedTransitions: u, defaultedUI: d } = Mt(a), { showTransition: c, transitionName: f } = Jo(u), v = (R = !1, V) => {
      n("toggle-year-picker", { flow: R, show: V });
    }, k = (R) => {
      n("year-select", R);
    }, b = (R = !1) => {
      n("handle-year", R);
    };
    return (R, V) => {
      var G, C, q, re, $;
      return y(), O("div", lM, [
        x(r)(x(l), e.instance) ? (y(), le(Eo, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": (G = x(s)) == null ? void 0 : G.prevYear,
          disabled: e.isDisabled(!1),
          class: Ne((C = x(d)) == null ? void 0 : C.navBtnPrev),
          onActivate: V[0] || (V[0] = (A) => b(!1))
        }, {
          default: De(() => [
            R.$slots["arrow-left"] ? me(R.$slots, "arrow-left", { key: 0 }) : F("", !0),
            R.$slots["arrow-left"] ? F("", !0) : (y(), le(x(mc), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : F("", !0),
        ee("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (q = x(s)) == null ? void 0 : q.openYearsOverlay,
          "data-test": `year-mode-btn-${e.instance}`,
          onClick: V[1] || (V[1] = () => v(!1)),
          onKeydown: V[2] || (V[2] = Hf(() => v(!1), ["enter"]))
        }, [
          R.$slots.year ? me(R.$slots, "year", {
            key: 0,
            year: e.year
          }) : F("", !0),
          R.$slots.year ? F("", !0) : (y(), O(Fe, { key: 1 }, [
            sa(et(e.year), 1)
          ], 64))
        ], 40, uM),
        x(i)(x(l), e.instance) ? (y(), le(Eo, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (re = x(s)) == null ? void 0 : re.nextYear,
          disabled: e.isDisabled(!0),
          class: Ne(($ = x(d)) == null ? void 0 : $.navBtnNext),
          onActivate: V[3] || (V[3] = (A) => b(!0))
        }, {
          default: De(() => [
            R.$slots["arrow-right"] ? me(R.$slots, "arrow-right", { key: 0 }) : F("", !0),
            R.$slots["arrow-right"] ? F("", !0) : (y(), le(x(pc), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : F("", !0),
        Pe(Ri, {
          name: x(f)(e.showYearPicker),
          css: x(c)
        }, {
          default: De(() => [
            e.showYearPicker ? (y(), le(Ko, {
              key: 0,
              items: e.items,
              "text-input": R.textInput,
              "esc-close": R.escClose,
              config: R.config,
              "is-last": R.autoApply && !x(o).keepActionRow,
              "hide-navigation": R.hideNavigation,
              "aria-labels": R.ariaLabels,
              type: "year",
              onToggle: v,
              onSelected: V[4] || (V[4] = (A) => k(A))
            }, gn({
              "button-icon": De(() => [
                R.$slots["calendar-icon"] ? me(R.$slots, "calendar-icon", { key: 0 }) : F("", !0),
                R.$slots["calendar-icon"] ? F("", !0) : (y(), le(x(Zr), { key: 1 }))
              ]),
              _: 2
            }, [
              R.$slots["year-overlay-value"] ? {
                name: "item",
                fn: De(({ item: A }) => [
                  me(R.$slots, "year-overlay-value", {
                    text: A.text,
                    value: A.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels"])) : F("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Mc = (e, t, n) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((a) => Ge(e, a))) {
      const a = t.value.filter((i) => !Ge(i, e));
      t.value = a.length ? a : null;
    } else
      (n && +n > t.value.length || !n) && t.value.push(e);
  else
    t.value = [e];
}, Dc = (e, t, n) => {
  let a = e.value ? e.value.slice() : [];
  return a.length === 2 && a[1] !== null && (a = []), a.length ? Ct(t, a[0]) ? (a.unshift(t), n("range-start", a[0]), n("range-start", a[1])) : (a[1] = t, n("range-end", t)) : (a = [t], n("range-start", t)), a;
}, $l = (e, t, n, a) => {
  e && (e[0] && e[1] && n && t("auto-apply"), e[0] && !e[1] && a && n && t("auto-apply"));
}, Up = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => Rn(ne(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = Rn(ne(e.value), e.timezone));
}, Gp = (e, t, n, a) => Array.isArray(t.value) && (t.value.length === 2 || t.value.length === 1 && a.value.partialRange) ? a.value.fixedStart && ($t(e, t.value[0]) || Ge(e, t.value[0])) ? [t.value[0], e] : a.value.fixedEnd && (Ct(e, t.value[1]) || Ge(e, t.value[1])) ? [e, t.value[1]] : (n("invalid-fixed-range", e), t.value) : [], qp = ({
  multiCalendars: e,
  range: t,
  highlight: n,
  propDates: a,
  calendars: i,
  modelValue: r,
  props: o,
  filters: l,
  year: s,
  month: u,
  emit: d
}) => {
  const c = ae(() => bc(o.yearRange, o.locale, o.reverseYears)), f = he([!1]), v = ae(() => (j, oe) => {
    const xe = ct(wa(/* @__PURE__ */ new Date()), {
      month: u.value(j),
      year: s.value(j)
    }), be = oe ? gp(xe) : Vo(xe);
    return zp(
      be,
      a.value.maxDate,
      a.value.minDate,
      o.preventMinMaxNavigation,
      oe
    );
  }), k = () => Array.isArray(r.value) && e.value.solo && r.value[1], b = () => {
    for (let j = 0; j < e.value.count; j++)
      if (j === 0)
        i.value[j] = i.value[0];
      else if (j === e.value.count - 1 && k())
        i.value[j] = {
          month: Ue(r.value[1]),
          year: We(r.value[1])
        };
      else {
        const oe = ct(ne(), i.value[j - 1]);
        i.value[j] = { month: Ue(oe), year: We(lc(oe, 1)) };
      }
  }, R = (j) => {
    if (!j)
      return b();
    const oe = ct(ne(), i.value[j]);
    return i.value[0].year = We(Cp(oe, e.value.count - 1)), b();
  }, V = (j, oe) => {
    const xe = __(oe, j);
    return t.value.showLastInRange && xe > 1 ? oe : j;
  }, G = (j) => o.focusStartDate || e.value.solo ? j[0] : j[1] ? V(j[0], j[1]) : j[0], C = () => {
    if (r.value) {
      const j = Array.isArray(r.value) ? G(r.value) : r.value;
      i.value[0] = { month: Ue(j), year: We(j) };
    }
  }, q = () => {
    C(), e.value.count && b();
  };
  ra(r, (j, oe) => {
    o.isTextInputDate && JSON.stringify(j ?? {}) !== JSON.stringify(oe ?? {}) && q();
  }), wn(() => {
    q();
  });
  const re = (j, oe) => {
    i.value[oe].year = j, d("update-month-year", { instance: oe, year: j, month: i.value[oe].month }), e.value.count && !e.value.solo && R(oe);
  }, $ = ae(() => (j) => Hr(c.value, (oe) => {
    var xe;
    const be = s.value(j) === oe.value, H = Uo(
      oe.value,
      Wr(a.value.minDate),
      Wr(a.value.maxDate)
    ) || ((xe = l.value.years) == null ? void 0 : xe.includes(s.value(j))), _ = xc(n.value, oe.value);
    return { active: be, disabled: H, highlighted: _ };
  })), A = (j, oe) => {
    re(j, oe), X(oe);
  }, I = (j, oe = !1) => {
    if (!v.value(j, oe)) {
      const xe = oe ? s.value(j) + 1 : s.value(j) - 1;
      re(xe, j);
    }
  }, X = (j, oe = !1, xe) => {
    oe || d("reset-flow"), xe !== void 0 ? f.value[j] = xe : f.value[j] = !f.value[j], f.value[j] ? d("overlay-toggle", { open: !0, overlay: vn.year }) : (d("overlay-closed"), d("overlay-toggle", { open: !1, overlay: vn.year }));
  };
  return {
    isDisabled: v,
    groupedYears: $,
    showYearPicker: f,
    selectYear: re,
    toggleYearPicker: X,
    handleYearSelect: A,
    handleYear: I
  };
}, dM = (e, t) => {
  const {
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: i,
    defaultedConfig: r,
    defaultedRange: o,
    defaultedHighlight: l,
    propDates: s,
    defaultedTz: u,
    defaultedFilters: d,
    defaultedMultiDates: c
  } = Mt(e), f = () => {
    e.isTextInputDate && q(We(ne(e.startDate)), 0);
  }, { modelValue: v, year: k, month: b, calendars: R } = es(e, t, f), V = ae(() => Pp(e.formatLocale, e.locale, e.monthNameFormat)), G = he(null), { checkMinMaxRange: C } = $i(e), {
    selectYear: q,
    groupedYears: re,
    showYearPicker: $,
    toggleYearPicker: A,
    handleYearSelect: I,
    handleYear: X,
    isDisabled: j
  } = qp({
    modelValue: v,
    multiCalendars: n,
    range: o,
    highlight: l,
    calendars: R,
    year: k,
    propDates: s,
    month: b,
    filters: d,
    props: e,
    emit: t
  });
  wn(() => {
    e.startDate && (v.value && e.focusStartDate || !v.value) && q(We(ne(e.startDate)), 0);
  });
  const oe = (m) => m ? { month: Ue(m), year: We(m) } : { month: null, year: null }, xe = () => v.value ? Array.isArray(v.value) ? v.value.map((m) => oe(m)) : oe(v.value) : oe(), be = (m, S) => {
    const pe = R.value[m], M = xe();
    return Array.isArray(M) ? M.some((ye) => ye.year === (pe == null ? void 0 : pe.year) && ye.month === S) : (pe == null ? void 0 : pe.year) === M.year && S === M.month;
  }, H = (m, S, pe) => {
    var M, ye;
    const ce = xe();
    return Array.isArray(ce) ? k.value(S) === ((M = ce[pe]) == null ? void 0 : M.year) && m === ((ye = ce[pe]) == null ? void 0 : ye.month) : !1;
  }, _ = (m, S) => {
    if (o.value.enabled) {
      const pe = xe();
      if (Array.isArray(v.value) && Array.isArray(pe)) {
        const M = H(m, S, 0) || H(m, S, 1), ye = ni(wa(ne()), m, k.value(S));
        return Il(v.value, G.value, ye) && !M;
      }
      return !1;
    }
    return !1;
  }, Y = ae(() => (m) => Hr(V.value, (S) => {
    var pe;
    const M = be(m, S.value), ye = Uo(
      S.value,
      Np(k.value(m), s.value.minDate),
      $p(k.value(m), s.value.maxDate)
    ) || Yx(s.value.disabledDates, k.value(m)).includes(S.value) || ((pe = d.value.months) == null ? void 0 : pe.includes(S.value)), ce = _(S.value, m), T = Wp(l.value, S.value, k.value(m));
    return { active: M, disabled: ye, isBetween: ce, highlighted: T };
  })), p = (m, S) => ni(wa(ne()), m, k.value(S)), U = (m, S) => {
    const pe = v.value ? v.value : wa(/* @__PURE__ */ new Date());
    v.value = ni(pe, m, k.value(S)), t("auto-apply"), t("update-flow-step");
  }, ie = (m, S) => {
    const pe = p(m, S);
    o.value.fixedEnd || o.value.fixedStart ? v.value = Gp(pe, v, t, o) : v.value ? C(pe, v.value) && (v.value = Dc(v, p(m, S), t)) : v.value = [p(m, S)], Un().then(() => {
      $l(v.value, t, e.autoApply, e.modelAuto);
    });
  }, fe = (m, S) => {
    Mc(p(m, S), v, c.value.limit), t("auto-apply", !0);
  }, J = (m, S) => (R.value[S].month = m, Q(S, R.value[S].year, m), c.value.enabled ? fe(m, S) : o.value.enabled ? ie(m, S) : U(m, S)), D = (m, S) => {
    q(m, S), Q(S, m, null);
  }, Q = (m, S, pe) => {
    let M = pe;
    if (!M && M !== 0) {
      const ye = xe();
      M = Array.isArray(ye) ? ye[m].month : ye.month;
    }
    t("update-month-year", { instance: m, year: S, month: M });
  };
  return {
    groupedMonths: Y,
    groupedYears: re,
    year: k,
    isDisabled: j,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: i,
    defaultedConfig: r,
    showYearPicker: $,
    modelValue: v,
    presetDate: (m, S) => {
      Up({
        value: m,
        modelValue: v,
        range: o.value.enabled,
        timezone: S ? void 0 : u.value.timezone
      }), t("auto-apply");
    },
    setHoverDate: (m, S) => {
      G.value = p(m, S);
    },
    selectMonth: J,
    selectYear: D,
    toggleYearPicker: A,
    handleYearSelect: I,
    handleYear: X,
    getModelMonthYear: xe
  };
}, cM = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Sa
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = Yi(), r = Vn(i, "yearMode"), o = e;
    wn(() => {
      o.shadow || a("mount", null);
    });
    const {
      groupedMonths: l,
      groupedYears: s,
      year: u,
      isDisabled: d,
      defaultedMultiCalendars: c,
      defaultedConfig: f,
      showYearPicker: v,
      modelValue: k,
      presetDate: b,
      setHoverDate: R,
      selectMonth: V,
      selectYear: G,
      toggleYearPicker: C,
      handleYearSelect: q,
      handleYear: re,
      getModelMonthYear: $
    } = dM(o, a);
    return t({ getSidebarProps: () => ({
      modelValue: k,
      year: u,
      getModelMonthYear: $,
      selectMonth: V,
      selectYear: G,
      handleYear: re
    }), presetDate: b, toggleYearPicker: (A) => C(0, A) }), (A, I) => (y(), le(Nl, {
      "multi-calendars": x(c).count,
      collapse: A.collapse,
      stretch: ""
    }, {
      default: De(({ instance: X }) => [
        A.$slots["top-extra"] ? me(A.$slots, "top-extra", {
          key: 0,
          value: A.internalModelValue
        }) : F("", !0),
        A.$slots["month-year"] ? me(A.$slots, "month-year", tn(Ft({ key: 1 }, {
          year: x(u),
          months: x(l)(X),
          years: x(s)(X),
          selectMonth: x(V),
          selectYear: x(G),
          instance: X
        }))) : (y(), le(Ko, {
          key: 2,
          items: x(l)(X),
          "arrow-navigation": A.arrowNavigation,
          "is-last": A.autoApply && !x(f).keepActionRow,
          "esc-close": A.escClose,
          height: x(f).modeHeight,
          config: A.config,
          "no-overlay-focus": !!(A.noOverlayFocus || A.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (j) => x(V)(j, X),
          onHoverValue: (j) => x(R)(j, X)
        }, gn({
          header: De(() => [
            Pe(jp, Ft(A.$props, {
              items: x(s)(X),
              instance: X,
              "show-year-picker": x(v)[X],
              year: x(u)(X),
              "is-disabled": (j) => x(d)(X, j),
              onHandleYear: (j) => x(re)(X, j),
              onYearSelect: (j) => x(q)(j, X),
              onToggleYearPicker: (j) => x(C)(X, j == null ? void 0 : j.flow, j == null ? void 0 : j.show)
            }), gn({ _: 2 }, [
              Xe(x(r), (j, oe) => ({
                name: j,
                fn: De((xe) => [
                  me(A.$slots, j, tn(Cn(xe)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          A.$slots["month-overlay-value"] ? {
            name: "item",
            fn: De(({ item: j }) => [
              me(A.$slots, "month-overlay-value", {
                text: j.text,
                value: j.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), hM = (e, t) => {
  const n = () => {
    e.isTextInputDate && (d.value = We(ne(e.startDate)));
  }, { modelValue: a } = es(e, t, n), i = he(null), { defaultedHighlight: r, defaultedMultiDates: o, defaultedFilters: l, defaultedRange: s, propDates: u } = Mt(e), d = he();
  wn(() => {
    e.startDate && (a.value && e.focusStartDate || !a.value) && (d.value = We(ne(e.startDate)));
  });
  const c = (b) => Array.isArray(a.value) ? a.value.some((R) => We(R) === b) : a.value ? We(a.value) === b : !1, f = (b) => s.value.enabled && Array.isArray(a.value) ? Il(a.value, i.value, k(b)) : !1, v = ae(() => Hr(bc(e.yearRange, e.locale, e.reverseYears), (b) => {
    const R = c(b.value), V = Uo(
      b.value,
      Wr(u.value.minDate),
      Wr(u.value.maxDate)
    ) || l.value.years.includes(b.value), G = f(b.value) && !R, C = xc(r.value, b.value);
    return { active: R, disabled: V, isBetween: G, highlighted: C };
  })), k = (b) => Na(wa(Vo(/* @__PURE__ */ new Date())), b);
  return {
    groupedYears: v,
    modelValue: a,
    focusYear: d,
    setHoverValue: (b) => {
      i.value = Na(wa(/* @__PURE__ */ new Date()), b);
    },
    selectYear: (b) => {
      var R;
      if (t("update-month-year", { instance: 0, year: b }), o.value.enabled)
        return a.value ? Array.isArray(a.value) && (((R = a.value) == null ? void 0 : R.map((V) => We(V))).includes(b) ? a.value = a.value.filter((V) => We(V) !== b) : a.value.push(Na(xn(ne()), b))) : a.value = [Na(xn(Vo(ne())), b)], t("auto-apply", !0);
      s.value.enabled ? (a.value = Dc(a, k(b), t), Un().then(() => {
        $l(a.value, t, e.autoApply, e.modelAuto);
      })) : (a.value = k(b), t("auto-apply"));
    }
  };
}, fM = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Sa
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, { groupedYears: r, modelValue: o, focusYear: l, selectYear: s, setHoverValue: u } = hM(i, a), { defaultedConfig: d } = Mt(i);
    return t({ getSidebarProps: () => ({
      modelValue: o,
      selectYear: s
    }) }), (c, f) => (y(), O("div", null, [
      c.$slots["top-extra"] ? me(c.$slots, "top-extra", {
        key: 0,
        value: c.internalModelValue
      }) : F("", !0),
      c.$slots["month-year"] ? me(c.$slots, "month-year", tn(Ft({ key: 1 }, {
        years: x(r),
        selectYear: x(s)
      }))) : (y(), le(Ko, {
        key: 2,
        items: x(r),
        "is-last": c.autoApply && !x(d).keepActionRow,
        height: x(d).modeHeight,
        config: c.config,
        "no-overlay-focus": !!(c.noOverlayFocus || c.textInput),
        "focus-value": x(l),
        type: "year",
        "use-relative": "",
        onSelected: x(s),
        onHoverValue: x(u)
      }, gn({ _: 2 }, [
        c.$slots["year-overlay-value"] ? {
          name: "item",
          fn: De(({ item: v }) => [
            me(c.$slots, "year-overlay-value", {
              text: v.text,
              value: v.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), mM = {
  key: 0,
  class: "dp__time_input"
}, pM = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], vM = /* @__PURE__ */ ee("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), gM = /* @__PURE__ */ ee("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), yM = ["aria-label", "disabled", "data-test", "onKeydown", "onClick"], wM = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], bM = /* @__PURE__ */ ee("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), _M = /* @__PURE__ */ ee("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), kM = { key: 0 }, xM = ["aria-label"], MM = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...Sa
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, { setTimePickerElements: r, setTimePickerBackRef: o } = Ni(), { defaultedAriaLabels: l, defaultedTransitions: s, defaultedFilters: u, defaultedConfig: d, defaultedRange: c } = Mt(i), { transitionName: f, showTransition: v } = Jo(s), k = Go({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), b = he("AM"), R = he(null), V = he([]), G = he();
    wn(() => {
      a("mounted");
    });
    const C = (g) => ct(/* @__PURE__ */ new Date(), {
      hours: g.hours,
      minutes: g.minutes,
      seconds: i.enableSeconds ? g.seconds : 0,
      milliseconds: 0
    }), q = ae(
      () => (g) => Y(g, i[g]) || $(g, i[g])
    ), re = ae(() => ({ hours: i.hours, minutes: i.minutes, seconds: i.seconds })), $ = (g, W) => c.value.enabled && !c.value.disableTimeRangeValidation ? !i.validateTime(g, W) : !1, A = (g, W) => {
      if (c.value.enabled && !c.value.disableTimeRangeValidation) {
        const K = W ? +i[`${g}Increment`] : -+i[`${g}Increment`], B = i[g] + K;
        return !i.validateTime(g, B);
      }
      return !1;
    }, I = ae(() => (g) => !J(+i[g] + +i[`${g}Increment`], g) || A(g, !0)), X = ae(() => (g) => !J(+i[g] - +i[`${g}Increment`], g) || A(g, !1)), j = (g, W) => dp(ct(ne(), g), W), oe = (g, W) => vx(ct(ne(), g), W), xe = ae(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !i.timePickerInline,
        dp__time_col_reg_block: !i.enableSeconds && i.is24 && !i.timePickerInline,
        dp__time_col_reg_inline: !i.enableSeconds && i.is24 && i.timePickerInline,
        dp__time_col_reg_with_button: !i.enableSeconds && !i.is24,
        dp__time_col_sec: i.enableSeconds && i.is24,
        dp__time_col_sec_with_button: i.enableSeconds && !i.is24
      })
    ), be = ae(() => {
      const g = [{ type: "hours" }];
      return i.enableMinutes && g.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), i.enableSeconds && g.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), g;
    }), H = ae(() => be.value.filter((g) => !g.separator)), _ = ae(() => (g) => {
      if (g === "hours") {
        const W = M(+i.hours);
        return { text: W < 10 ? `0${W}` : `${W}`, value: W };
      }
      return { text: i[g] < 10 ? `0${i[g]}` : `${i[g]}`, value: i[g] };
    }), Y = (g, W) => {
      var K;
      if (!i.disabledTimesConfig)
        return !1;
      const B = i.disabledTimesConfig(i.order, g === "hours" ? W : void 0);
      return B[g] ? !!((K = B[g]) != null && K.includes(W)) : !0;
    }, p = (g, W) => W !== "hours" || b.value === "AM" ? g : g + 12, U = (g) => {
      const W = i.is24 ? 24 : 12, K = g === "hours" ? W : 60, B = +i[`${g}GridIncrement`], Z = g === "hours" && !i.is24 ? B : 0, je = [];
      for (let N = Z; N < K; N += B)
        je.push({ value: i.is24 ? N : p(N, g), text: N < 10 ? `0${N}` : `${N}` });
      return g === "hours" && !i.is24 && je.unshift({ value: b.value === "PM" ? 12 : 0, text: "12" }), Hr(je, (N) => ({ active: !1, disabled: u.value.times[g].includes(N.value) || !J(N.value, g) || Y(g, N.value) || $(g, N.value) }));
    }, ie = (g) => g >= 0 ? g : 59, fe = (g) => g >= 0 ? g : 23, J = (g, W) => {
      const K = i.minTime ? C(Eu(i.minTime)) : null, B = i.maxTime ? C(Eu(i.maxTime)) : null, Z = C(
        Eu(
          re.value,
          W,
          W === "minutes" || W === "seconds" ? ie(g) : fe(g)
        )
      );
      return K && B ? (jo(Z, B) || Mr(Z, B)) && (Fr(Z, K) || Mr(Z, K)) : K ? Fr(Z, K) || Mr(Z, K) : B ? jo(Z, B) || Mr(Z, B) : !0;
    }, D = (g) => i[`no${g[0].toUpperCase() + g.slice(1)}Overlay`], Q = (g) => {
      D(g) || (k[g] = !k[g], k[g] ? a("overlay-opened", g) : a("overlay-closed", g));
    }, m = (g) => g === "hours" ? di : g === "minutes" ? Ii : Lr, S = () => {
      G.value && clearTimeout(G.value);
    }, pe = (g, W = !0, K) => {
      const B = W ? j : oe, Z = W ? +i[`${g}Increment`] : -+i[`${g}Increment`];
      J(+i[g] + Z, g) && a(
        `update:${g}`,
        m(g)(B({ [g]: +i[g] }, { [g]: +i[`${g}Increment`] }))
      ), !(K != null && K.keyboard) && d.value.timeArrowHoldThreshold && (G.value = setTimeout(() => {
        pe(g, W);
      }, d.value.timeArrowHoldThreshold));
    }, M = (g) => i.is24 ? g : (g >= 12 ? b.value = "PM" : b.value = "AM", kx(g)), ye = () => {
      b.value === "PM" ? (b.value = "AM", a("update:hours", i.hours - 12)) : (b.value = "PM", a("update:hours", i.hours + 12)), a("am-pm-change", b.value);
    }, ce = (g) => {
      k[g] = !0;
    }, T = (g, W, K) => {
      if (g && i.arrowNavigation) {
        Array.isArray(V.value[W]) ? V.value[W][K] = g : V.value[W] = [g];
        const B = V.value.reduce(
          (Z, je) => je.map((N, se) => [...Z[se] || [], je[se]]),
          []
        );
        o(i.closeTimePickerBtn), R.value && (B[1] = B[1].concat(R.value)), r(B, i.order);
      }
    }, Me = (g, W) => (Q(g), a(`update:${g}`, W));
    return t({ openChildCmp: ce }), (g, W) => {
      var K;
      return g.disabled ? F("", !0) : (y(), O("div", mM, [
        (y(!0), O(Fe, null, Xe(be.value, (B, Z) => {
          var je, N, se;
          return y(), O("div", {
            key: Z,
            class: Ne(xe.value)
          }, [
            B.separator ? (y(), O(Fe, { key: 0 }, [
              sa(" : ")
            ], 64)) : (y(), O(Fe, { key: 1 }, [
              ee("button", {
                ref_for: !0,
                ref: (Ee) => T(Ee, Z, 0),
                type: "button",
                class: Ne({
                  dp__btn: !0,
                  dp__inc_dec_button: !g.timePickerInline,
                  dp__inc_dec_button_inline: g.timePickerInline,
                  dp__tp_inline_btn_top: g.timePickerInline,
                  dp__inc_dec_button_disabled: I.value(B.type)
                }),
                "data-test": `${B.type}-time-inc-btn-${i.order}`,
                "aria-label": (je = x(l)) == null ? void 0 : je.incrementValue(B.type),
                tabindex: "0",
                onKeydown: (Ee) => x(En)(Ee, () => pe(B.type, !0, { keyboard: !0 }), !0),
                onClick: (Ee) => x(d).timeArrowHoldThreshold ? void 0 : pe(B.type, !0),
                onMousedown: (Ee) => x(d).timeArrowHoldThreshold ? pe(B.type, !0) : void 0,
                onMouseup: S
              }, [
                i.timePickerInline ? (y(), O(Fe, { key: 1 }, [
                  g.$slots["tp-inline-arrow-up"] ? me(g.$slots, "tp-inline-arrow-up", { key: 0 }) : (y(), O(Fe, { key: 1 }, [
                    vM,
                    gM
                  ], 64))
                ], 64)) : (y(), O(Fe, { key: 0 }, [
                  g.$slots["arrow-up"] ? me(g.$slots, "arrow-up", { key: 0 }) : F("", !0),
                  g.$slots["arrow-up"] ? F("", !0) : (y(), le(x(gc), { key: 1 }))
                ], 64))
              ], 42, pM),
              ee("button", {
                ref_for: !0,
                ref: (Ee) => T(Ee, Z, 1),
                type: "button",
                "aria-label": (N = x(l)) == null ? void 0 : N.openTpOverlay(B.type),
                class: Ne({
                  dp__time_display: !0,
                  dp__time_display_block: !g.timePickerInline,
                  dp__time_display_inline: g.timePickerInline,
                  "dp--time-invalid": q.value(B.type),
                  "dp--time-overlay-btn": !q.value(B.type)
                }),
                disabled: D(B.type),
                tabindex: "0",
                "data-test": `${B.type}-toggle-overlay-btn-${i.order}`,
                onKeydown: (Ee) => x(En)(Ee, () => Q(B.type), !0),
                onClick: (Ee) => Q(B.type)
              }, [
                g.$slots[B.type] ? me(g.$slots, B.type, {
                  key: 0,
                  text: _.value(B.type).text,
                  value: _.value(B.type).value
                }) : F("", !0),
                g.$slots[B.type] ? F("", !0) : (y(), O(Fe, { key: 1 }, [
                  sa(et(_.value(B.type).text), 1)
                ], 64))
              ], 42, yM),
              ee("button", {
                ref_for: !0,
                ref: (Ee) => T(Ee, Z, 2),
                type: "button",
                class: Ne({
                  dp__btn: !0,
                  dp__inc_dec_button: !g.timePickerInline,
                  dp__inc_dec_button_inline: g.timePickerInline,
                  dp__tp_inline_btn_bottom: g.timePickerInline,
                  dp__inc_dec_button_disabled: X.value(B.type)
                }),
                "data-test": `${B.type}-time-dec-btn-${i.order}`,
                "aria-label": (se = x(l)) == null ? void 0 : se.decrementValue(B.type),
                tabindex: "0",
                onKeydown: (Ee) => x(En)(Ee, () => pe(B.type, !1, { keyboard: !0 }), !0),
                onClick: (Ee) => x(d).timeArrowHoldThreshold ? void 0 : pe(B.type, !1),
                onMousedown: (Ee) => x(d).timeArrowHoldThreshold ? pe(B.type, !1) : void 0,
                onMouseup: S
              }, [
                i.timePickerInline ? (y(), O(Fe, { key: 1 }, [
                  g.$slots["tp-inline-arrow-down"] ? me(g.$slots, "tp-inline-arrow-down", { key: 0 }) : (y(), O(Fe, { key: 1 }, [
                    bM,
                    _M
                  ], 64))
                ], 64)) : (y(), O(Fe, { key: 0 }, [
                  g.$slots["arrow-down"] ? me(g.$slots, "arrow-down", { key: 0 }) : F("", !0),
                  g.$slots["arrow-down"] ? F("", !0) : (y(), le(x(yc), { key: 1 }))
                ], 64))
              ], 42, wM)
            ], 64))
          ], 2);
        }), 128)),
        g.is24 ? F("", !0) : (y(), O("div", kM, [
          g.$slots["am-pm-button"] ? me(g.$slots, "am-pm-button", {
            key: 0,
            toggle: ye,
            value: b.value
          }) : F("", !0),
          g.$slots["am-pm-button"] ? F("", !0) : (y(), O("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: R,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (K = x(l)) == null ? void 0 : K.amPmButton,
            tabindex: "0",
            onClick: ye,
            onKeydown: W[0] || (W[0] = (B) => x(En)(B, () => ye(), !0))
          }, et(b.value), 41, xM))
        ])),
        (y(!0), O(Fe, null, Xe(H.value, (B, Z) => (y(), le(Ri, {
          key: Z,
          name: x(f)(k[B.type]),
          css: x(v)
        }, {
          default: De(() => [
            k[B.type] ? (y(), le(Ko, {
              key: 0,
              items: U(B.type),
              "is-last": g.autoApply && !x(d).keepActionRow,
              "esc-close": g.escClose,
              type: B.type,
              "text-input": g.textInput,
              config: g.config,
              "arrow-navigation": g.arrowNavigation,
              "aria-labels": g.ariaLabels,
              onSelected: (je) => Me(B.type, je),
              onToggle: (je) => Q(B.type),
              onResetFlow: W[1] || (W[1] = (je) => g.$emit("reset-flow"))
            }, gn({
              "button-icon": De(() => [
                g.$slots["clock-icon"] ? me(g.$slots, "clock-icon", { key: 0 }) : F("", !0),
                g.$slots["clock-icon"] ? F("", !0) : (y(), le(li(g.timePickerInline ? x(Zr) : x(vc)), { key: 1 }))
              ]),
              _: 2
            }, [
              g.$slots[`${B.type}-overlay-value`] ? {
                name: "item",
                fn: De(({ item: je }) => [
                  me(g.$slots, `${B.type}-overlay-value`, {
                    text: je.text,
                    value: je.value
                  })
                ]),
                key: "0"
              } : void 0,
              g.$slots[`${B.type}-overlay-header`] ? {
                name: "header",
                fn: De(() => [
                  me(g.$slots, `${B.type}-overlay-header`, {
                    toggle: () => Q(B.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "onSelected", "onToggle"])) : F("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), DM = { class: "dp--tp-wrap" }, SM = ["aria-label", "tabindex"], TM = ["tabindex"], AM = ["aria-label"], Xp = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...Sa
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, { buildMatrix: r, setTimePicker: o } = Ni(), l = Yi(), { defaultedTransitions: s, defaultedAriaLabels: u, defaultedTextInput: d, defaultedConfig: c, defaultedRange: f } = Mt(i), { transitionName: v, showTransition: k } = Jo(s), { hideNavigationButtons: b } = Ll(), R = he(null), V = he(null), G = he([]), C = he(null);
    wn(() => {
      a("mount"), !i.timePicker && i.arrowNavigation ? r([Zt(R.value)], "time") : o(!0, i.timePicker);
    });
    const q = ae(() => f.value.enabled && i.modelAuto ? Rp(i.internalModelValue) : !0), re = he(!1), $ = (p) => ({
      hours: Array.isArray(i.hours) ? i.hours[p] : i.hours,
      minutes: Array.isArray(i.minutes) ? i.minutes[p] : i.minutes,
      seconds: Array.isArray(i.seconds) ? i.seconds[p] : i.seconds
    }), A = ae(() => {
      const p = [];
      if (f.value.enabled)
        for (let U = 0; U < 2; U++)
          p.push($(U));
      else
        p.push($(0));
      return p;
    }), I = (p, U = !1, ie = "") => {
      U || a("reset-flow"), re.value = p, a(p ? "overlay-opened" : "overlay-closed", vn.time), i.arrowNavigation && o(p), Un(() => {
        ie !== "" && G.value[0] && G.value[0].openChildCmp(ie);
      });
    }, X = ae(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: i.autoApply && !c.value.keepActionRow
    })), j = Vn(l, "timePicker"), oe = (p, U, ie) => f.value.enabled ? U === 0 ? [p, A.value[1][ie]] : [A.value[0][ie], p] : p, xe = (p) => {
      a("update:hours", p);
    }, be = (p) => {
      a("update:minutes", p);
    }, H = (p) => {
      a("update:seconds", p);
    }, _ = () => {
      if (C.value && !d.value.enabled && !i.noOverlayFocus) {
        const p = Ip(C.value);
        p && p.focus({ preventScroll: !0 });
      }
    }, Y = (p) => {
      a("overlay-closed", p);
    };
    return t({ toggleTimePicker: I }), (p, U) => {
      var ie;
      return y(), O("div", DM, [
        !p.timePicker && !p.timePickerInline ? ai((y(), O("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: R,
          type: "button",
          class: Ne(X.value),
          "aria-label": (ie = x(u)) == null ? void 0 : ie.openTimePicker,
          tabindex: p.noOverlayFocus ? void 0 : 0,
          "data-test": "open-time-picker-btn",
          onKeydown: U[0] || (U[0] = (fe) => x(En)(fe, () => I(!0))),
          onClick: U[1] || (U[1] = (fe) => I(!0))
        }, [
          p.$slots["clock-icon"] ? me(p.$slots, "clock-icon", { key: 0 }) : F("", !0),
          p.$slots["clock-icon"] ? F("", !0) : (y(), le(x(vc), { key: 1 }))
        ], 42, SM)), [
          [Sr, !x(b)(p.hideNavigation, "time")]
        ]) : F("", !0),
        Pe(Ri, {
          name: x(v)(re.value),
          css: x(k) && !p.timePickerInline
        }, {
          default: De(() => {
            var fe;
            return [
              re.value || p.timePicker || p.timePickerInline ? (y(), O("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: C,
                class: Ne({
                  dp__overlay: !p.timePickerInline,
                  "dp--overlay-absolute": !i.timePicker && !p.timePickerInline,
                  "dp--overlay-relative": i.timePicker
                }),
                style: kn(p.timePicker ? { height: `${x(c).modeHeight}px` } : void 0),
                tabindex: p.timePickerInline ? void 0 : 0
              }, [
                ee("div", {
                  class: Ne(
                    p.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  p.$slots["time-picker-overlay"] ? me(p.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: xe,
                    setMinutes: be,
                    setSeconds: H
                  }) : F("", !0),
                  p.$slots["time-picker-overlay"] ? F("", !0) : (y(), O("div", {
                    key: 1,
                    class: Ne(p.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (y(!0), O(Fe, null, Xe(A.value, (J, D) => ai((y(), le(MM, Ft({
                      key: D,
                      ref_for: !0
                    }, {
                      ...p.$props,
                      order: D,
                      hours: J.hours,
                      minutes: J.minutes,
                      seconds: J.seconds,
                      closeTimePickerBtn: V.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: D === 0 ? p.fixedStart : p.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: G,
                      "validate-time": (Q, m) => e.validateTime(Q, oe(m, D, Q)),
                      "onUpdate:hours": (Q) => xe(oe(Q, D, "hours")),
                      "onUpdate:minutes": (Q) => be(oe(Q, D, "minutes")),
                      "onUpdate:seconds": (Q) => H(oe(Q, D, "seconds")),
                      onMounted: _,
                      onOverlayClosed: Y,
                      onOverlayOpened: U[2] || (U[2] = (Q) => p.$emit("overlay-opened", Q)),
                      onAmPmChange: U[3] || (U[3] = (Q) => p.$emit("am-pm-change", Q))
                    }), gn({ _: 2 }, [
                      Xe(x(j), (Q, m) => ({
                        name: Q,
                        fn: De((S) => [
                          me(p.$slots, Q, Ft({ ref_for: !0 }, S))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Sr, D === 0 ? !0 : q.value]
                    ])), 128))
                  ], 2)),
                  !p.timePicker && !p.timePickerInline ? ai((y(), O("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: V,
                    type: "button",
                    class: Ne(X.value),
                    "aria-label": (fe = x(u)) == null ? void 0 : fe.closeTimePicker,
                    tabindex: "0",
                    onKeydown: U[4] || (U[4] = (J) => x(En)(J, () => I(!1))),
                    onClick: U[5] || (U[5] = (J) => I(!1))
                  }, [
                    p.$slots["calendar-icon"] ? me(p.$slots, "calendar-icon", { key: 0 }) : F("", !0),
                    p.$slots["calendar-icon"] ? F("", !0) : (y(), le(x(Zr), { key: 1 }))
                  ], 42, AM)), [
                    [Sr, !x(b)(p.hideNavigation, "time")]
                  ]) : F("", !0)
                ], 2)
              ], 14, TM)) : F("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Zp = (e, t, n, a) => {
  const { defaultedRange: i } = Mt(e), r = (C, q) => Array.isArray(t[C]) ? t[C][q] : t[C], o = (C) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[C] : t.seconds : 0, l = (C, q) => C ? q !== void 0 ? Pi(C, r("hours", q), r("minutes", q), o(q)) : Pi(C, t.hours, t.minutes, o()) : Op(ne(), o(q)), s = (C, q) => {
    t[C] = q;
  }, u = ae(() => e.modelAuto && i.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : i.value.enabled), d = (C, q) => {
    const re = Object.fromEntries(
      Object.keys(t).map(($) => $ === C ? [$, q] : [$, t[$]].slice())
    );
    if (u.value && !i.value.disableTimeRangeValidation) {
      const $ = (I) => n.value ? Pi(
        n.value[I],
        re.hours[I],
        re.minutes[I],
        re.seconds[I]
      ) : null, A = (I) => Ap(n.value[I], 0);
      return !(Ge($(0), $(1)) && (Fr($(0), A(1)) || jo($(1), A(0))));
    }
    return !0;
  }, c = (C, q) => {
    d(C, q) && (s(C, q), a && a());
  }, f = (C) => {
    c("hours", C);
  }, v = (C) => {
    c("minutes", C);
  }, k = (C) => {
    c("seconds", C);
  }, b = (C, q, re, $) => {
    q && f(C), !q && !re && v(C), re && k(C), n.value && $(n.value);
  }, R = (C) => {
    if (C) {
      const q = Array.isArray(C), re = q ? [+C[0].hours, +C[1].hours] : +C.hours, $ = q ? [+C[0].minutes, +C[1].minutes] : +C.minutes, A = q ? [+C[0].seconds, +C[1].seconds] : +C.seconds;
      s("hours", re), s("minutes", $), e.enableSeconds && s("seconds", A);
    }
  }, V = (C, q) => {
    const re = {
      hours: Array.isArray(t.hours) ? t.hours[C] : t.hours,
      disabledArr: []
    };
    return (q || q === 0) && (re.hours = q), Array.isArray(e.disabledTimes) && (re.disabledArr = i.value.enabled && Array.isArray(e.disabledTimes[C]) ? e.disabledTimes[C] : e.disabledTimes), re;
  }, G = ae(() => (C, q) => {
    var re;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: $, hours: A } = V(C, q), I = $.filter((X) => +X.hours === A);
      return ((re = I[0]) == null ? void 0 : re.minutes) === "*" ? { hours: [A], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (I == null ? void 0 : I.map((X) => +X.minutes)) ?? [],
        seconds: (I == null ? void 0 : I.map((X) => X.seconds ? +X.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: s,
    updateHours: f,
    updateMinutes: v,
    updateSeconds: k,
    getSetDateTime: l,
    updateTimeValues: b,
    getSecondsValue: o,
    assignStartTime: R,
    validateTime: d,
    disabledTimesConfig: G
  };
}, OM = (e, t) => {
  const n = () => {
    e.isTextInputDate && q();
  }, { modelValue: a, time: i } = es(e, t, n), { defaultedStartTime: r, defaultedRange: o, defaultedTz: l } = Mt(e), { updateTimeValues: s, getSetDateTime: u, setTime: d, assignStartTime: c, disabledTimesConfig: f, validateTime: v } = Zp(e, i, a, k);
  function k() {
    t("update-flow-step");
  }
  const b = ($) => {
    const { hours: A, minutes: I, seconds: X } = $;
    return { hours: +A, minutes: +I, seconds: X ? +X : 0 };
  }, R = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const A = b(e.startTime[0]), I = b(e.startTime[1]);
        return [ct(ne(), A), ct(ne(), I)];
      }
      const $ = b(e.startTime);
      return ct(ne(), $);
    }
    return o.value.enabled ? [null, null] : null;
  }, V = () => {
    if (o.value.enabled) {
      const [$, A] = R();
      a.value = [
        Rn(u($, 0), l.value.timezone),
        Rn(u(A, 1), l.value.timezone)
      ];
    } else
      a.value = Rn(u(R()), l.value.timezone);
  }, G = ($) => Array.isArray($) ? [nr(ne($[0])), nr(ne($[1]))] : [nr($ ?? ne())], C = ($, A, I) => {
    d("hours", $), d("minutes", A), d("seconds", e.enableSeconds ? I : 0);
  }, q = () => {
    const [$, A] = G(a.value);
    return o.value.enabled ? C(
      [$.hours, A.hours],
      [$.minutes, A.minutes],
      [$.seconds, A.seconds]
    ) : C($.hours, $.minutes, $.seconds);
  };
  wn(() => {
    if (!e.shadow)
      return c(r.value), a.value ? q() : V();
  });
  const re = () => {
    Array.isArray(a.value) ? a.value = a.value.map(($, A) => $ && u($, A)) : a.value = u(a.value), t("time-update");
  };
  return {
    modelValue: a,
    time: i,
    disabledTimesConfig: f,
    updateTime: ($, A = !0, I = !1) => {
      s($, A, I, re);
    },
    validateTime: v
  };
}, CM = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Sa
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, r = Yi(), o = Vn(r, "timePicker"), l = he(null), { time: s, modelValue: u, disabledTimesConfig: d, updateTime: c, validateTime: f } = OM(i, a);
    return wn(() => {
      i.shadow || a("mount", null);
    }), t({ getSidebarProps: () => ({
      modelValue: u,
      time: s,
      updateTime: c
    }), toggleTimePicker: (v, k = !1, b = "") => {
      var R;
      (R = l.value) == null || R.toggleTimePicker(v, k, b);
    } }), (v, k) => (y(), le(Nl, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: De(() => [
        Pe(Xp, Ft({
          ref_key: "tpRef",
          ref: l
        }, v.$props, {
          hours: x(s).hours,
          minutes: x(s).minutes,
          seconds: x(s).seconds,
          "internal-model-value": v.internalModelValue,
          "disabled-times-config": x(d),
          "validate-time": x(f),
          "onUpdate:hours": k[0] || (k[0] = (b) => x(c)(b)),
          "onUpdate:minutes": k[1] || (k[1] = (b) => x(c)(b, !1)),
          "onUpdate:seconds": k[2] || (k[2] = (b) => x(c)(b, !1, !0)),
          onAmPmChange: k[3] || (k[3] = (b) => v.$emit("am-pm-change", b)),
          onResetFlow: k[4] || (k[4] = (b) => v.$emit("reset-flow")),
          onOverlayClosed: k[5] || (k[5] = (b) => v.$emit("overlay-toggle", { open: !1, overlay: b })),
          onOverlayOpened: k[6] || (k[6] = (b) => v.$emit("overlay-toggle", { open: !0, overlay: b }))
        }), gn({ _: 2 }, [
          Xe(x(o), (b, R) => ({
            name: b,
            fn: De((V) => [
              me(v.$slots, b, tn(Cn(V)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), EM = { class: "dp--header-wrap" }, PM = {
  key: 0,
  class: "dp__month_year_wrap"
}, RM = { key: 0 }, IM = { class: "dp__month_year_wrap" }, YM = ["aria-label", "data-test", "onClick", "onKeydown"], NM = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Sa
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, {
      defaultedTransitions: r,
      defaultedAriaLabels: o,
      defaultedMultiCalendars: l,
      defaultedFilters: s,
      defaultedConfig: u,
      defaultedHighlight: d,
      propDates: c,
      defaultedUI: f
    } = Mt(i), { transitionName: v, showTransition: k } = Jo(r), { buildMatrix: b } = Ni(), { handleMonthYearChange: R, isDisabled: V, updateMonthYear: G } = eM(i, a), { showLeftIcon: C, showRightIcon: q } = Ll(), re = he(!1), $ = he(!1), A = he([null, null, null, null]);
    wn(() => {
      a("mount");
    });
    const I = (D) => ({
      get: () => i[D],
      set: (Q) => {
        const m = D === ga.month ? ga.year : ga.month;
        a("update-month-year", { [D]: Q, [m]: i[m] }), D === ga.month ? Y(!0) : p(!0);
      }
    }), X = ae(I(ga.month)), j = ae(I(ga.year)), oe = ae(() => (D) => ({
      month: i.month,
      year: i.year,
      items: D === ga.month ? i.months : i.years,
      instance: i.instance,
      updateMonthYear: G,
      toggle: D === ga.month ? Y : p
    })), xe = ae(() => i.months.find((Q) => Q.value === i.month) || { text: "", value: 0 }), be = ae(() => Hr(i.months, (D) => {
      const Q = i.month === D.value, m = Uo(
        D.value,
        Np(i.year, c.value.minDate),
        $p(i.year, c.value.maxDate)
      ) || s.value.months.includes(D.value), S = Wp(d.value, D.value, i.year);
      return { active: Q, disabled: m, highlighted: S };
    })), H = ae(() => Hr(i.years, (D) => {
      const Q = i.year === D.value, m = Uo(
        D.value,
        Wr(c.value.minDate),
        Wr(c.value.maxDate)
      ) || s.value.years.includes(D.value), S = xc(d.value, D.value);
      return { active: Q, disabled: m, highlighted: S };
    })), _ = (D, Q, m) => {
      m !== void 0 ? D.value = m : D.value = !D.value, D.value ? a("overlay-opened", Q) : a("overlay-closed", Q);
    }, Y = (D = !1, Q) => {
      U(D), _(re, vn.month, Q);
    }, p = (D = !1, Q) => {
      U(D), _($, vn.year, Q);
    }, U = (D) => {
      D || a("reset-flow");
    }, ie = (D, Q) => {
      i.arrowNavigation && (A.value[Q] = Zt(D), b(A.value, "monthYear"));
    }, fe = ae(() => {
      var D, Q;
      return [
        {
          type: ga.month,
          index: 1,
          toggle: Y,
          modelValue: X.value,
          updateModelValue: (m) => X.value = m,
          text: xe.value.text,
          showSelectionGrid: re.value,
          items: be.value,
          ariaLabel: (D = o.value) == null ? void 0 : D.openMonthsOverlay
        },
        {
          type: ga.year,
          index: 2,
          toggle: p,
          modelValue: j.value,
          updateModelValue: (m) => j.value = m,
          text: Yp(i.year, i.locale),
          showSelectionGrid: $.value,
          items: H.value,
          ariaLabel: (Q = o.value) == null ? void 0 : Q.openYearsOverlay
        }
      ];
    }), J = ae(() => i.disableYearSelect ? [fe.value[0]] : i.yearFirst ? [...fe.value].reverse() : fe.value);
    return t({
      toggleMonthPicker: Y,
      toggleYearPicker: p,
      handleMonthYearChange: R
    }), (D, Q) => {
      var m, S, pe, M, ye, ce;
      return y(), O("div", EM, [
        D.$slots["month-year"] ? (y(), O("div", PM, [
          me(D.$slots, "month-year", tn(Cn({ month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: x(G), handleMonthYearChange: x(R), instance: e.instance })))
        ])) : (y(), O(Fe, { key: 1 }, [
          D.$slots["top-extra"] ? (y(), O("div", RM, [
            me(D.$slots, "top-extra", { value: D.internalModelValue })
          ])) : F("", !0),
          ee("div", IM, [
            x(C)(x(l), e.instance) && !D.vertical ? (y(), le(Eo, {
              key: 0,
              "aria-label": (m = x(o)) == null ? void 0 : m.prevMonth,
              disabled: x(V)(!1),
              class: Ne((S = x(f)) == null ? void 0 : S.navBtnPrev),
              onActivate: Q[0] || (Q[0] = (T) => x(R)(!1, !0)),
              onSetRef: Q[1] || (Q[1] = (T) => ie(T, 0))
            }, {
              default: De(() => [
                D.$slots["arrow-left"] ? me(D.$slots, "arrow-left", { key: 0 }) : F("", !0),
                D.$slots["arrow-left"] ? F("", !0) : (y(), le(x(mc), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : F("", !0),
            ee("div", {
              class: Ne(["dp__month_year_wrap", {
                dp__year_disable_select: D.disableYearSelect
              }])
            }, [
              (y(!0), O(Fe, null, Xe(J.value, (T, Me) => (y(), O(Fe, {
                key: T.type
              }, [
                ee("button", {
                  ref_for: !0,
                  ref: (g) => ie(g, Me + 1),
                  type: "button",
                  class: "dp__btn dp__month_year_select",
                  tabindex: "0",
                  "aria-label": T.ariaLabel,
                  "data-test": `${T.type}-toggle-overlay-${e.instance}`,
                  onClick: T.toggle,
                  onKeydown: (g) => x(En)(g, () => T.toggle(), !0)
                }, [
                  D.$slots[T.type] ? me(D.$slots, T.type, {
                    key: 0,
                    text: T.text,
                    value: i[T.type]
                  }) : F("", !0),
                  D.$slots[T.type] ? F("", !0) : (y(), O(Fe, { key: 1 }, [
                    sa(et(T.text), 1)
                  ], 64))
                ], 40, YM),
                Pe(Ri, {
                  name: x(v)(T.showSelectionGrid),
                  css: x(k)
                }, {
                  default: De(() => [
                    T.showSelectionGrid ? (y(), le(Ko, {
                      key: 0,
                      items: T.items,
                      "arrow-navigation": D.arrowNavigation,
                      "hide-navigation": D.hideNavigation,
                      "is-last": D.autoApply && !x(u).keepActionRow,
                      "skip-button-ref": !1,
                      config: D.config,
                      type: T.type,
                      "header-refs": [],
                      "esc-close": D.escClose,
                      "menu-wrap-ref": D.menuWrapRef,
                      "text-input": D.textInput,
                      "aria-labels": D.ariaLabels,
                      onSelected: T.updateModelValue,
                      onToggle: T.toggle
                    }, gn({
                      "button-icon": De(() => [
                        D.$slots["calendar-icon"] ? me(D.$slots, "calendar-icon", { key: 0 }) : F("", !0),
                        D.$slots["calendar-icon"] ? F("", !0) : (y(), le(x(Zr), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      D.$slots[`${T.type}-overlay-value`] ? {
                        name: "item",
                        fn: De(({ item: g }) => [
                          me(D.$slots, `${T.type}-overlay-value`, {
                            text: g.text,
                            value: g.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      D.$slots[`${T.type}-overlay`] ? {
                        name: "overlay",
                        fn: De(() => [
                          me(D.$slots, `${T.type}-overlay`, Ft({ ref_for: !0 }, oe.value(T.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      D.$slots[`${T.type}-overlay-header`] ? {
                        name: "header",
                        fn: De(() => [
                          me(D.$slots, `${T.type}-overlay-header`, {
                            toggle: T.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "onSelected", "onToggle"])) : F("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            x(C)(x(l), e.instance) && D.vertical ? (y(), le(Eo, {
              key: 1,
              "aria-label": (pe = x(o)) == null ? void 0 : pe.prevMonth,
              disabled: x(V)(!1),
              class: Ne((M = x(f)) == null ? void 0 : M.navBtnPrev),
              onActivate: Q[2] || (Q[2] = (T) => x(R)(!1, !0))
            }, {
              default: De(() => [
                D.$slots["arrow-up"] ? me(D.$slots, "arrow-up", { key: 0 }) : F("", !0),
                D.$slots["arrow-up"] ? F("", !0) : (y(), le(x(gc), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : F("", !0),
            x(q)(x(l), e.instance) ? (y(), le(Eo, {
              key: 2,
              ref: "rightIcon",
              disabled: x(V)(!0),
              "aria-label": (ye = x(o)) == null ? void 0 : ye.nextMonth,
              class: Ne((ce = x(f)) == null ? void 0 : ce.navBtnNext),
              onActivate: Q[3] || (Q[3] = (T) => x(R)(!0, !0)),
              onSetRef: Q[4] || (Q[4] = (T) => ie(T, D.disableYearSelect ? 2 : 3))
            }, {
              default: De(() => [
                D.$slots[D.vertical ? "arrow-down" : "arrow-right"] ? me(D.$slots, D.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : F("", !0),
                D.$slots[D.vertical ? "arrow-down" : "arrow-right"] ? F("", !0) : (y(), le(li(D.vertical ? x(yc) : x(pc)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : F("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), $M = ["aria-label"], LM = {
  class: "dp__calendar_header",
  role: "row"
}, FM = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, zM = ["aria-label"], HM = /* @__PURE__ */ ee("div", { class: "dp__calendar_header_separator" }, null, -1), WM = ["aria-label"], BM = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, VM = { class: "dp__cell_inner" }, jM = ["id", "aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], UM = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Sa
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, { buildMultiLevelMatrix: r } = Ni(), {
      defaultedTransitions: o,
      defaultedConfig: l,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: u,
      defaultedWeekNumbers: d,
      defaultedMultiDates: c,
      defaultedUI: f
    } = Mt(i), v = he(null), k = he({
      bottom: "",
      left: "",
      transform: ""
    }), b = he([]), R = he(null), V = he(!0), G = he(""), C = he({ startX: 0, endX: 0, startY: 0, endY: 0 }), q = he([]), re = he({ left: "50%" }), $ = he(!1), A = ae(() => i.calendar ? i.calendar(i.mappedDates) : i.mappedDates), I = ae(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames(i.locale, +i.weekStart) : _x(i.formatLocale, i.locale, +i.weekStart));
    wn(() => {
      a("mount", { cmp: "calendar", refs: b }), l.value.noSwipe || R.value && (R.value.addEventListener("touchstart", ie, { passive: !1 }), R.value.addEventListener("touchend", fe, { passive: !1 }), R.value.addEventListener("touchmove", J, { passive: !1 })), i.monthChangeOnScroll && R.value && R.value.addEventListener("wheel", m, { passive: !1 });
    });
    const X = (T) => T ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", j = (T, Me) => {
      if (i.transitions) {
        const g = xn(ni(ne(), i.month, i.year));
        G.value = $t(xn(ni(ne(), T, Me)), g) ? o.value[X(!0)] : o.value[X(!1)], V.value = !1, Un(() => {
          V.value = !0;
        });
      }
    }, oe = ae(
      () => ({
        [i.calendarClassName]: !!i.calendarClassName,
        ...f.value.calendar ?? {}
      })
    ), xe = ae(() => (T) => {
      const Me = xx(T);
      return {
        dp__marker_dot: Me.type === "dot",
        dp__marker_line: Me.type === "line"
      };
    }), be = ae(() => (T) => Ge(T, v.value)), H = ae(() => ({
      dp__calendar: !0,
      dp__calendar_next: u.value.count > 0 && i.instance !== 0
    })), _ = ae(() => (T) => i.hideOffsetDates ? T.current : !0), Y = async (T, Me, g) => {
      const W = Zt(b.value[Me][g]);
      if (W) {
        const { width: K, height: B } = W.getBoundingClientRect();
        v.value = T.value;
        let Z = { left: `${K / 2}px` }, je = -50;
        if (await Un(), q.value[0]) {
          const { left: N, width: se } = q.value[0].getBoundingClientRect();
          N < 0 && (Z = { left: "0" }, je = 0, re.value.left = `${K / 2}px`), window.innerWidth < N + se && (Z = { right: "0" }, je = 0, re.value.left = `${se - K / 2}px`);
        }
        k.value = {
          bottom: `${B}px`,
          ...Z,
          transform: `translateX(${je}%)`
        }, a("tooltip-open", T.marker);
      }
    }, p = async (T, Me, g) => {
      var W, K;
      if ($.value && c.value.enabled && c.value.dragSelect)
        return a("select-date", T);
      a("set-hover-date", T), (K = (W = T.marker) == null ? void 0 : W.tooltip) != null && K.length && await Y(T, Me, g);
    }, U = (T) => {
      v.value && (v.value = null, k.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", T.marker));
    }, ie = (T) => {
      C.value.startX = T.changedTouches[0].screenX, C.value.startY = T.changedTouches[0].screenY;
    }, fe = (T) => {
      C.value.endX = T.changedTouches[0].screenX, C.value.endY = T.changedTouches[0].screenY, D();
    }, J = (T) => {
      i.vertical && !i.inline && T.preventDefault();
    }, D = () => {
      const T = i.vertical ? "Y" : "X";
      Math.abs(C.value[`start${T}`] - C.value[`end${T}`]) > 10 && a("handle-swipe", C.value[`start${T}`] > C.value[`end${T}`] ? "right" : "left");
    }, Q = (T, Me, g) => {
      T && (Array.isArray(b.value[Me]) ? b.value[Me][g] = T : b.value[Me] = [T]), i.arrowNavigation && r(b.value, "calendar");
    }, m = (T) => {
      i.monthChangeOnScroll && (T.preventDefault(), a("handle-scroll", T));
    }, S = (T) => d.value.type === "local" ? cc(T.value, { weekStartsOn: +i.weekStart }) : d.value.type === "iso" ? uc(T.value) : typeof d.value.type == "function" ? d.value.type(T.value) : "", pe = (T) => {
      const Me = T[0];
      return d.value.hideOnOffsetDates ? T.some((g) => g.current) ? S(Me) : "" : S(Me);
    }, M = (T, Me) => {
      c.value.enabled || (Ei(T, l.value), a("select-date", Me));
    }, ye = (T) => {
      Ei(T, l.value);
    }, ce = (T) => {
      c.value.enabled && c.value.dragSelect ? ($.value = !0, a("select-date", T)) : c.value.enabled && a("select-date", T);
    };
    return t({ triggerTransition: j }), (T, Me) => {
      var g;
      return y(), O("div", {
        class: Ne(H.value)
      }, [
        ee("div", {
          ref_key: "calendarWrapRef",
          ref: R,
          role: "grid",
          class: Ne(oe.value),
          "aria-label": (g = x(s)) == null ? void 0 : g.calendarWrap
        }, [
          ee("div", LM, [
            T.weekNumbers ? (y(), O("div", FM, et(T.weekNumName), 1)) : F("", !0),
            (y(!0), O(Fe, null, Xe(I.value, (W, K) => {
              var B, Z;
              return y(), O("div", {
                key: K,
                class: "dp__calendar_header_item",
                role: "gridcell",
                "data-test": "calendar-header",
                "aria-label": (Z = (B = x(s)) == null ? void 0 : B.weekDay) == null ? void 0 : Z.call(B, K)
              }, [
                T.$slots["calendar-header"] ? me(T.$slots, "calendar-header", {
                  key: 0,
                  day: W,
                  index: K
                }) : F("", !0),
                T.$slots["calendar-header"] ? F("", !0) : (y(), O(Fe, { key: 1 }, [
                  sa(et(W), 1)
                ], 64))
              ], 8, zM);
            }), 128))
          ]),
          HM,
          Pe(Ri, {
            name: G.value,
            css: !!T.transitions
          }, {
            default: De(() => {
              var W;
              return [
                V.value ? (y(), O("div", {
                  key: 0,
                  class: "dp__calendar",
                  role: "rowgroup",
                  "aria-label": ((W = x(s)) == null ? void 0 : W.calendarDays) || void 0,
                  onMouseleave: Me[1] || (Me[1] = (K) => $.value = !1)
                }, [
                  (y(!0), O(Fe, null, Xe(A.value, (K, B) => (y(), O("div", {
                    key: B,
                    class: "dp__calendar_row",
                    role: "row"
                  }, [
                    T.weekNumbers ? (y(), O("div", BM, [
                      ee("div", VM, et(pe(K.days)), 1)
                    ])) : F("", !0),
                    (y(!0), O(Fe, null, Xe(K.days, (Z, je) => {
                      var N, se, Ee;
                      return y(), O("div", {
                        id: x(Bp)(Z.value),
                        ref_for: !0,
                        ref: ($e) => Q($e, B, je),
                        key: je + B,
                        role: "gridcell",
                        class: "dp__calendar_item",
                        "aria-selected": (Z.classData.dp__active_date || Z.classData.dp__range_start || Z.classData.dp__range_start) ?? void 0,
                        "aria-disabled": Z.classData.dp__cell_disabled || void 0,
                        "aria-label": (se = (N = x(s)) == null ? void 0 : N.day) == null ? void 0 : se.call(N, Z),
                        tabindex: "0",
                        "data-test": Z.value,
                        onClick: ii(($e) => M($e, Z), ["prevent"]),
                        onKeydown: ($e) => x(En)($e, () => T.$emit("select-date", Z)),
                        onMouseenter: ($e) => p(Z, B, je),
                        onMouseleave: ($e) => U(Z),
                        onMousedown: ($e) => ce(Z),
                        onMouseup: Me[0] || (Me[0] = ($e) => $.value = !1)
                      }, [
                        ee("div", {
                          class: Ne(["dp__cell_inner", Z.classData])
                        }, [
                          T.$slots.day && _.value(Z) ? me(T.$slots, "day", {
                            key: 0,
                            day: +Z.text,
                            date: Z.value
                          }) : F("", !0),
                          T.$slots.day ? F("", !0) : (y(), O(Fe, { key: 1 }, [
                            sa(et(Z.text), 1)
                          ], 64)),
                          Z.marker && _.value(Z) ? (y(), O(Fe, { key: 2 }, [
                            T.$slots.marker ? me(T.$slots, "marker", {
                              key: 0,
                              marker: Z.marker,
                              day: +Z.text,
                              date: Z.value
                            }) : (y(), O("div", {
                              key: 1,
                              class: Ne(xe.value(Z.marker)),
                              style: kn(Z.marker.color ? { backgroundColor: Z.marker.color } : {})
                            }, null, 6))
                          ], 64)) : F("", !0),
                          be.value(Z.value) ? (y(), O("div", {
                            key: 3,
                            ref_for: !0,
                            ref_key: "activeTooltip",
                            ref: q,
                            class: "dp__marker_tooltip",
                            style: kn(k.value)
                          }, [
                            (Ee = Z.marker) != null && Ee.tooltip ? (y(), O("div", {
                              key: 0,
                              class: "dp__tooltip_content",
                              onClick: ye
                            }, [
                              (y(!0), O(Fe, null, Xe(Z.marker.tooltip, ($e, lt) => (y(), O("div", {
                                key: lt,
                                class: "dp__tooltip_text"
                              }, [
                                T.$slots["marker-tooltip"] ? me(T.$slots, "marker-tooltip", {
                                  key: 0,
                                  tooltip: $e,
                                  day: Z.value
                                }) : F("", !0),
                                T.$slots["marker-tooltip"] ? F("", !0) : (y(), O(Fe, { key: 1 }, [
                                  ee("div", {
                                    class: "dp__tooltip_mark",
                                    style: kn($e.color ? { backgroundColor: $e.color } : {})
                                  }, null, 4),
                                  ee("div", null, et($e.text), 1)
                                ], 64))
                              ]))), 128)),
                              ee("div", {
                                class: "dp__arrow_bottom_tp",
                                style: kn(re.value)
                              }, null, 4)
                            ])) : F("", !0)
                          ], 4)) : F("", !0)
                        ], 2)
                      ], 40, jM);
                    }), 128))
                  ]))), 128))
                ], 40, WM)) : F("", !0)
              ];
            }),
            _: 3
          }, 8, ["name", "css"])
        ], 10, $M)
      ], 2);
    };
  }
}), kf = (e) => Array.isArray(e), GM = (e, t, n, a) => {
  const i = he([]), r = he(/* @__PURE__ */ new Date()), o = he(), l = () => fe(e.isTextInputDate), { modelValue: s, calendars: u, time: d, today: c } = es(e, t, l), {
    defaultedMultiCalendars: f,
    defaultedStartTime: v,
    defaultedRange: k,
    defaultedConfig: b,
    defaultedTz: R,
    propDates: V,
    defaultedMultiDates: G
  } = Mt(e), { validateMonthYearInRange: C, isDisabled: q, isDateRangeAllowed: re, checkMinMaxRange: $ } = $i(e), { updateTimeValues: A, getSetDateTime: I, setTime: X, assignStartTime: j, validateTime: oe, disabledTimesConfig: xe } = Zp(e, d, s, a), be = ae(
    () => (E) => u.value[E] ? u.value[E].month : 0
  ), H = ae(
    () => (E) => u.value[E] ? u.value[E].year : 0
  ), _ = (E) => !b.value.keepViewOnOffsetClick || E ? !0 : !o.value, Y = (E, te, P, de = !1) => {
    var we, Ut;
    _(de) && (u.value[E] || (u.value[E] = { month: 0, year: 0 }), u.value[E].month = gf(te) ? (we = u.value[E]) == null ? void 0 : we.month : te, u.value[E].year = gf(P) ? (Ut = u.value[E]) == null ? void 0 : Ut.year : P);
  }, p = () => {
    e.autoApply && t("select-date");
  };
  wn(() => {
    e.shadow || (s.value || (Me(), v.value && j(v.value)), fe(!0), e.focusStartDate && e.startDate && Me());
  });
  const U = ae(() => {
    var E;
    return (E = e.flow) != null && E.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), ie = () => {
    e.autoApply && U.value && t("auto-apply");
  }, fe = (E = !1) => {
    if (s.value)
      return Array.isArray(s.value) ? (i.value = s.value, M(E)) : Q(s.value, E);
    if (f.value.count && E && !e.startDate)
      return D(ne(), E);
  }, J = () => Array.isArray(s.value) && k.value.enabled ? Ue(s.value[0]) === Ue(s.value[1] ?? s.value[0]) : !1, D = (E = /* @__PURE__ */ new Date(), te = !1) => {
    if ((!f.value.count || !f.value.static || te) && Y(0, Ue(E), We(E)), f.value.count && (!f.value.solo || !s.value || J()))
      for (let P = 1; P < f.value.count; P++) {
        const de = ct(ne(), { month: be.value(P - 1), year: H.value(P - 1) }), we = dp(de, { months: 1 });
        u.value[P] = { month: Ue(we), year: We(we) };
      }
  }, Q = (E, te) => {
    D(E), X("hours", di(E)), X("minutes", Ii(E)), X("seconds", Lr(E)), f.value.count && te && T();
  }, m = (E) => {
    if (f.value.count) {
      if (f.value.solo)
        return 0;
      const te = Ue(E[0]), P = Ue(E[1]);
      return Math.abs(P - te) < f.value.count ? 0 : 1;
    }
    return 1;
  }, S = (E, te) => {
    E[1] && k.value.showLastInRange ? D(E[m(E)], te) : D(E[0], te);
    const P = (de, we) => [
      de(E[0]),
      E[1] ? de(E[1]) : d[we][1]
    ];
    X("hours", P(di, "hours")), X("minutes", P(Ii, "minutes")), X("seconds", P(Lr, "seconds"));
  }, pe = (E, te) => {
    if ((k.value.enabled || e.weekPicker) && !G.value.enabled)
      return S(E, te);
    if (G.value.enabled && te) {
      const P = E[E.length - 1];
      return Q(P, te);
    }
  }, M = (E) => {
    const te = s.value;
    pe(te, E), f.value.count && f.value.solo && T();
  }, ye = (E, te) => {
    const P = ct(ne(), { month: be.value(te), year: H.value(te) }), de = E < 0 ? _a(P, 1) : zr(P, 1);
    C(Ue(de), We(de), E < 0, e.preventMinMaxNavigation) && (Y(te, Ue(de), We(de)), t("update-month-year", { instance: te, month: Ue(de), year: We(de) }), f.value.count && !f.value.solo && ce(te), n());
  }, ce = (E) => {
    for (let te = E - 1; te >= 0; te--) {
      const P = zr(ct(ne(), { month: be.value(te + 1), year: H.value(te + 1) }), 1);
      Y(te, Ue(P), We(P));
    }
    for (let te = E + 1; te <= f.value.count - 1; te++) {
      const P = _a(ct(ne(), { month: be.value(te - 1), year: H.value(te - 1) }), 1);
      Y(te, Ue(P), We(P));
    }
  }, T = () => {
    if (Array.isArray(s.value) && s.value.length === 2) {
      const E = ne(
        ne(s.value[1] ? s.value[1] : _a(s.value[0], 1))
      ), [te, P] = [Ue(s.value[0]), We(s.value[0])], [de, we] = [Ue(s.value[1]), We(s.value[1])];
      (te !== de || te === de && P !== we) && f.value.solo && Y(1, Ue(E), We(E));
    } else
      s.value && !Array.isArray(s.value) && (Y(0, Ue(s.value), We(s.value)), D(ne()));
  }, Me = () => {
    e.startDate && (Y(0, Ue(ne(e.startDate)), We(ne(e.startDate))), f.value.count && ce(0));
  }, g = (E, te) => {
    if (e.monthChangeOnScroll) {
      const P = (/* @__PURE__ */ new Date()).getTime() - r.value.getTime(), de = Math.abs(E.deltaY);
      let we = 500;
      de > 1 && (we = 100), de > 100 && (we = 0), P > we && (r.value = /* @__PURE__ */ new Date(), ye(e.monthChangeOnScroll !== "inverse" ? -E.deltaY : E.deltaY, te));
    }
  }, W = (E, te, P = !1) => {
    e.monthChangeOnArrows && e.vertical === P && K(E, te);
  }, K = (E, te) => {
    ye(E === "right" ? -1 : 1, te);
  }, B = (E) => {
    if (V.value.markers)
      return dl(E.value, V.value.markers);
  }, Z = (E, te) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [E == 0, !0];
      case "fair":
        return [E == 0 || te > E, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, je = (E, te, P, de) => {
    if (e.sixWeeks && E.length < 6) {
      const we = 6 - E.length, Ut = (te.getDay() + 7 - de) % 7, Wt = 6 - (P.getDay() + 7 - de) % 7, [cn, ca] = Z(Ut, Wt);
      for (let ha = 1; ha <= we; ha++)
        if (ca ? !!(ha % 2) == cn : cn) {
          const ve = E[0].days[0], Zn = N(ya(ve.value, -7), Ue(te));
          E.unshift({ days: Zn });
        } else {
          const ve = E[E.length - 1], Zn = ve.days[ve.days.length - 1], Qn = N(ya(Zn.value, 1), Ue(te));
          E.push({ days: Qn });
        }
    }
    return E;
  }, N = (E, te) => {
    const P = ne(E), de = [];
    for (let we = 0; we < 7; we++) {
      const Ut = ya(P, we), Wt = Ue(Ut) !== te;
      de.push({
        text: e.hideOffsetDates && Wt ? "" : Ut.getDate(),
        value: Ut,
        current: !Wt,
        classData: {}
      });
    }
    return de;
  }, se = (E, te) => {
    const P = [], de = new Date(te, E), we = new Date(te, E + 1, 0), Ut = e.weekStart, Wt = Ma(de, { weekStartsOn: Ut }), cn = (ca) => {
      const ha = N(ca, E);
      if (P.push({ days: ha }), !P[P.length - 1].days.some(
        (ve) => Ge(xn(ve.value), xn(we))
      )) {
        const ve = ya(ca, 7);
        cn(ve);
      }
    };
    return cn(Wt), je(P, de, we, Ut);
  }, Ee = (E) => {
    const te = Pi(ne(E.value), d.hours, d.minutes, Dt());
    t("date-update", te), G.value.enabled ? Mc(te, s, G.value.limit) : s.value = te, a(), Un().then(() => {
      ie();
    });
  }, $e = (E) => k.value.noDisabledRange ? Lp(i.value[0], E).some((te) => q(te)) : !1, lt = () => {
    i.value = s.value ? s.value.slice() : [], i.value.length === 2 && !(k.value.fixedStart || k.value.fixedEnd) && (i.value = []);
  }, Oe = (E, te) => {
    const P = [
      ne(E.value),
      ya(ne(E.value), +k.value.autoRange)
    ];
    re(P) ? (te && rn(E.value), i.value = P) : t("invalid-date", E.value);
  }, rn = (E) => {
    const te = Ue(ne(E)), P = We(ne(E));
    if (Y(0, te, P), f.value.count > 0)
      for (let de = 1; de < f.value.count; de++) {
        const we = Ex(
          ct(ne(E), { year: be.value(de - 1), month: H.value(de - 1) })
        );
        Y(de, we.month, we.year);
      }
  }, Rt = (E) => {
    if ($e(E.value) || !$(E.value, s.value, k.value.fixedStart ? 0 : 1))
      return t("invalid-date", E.value);
    i.value = Gp(ne(E.value), s, t, k);
  }, Mn = (E, te) => {
    if (lt(), k.value.autoRange)
      return Oe(E, te);
    if (k.value.fixedStart || k.value.fixedEnd)
      return Rt(E);
    i.value[0] ? $(ne(E.value), s.value) && !$e(E.value) ? Ct(ne(E.value), ne(i.value[0])) ? (i.value.unshift(ne(E.value)), t("range-end", i.value[0])) : (i.value[1] = ne(E.value), t("range-end", i.value[1])) : (e.autoApply && t("auto-apply-invalid", E.value), t("invalid-date", E.value)) : (i.value[0] = ne(E.value), t("range-start", i.value[0]));
  }, Dt = (E = !0) => e.enableSeconds ? Array.isArray(d.seconds) ? E ? d.seconds[0] : d.seconds[1] : d.seconds : 0, St = (E) => {
    i.value[E] = Pi(
      i.value[E],
      d.hours[E],
      d.minutes[E],
      Dt(E !== 1)
    );
  }, Li = () => {
    var E, te;
    i.value[0] && i.value[1] && +((E = i.value) == null ? void 0 : E[0]) > +((te = i.value) == null ? void 0 : te[1]) && (i.value.reverse(), t("range-start", i.value[0]), t("range-end", i.value[1]));
  }, In = () => {
    i.value.length && (i.value[0] && !i.value[1] ? St(0) : (St(0), St(1), a()), Li(), s.value = i.value.slice(), $l(i.value, t, e.autoApply, e.modelAuto));
  }, qn = (E, te = !1) => {
    if (q(E.value) || !E.current && e.hideOffsetDates)
      return t("invalid-date", E.value);
    if (o.value = JSON.parse(JSON.stringify(E)), !k.value.enabled)
      return Ee(E);
    kf(d.hours) && kf(d.minutes) && !G.value.enabled && (Mn(E, te), In());
  }, Xn = (E, te) => {
    var P;
    Y(E, te.month, te.year, !0), f.value.count && !f.value.solo && ce(E), t("update-month-year", { instance: E, month: te.month, year: te.year }), n(f.value.solo ? E : void 0);
    const de = (P = e.flow) != null && P.length ? e.flow[e.flowStep] : void 0;
    !te.fromNav && (de === vn.month || de === vn.year) && a();
  }, Qe = (E, te) => {
    Up({
      value: E,
      modelValue: s,
      range: k.value.enabled,
      timezone: te ? void 0 : R.value.timezone
    }), p(), e.multiCalendars && Un().then(() => fe(!0));
  }, ja = () => {
    const E = wc(ne(), R.value);
    k.value.enabled ? s.value && Array.isArray(s.value) && s.value[0] ? s.value = Ct(E, s.value[0]) ? [E, s.value[0]] : [s.value[0], E] : s.value = [E] : s.value = E, p();
  }, Qr = () => {
    if (Array.isArray(s.value))
      if (G.value.enabled) {
        const E = gt();
        s.value[s.value.length - 1] = I(E);
      } else
        s.value = s.value.map((E, te) => E && I(E, te));
    else
      s.value = I(s.value);
    t("time-update");
  }, gt = () => Array.isArray(s.value) && s.value.length ? s.value[s.value.length - 1] : null;
  return {
    calendars: u,
    modelValue: s,
    month: be,
    year: H,
    time: d,
    disabledTimesConfig: xe,
    today: c,
    validateTime: oe,
    getCalendarDays: se,
    getMarker: B,
    handleScroll: g,
    handleSwipe: K,
    handleArrow: W,
    selectDate: qn,
    updateMonthYear: Xn,
    presetDate: Qe,
    selectCurrentDate: ja,
    updateTime: (E, te = !0, P = !1) => {
      A(E, te, P, Qr);
    },
    assignMonthAndYear: D
  };
}, qM = { key: 0 }, XM = /* @__PURE__ */ nn({
  __name: "DatePicker",
  props: {
    ...Sa
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, {
      calendars: r,
      month: o,
      year: l,
      modelValue: s,
      time: u,
      disabledTimesConfig: d,
      today: c,
      validateTime: f,
      getCalendarDays: v,
      getMarker: k,
      handleArrow: b,
      handleScroll: R,
      handleSwipe: V,
      selectDate: G,
      updateMonthYear: C,
      presetDate: q,
      selectCurrentDate: re,
      updateTime: $,
      assignMonthAndYear: A
    } = GM(i, a, J, D), I = Yi(), { setHoverDate: X, getDayClassData: j, clearHoverDate: oe } = cD(s, i), { defaultedMultiCalendars: xe } = Mt(i), be = he([]), H = he([]), _ = he(null), Y = Vn(I, "calendar"), p = Vn(I, "monthYear"), U = Vn(I, "timePicker"), ie = (g) => {
      i.shadow || a("mount", g);
    };
    ra(
      r,
      () => {
        i.shadow || setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), ra(
      xe,
      (g, W) => {
        g.count - W.count > 0 && A();
      },
      { deep: !0 }
    );
    const fe = ae(() => (g) => v(o.value(g), l.value(g)).map((W) => ({
      ...W,
      days: W.days.map((K) => (K.marker = k(K), K.classData = j(K), K))
    })));
    function J(g) {
      var W;
      g || g === 0 ? (W = H.value[g]) == null || W.triggerTransition(o.value(g), l.value(g)) : H.value.forEach((K, B) => K.triggerTransition(o.value(B), l.value(B)));
    }
    function D() {
      a("update-flow-step");
    }
    const Q = (g, W = !1) => {
      G(g, W), i.spaceConfirm && a("select-date");
    }, m = (g, W, K = 0) => {
      var B;
      (B = be.value[K]) == null || B.toggleMonthPicker(g, W);
    }, S = (g, W, K = 0) => {
      var B;
      (B = be.value[K]) == null || B.toggleYearPicker(g, W);
    }, pe = (g, W, K) => {
      var B;
      (B = _.value) == null || B.toggleTimePicker(g, W, K);
    }, M = (g, W) => {
      var K;
      if (!i.range) {
        const B = s.value ? s.value : c, Z = W ? new Date(W) : B, je = g ? Ma(Z, { weekStartsOn: 1 }) : yp(Z, { weekStartsOn: 1 });
        G({
          value: je,
          current: Ue(Z) === o.value(0),
          text: "",
          classData: {}
        }), (K = document.getElementById(Bp(je))) == null || K.focus();
      }
    }, ye = (g) => {
      var W;
      (W = be.value[0]) == null || W.handleMonthYearChange(g, !0);
    }, ce = (g) => {
      C(0, { month: o.value(0), year: l.value(0) + (g ? 1 : -1), fromNav: !0 });
    }, T = (g, W) => {
      g === vn.time && a(`time-picker-${W ? "open" : "close"}`), a("overlay-toggle", { open: W, overlay: g });
    }, Me = (g) => {
      a("overlay-toggle", { open: !1, overlay: g }), a("focus-menu");
    };
    return t({
      clearHoverDate: oe,
      presetDate: q,
      selectCurrentDate: re,
      toggleMonthPicker: m,
      toggleYearPicker: S,
      toggleTimePicker: pe,
      handleArrow: b,
      updateMonthYear: C,
      getSidebarProps: () => ({
        modelValue: s,
        month: o,
        year: l,
        time: u,
        updateTime: $,
        updateMonthYear: C,
        selectDate: G,
        presetDate: q
      }),
      changeMonth: ye,
      changeYear: ce,
      selectWeekDate: M
    }), (g, W) => (y(), O(Fe, null, [
      Pe(Nl, {
        "multi-calendars": x(xe).count,
        collapse: g.collapse
      }, {
        default: De(({ instance: K, index: B }) => [
          g.disableMonthYearSelect ? F("", !0) : (y(), le(NM, Ft({
            key: 0,
            ref: (Z) => {
              Z && (be.value[B] = Z);
            },
            months: x(Pp)(g.formatLocale, g.locale, g.monthNameFormat),
            years: x(bc)(g.yearRange, g.locale, g.reverseYears),
            month: x(o)(K),
            year: x(l)(K),
            instance: K
          }, g.$props, {
            onMount: W[0] || (W[0] = (Z) => ie(x(tr).header)),
            onResetFlow: W[1] || (W[1] = (Z) => g.$emit("reset-flow")),
            onUpdateMonthYear: (Z) => x(C)(K, Z),
            onOverlayClosed: Me,
            onOverlayOpened: W[2] || (W[2] = (Z) => g.$emit("overlay-toggle", { open: !0, overlay: Z }))
          }), gn({ _: 2 }, [
            Xe(x(p), (Z, je) => ({
              name: Z,
              fn: De((N) => [
                me(g.$slots, Z, tn(Cn(N)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Pe(UM, Ft({
            ref: (Z) => {
              Z && (H.value[B] = Z);
            },
            "mapped-dates": fe.value(K),
            month: x(o)(K),
            year: x(l)(K),
            instance: K
          }, g.$props, {
            onSelectDate: (Z) => x(G)(Z, K !== 1),
            onHandleSpace: (Z) => Q(Z, K !== 1),
            onSetHoverDate: W[3] || (W[3] = (Z) => x(X)(Z)),
            onHandleScroll: (Z) => x(R)(Z, K),
            onHandleSwipe: (Z) => x(V)(Z, K),
            onMount: W[4] || (W[4] = (Z) => ie(x(tr).calendar)),
            onResetFlow: W[5] || (W[5] = (Z) => g.$emit("reset-flow")),
            onTooltipOpen: W[6] || (W[6] = (Z) => g.$emit("tooltip-open", Z)),
            onTooltipClose: W[7] || (W[7] = (Z) => g.$emit("tooltip-close", Z))
          }), gn({ _: 2 }, [
            Xe(x(Y), (Z, je) => ({
              name: Z,
              fn: De((N) => [
                me(g.$slots, Z, tn(Cn({ ...N })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse"]),
      g.enableTimePicker ? (y(), O("div", qM, [
        g.$slots["time-picker"] ? me(g.$slots, "time-picker", tn(Ft({ key: 0 }, { time: x(u), updateTime: x($) }))) : (y(), le(Xp, Ft({
          key: 1,
          ref_key: "timePickerRef",
          ref: _
        }, g.$props, {
          hours: x(u).hours,
          minutes: x(u).minutes,
          seconds: x(u).seconds,
          "internal-model-value": g.internalModelValue,
          "disabled-times-config": x(d),
          "validate-time": x(f),
          onMount: W[8] || (W[8] = (K) => ie(x(tr).timePicker)),
          "onUpdate:hours": W[9] || (W[9] = (K) => x($)(K)),
          "onUpdate:minutes": W[10] || (W[10] = (K) => x($)(K, !1)),
          "onUpdate:seconds": W[11] || (W[11] = (K) => x($)(K, !1, !0)),
          onResetFlow: W[12] || (W[12] = (K) => g.$emit("reset-flow")),
          onOverlayClosed: W[13] || (W[13] = (K) => T(K, !1)),
          onOverlayOpened: W[14] || (W[14] = (K) => T(K, !0)),
          onAmPmChange: W[15] || (W[15] = (K) => g.$emit("am-pm-change", K))
        }), gn({ _: 2 }, [
          Xe(x(U), (K, B) => ({
            name: K,
            fn: De((Z) => [
              me(g.$slots, K, tn(Cn(Z)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : F("", !0)
    ], 64));
  }
}), ZM = (e, t) => {
  const n = he(), {
    defaultedMultiCalendars: a,
    defaultedConfig: i,
    defaultedHighlight: r,
    defaultedRange: o,
    propDates: l,
    defaultedFilters: s,
    defaultedMultiDates: u
  } = Mt(e), { modelValue: d, year: c, month: f, calendars: v } = es(e, t), { isDisabled: k } = $i(e), { selectYear: b, groupedYears: R, showYearPicker: V, isDisabled: G, toggleYearPicker: C, handleYearSelect: q, handleYear: re } = qp({
    modelValue: d,
    multiCalendars: a,
    range: o,
    highlight: r,
    calendars: v,
    propDates: l,
    month: f,
    year: c,
    filters: s,
    props: e,
    emit: t
  }), $ = (_, Y) => [_, Y].map((p) => La(p, "MMMM", { locale: e.formatLocale })).join("-"), A = ae(() => (_) => d.value ? Array.isArray(d.value) ? d.value.some((Y) => mf(_, Y)) : mf(d.value, _) : !1), I = (_) => {
    if (o.value.enabled) {
      if (Array.isArray(d.value)) {
        const Y = Ge(_, d.value[0]) || Ge(_, d.value[1]);
        return Il(d.value, n.value, _) && !Y;
      }
      return !1;
    }
    return !1;
  }, X = (_, Y) => _.quarter === lf(Y) && _.year === We(Y), j = (_) => typeof r.value == "function" ? r.value({ quarter: lf(_), year: We(_) }) : !!r.value.quarters.find((Y) => X(Y, _)), oe = ae(() => (_) => {
    const Y = ct(/* @__PURE__ */ new Date(), { year: c.value(_) });
    return k_({
      start: Vo(Y),
      end: gp(Y)
    }).map((p) => {
      const U = Ji(p), ie = uf(p), fe = k(p), J = I(U), D = j(U);
      return {
        text: $(U, ie),
        value: U,
        active: A.value(U),
        highlighted: D,
        disabled: fe,
        isBetween: J
      };
    });
  }), xe = (_) => {
    Mc(_, d, u.value.limit), t("auto-apply", !0);
  }, be = (_) => {
    d.value = Dc(d, _, t), $l(d.value, t, e.autoApply, e.modelAuto);
  }, H = (_) => {
    d.value = _, t("auto-apply");
  };
  return {
    defaultedConfig: i,
    defaultedMultiCalendars: a,
    groupedYears: R,
    year: c,
    isDisabled: G,
    quarters: oe,
    showYearPicker: V,
    modelValue: d,
    setHoverDate: (_) => {
      n.value = _;
    },
    selectYear: b,
    selectQuarter: (_, Y, p) => {
      if (!p)
        return v.value[Y].month = Ue(uf(_)), u.value.enabled ? xe(_) : o.value.enabled ? be(_) : H(_);
    },
    toggleYearPicker: C,
    handleYearSelect: q,
    handleYear: re
  };
}, QM = { class: "dp--quarter-items" }, KM = ["data-test", "disabled", "onClick", "onMouseover"], JM = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...Sa
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, r = Yi(), o = Vn(r, "yearMode"), {
      defaultedMultiCalendars: l,
      defaultedConfig: s,
      groupedYears: u,
      year: d,
      isDisabled: c,
      quarters: f,
      modelValue: v,
      showYearPicker: k,
      setHoverDate: b,
      selectQuarter: R,
      toggleYearPicker: V,
      handleYearSelect: G,
      handleYear: C
    } = ZM(i, a);
    return t({ getSidebarProps: () => ({
      modelValue: v,
      year: d,
      selectQuarter: R,
      handleYearSelect: G,
      handleYear: C
    }) }), (q, re) => (y(), le(Nl, {
      "multi-calendars": x(l).count,
      collapse: q.collapse,
      stretch: ""
    }, {
      default: De(({ instance: $ }) => [
        ee("div", {
          class: "dp-quarter-picker-wrap",
          style: kn({ minHeight: `${x(s).modeHeight}px` })
        }, [
          q.$slots["top-extra"] ? me(q.$slots, "top-extra", {
            key: 0,
            value: q.internalModelValue
          }) : F("", !0),
          ee("div", null, [
            Pe(jp, Ft(q.$props, {
              items: x(u)($),
              instance: $,
              "show-year-picker": x(k)[$],
              year: x(d)($),
              "is-disabled": (A) => x(c)($, A),
              onHandleYear: (A) => x(C)($, A),
              onYearSelect: (A) => x(G)(A, $),
              onToggleYearPicker: (A) => x(V)($, A == null ? void 0 : A.flow, A == null ? void 0 : A.show)
            }), gn({ _: 2 }, [
              Xe(x(o), (A, I) => ({
                name: A,
                fn: De((X) => [
                  me(q.$slots, A, tn(Cn(X)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          ee("div", QM, [
            (y(!0), O(Fe, null, Xe(x(f)($), (A, I) => (y(), O("div", { key: I }, [
              ee("button", {
                type: "button",
                class: Ne(["dp--qr-btn", {
                  "dp--qr-btn-active": A.active,
                  "dp--qr-btn-between": A.isBetween,
                  "dp--qr-btn-disabled": A.disabled,
                  "dp--highlighted": A.highlighted
                }]),
                "data-test": A.value,
                disabled: A.disabled,
                onClick: (X) => x(R)(A.value, $, A.disabled),
                onMouseover: (X) => x(b)(A.value)
              }, [
                q.$slots.quarter ? me(q.$slots, "quarter", {
                  key: 0,
                  value: A.value,
                  text: A.text
                }) : (y(), O(Fe, { key: 1 }, [
                  sa(et(A.text), 1)
                ], 64))
              ], 42, KM)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), eD = ["id", "aria-label"], tD = {
  key: 0,
  class: "dp--menu-load-container"
}, nD = /* @__PURE__ */ ee("span", { class: "dp--menu-loader" }, null, -1), aD = [
  nD
], iD = {
  key: 0,
  class: "dp__sidebar_left"
}, rD = ["data-test", "onClick", "onKeydown"], oD = {
  key: 2,
  class: "dp__sidebar_right"
}, sD = {
  key: 3,
  class: "dp__action_extra"
}, xf = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Yl,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, r = he(null), o = ae(() => {
      const { openOnTop: N, ...se } = i;
      return {
        ...se,
        flowStep: X.value,
        collapse: i.collapse,
        noOverlayFocus: i.noOverlayFocus,
        menuWrapRef: r.value
      };
    }), { setMenuFocused: l, setShiftKey: s, control: u } = Vp(), d = Yi(), { defaultedTextInput: c, defaultedInline: f, defaultedConfig: v, defaultedUI: k } = Mt(i), b = he(null), R = he(0), V = he(null), G = he(!1), C = he(null);
    wn(() => {
      if (!i.shadow) {
        G.value = !0, q(), window.addEventListener("resize", q);
        const N = Zt(r);
        if (N && !c.value.enabled && !f.value.enabled && (l(!0), Y()), N) {
          const se = (Ee) => {
            v.value.allowPreventDefault && Ee.preventDefault(), Ei(Ee, v.value, !0);
          };
          N.addEventListener("pointerdown", se), N.addEventListener("mousedown", se);
        }
      }
    }), vl(() => {
      window.removeEventListener("resize", q);
    });
    const q = () => {
      const N = Zt(V);
      N && (R.value = N.getBoundingClientRect().width);
    }, { arrowRight: re, arrowLeft: $, arrowDown: A, arrowUp: I } = Ni(), { flowStep: X, updateFlowStep: j, childMount: oe, resetFlow: xe, handleFlow: be } = hD(i, a, C), H = ae(() => i.monthPicker ? cM : i.yearPicker ? fM : i.timePicker ? CM : i.quarterPicker ? JM : XM), _ = ae(() => {
      var N;
      if (v.value.arrowLeft)
        return v.value.arrowLeft;
      const se = (N = r.value) == null ? void 0 : N.getBoundingClientRect(), Ee = i.getInputRect();
      return (Ee == null ? void 0 : Ee.width) < (R == null ? void 0 : R.value) && (Ee == null ? void 0 : Ee.left) <= ((se == null ? void 0 : se.left) ?? 0) ? `${(Ee == null ? void 0 : Ee.width) / 2}px` : (Ee == null ? void 0 : Ee.right) >= ((se == null ? void 0 : se.right) ?? 0) && (Ee == null ? void 0 : Ee.width) < (R == null ? void 0 : R.value) ? `${(R == null ? void 0 : R.value) - (Ee == null ? void 0 : Ee.width) / 2}px` : "50%";
    }), Y = () => {
      const N = Zt(r);
      N && N.focus({ preventScroll: !0 });
    }, p = ae(() => {
      var N;
      return ((N = C.value) == null ? void 0 : N.getSidebarProps()) || {};
    }), U = () => {
      i.openOnTop && a("recalculate-position");
    }, ie = Vn(d, "action"), fe = ae(() => i.monthPicker || i.yearPicker ? Vn(d, "monthYear") : i.timePicker ? Vn(d, "timePicker") : Vn(d, "shared")), J = ae(() => i.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), D = ae(() => ({
      dp__menu_disabled: i.disabled,
      dp__menu_readonly: i.readonly,
      "dp-menu-loading": i.loading
    })), Q = ae(
      () => ({
        dp__menu: !0,
        dp__menu_index: !f.value.enabled,
        dp__relative: f.value.enabled,
        [i.menuClassName]: !!i.menuClassName,
        ...k.value.menu ?? {}
      })
    ), m = (N) => {
      Ei(N, v.value, !0);
    }, S = () => {
      i.escClose && a("close-picker");
    }, pe = (N) => {
      if (i.arrowNavigation) {
        if (N === bn.up)
          return I();
        if (N === bn.down)
          return A();
        if (N === bn.left)
          return $();
        if (N === bn.right)
          return re();
      } else
        N === bn.left || N === bn.up ? Me("handleArrow", bn.left, 0, N === bn.up) : Me("handleArrow", bn.right, 0, N === bn.down);
    }, M = (N) => {
      s(N.shiftKey), !i.disableMonthYearSelect && N.code === kt.tab && N.target.classList.contains("dp__menu") && u.value.shiftKeyInMenu && (N.preventDefault(), Ei(N, v.value, !0), a("close-picker"));
    }, ye = () => {
      Y(), a("time-picker-close");
    }, ce = (N) => {
      var se, Ee, $e;
      (se = C.value) == null || se.toggleTimePicker(!1, !1), (Ee = C.value) == null || Ee.toggleMonthPicker(!1, !1, N), ($e = C.value) == null || $e.toggleYearPicker(!1, !1, N);
    }, T = (N, se = 0) => {
      var Ee, $e, lt;
      return N === "month" ? (Ee = C.value) == null ? void 0 : Ee.toggleMonthPicker(!1, !0, se) : N === "year" ? ($e = C.value) == null ? void 0 : $e.toggleYearPicker(!1, !0, se) : N === "time" ? (lt = C.value) == null ? void 0 : lt.toggleTimePicker(!0, !1) : ce(se);
    }, Me = (N, ...se) => {
      var Ee, $e;
      (Ee = C.value) != null && Ee[N] && (($e = C.value) == null || $e[N](...se));
    }, g = () => {
      Me("selectCurrentDate");
    }, W = (N, se) => {
      Me("presetDate", N, se);
    }, K = () => {
      Me("clearHoverDate");
    }, B = (N, se) => {
      Me("updateMonthYear", N, se);
    }, Z = (N, se) => {
      N.preventDefault(), pe(se);
    }, je = (N) => {
      var se;
      if (M(N), N.key === kt.home || N.key === kt.end)
        return Me(
          "selectWeekDate",
          N.key === kt.home,
          N.target.getAttribute("id")
        );
      switch ((N.key === kt.pageUp || N.key === kt.pageDown) && (N.shiftKey ? Me("changeYear", N.key === kt.pageUp) : Me("changeMonth", N.key === kt.pageUp), N.target.getAttribute("id") && ((se = r.value) == null || se.focus({ preventScroll: !0 }))), N.key) {
        case kt.esc:
          return S();
        case kt.arrowLeft:
          return Z(N, bn.left);
        case kt.arrowRight:
          return Z(N, bn.right);
        case kt.arrowUp:
          return Z(N, bn.up);
        case kt.arrowDown:
          return Z(N, bn.down);
        default:
          return;
      }
    };
    return t({
      updateMonthYear: B,
      switchView: T,
      handleFlow: be
    }), (N, se) => {
      var Ee, $e, lt;
      return y(), O("div", {
        id: N.uid ? `dp-menu-${N.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: r,
        tabindex: "0",
        role: "dialog",
        "aria-label": (Ee = N.ariaLabels) == null ? void 0 : Ee.menu,
        class: Ne(Q.value),
        style: kn({ "--dp-arrow-left": _.value }),
        onMouseleave: K,
        onClick: m,
        onKeydown: je
      }, [
        (N.disabled || N.readonly) && x(f).enabled || N.loading ? (y(), O("div", {
          key: 0,
          class: Ne(D.value)
        }, [
          N.loading ? (y(), O("div", tD, aD)) : F("", !0)
        ], 2)) : F("", !0),
        !x(f).enabled && !N.teleportCenter ? (y(), O("div", {
          key: 1,
          class: Ne(J.value)
        }, null, 2)) : F("", !0),
        ee("div", {
          ref_key: "innerMenuRef",
          ref: V,
          class: Ne({
            dp__menu_content_wrapper: (($e = N.presetDates) == null ? void 0 : $e.length) || !!N.$slots["left-sidebar"] || !!N.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((lt = N.presetDates) == null ? void 0 : lt.length) || !!N.$slots["left-sidebar"] || !!N.$slots["right-sidebar"])
          }),
          style: kn({ "--dp-menu-width": `${R.value}px` })
        }, [
          N.$slots["left-sidebar"] ? (y(), O("div", iD, [
            me(N.$slots, "left-sidebar", tn(Cn(p.value)))
          ])) : F("", !0),
          N.presetDates.length ? (y(), O("div", {
            key: 1,
            class: Ne({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 })
          }, [
            (y(!0), O(Fe, null, Xe(N.presetDates, (Oe, rn) => (y(), O(Fe, { key: rn }, [
              Oe.slot ? me(N.$slots, Oe.slot, {
                key: 0,
                presetDate: W,
                label: Oe.label,
                value: Oe.value
              }) : (y(), O("button", {
                key: 1,
                type: "button",
                style: kn(Oe.style || {}),
                class: Ne(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test": Oe.testId ?? void 0,
                onClick: ii((Rt) => W(Oe.value, Oe.noTz), ["prevent"]),
                onKeydown: (Rt) => x(En)(Rt, () => W(Oe.value, Oe.noTz), !0)
              }, et(Oe.label), 47, rD))
            ], 64))), 128))
          ], 2)) : F("", !0),
          ee("div", {
            ref_key: "calendarWrapperRef",
            ref: b,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (y(), le(li(H.value), Ft({
              ref_key: "dynCmpRef",
              ref: C
            }, o.value, {
              "flow-step": x(X),
              onMount: x(oe),
              onUpdateFlowStep: x(j),
              onResetFlow: x(xe),
              onFocusMenu: Y,
              onSelectDate: se[0] || (se[0] = (Oe) => N.$emit("select-date")),
              onDateUpdate: se[1] || (se[1] = (Oe) => N.$emit("date-update", Oe)),
              onTooltipOpen: se[2] || (se[2] = (Oe) => N.$emit("tooltip-open", Oe)),
              onTooltipClose: se[3] || (se[3] = (Oe) => N.$emit("tooltip-close", Oe)),
              onAutoApply: se[4] || (se[4] = (Oe) => N.$emit("auto-apply", Oe)),
              onRangeStart: se[5] || (se[5] = (Oe) => N.$emit("range-start", Oe)),
              onRangeEnd: se[6] || (se[6] = (Oe) => N.$emit("range-end", Oe)),
              onInvalidFixedRange: se[7] || (se[7] = (Oe) => N.$emit("invalid-fixed-range", Oe)),
              onTimeUpdate: se[8] || (se[8] = (Oe) => N.$emit("time-update")),
              onAmPmChange: se[9] || (se[9] = (Oe) => N.$emit("am-pm-change", Oe)),
              onTimePickerOpen: se[10] || (se[10] = (Oe) => N.$emit("time-picker-open", Oe)),
              onTimePickerClose: ye,
              onRecalculatePosition: U,
              onUpdateMonthYear: se[11] || (se[11] = (Oe) => N.$emit("update-month-year", Oe)),
              onAutoApplyInvalid: se[12] || (se[12] = (Oe) => N.$emit("auto-apply-invalid", Oe)),
              onInvalidDate: se[13] || (se[13] = (Oe) => N.$emit("invalid-date", Oe)),
              onOverlayToggle: se[14] || (se[14] = (Oe) => N.$emit("overlay-toggle", Oe)),
              "onUpdate:internalModelValue": se[15] || (se[15] = (Oe) => N.$emit("update:internal-model-value", Oe))
            }), gn({ _: 2 }, [
              Xe(fe.value, (Oe, rn) => ({
                name: Oe,
                fn: De((Rt) => [
                  me(N.$slots, Oe, tn(Cn({ ...Rt })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          N.$slots["right-sidebar"] ? (y(), O("div", oD, [
            me(N.$slots, "right-sidebar", tn(Cn(p.value)))
          ])) : F("", !0),
          N.$slots["action-extra"] ? (y(), O("div", sD, [
            N.$slots["action-extra"] ? me(N.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: g
            }) : F("", !0)
          ])) : F("", !0)
        ], 6),
        !N.autoApply || x(v).keepActionRow ? (y(), le(aM, Ft({
          key: 2,
          "menu-mount": G.value
        }, o.value, {
          "calendar-width": R.value,
          onClosePicker: se[16] || (se[16] = (Oe) => N.$emit("close-picker")),
          onSelectDate: se[17] || (se[17] = (Oe) => N.$emit("select-date")),
          onInvalidSelect: se[18] || (se[18] = (Oe) => N.$emit("invalid-select")),
          onSelectNow: g
        }), gn({ _: 2 }, [
          Xe(x(ie), (Oe, rn) => ({
            name: Oe,
            fn: De((Rt) => [
              me(N.$slots, Oe, tn(Cn({ ...Rt })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : F("", !0)
      ], 46, eD);
    };
  }
});
var _r = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(_r || {});
const lD = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: n,
  pickerWrapperRef: a,
  inline: i,
  emit: r,
  props: o,
  slots: l
}) => {
  const s = he({}), u = he(!1), d = he({
    top: "0",
    left: "0"
  }), c = he(!1), f = Lo(o, "teleportCenter");
  ra(f, () => {
    d.value = JSON.parse(JSON.stringify({})), q();
  });
  const v = (_) => {
    if (o.teleport) {
      const Y = _.getBoundingClientRect();
      return {
        left: Y.left + window.scrollX,
        top: Y.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, k = (_, Y) => {
    d.value.left = `${_ + Y - s.value.width}px`;
  }, b = (_) => {
    d.value.left = `${_}px`;
  }, R = (_, Y) => {
    o.position === _r.left && b(_), o.position === _r.right && k(_, Y), o.position === _r.center && (d.value.left = `${_ + Y / 2 - s.value.width / 2}px`);
  }, V = (_) => {
    const { width: Y, height: p } = _.getBoundingClientRect(), { top: U, left: ie } = o.altPosition ? o.altPosition(_) : v(_);
    return { top: +U, left: +ie, width: Y, height: p };
  }, G = () => {
    d.value.left = "50%", d.value.top = "50%", d.value.transform = "translate(-50%, -50%)", d.value.position = "fixed", delete d.value.opacity;
  }, C = () => {
    const _ = Zt(n), { top: Y, left: p, transform: U } = o.altPosition(_);
    d.value = { top: `${Y}px`, left: `${p}px`, transform: U ?? "" };
  }, q = (_ = !0) => {
    var Y;
    if (!i.value.enabled) {
      if (f.value)
        return G();
      if (o.altPosition !== null)
        return C();
      if (_) {
        const p = o.teleport ? (Y = t.value) == null ? void 0 : Y.$el : e.value;
        p && (s.value = p.getBoundingClientRect()), r("recalculate-position");
      }
      return oe();
    }
  }, re = ({ inputEl: _, left: Y, width: p }) => {
    window.screen.width > 768 && !u.value && R(Y, p), I(_);
  }, $ = (_) => {
    const { top: Y, left: p, height: U, width: ie } = V(_);
    d.value.top = `${U + Y + +o.offset}px`, c.value = !1, u.value || (d.value.left = `${p + ie / 2 - s.value.width / 2}px`), re({ inputEl: _, left: p, width: ie });
  }, A = (_) => {
    const { top: Y, left: p, width: U } = V(_);
    d.value.top = `${Y - +o.offset - s.value.height}px`, c.value = !0, re({ inputEl: _, left: p, width: U });
  }, I = (_) => {
    if (o.autoPosition) {
      const { left: Y, width: p } = V(_), { left: U, right: ie } = s.value;
      if (!u.value) {
        if (Math.abs(U) !== Math.abs(ie)) {
          if (U <= 0)
            return u.value = !0, b(Y);
          if (ie >= document.documentElement.clientWidth)
            return u.value = !0, k(Y, p);
        }
        return R(Y, p);
      }
    }
  }, X = () => {
    const _ = Zt(n);
    if (_) {
      const { height: Y } = s.value, { top: p, height: U } = _.getBoundingClientRect(), ie = window.innerHeight - p - U, fe = p;
      return Y <= ie ? Zi.bottom : Y > ie && Y <= fe ? Zi.top : ie >= fe ? Zi.bottom : Zi.top;
    }
    return Zi.bottom;
  }, j = (_) => X() === Zi.bottom ? $(_) : A(_), oe = () => {
    const _ = Zt(n);
    if (_)
      return o.autoPosition ? j(_) : $(_);
  }, xe = function(_) {
    if (_) {
      const Y = _.scrollHeight > _.clientHeight, p = window.getComputedStyle(_).overflowY.indexOf("hidden") !== -1;
      return Y && !p;
    }
    return !0;
  }, be = function(_) {
    return !_ || _ === document.body || _.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : xe(_) ? _ : be(_.assignedSlot ? _.assignedSlot.parentNode : _.parentNode);
  }, H = (_) => {
    if (_)
      switch (o.position) {
        case _r.left:
          return { left: 0, transform: "translateX(0)" };
        case _r.right:
          return { left: `${_.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${_.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: c,
    menuStyle: d,
    xCorrect: u,
    setMenuPosition: q,
    getScrollableParent: be,
    shadowRender: (_, Y) => {
      var p, U, ie;
      const fe = document.createElement("div"), J = (p = Zt(n)) == null ? void 0 : p.getBoundingClientRect();
      fe.setAttribute("id", "dp--temp-container");
      const D = (U = a.value) != null && U.clientWidth ? a.value : document.body;
      D.append(fe);
      const Q = H(J), m = nd(
        _,
        {
          ...Y,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...Q }
        },
        Object.fromEntries(
          Object.keys(l).filter((S) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(S)).map((S) => [S, l[S]])
        )
      );
      Th(m, fe), s.value = (ie = m.el) == null ? void 0 : ie.getBoundingClientRect(), Th(null, fe), D.removeChild(fe);
    }
  };
}, wi = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] }
], uD = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], dD = {
  all: () => wi,
  monthYear: () => wi.filter((e) => e.use.includes("month-year")),
  input: () => uD,
  timePicker: () => wi.filter((e) => e.use.includes("time")),
  action: () => wi.filter((e) => e.use.includes("action")),
  calendar: () => wi.filter((e) => e.use.includes("calendar")),
  menu: () => wi.filter((e) => e.use.includes("menu")),
  shared: () => wi.filter((e) => e.use.includes("shared")),
  yearMode: () => wi.filter((e) => e.use.includes("year-mode"))
}, Vn = (e, t, n) => {
  const a = [];
  return dD[t]().forEach((i) => {
    e[i.name] && a.push(i.name);
  }), n != null && n.length && n.forEach((i) => {
    i.slot && a.push(i.slot);
  }), a;
}, Jo = (e) => {
  const t = ae(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), n = ae(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: n };
}, es = (e, t, n) => {
  const { defaultedRange: a, defaultedTz: i } = Mt(e), r = ne(Rn(ne(), i.value.timezone)), o = he([{ month: Ue(r), year: We(r) }]), l = (f) => {
    const v = {
      hours: di(r),
      minutes: Ii(r),
      seconds: 0
    };
    return a.value.enabled ? [v[f], v[f]] : v[f];
  }, s = Go({
    hours: l("hours"),
    minutes: l("minutes"),
    seconds: l("seconds")
  });
  ra(
    a,
    (f, v) => {
      f.enabled !== v.enabled && (s.hours = l("hours"), s.minutes = l("minutes"), s.seconds = l("seconds"));
    },
    { deep: !0 }
  );
  const u = ae({
    get: () => e.internalModelValue,
    set: (f) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", f);
    }
  }), d = ae(
    () => (f) => o.value[f] ? o.value[f].month : 0
  ), c = ae(
    () => (f) => o.value[f] ? o.value[f].year : 0
  );
  return ra(
    u,
    (f, v) => {
      n && JSON.stringify(f ?? {}) !== JSON.stringify(v ?? {}) && n();
    },
    { deep: !0 }
  ), {
    calendars: o,
    time: s,
    modelValue: u,
    month: d,
    year: c,
    today: r
  };
}, cD = (e, t) => {
  const {
    defaultedMultiCalendars: n,
    defaultedMultiDates: a,
    defaultedUI: i,
    defaultedHighlight: r,
    defaultedTz: o,
    propDates: l,
    defaultedRange: s
  } = Mt(t), { isDisabled: u } = $i(t), d = he(null), c = he(Rn(/* @__PURE__ */ new Date(), o.value.timezone)), f = (m) => {
    !m.current && t.hideOffsetDates || (d.value = m.value);
  }, v = () => {
    d.value = null;
  }, k = (m) => Array.isArray(e.value) && s.value.enabled && e.value[0] && d.value ? m ? $t(d.value, e.value[0]) : Ct(d.value, e.value[0]) : !0, b = (m, S) => {
    const pe = () => e.value ? S ? e.value[0] || null : e.value[1] : null, M = e.value && Array.isArray(e.value) ? pe() : null;
    return Ge(ne(m.value), M);
  }, R = (m) => {
    const S = Array.isArray(e.value) ? e.value[0] : null;
    return m ? !Ct(d.value ?? null, S) : !0;
  }, V = (m, S = !0) => (s.value.enabled || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !m.current ? !1 : Ge(ne(m.value), e.value[S ? 0 : 1]) : s.value.enabled ? b(m, S) && R(S) || Ge(m.value, Array.isArray(e.value) ? e.value[0] : null) && k(S) : !1, G = (m, S) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const pe = Ge(m.value, d.value);
      return S ? $t(e.value[0], m.value) && pe : Ct(e.value[0], m.value) && pe;
    }
    return !1;
  }, C = (m) => !e.value || t.hideOffsetDates && !m.current ? !1 : s.value.enabled ? t.modelAuto && Array.isArray(e.value) ? Ge(m.value, e.value[0] ? e.value[0] : c.value) : !1 : a.value.enabled && Array.isArray(e.value) ? e.value.some((S) => Ge(S, m.value)) : Ge(m.value, e.value ? e.value : c.value), q = (m) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        if (t.hideOffsetDates && !m.current)
          return !1;
        const S = ya(d.value, +s.value.autoRange), pe = Ka(ne(d.value), t.weekStart);
        return t.weekPicker ? Ge(pe[1], ne(m.value)) : Ge(S, ne(m.value));
      }
      return !1;
    }
    return !1;
  }, re = (m) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        const S = ya(d.value, +s.value.autoRange);
        if (t.hideOffsetDates && !m.current)
          return !1;
        const pe = Ka(ne(d.value), t.weekStart);
        return t.weekPicker ? $t(m.value, pe[0]) && Ct(m.value, pe[1]) : $t(m.value, d.value) && Ct(m.value, S);
      }
      return !1;
    }
    return !1;
  }, $ = (m) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        if (t.hideOffsetDates && !m.current)
          return !1;
        const S = Ka(ne(d.value), t.weekStart);
        return t.weekPicker ? Ge(S[0], m.value) : Ge(d.value, m.value);
      }
      return !1;
    }
    return !1;
  }, A = (m) => Il(e.value, d.value, m.value), I = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, X = () => t.modelAuto ? Rp(t.internalModelValue) : !0, j = (m) => {
    if (t.weekPicker)
      return !1;
    const S = s.value.enabled ? !V(m) && !V(m, !1) : !0;
    return !u(m.value) && !C(m) && !(!m.current && t.hideOffsetDates) && S;
  }, oe = (m) => s.value.enabled ? t.modelAuto ? I() && C(m) : !1 : C(m), xe = (m) => r.value ? Ax(m.value, l.value.highlight) : !1, be = (m) => {
    const S = u(m.value);
    return S && (typeof r.value == "function" ? !r.value(m.value, S) : !r.value.options.highlightDisabled);
  }, H = (m) => {
    var S;
    return typeof r.value == "function" ? r.value(m.value) : (S = r.value.weekdays) == null ? void 0 : S.includes(m.value.getDay());
  }, _ = (m) => (s.value.enabled || t.weekPicker) && (!(n.value.count > 0) || m.current) && X() && !(!m.current && t.hideOffsetDates) && !C(m) ? A(m) : !1, Y = (m) => {
    const { isRangeStart: S, isRangeEnd: pe } = fe(m), M = s.value.enabled ? S || pe : !1;
    return {
      dp__cell_offset: !m.current,
      dp__pointer: !t.disabled && !(!m.current && t.hideOffsetDates) && !u(m.value),
      dp__cell_disabled: u(m.value),
      dp__cell_highlight: !be(m) && (xe(m) || H(m)) && !oe(m) && !M && !$(m) && !(_(m) && t.weekPicker) && !pe,
      dp__cell_highlight_active: !be(m) && (xe(m) || H(m)) && oe(m),
      dp__today: !t.noToday && Ge(m.value, c.value) && m.current,
      "dp--past": Ct(m.value, c.value),
      "dp--future": $t(m.value, c.value)
    };
  }, p = (m) => ({
    dp__active_date: oe(m),
    dp__date_hover: j(m)
  }), U = (m) => {
    if (e.value && !Array.isArray(e.value)) {
      const S = Ka(e.value, t.weekStart);
      return {
        ...D(m),
        dp__range_start: Ge(S[0], m.value),
        dp__range_end: Ge(S[1], m.value),
        dp__range_between_week: $t(m.value, S[0]) && Ct(m.value, S[1])
      };
    }
    return {
      ...D(m)
    };
  }, ie = (m) => {
    if (e.value && Array.isArray(e.value)) {
      const S = Ka(e.value[0], t.weekStart), pe = e.value[1] ? Ka(e.value[1], t.weekStart) : [];
      return {
        ...D(m),
        dp__range_start: Ge(S[0], m.value) || Ge(pe[0], m.value),
        dp__range_end: Ge(S[1], m.value) || Ge(pe[1], m.value),
        dp__range_between_week: $t(m.value, S[0]) && Ct(m.value, S[1]) || $t(m.value, pe[0]) && Ct(m.value, pe[1]),
        dp__range_between: $t(m.value, S[1]) && Ct(m.value, pe[0])
      };
    }
    return {
      ...D(m)
    };
  }, fe = (m) => {
    const S = n.value.count > 0 ? m.current && V(m) && X() : V(m) && X(), pe = n.value.count > 0 ? m.current && V(m, !1) && X() : V(m, !1) && X();
    return { isRangeStart: S, isRangeEnd: pe };
  }, J = (m) => {
    const { isRangeStart: S, isRangeEnd: pe } = fe(m);
    return {
      dp__range_start: S,
      dp__range_end: pe,
      dp__range_between: _(m),
      dp__date_hover: Ge(m.value, d.value) && !S && !pe && !t.weekPicker,
      dp__date_hover_start: G(m, !0),
      dp__date_hover_end: G(m, !1)
    };
  }, D = (m) => ({
    ...J(m),
    dp__cell_auto_range: re(m),
    dp__cell_auto_range_start: $(m),
    dp__cell_auto_range_end: q(m)
  }), Q = (m) => s.value.enabled ? s.value.autoRange ? D(m) : t.modelAuto ? { ...p(m), ...J(m) } : t.weekPicker ? ie(m) : J(m) : t.weekPicker ? U(m) : p(m);
  return {
    setHoverDate: f,
    clearHoverDate: v,
    getDayClassData: (m) => t.hideOffsetDates && !m.current ? {} : {
      ...Y(m),
      ...Q(m),
      [t.dayClass ? t.dayClass(m.value, t.internalModelValue) : ""]: !0,
      [t.calendarCellClassName]: !!t.calendarCellClassName,
      ...i.value.calendarCell ?? {}
    }
  };
}, $i = (e) => {
  const { defaultedFilters: t, defaultedRange: n, propDates: a, defaultedMultiDates: i } = Mt(e), r = (H) => a.value.disabledDates ? typeof a.value.disabledDates == "function" ? a.value.disabledDates(ne(H)) : !!dl(H, a.value.disabledDates) : !1, o = (H) => a.value.maxDate ? e.yearPicker ? We(H) > We(a.value.maxDate) : $t(H, a.value.maxDate) : !1, l = (H) => a.value.minDate ? e.yearPicker ? We(H) < We(a.value.minDate) : Ct(H, a.value.minDate) : !1, s = (H) => {
    const _ = o(H), Y = l(H), p = r(H), U = t.value.months.map((Q) => +Q).includes(Ue(H)), ie = e.disabledWeekDays.length ? e.disabledWeekDays.some((Q) => +Q === pk(H)) : !1, fe = v(H), J = We(H), D = J < +e.yearRange[0] || J > +e.yearRange[1];
    return !(_ || Y || p || U || D || ie || fe);
  }, u = (H, _) => Ct(...Ai(a.value.minDate, H, _)) || Ge(...Ai(a.value.minDate, H, _)), d = (H, _) => $t(...Ai(a.value.maxDate, H, _)) || Ge(...Ai(a.value.maxDate, H, _)), c = (H, _, Y) => {
    let p = !1;
    return a.value.maxDate && Y && d(H, _) && (p = !0), a.value.minDate && !Y && u(H, _) && (p = !0), p;
  }, f = (H, _, Y, p) => {
    let U = !1;
    return p ? a.value.minDate && a.value.maxDate ? U = c(H, _, Y) : (a.value.minDate && u(H, _) || a.value.maxDate && d(H, _)) && (U = !0) : U = !0, U;
  }, v = (H) => Array.isArray(a.value.allowedDates) && !a.value.allowedDates.length ? !0 : a.value.allowedDates ? !dl(H, a.value.allowedDates) : !1, k = (H) => !s(H), b = (H) => n.value.noDisabledRange ? !vp({ start: H[0], end: H[1] }).some((_) => k(_)) : !0, R = (H) => {
    if (H) {
      const _ = We(H);
      return _ >= +e.yearRange[0] && _ <= e.yearRange[1];
    }
    return !0;
  }, V = (H, _) => !!(Array.isArray(H) && H[_] && (n.value.maxRange || n.value.minRange) && R(H[_])), G = (H, _, Y = 0) => {
    if (V(_, Y) && R(H)) {
      const p = mp(H, _[Y]), U = Lp(_[Y], H), ie = U.length === 1 ? 0 : U.filter((J) => k(J)).length, fe = Math.abs(p) - (n.value.minMaxRawRange ? 0 : ie);
      if (n.value.minRange && n.value.maxRange)
        return fe >= +n.value.minRange && fe <= +n.value.maxRange;
      if (n.value.minRange)
        return fe >= +n.value.minRange;
      if (n.value.maxRange)
        return fe <= +n.value.maxRange;
    }
    return !0;
  }, C = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, q = (H) => Array.isArray(H) ? [H[0] ? Iu(H[0]) : null, H[1] ? Iu(H[1]) : null] : Iu(H), re = (H, _, Y) => H.find(
    (p) => +p.hours === di(_) && p.minutes === "*" ? !0 : +p.minutes === Ii(_) && +p.hours === di(_)
  ) && Y, $ = (H, _, Y) => {
    const [p, U] = H, [ie, fe] = _;
    return !re(p, ie, Y) && !re(U, fe, Y) && Y;
  }, A = (H, _) => {
    const Y = Array.isArray(_) ? _ : [_];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? $(e.disabledTimes, Y, H) : !Y.some((p) => re(e.disabledTimes, p, H)) : H;
  }, I = (H, _) => {
    const Y = Array.isArray(_) ? [nr(_[0]), _[1] ? nr(_[1]) : void 0] : nr(_), p = !e.disabledTimes(Y);
    return H && p;
  }, X = (H, _) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? A(_, H) : I(_, H) : _, j = (H) => {
    let _ = !0;
    if (!H || C())
      return !0;
    const Y = !a.value.minDate && !a.value.maxDate ? q(H) : H;
    return (e.maxTime || a.value.maxDate) && (_ = wf(
      e.maxTime,
      a.value.maxDate,
      "max",
      Jt(Y),
      _
    )), (e.minTime || a.value.minDate) && (_ = wf(
      e.minTime,
      a.value.minDate,
      "min",
      Jt(Y),
      _
    )), X(H, _);
  }, oe = (H) => {
    if (!e.monthPicker)
      return !0;
    let _ = !0;
    const Y = ne(wa(H));
    if (a.value.minDate && a.value.maxDate) {
      const p = ne(wa(a.value.minDate)), U = ne(wa(a.value.maxDate));
      return $t(Y, p) && Ct(Y, U) || Ge(Y, p) || Ge(Y, U);
    }
    if (a.value.minDate) {
      const p = ne(wa(a.value.minDate));
      _ = $t(Y, p) || Ge(Y, p);
    }
    if (a.value.maxDate) {
      const p = ne(wa(a.value.maxDate));
      _ = Ct(Y, p) || Ge(Y, p);
    }
    return _;
  }, xe = ae(() => (H) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : j(H)), be = ae(() => (H) => e.monthPicker ? Array.isArray(H) && (n.value.enabled || i.value.enabled) ? !H.filter((_) => !oe(_)).length : oe(H) : !0);
  return {
    isDisabled: k,
    validateDate: s,
    validateMonthYearInRange: f,
    isDateRangeAllowed: b,
    checkMinMaxRange: G,
    isValidTime: j,
    isTimeValid: xe,
    isMonthValid: be
  };
}, Ll = () => {
  const e = ae(() => (a, i) => a == null ? void 0 : a.includes(i)), t = ae(() => (a, i) => a.count ? a.solo ? !0 : i === 0 : !0), n = ae(() => (a, i) => a.count ? a.solo ? !0 : i === a.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: n };
}, hD = (e, t, n) => {
  const a = he(0), i = Go({
    [tr.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [tr.calendar]: !1,
    [tr.header]: !1
  }), r = ae(() => e.monthPicker || e.timePicker), o = (c) => {
    var f;
    if ((f = e.flow) != null && f.length) {
      if (!c && r.value)
        return d();
      i[c] = !0, Object.keys(i).filter((v) => !i[v]).length || d();
    }
  }, l = () => {
    var c, f;
    (c = e.flow) != null && c.length && a.value !== -1 && (a.value += 1, t("flow-step", a.value), d()), ((f = e.flow) == null ? void 0 : f.length) === a.value && Un().then(() => s());
  }, s = () => {
    a.value = -1;
  }, u = (c, f, ...v) => {
    var k, b;
    e.flow[a.value] === c && n.value && ((b = (k = n.value)[f]) == null || b.call(k, ...v));
  }, d = (c = 0) => {
    c && (a.value += c), u(vn.month, "toggleMonthPicker", !0), u(vn.year, "toggleYearPicker", !0), u(vn.calendar, "toggleTimePicker", !1, !0), u(vn.time, "toggleTimePicker", !0, !0);
    const f = e.flow[a.value];
    (f === vn.hours || f === vn.minutes || f === vn.seconds) && u(f, "toggleTimePicker", !0, !0, f);
  };
  return { childMount: o, updateFlowStep: l, resetFlow: s, handleFlow: d, flowStep: a };
}, fD = {
  key: 1,
  class: "dp__input_wrap"
}, mD = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], pD = {
  key: 2,
  class: "dp__clear_icon"
}, vD = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Yl
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, {
      defaultedTextInput: r,
      defaultedAriaLabels: o,
      defaultedInline: l,
      defaultedConfig: s,
      defaultedRange: u,
      defaultedMultiDates: d,
      defaultedUI: c,
      getDefaultPattern: f,
      getDefaultStartTime: v
    } = Mt(i), { checkMinMaxRange: k } = $i(i), b = he(), R = he(null), V = he(!1), G = he(!1), C = ae(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !r.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !r.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !i.hideInputIcon,
        dp__input_valid: !!i.state,
        dp__input_invalid: i.state === !1,
        dp__input_focus: V.value || i.isMenuOpen,
        dp__input_reg: !r.value.enabled,
        [i.inputClassName]: !!i.inputClassName,
        ...c.value.input ?? {}
      })
    ), q = () => {
      a("set-input-date", null), i.clearable && i.autoApply && (a("set-empty-date"), b.value = null);
    }, re = (p) => {
      const U = v();
      return Ox(
        p,
        r.value.format ?? f(),
        U ?? Fp({}, i.enableSeconds),
        i.inputValue,
        G.value,
        i.formatLocale
      );
    }, $ = (p) => {
      const { rangeSeparator: U } = r.value, [ie, fe] = p.split(`${U}`);
      if (ie) {
        const J = re(ie.trim()), D = fe ? re(fe.trim()) : null;
        if (Fr(J, D))
          return;
        const Q = J && D ? [J, D] : [J];
        k(D, Q, 0) && (b.value = J ? Q : null);
      }
    }, A = () => {
      G.value = !0;
    }, I = (p) => {
      if (u.value.enabled)
        $(p);
      else if (d.value.enabled) {
        const U = p.split(";");
        b.value = U.map((ie) => re(ie.trim())).filter((ie) => ie);
      } else
        b.value = re(p);
    }, X = (p) => {
      var U;
      const ie = typeof p == "string" ? p : (U = p.target) == null ? void 0 : U.value;
      ie !== "" ? (r.value.openMenu && !i.isMenuOpen && a("open"), I(ie), a("set-input-date", b.value)) : q(), G.value = !1, a("update:input-value", ie);
    }, j = (p) => {
      r.value.enabled ? (I(p.target.value), r.value.enterSubmit && _d(b.value) && i.inputValue !== "" ? (a("set-input-date", b.value, !0), b.value = null) : r.value.enterSubmit && i.inputValue === "" && (b.value = null, a("clear"))) : be(p);
    }, oe = (p) => {
      r.value.enabled && r.value.tabSubmit && I(p.target.value), r.value.tabSubmit && _d(b.value) && i.inputValue !== "" ? (a("set-input-date", b.value, !0, !0), b.value = null) : r.value.tabSubmit && i.inputValue === "" && (b.value = null, a("clear", !0));
    }, xe = () => {
      V.value = !0, a("focus"), Un().then(() => {
        var p;
        r.value.enabled && r.value.selectOnFocus && ((p = R.value) == null || p.select());
      });
    }, be = (p) => {
      p.preventDefault(), Ei(p, s.value, !0), r.value.enabled && r.value.openMenu && !l.value.input && !i.isMenuOpen ? a("open") : r.value.enabled || a("toggle");
    }, H = () => {
      a("real-blur"), V.value = !1, (!i.isMenuOpen || l.value.enabled && l.value.input) && a("blur"), i.autoApply && r.value.enabled && b.value && !i.isMenuOpen && (a("set-input-date", b.value), a("select-date"), b.value = null);
    }, _ = (p) => {
      Ei(p, s.value, !0), a("clear");
    }, Y = (p) => {
      if (p.key === "Tab" && oe(p), p.key === "Enter" && j(p), !r.value.enabled) {
        if (p.code === "Tab")
          return;
        p.preventDefault();
      }
    };
    return t({
      focusInput: () => {
        var p;
        (p = R.value) == null || p.focus({ preventScroll: !0 });
      },
      setParsedDate: (p) => {
        b.value = p;
      }
    }), (p, U) => {
      var ie;
      return y(), O("div", { onClick: be }, [
        p.$slots.trigger && !p.$slots["dp-input"] && !x(l).enabled ? me(p.$slots, "trigger", { key: 0 }) : F("", !0),
        !p.$slots.trigger && (!x(l).enabled || x(l).input) ? (y(), O("div", fD, [
          p.$slots["dp-input"] && !p.$slots.trigger && (!x(l).enabled || x(l).enabled && x(l).input) ? me(p.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: X,
            onEnter: j,
            onTab: oe,
            onClear: _,
            onBlur: H,
            onKeypress: Y,
            onPaste: A,
            onFocus: xe,
            openMenu: () => p.$emit("open"),
            closeMenu: () => p.$emit("close"),
            toggleMenu: () => p.$emit("toggle")
          }) : F("", !0),
          p.$slots["dp-input"] ? F("", !0) : (y(), O("input", {
            key: 1,
            id: p.uid ? `dp-input-${p.uid}` : void 0,
            ref_key: "inputRef",
            ref: R,
            "data-test": "dp-input",
            name: p.name,
            class: Ne(C.value),
            inputmode: x(r).enabled ? "text" : "none",
            placeholder: p.placeholder,
            disabled: p.disabled,
            readonly: p.readonly,
            required: p.required,
            value: e.inputValue,
            autocomplete: p.autocomplete,
            "aria-label": (ie = x(o)) == null ? void 0 : ie.input,
            "aria-disabled": p.disabled || void 0,
            "aria-invalid": p.state === !1 ? !0 : void 0,
            onInput: X,
            onBlur: H,
            onFocus: xe,
            onKeypress: Y,
            onKeydown: Y,
            onPaste: A
          }, null, 42, mD)),
          ee("div", {
            onClick: U[2] || (U[2] = (fe) => a("toggle"))
          }, [
            p.$slots["input-icon"] && !p.hideInputIcon ? (y(), O("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: U[0] || (U[0] = (fe) => a("toggle"))
            }, [
              me(p.$slots, "input-icon")
            ])) : F("", !0),
            !p.$slots["input-icon"] && !p.hideInputIcon && !p.$slots["dp-input"] ? (y(), le(x(Zr), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: U[1] || (U[1] = (fe) => a("toggle"))
            })) : F("", !0)
          ]),
          p.$slots["clear-icon"] && e.inputValue && p.clearable && !p.disabled && !p.readonly ? (y(), O("span", pD, [
            me(p.$slots, "clear-icon", { clear: _ })
          ])) : F("", !0),
          p.clearable && !p.$slots["clear-icon"] && e.inputValue && !p.disabled && !p.readonly ? (y(), le(x(Ep), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: U[3] || (U[3] = ii((fe) => _(fe), ["prevent"]))
          })) : F("", !0)
        ])) : F("", !0)
      ]);
    };
  }
}), gD = typeof window < "u" ? window : void 0, zu = () => {
}, yD = (e) => Jv() ? (eg(e), !0) : !1, wD = (e, t, n, a) => {
  if (!e)
    return zu;
  let i = zu;
  const r = ra(
    () => x(e),
    (l) => {
      i(), l && (l.addEventListener(t, n, a), i = () => {
        l.removeEventListener(t, n, a), i = zu;
      });
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    r(), i();
  };
  return yD(o), o;
}, bD = (e, t, n, a = {}) => {
  const { window: i = gD, event: r = "pointerdown" } = a;
  return i ? wD(i, r, (o) => {
    const l = Zt(e), s = Zt(t);
    !l || !s || l === o.target || o.composedPath().includes(l) || o.composedPath().includes(s) || n(o);
  }, { passive: !0 }) : void 0;
}, _D = /* @__PURE__ */ nn({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Yl
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, i = e, r = Yi(), o = he(!1), l = Lo(i, "modelValue"), s = Lo(i, "timezone"), u = he(null), d = he(null), c = he(null), f = he(!1), v = he(null), k = he(!1), b = he(!1), R = he(!1), V = he(!1), { setMenuFocused: G, setShiftKey: C } = Vp(), { clearArrowNav: q } = Ni(), { validateDate: re, isValidTime: $ } = $i(i), {
      defaultedTransitions: A,
      defaultedTextInput: I,
      defaultedInline: X,
      defaultedConfig: j,
      defaultedRange: oe,
      defaultedMultiDates: xe
    } = Mt(i), { menuTransition: be, showTransition: H } = Jo(A);
    wn(() => {
      S(i.modelValue), Un().then(() => {
        if (!X.value.enabled) {
          const P = J(v.value);
          P == null || P.addEventListener("scroll", B), window == null || window.addEventListener("resize", Z);
        }
      }), X.value.enabled && (o.value = !0), window == null || window.addEventListener("keyup", je), window == null || window.addEventListener("keydown", N);
    }), vl(() => {
      if (!X.value.enabled) {
        const P = J(v.value);
        P == null || P.removeEventListener("scroll", B), window == null || window.removeEventListener("resize", Z);
      }
      window == null || window.removeEventListener("keyup", je), window == null || window.removeEventListener("keydown", N);
    });
    const _ = Vn(r, "all", i.presetDates), Y = Vn(r, "input");
    ra(
      [l, s],
      () => {
        S(l.value);
      },
      { deep: !0 }
    );
    const { openOnTop: p, menuStyle: U, xCorrect: ie, setMenuPosition: fe, getScrollableParent: J, shadowRender: D } = lD({
      menuRef: u,
      menuRefInner: d,
      inputRef: c,
      pickerWrapperRef: v,
      inline: X,
      emit: a,
      props: i,
      slots: r
    }), {
      inputValue: Q,
      internalModelValue: m,
      parseExternalModelValue: S,
      emitModelValue: pe,
      formatInputValue: M,
      checkBeforeEmit: ye
    } = Jx(a, i, f), ce = ae(
      () => ({
        dp__main: !0,
        dp__theme_dark: i.dark,
        dp__theme_light: !i.dark,
        dp__flex_display: X.value.enabled,
        "dp--flex-display-collapsed": R.value,
        dp__flex_display_with_input: X.value.input
      })
    ), T = ae(() => i.dark ? "dp__theme_dark" : "dp__theme_light"), Me = ae(() => i.teleport ? {
      to: typeof i.teleport == "boolean" ? "body" : i.teleport,
      disabled: !i.teleport || X.value.enabled
    } : {}), g = ae(() => ({ class: "dp__outer_menu_wrap" })), W = ae(() => X.value.enabled && (i.timePicker || i.monthPicker || i.yearPicker || i.quarterPicker)), K = () => {
      var P, de;
      return (de = (P = c.value) == null ? void 0 : P.$el) == null ? void 0 : de.getBoundingClientRect();
    }, B = () => {
      o.value && (j.value.closeOnScroll ? Dt() : fe());
    }, Z = () => {
      var P;
      o.value && fe();
      const de = (P = d.value) == null ? void 0 : P.$el.getBoundingClientRect().width;
      R.value = document.body.offsetWidth <= de;
    }, je = (P) => {
      P.key === "Tab" && !X.value.enabled && !i.teleport && j.value.tabOutClosesMenu && (v.value.contains(document.activeElement) || Dt()), b.value = P.shiftKey;
    }, N = (P) => {
      b.value = P.shiftKey;
    }, se = () => {
      !i.disabled && !i.readonly && (D(xf, i), fe(!1), o.value = !0, o.value && a("open"), o.value || Mn(), S(i.modelValue));
    }, Ee = () => {
      var P;
      Q.value = "", Mn(), (P = c.value) == null || P.setParsedDate(null), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), j.value.closeOnClearValue && Dt();
    }, $e = () => {
      const P = m.value;
      return !P || !Array.isArray(P) && re(P) ? !0 : Array.isArray(P) ? xe.value.enabled || P.length === 2 && re(P[0]) && re(P[1]) ? !0 : oe.value.partialRange && !i.timePicker ? re(P[0]) : !1 : !1;
    }, lt = () => {
      ye() && $e() ? (pe(), Dt()) : a("invalid-select", m.value);
    }, Oe = (P) => {
      rn(), pe(), j.value.closeOnAutoApply && !P && Dt();
    }, rn = () => {
      c.value && I.value.enabled && c.value.setParsedDate(m.value);
    }, Rt = (P = !1) => {
      i.autoApply && $(m.value) && $e() && (oe.value.enabled && Array.isArray(m.value) ? (oe.value.partialRange || m.value.length === 2) && Oe(P) : Oe(P));
    }, Mn = () => {
      I.value.enabled || (m.value = null);
    }, Dt = () => {
      X.value.enabled || (o.value && (o.value = !1, ie.value = !1, G(!1), C(!1), q(), a("closed"), Q.value && S(l.value)), Mn(), a("blur"));
    }, St = (P, de, we = !1) => {
      if (!P) {
        m.value = null;
        return;
      }
      const Ut = Array.isArray(P) ? !P.some((cn) => !re(cn)) : re(P), Wt = $(P);
      Ut && Wt && (V.value = !0, m.value = P, de && (k.value = we, lt(), a("text-submit")), Un().then(() => {
        V.value = !1;
      }));
    }, Li = () => {
      i.autoApply && $(m.value) && pe(), rn();
    }, In = () => o.value ? Dt() : se(), qn = (P) => {
      m.value = P;
    }, Xn = () => {
      I.value.enabled && (f.value = !0, M()), a("focus");
    }, Qe = () => {
      if (I.value.enabled && (f.value = !1, S(i.modelValue), k.value)) {
        const P = Sx(v.value, b.value);
        P == null || P.focus();
      }
      a("blur");
    }, ja = (P) => {
      d.value && d.value.updateMonthYear(0, {
        month: vf(P.month),
        year: vf(P.year)
      });
    }, Qr = (P) => {
      S(P ?? i.modelValue);
    }, gt = (P, de) => {
      var we;
      (we = d.value) == null || we.switchView(P, de);
    }, E = (P) => j.value.onClickOutside ? j.value.onClickOutside(P) : Dt(), te = (P = 0) => {
      var de;
      (de = d.value) == null || de.handleFlow(P);
    };
    return bD(u, c, () => E($e)), t({
      closeMenu: Dt,
      selectDate: lt,
      clearValue: Ee,
      openMenu: se,
      onScroll: B,
      formatInputValue: M,
      // exposed for testing purposes
      updateInternalModelValue: qn,
      // modify internal modelValue
      setMonthYear: ja,
      parseModel: Qr,
      switchView: gt,
      toggleMenu: In,
      handleFlow: te
    }), (P, de) => (y(), O("div", {
      ref_key: "pickerWrapperRef",
      ref: v,
      class: Ne(ce.value),
      "data-datepicker-instance": ""
    }, [
      Pe(vD, Ft({
        ref_key: "inputRef",
        ref: c,
        "input-value": x(Q),
        "onUpdate:inputValue": de[0] || (de[0] = (we) => Sh(Q) ? Q.value = we : null),
        "is-menu-open": o.value
      }, P.$props, {
        onClear: Ee,
        onOpen: se,
        onSetInputDate: St,
        onSetEmptyDate: x(pe),
        onSelectDate: lt,
        onToggle: In,
        onClose: Dt,
        onFocus: Xn,
        onBlur: Qe,
        onRealBlur: de[1] || (de[1] = (we) => f.value = !1)
      }), gn({ _: 2 }, [
        Xe(x(Y), (we, Ut) => ({
          name: we,
          fn: De((Wt) => [
            me(P.$slots, we, tn(Cn(Wt)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (y(), le(li(P.teleport ? zf : "div"), tn(Cn(Me.value)), {
        default: De(() => [
          Pe(Ri, {
            name: x(be)(x(p)),
            css: x(H) && !x(X).enabled
          }, {
            default: De(() => [
              o.value ? (y(), O("div", Ft({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: u
              }, g.value, {
                class: { "dp--menu-wrapper": !x(X).enabled },
                style: x(X).enabled ? void 0 : x(U)
              }), [
                Pe(xf, Ft({
                  ref_key: "dpMenuRef",
                  ref: d
                }, P.$props, {
                  "internal-model-value": x(m),
                  "onUpdate:internalModelValue": de[2] || (de[2] = (we) => Sh(m) ? m.value = we : null),
                  class: { [T.value]: !0, "dp--menu-wrapper": P.teleport },
                  "open-on-top": x(p),
                  "no-overlay-focus": W.value,
                  collapse: R.value,
                  "get-input-rect": K,
                  "is-text-input-date": V.value,
                  onClosePicker: Dt,
                  onSelectDate: lt,
                  onAutoApply: Rt,
                  onTimeUpdate: Li,
                  onFlowStep: de[3] || (de[3] = (we) => P.$emit("flow-step", we)),
                  onUpdateMonthYear: de[4] || (de[4] = (we) => P.$emit("update-month-year", we)),
                  onInvalidSelect: de[5] || (de[5] = (we) => P.$emit("invalid-select", x(m))),
                  onAutoApplyInvalid: de[6] || (de[6] = (we) => P.$emit("invalid-select", we)),
                  onInvalidFixedRange: de[7] || (de[7] = (we) => P.$emit("invalid-fixed-range", we)),
                  onRecalculatePosition: x(fe),
                  onTooltipOpen: de[8] || (de[8] = (we) => P.$emit("tooltip-open", we)),
                  onTooltipClose: de[9] || (de[9] = (we) => P.$emit("tooltip-close", we)),
                  onTimePickerOpen: de[10] || (de[10] = (we) => P.$emit("time-picker-open", we)),
                  onTimePickerClose: de[11] || (de[11] = (we) => P.$emit("time-picker-close", we)),
                  onAmPmChange: de[12] || (de[12] = (we) => P.$emit("am-pm-change", we)),
                  onRangeStart: de[13] || (de[13] = (we) => P.$emit("range-start", we)),
                  onRangeEnd: de[14] || (de[14] = (we) => P.$emit("range-end", we)),
                  onDateUpdate: de[15] || (de[15] = (we) => P.$emit("date-update", we)),
                  onInvalidDate: de[16] || (de[16] = (we) => P.$emit("invalid-date", we)),
                  onOverlayToggle: de[17] || (de[17] = (we) => P.$emit("overlay-toggle", we))
                }), gn({ _: 2 }, [
                  Xe(x(_), (we, Ut) => ({
                    name: we,
                    fn: De((Wt) => [
                      me(P.$slots, we, tn(Cn({ ...Wt })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : F("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 2));
  }
}), Qp = /* @__PURE__ */ (() => {
  const e = _D;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), kD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qp
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(kD).forEach(([e, t]) => {
  e !== "default" && (Qp[e] = t);
});
/*!
  * vue-draggable-next v2.2.0
  * (c) 2023 Anish George
  * @license MIT
  */
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Mf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function Wa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mf(Object(n), !0).forEach(function(a) {
      xD(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mf(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function Xs(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xs = function(t) {
    return typeof t;
  } : Xs = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xs(e);
}
function xD(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ci() {
  return ci = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, ci.apply(this, arguments);
}
function MD(e, t) {
  if (e == null)
    return {};
  var n = {}, a = Object.keys(e), i, r;
  for (r = 0; r < a.length; r++)
    i = a[r], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function DD(e, t) {
  if (e == null)
    return {};
  var n = MD(e, t), a, i;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    for (i = 0; i < r.length; i++)
      a = r[i], !(t.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
  }
  return n;
}
var SD = "1.14.0";
function si(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var mi = si(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), ts = si(/Edge/i), Df = si(/firefox/i), Po = si(/safari/i) && !si(/chrome/i) && !si(/android/i), Kp = si(/iP(ad|od|hone)/i), TD = si(/chrome/i) && si(/android/i), Jp = {
  capture: !1,
  passive: !1
};
function rt(e, t, n) {
  e.addEventListener(t, n, !mi && Jp);
}
function Je(e, t, n) {
  e.removeEventListener(t, n, !mi && Jp);
}
function cl(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function AD(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function Ca(e, t, n, a) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && cl(e, t) : cl(e, t)) || a && e === n)
        return e;
      if (e === n)
        break;
    } while (e = AD(e));
  }
  return null;
}
var Sf = /\s+/g;
function Hn(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var a = (" " + e.className + " ").replace(Sf, " ").replace(" " + t + " ", " ");
      e.className = (a + (n ? " " + t : "")).replace(Sf, " ");
    }
}
function ze(e, t, n) {
  var a = e && e.style;
  if (a) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in a) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), a[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function Cr(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var a = ze(e, "transform");
      a && a !== "none" && (n = a + " " + n);
    } while (!t && (e = e.parentNode));
  var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return i && new i(n);
}
function ev(e, t, n) {
  if (e) {
    var a = e.getElementsByTagName(t), i = 0, r = a.length;
    if (n)
      for (; i < r; i++)
        n(a[i], i);
    return a;
  }
  return [];
}
function Fa() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function Xt(e, t, n, a, i) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var r, o, l, s, u, d, c;
    if (e !== window && e.parentNode && e !== Fa() ? (r = e.getBoundingClientRect(), o = r.top, l = r.left, s = r.bottom, u = r.right, d = r.height, c = r.width) : (o = 0, l = 0, s = window.innerHeight, u = window.innerWidth, d = window.innerHeight, c = window.innerWidth), (t || n) && e !== window && (i = i || e.parentNode, !mi))
      do
        if (i && i.getBoundingClientRect && (ze(i, "transform") !== "none" || n && ze(i, "position") !== "static")) {
          var f = i.getBoundingClientRect();
          o -= f.top + parseInt(ze(i, "border-top-width")), l -= f.left + parseInt(ze(i, "border-left-width")), s = o + r.height, u = l + r.width;
          break;
        }
      while (i = i.parentNode);
    if (a && e !== window) {
      var v = Cr(i || e), k = v && v.a, b = v && v.d;
      v && (o /= b, l /= k, c /= k, d /= b, s = o + d, u = l + c);
    }
    return {
      top: o,
      left: l,
      bottom: s,
      right: u,
      width: c,
      height: d
    };
  }
}
function Tf(e, t, n) {
  for (var a = Oi(e, !0), i = Xt(e)[t]; a; ) {
    var r = Xt(a)[n], o = void 0;
    if (n === "top" || n === "left" ? o = i >= r : o = i <= r, !o)
      return a;
    if (a === Fa())
      break;
    a = Oi(a, !1);
  }
  return !1;
}
function Br(e, t, n, a) {
  for (var i = 0, r = 0, o = e.children; r < o.length; ) {
    if (o[r].style.display !== "none" && o[r] !== He.ghost && (a || o[r] !== He.dragged) && Ca(o[r], n.draggable, e, !1)) {
      if (i === t)
        return o[r];
      i++;
    }
    r++;
  }
  return null;
}
function Sc(e, t) {
  for (var n = e.lastElementChild; n && (n === He.ghost || ze(n, "display") === "none" || t && !cl(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function ta(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== He.clone && (!t || cl(e, t)) && n++;
  return n;
}
function Af(e) {
  var t = 0, n = 0, a = Fa();
  if (e)
    do {
      var i = Cr(e), r = i.a, o = i.d;
      t += e.scrollLeft * r, n += e.scrollTop * o;
    } while (e !== a && (e = e.parentNode));
  return [t, n];
}
function OD(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      for (var a in t)
        if (t.hasOwnProperty(a) && t[a] === e[n][a])
          return Number(n);
    }
  return -1;
}
function Oi(e, t) {
  if (!e || !e.getBoundingClientRect)
    return Fa();
  var n = e, a = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var i = ze(n);
      if (n.clientWidth < n.scrollWidth && (i.overflowX == "auto" || i.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (i.overflowY == "auto" || i.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body)
          return Fa();
        if (a || t)
          return n;
        a = !0;
      }
    }
  while (n = n.parentNode);
  return Fa();
}
function CD(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function Hu(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var Ro;
function tv(e, t) {
  return function() {
    if (!Ro) {
      var n = arguments, a = this;
      n.length === 1 ? e.call(a, n[0]) : e.apply(a, n), Ro = setTimeout(function() {
        Ro = void 0;
      }, t);
    }
  };
}
function ED() {
  clearTimeout(Ro), Ro = void 0;
}
function nv(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function av(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
var Bn = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function PD() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var a = [].slice.call(this.el.children);
        a.forEach(function(i) {
          if (!(ze(i, "display") === "none" || i === He.ghost)) {
            e.push({
              target: i,
              rect: Xt(i)
            });
            var r = Wa({}, e[e.length - 1].rect);
            if (i.thisAnimationDuration) {
              var o = Cr(i, !0);
              o && (r.top -= o.f, r.left -= o.e);
            }
            i.fromRect = r;
          }
        });
      }
    },
    addAnimationState: function(a) {
      e.push(a);
    },
    removeAnimationState: function(a) {
      e.splice(OD(e, {
        target: a
      }), 1);
    },
    animateAll: function(a) {
      var i = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof a == "function" && a();
        return;
      }
      var r = !1, o = 0;
      e.forEach(function(l) {
        var s = 0, u = l.target, d = u.fromRect, c = Xt(u), f = u.prevFromRect, v = u.prevToRect, k = l.rect, b = Cr(u, !0);
        b && (c.top -= b.f, c.left -= b.e), u.toRect = c, u.thisAnimationDuration && Hu(f, c) && !Hu(d, c) && // Make sure animatingRect is on line between toRect & fromRect
        (k.top - c.top) / (k.left - c.left) === (d.top - c.top) / (d.left - c.left) && (s = ID(k, f, v, i.options)), Hu(c, d) || (u.prevFromRect = d, u.prevToRect = c, s || (s = i.options.animation), i.animate(u, k, c, s)), s && (r = !0, o = Math.max(o, s), clearTimeout(u.animationResetTimer), u.animationResetTimer = setTimeout(function() {
          u.animationTime = 0, u.prevFromRect = null, u.fromRect = null, u.prevToRect = null, u.thisAnimationDuration = null;
        }, s), u.thisAnimationDuration = s);
      }), clearTimeout(t), r ? t = setTimeout(function() {
        typeof a == "function" && a();
      }, o) : typeof a == "function" && a(), e = [];
    },
    animate: function(a, i, r, o) {
      if (o) {
        ze(a, "transition", ""), ze(a, "transform", "");
        var l = Cr(this.el), s = l && l.a, u = l && l.d, d = (i.left - r.left) / (s || 1), c = (i.top - r.top) / (u || 1);
        a.animatingX = !!d, a.animatingY = !!c, ze(a, "transform", "translate3d(" + d + "px," + c + "px,0)"), this.forRepaintDummy = RD(a), ze(a, "transition", "transform " + o + "ms" + (this.options.easing ? " " + this.options.easing : "")), ze(a, "transform", "translate3d(0,0,0)"), typeof a.animated == "number" && clearTimeout(a.animated), a.animated = setTimeout(function() {
          ze(a, "transition", ""), ze(a, "transform", ""), a.animated = !1, a.animatingX = !1, a.animatingY = !1;
        }, o);
      }
    }
  };
}
function RD(e) {
  return e.offsetWidth;
}
function ID(e, t, n, a) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * a.animation;
}
var yr = [], Wu = {
  initializeByDefault: !0
}, ns = {
  mount: function(t) {
    for (var n in Wu)
      Wu.hasOwnProperty(n) && !(n in t) && (t[n] = Wu[n]);
    yr.forEach(function(a) {
      if (a.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), yr.push(t);
  },
  pluginEvent: function(t, n, a) {
    var i = this;
    this.eventCanceled = !1, a.cancel = function() {
      i.eventCanceled = !0;
    };
    var r = t + "Global";
    yr.forEach(function(o) {
      n[o.pluginName] && (n[o.pluginName][r] && n[o.pluginName][r](Wa({
        sortable: n
      }, a)), n.options[o.pluginName] && n[o.pluginName][t] && n[o.pluginName][t](Wa({
        sortable: n
      }, a)));
    });
  },
  initializePlugins: function(t, n, a, i) {
    yr.forEach(function(l) {
      var s = l.pluginName;
      if (!(!t.options[s] && !l.initializeByDefault)) {
        var u = new l(t, n, t.options);
        u.sortable = t, u.options = t.options, t[s] = u, ci(a, u.defaults);
      }
    });
    for (var r in t.options)
      if (t.options.hasOwnProperty(r)) {
        var o = this.modifyOption(t, r, t.options[r]);
        typeof o < "u" && (t.options[r] = o);
      }
  },
  getEventProperties: function(t, n) {
    var a = {};
    return yr.forEach(function(i) {
      typeof i.eventProperties == "function" && ci(a, i.eventProperties.call(n[i.pluginName], t));
    }), a;
  },
  modifyOption: function(t, n, a) {
    var i;
    return yr.forEach(function(r) {
      t[r.pluginName] && r.optionListeners && typeof r.optionListeners[n] == "function" && (i = r.optionListeners[n].call(t[r.pluginName], a));
    }), i;
  }
};
function YD(e) {
  var t = e.sortable, n = e.rootEl, a = e.name, i = e.targetEl, r = e.cloneEl, o = e.toEl, l = e.fromEl, s = e.oldIndex, u = e.newIndex, d = e.oldDraggableIndex, c = e.newDraggableIndex, f = e.originalEvent, v = e.putSortable, k = e.extraEventProperties;
  if (t = t || n && n[Bn], !!t) {
    var b, R = t.options, V = "on" + a.charAt(0).toUpperCase() + a.substr(1);
    window.CustomEvent && !mi && !ts ? b = new CustomEvent(a, {
      bubbles: !0,
      cancelable: !0
    }) : (b = document.createEvent("Event"), b.initEvent(a, !0, !0)), b.to = o || n, b.from = l || n, b.item = i || n, b.clone = r, b.oldIndex = s, b.newIndex = u, b.oldDraggableIndex = d, b.newDraggableIndex = c, b.originalEvent = f, b.pullMode = v ? v.lastPutMode : void 0;
    var G = Wa(Wa({}, k), ns.getEventProperties(a, t));
    for (var C in G)
      b[C] = G[C];
    n && n.dispatchEvent(b), R[V] && R[V].call(t, b);
  }
}
var ND = ["evt"], Tn = function(t, n) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = a.evt, r = DD(a, ND);
  ns.pluginEvent.bind(He)(t, n, Wa({
    dragEl: ge,
    parentEl: At,
    ghostEl: Be,
    rootEl: wt,
    nextEl: Qi,
    lastDownEl: Zs,
    cloneEl: Ot,
    cloneHidden: Di,
    dragStarted: Mo,
    putSortable: ln,
    activeSortable: He.active,
    originalEvent: i,
    oldIndex: Dr,
    oldDraggableIndex: Io,
    newIndex: Wn,
    newDraggableIndex: xi,
    hideGhostForTarget: sv,
    unhideGhostForTarget: lv,
    cloneNowHidden: function() {
      Di = !0;
    },
    cloneNowShown: function() {
      Di = !1;
    },
    dispatchSortableEvent: function(l) {
      _n({
        sortable: n,
        name: l,
        originalEvent: i
      });
    }
  }, r));
};
function _n(e) {
  YD(Wa({
    putSortable: ln,
    cloneEl: Ot,
    targetEl: ge,
    rootEl: wt,
    oldIndex: Dr,
    oldDraggableIndex: Io,
    newIndex: Wn,
    newDraggableIndex: xi
  }, e));
}
var ge, At, Be, wt, Qi, Zs, Ot, Di, Dr, Wn, Io, xi, Fs, ln, kr = !1, hl = !1, fl = [], Gi, ma, Bu, Vu, Of, Cf, Mo, wr, Yo, No = !1, zs = !1, Qs, pn, ju = [], kd = !1, ml = [], Fl = typeof document < "u", Hs = Kp, Ef = ts || mi ? "cssFloat" : "float", $D = Fl && !TD && !Kp && "draggable" in document.createElement("div"), iv = function() {
  if (Fl) {
    if (mi)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), rv = function(t, n) {
  var a = ze(t), i = parseInt(a.width) - parseInt(a.paddingLeft) - parseInt(a.paddingRight) - parseInt(a.borderLeftWidth) - parseInt(a.borderRightWidth), r = Br(t, 0, n), o = Br(t, 1, n), l = r && ze(r), s = o && ze(o), u = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + Xt(r).width, d = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + Xt(o).width;
  if (a.display === "flex")
    return a.flexDirection === "column" || a.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (a.display === "grid")
    return a.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (r && l.float && l.float !== "none") {
    var c = l.float === "left" ? "left" : "right";
    return o && (s.clear === "both" || s.clear === c) ? "vertical" : "horizontal";
  }
  return r && (l.display === "block" || l.display === "flex" || l.display === "table" || l.display === "grid" || u >= i && a[Ef] === "none" || o && a[Ef] === "none" && u + d > i) ? "vertical" : "horizontal";
}, LD = function(t, n, a) {
  var i = a ? t.left : t.top, r = a ? t.right : t.bottom, o = a ? t.width : t.height, l = a ? n.left : n.top, s = a ? n.right : n.bottom, u = a ? n.width : n.height;
  return i === l || r === s || i + o / 2 === l + u / 2;
}, FD = function(t, n) {
  var a;
  return fl.some(function(i) {
    var r = i[Bn].options.emptyInsertThreshold;
    if (!(!r || Sc(i))) {
      var o = Xt(i), l = t >= o.left - r && t <= o.right + r, s = n >= o.top - r && n <= o.bottom + r;
      if (l && s)
        return a = i;
    }
  }), a;
}, ov = function(t) {
  function n(r, o) {
    return function(l, s, u, d) {
      var c = l.options.group.name && s.options.group.name && l.options.group.name === s.options.group.name;
      if (r == null && (o || c))
        return !0;
      if (r == null || r === !1)
        return !1;
      if (o && r === "clone")
        return r;
      if (typeof r == "function")
        return n(r(l, s, u, d), o)(l, s, u, d);
      var f = (o ? l : s).options.group.name;
      return r === !0 || typeof r == "string" && r === f || r.join && r.indexOf(f) > -1;
    };
  }
  var a = {}, i = t.group;
  (!i || Xs(i) != "object") && (i = {
    name: i
  }), a.name = i.name, a.checkPull = n(i.pull, !0), a.checkPut = n(i.put), a.revertClone = i.revertClone, t.group = a;
}, sv = function() {
  !iv && Be && ze(Be, "display", "none");
}, lv = function() {
  !iv && Be && ze(Be, "display", "");
};
Fl && document.addEventListener("click", function(e) {
  if (hl)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), hl = !1, !1;
}, !0);
var qi = function(t) {
  if (ge) {
    t = t.touches ? t.touches[0] : t;
    var n = FD(t.clientX, t.clientY);
    if (n) {
      var a = {};
      for (var i in t)
        t.hasOwnProperty(i) && (a[i] = t[i]);
      a.target = a.rootEl = n, a.preventDefault = void 0, a.stopPropagation = void 0, n[Bn]._onDragOver(a);
    }
  }
}, zD = function(t) {
  ge && ge.parentNode[Bn]._isOutsideThisEl(t.target);
};
function He(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = ci({}, t), e[Bn] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return rv(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(o, l) {
      o.setData("Text", l.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: He.supportPointer !== !1 && "PointerEvent" in window && !Po,
    emptyInsertThreshold: 5
  };
  ns.initializePlugins(this, e, n);
  for (var a in n)
    !(a in t) && (t[a] = n[a]);
  ov(t);
  for (var i in this)
    i.charAt(0) === "_" && typeof this[i] == "function" && (this[i] = this[i].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : $D, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? rt(e, "pointerdown", this._onTapStart) : (rt(e, "mousedown", this._onTapStart), rt(e, "touchstart", this._onTapStart)), this.nativeDraggable && (rt(e, "dragover", this), rt(e, "dragenter", this)), fl.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), ci(this, PD());
}
He.prototype = /** @lends Sortable.prototype */
{
  constructor: He,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (wr = null);
  },
  _getDirection: function(t, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, n, ge) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var n = this, a = this.el, i = this.options, r = i.preventOnFilter, o = t.type, l = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, s = (l || t).target, u = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || s, d = i.filter;
      if (qD(a), !ge && !(/mousedown|pointerdown/.test(o) && t.button !== 0 || i.disabled) && !u.isContentEditable && !(!this.nativeDraggable && Po && s && s.tagName.toUpperCase() === "SELECT") && (s = Ca(s, i.draggable, a, !1), !(s && s.animated) && Zs !== s)) {
        if (Dr = ta(s), Io = ta(s, i.draggable), typeof d == "function") {
          if (d.call(this, t, s, this)) {
            _n({
              sortable: n,
              rootEl: u,
              name: "filter",
              targetEl: s,
              toEl: a,
              fromEl: a
            }), Tn("filter", n, {
              evt: t
            }), r && t.cancelable && t.preventDefault();
            return;
          }
        } else if (d && (d = d.split(",").some(function(c) {
          if (c = Ca(u, c.trim(), a, !1), c)
            return _n({
              sortable: n,
              rootEl: c,
              name: "filter",
              targetEl: s,
              fromEl: a,
              toEl: a
            }), Tn("filter", n, {
              evt: t
            }), !0;
        }), d)) {
          r && t.cancelable && t.preventDefault();
          return;
        }
        i.handle && !Ca(u, i.handle, a, !1) || this._prepareDragStart(t, l, s);
      }
    }
  },
  _prepareDragStart: function(t, n, a) {
    var i = this, r = i.el, o = i.options, l = r.ownerDocument, s;
    if (a && !ge && a.parentNode === r) {
      var u = Xt(a);
      if (wt = r, ge = a, At = ge.parentNode, Qi = ge.nextSibling, Zs = a, Fs = o.group, He.dragged = ge, Gi = {
        target: ge,
        clientX: (n || t).clientX,
        clientY: (n || t).clientY
      }, Of = Gi.clientX - u.left, Cf = Gi.clientY - u.top, this._lastX = (n || t).clientX, this._lastY = (n || t).clientY, ge.style["will-change"] = "all", s = function() {
        if (Tn("delayEnded", i, {
          evt: t
        }), He.eventCanceled) {
          i._onDrop();
          return;
        }
        i._disableDelayedDragEvents(), !Df && i.nativeDraggable && (ge.draggable = !0), i._triggerDragStart(t, n), _n({
          sortable: i,
          name: "choose",
          originalEvent: t
        }), Hn(ge, o.chosenClass, !0);
      }, o.ignore.split(",").forEach(function(d) {
        ev(ge, d.trim(), Uu);
      }), rt(l, "dragover", qi), rt(l, "mousemove", qi), rt(l, "touchmove", qi), rt(l, "mouseup", i._onDrop), rt(l, "touchend", i._onDrop), rt(l, "touchcancel", i._onDrop), Df && this.nativeDraggable && (this.options.touchStartThreshold = 4, ge.draggable = !0), Tn("delayStart", this, {
        evt: t
      }), o.delay && (!o.delayOnTouchOnly || n) && (!this.nativeDraggable || !(ts || mi))) {
        if (He.eventCanceled) {
          this._onDrop();
          return;
        }
        rt(l, "mouseup", i._disableDelayedDrag), rt(l, "touchend", i._disableDelayedDrag), rt(l, "touchcancel", i._disableDelayedDrag), rt(l, "mousemove", i._delayedDragTouchMoveHandler), rt(l, "touchmove", i._delayedDragTouchMoveHandler), o.supportPointer && rt(l, "pointermove", i._delayedDragTouchMoveHandler), i._dragStartTimer = setTimeout(s, o.delay);
      } else
        s();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var n = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    ge && Uu(ge), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    Je(t, "mouseup", this._disableDelayedDrag), Je(t, "touchend", this._disableDelayedDrag), Je(t, "touchcancel", this._disableDelayedDrag), Je(t, "mousemove", this._delayedDragTouchMoveHandler), Je(t, "touchmove", this._delayedDragTouchMoveHandler), Je(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, n) {
    n = n || t.pointerType == "touch" && t, !this.nativeDraggable || n ? this.options.supportPointer ? rt(document, "pointermove", this._onTouchMove) : n ? rt(document, "touchmove", this._onTouchMove) : rt(document, "mousemove", this._onTouchMove) : (rt(ge, "dragend", this), rt(wt, "dragstart", this._onDragStart));
    try {
      document.selection ? Ks(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, n) {
    if (kr = !1, wt && ge) {
      Tn("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && rt(document, "dragover", zD);
      var a = this.options;
      !t && Hn(ge, a.dragClass, !1), Hn(ge, a.ghostClass, !0), He.active = this, t && this._appendGhost(), _n({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (ma) {
      this._lastX = ma.clientX, this._lastY = ma.clientY, sv();
      for (var t = document.elementFromPoint(ma.clientX, ma.clientY), n = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(ma.clientX, ma.clientY), t !== n); )
        n = t;
      if (ge.parentNode[Bn]._isOutsideThisEl(t), n)
        do {
          if (n[Bn]) {
            var a = void 0;
            if (a = n[Bn]._onDragOver({
              clientX: ma.clientX,
              clientY: ma.clientY,
              target: t,
              rootEl: n
            }), a && !this.options.dragoverBubble)
              break;
          }
          t = n;
        } while (n = n.parentNode);
      lv();
    }
  },
  _onTouchMove: function(t) {
    if (Gi) {
      var n = this.options, a = n.fallbackTolerance, i = n.fallbackOffset, r = t.touches ? t.touches[0] : t, o = Be && Cr(Be, !0), l = Be && o && o.a, s = Be && o && o.d, u = Hs && pn && Af(pn), d = (r.clientX - Gi.clientX + i.x) / (l || 1) + (u ? u[0] - ju[0] : 0) / (l || 1), c = (r.clientY - Gi.clientY + i.y) / (s || 1) + (u ? u[1] - ju[1] : 0) / (s || 1);
      if (!He.active && !kr) {
        if (a && Math.max(Math.abs(r.clientX - this._lastX), Math.abs(r.clientY - this._lastY)) < a)
          return;
        this._onDragStart(t, !0);
      }
      if (Be) {
        o ? (o.e += d - (Bu || 0), o.f += c - (Vu || 0)) : o = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: d,
          f: c
        };
        var f = "matrix(".concat(o.a, ",").concat(o.b, ",").concat(o.c, ",").concat(o.d, ",").concat(o.e, ",").concat(o.f, ")");
        ze(Be, "webkitTransform", f), ze(Be, "mozTransform", f), ze(Be, "msTransform", f), ze(Be, "transform", f), Bu = d, Vu = c, ma = r;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!Be) {
      var t = this.options.fallbackOnBody ? document.body : wt, n = Xt(ge, !0, Hs, !0, t), a = this.options;
      if (Hs) {
        for (pn = t; ze(pn, "position") === "static" && ze(pn, "transform") === "none" && pn !== document; )
          pn = pn.parentNode;
        pn !== document.body && pn !== document.documentElement ? (pn === document && (pn = Fa()), n.top += pn.scrollTop, n.left += pn.scrollLeft) : pn = Fa(), ju = Af(pn);
      }
      Be = ge.cloneNode(!0), Hn(Be, a.ghostClass, !1), Hn(Be, a.fallbackClass, !0), Hn(Be, a.dragClass, !0), ze(Be, "transition", ""), ze(Be, "transform", ""), ze(Be, "box-sizing", "border-box"), ze(Be, "margin", 0), ze(Be, "top", n.top), ze(Be, "left", n.left), ze(Be, "width", n.width), ze(Be, "height", n.height), ze(Be, "opacity", "0.8"), ze(Be, "position", Hs ? "absolute" : "fixed"), ze(Be, "zIndex", "100000"), ze(Be, "pointerEvents", "none"), He.ghost = Be, t.appendChild(Be), ze(Be, "transform-origin", Of / parseInt(Be.style.width) * 100 + "% " + Cf / parseInt(Be.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, n) {
    var a = this, i = t.dataTransfer, r = a.options;
    if (Tn("dragStart", this, {
      evt: t
    }), He.eventCanceled) {
      this._onDrop();
      return;
    }
    Tn("setupClone", this), He.eventCanceled || (Ot = av(ge), Ot.draggable = !1, Ot.style["will-change"] = "", this._hideClone(), Hn(Ot, this.options.chosenClass, !1), He.clone = Ot), a.cloneId = Ks(function() {
      Tn("clone", a), !He.eventCanceled && (a.options.removeCloneOnHide || wt.insertBefore(Ot, ge), a._hideClone(), _n({
        sortable: a,
        name: "clone"
      }));
    }), !n && Hn(ge, r.dragClass, !0), n ? (hl = !0, a._loopId = setInterval(a._emulateDragOver, 50)) : (Je(document, "mouseup", a._onDrop), Je(document, "touchend", a._onDrop), Je(document, "touchcancel", a._onDrop), i && (i.effectAllowed = "move", r.setData && r.setData.call(a, i, ge)), rt(document, "drop", a), ze(ge, "transform", "translateZ(0)")), kr = !0, a._dragStartId = Ks(a._dragStarted.bind(a, n, t)), rt(document, "selectstart", a), Mo = !0, Po && ze(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var n = this.el, a = t.target, i, r, o, l = this.options, s = l.group, u = He.active, d = Fs === s, c = l.sort, f = ln || u, v, k = this, b = !1;
    if (kd)
      return;
    function R(U, ie) {
      Tn(U, k, Wa({
        evt: t,
        isOwner: d,
        axis: v ? "vertical" : "horizontal",
        revert: o,
        dragRect: i,
        targetRect: r,
        canSort: c,
        fromSortable: f,
        target: a,
        completed: G,
        onMove: function(J, D) {
          return Ws(wt, n, ge, i, J, Xt(J), t, D);
        },
        changed: C
      }, ie));
    }
    function V() {
      R("dragOverAnimationCapture"), k.captureAnimationState(), k !== f && f.captureAnimationState();
    }
    function G(U) {
      return R("dragOverCompleted", {
        insertion: U
      }), U && (d ? u._hideClone() : u._showClone(k), k !== f && (Hn(ge, ln ? ln.options.ghostClass : u.options.ghostClass, !1), Hn(ge, l.ghostClass, !0)), ln !== k && k !== He.active ? ln = k : k === He.active && ln && (ln = null), f === k && (k._ignoreWhileAnimating = a), k.animateAll(function() {
        R("dragOverAnimationComplete"), k._ignoreWhileAnimating = null;
      }), k !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (a === ge && !ge.animated || a === n && !a.animated) && (wr = null), !l.dragoverBubble && !t.rootEl && a !== document && (ge.parentNode[Bn]._isOutsideThisEl(t.target), !U && qi(t)), !l.dragoverBubble && t.stopPropagation && t.stopPropagation(), b = !0;
    }
    function C() {
      Wn = ta(ge), xi = ta(ge, l.draggable), _n({
        sortable: k,
        name: "change",
        toEl: n,
        newIndex: Wn,
        newDraggableIndex: xi,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), a = Ca(a, l.draggable, n, !0), R("dragOver"), He.eventCanceled)
      return b;
    if (ge.contains(t.target) || a.animated && a.animatingX && a.animatingY || k._ignoreWhileAnimating === a)
      return G(!1);
    if (hl = !1, u && !l.disabled && (d ? c || (o = At !== wt) : ln === this || (this.lastPutMode = Fs.checkPull(this, u, ge, t)) && s.checkPut(this, u, ge, t))) {
      if (v = this._getDirection(t, a) === "vertical", i = Xt(ge), R("dragOverValid"), He.eventCanceled)
        return b;
      if (o)
        return At = wt, V(), this._hideClone(), R("revert"), He.eventCanceled || (Qi ? wt.insertBefore(ge, Qi) : wt.appendChild(ge)), G(!0);
      var q = Sc(n, l.draggable);
      if (!q || VD(t, v, this) && !q.animated) {
        if (q === ge)
          return G(!1);
        if (q && n === t.target && (a = q), a && (r = Xt(a)), Ws(wt, n, ge, i, a, r, t, !!a) !== !1)
          return V(), n.appendChild(ge), At = n, C(), G(!0);
      } else if (q && BD(t, v, this)) {
        var re = Br(n, 0, l, !0);
        if (re === ge)
          return G(!1);
        if (a = re, r = Xt(a), Ws(wt, n, ge, i, a, r, t, !1) !== !1)
          return V(), n.insertBefore(ge, re), At = n, C(), G(!0);
      } else if (a.parentNode === n) {
        r = Xt(a);
        var $ = 0, A, I = ge.parentNode !== n, X = !LD(ge.animated && ge.toRect || i, a.animated && a.toRect || r, v), j = v ? "top" : "left", oe = Tf(a, "top", "top") || Tf(ge, "top", "top"), xe = oe ? oe.scrollTop : void 0;
        wr !== a && (A = r[j], No = !1, zs = !X && l.invertSwap || I), $ = jD(t, a, r, v, X ? 1 : l.swapThreshold, l.invertedSwapThreshold == null ? l.swapThreshold : l.invertedSwapThreshold, zs, wr === a);
        var be;
        if ($ !== 0) {
          var H = ta(ge);
          do
            H -= $, be = At.children[H];
          while (be && (ze(be, "display") === "none" || be === Be));
        }
        if ($ === 0 || be === a)
          return G(!1);
        wr = a, Yo = $;
        var _ = a.nextElementSibling, Y = !1;
        Y = $ === 1;
        var p = Ws(wt, n, ge, i, a, r, t, Y);
        if (p !== !1)
          return (p === 1 || p === -1) && (Y = p === 1), kd = !0, setTimeout(WD, 30), V(), Y && !_ ? n.appendChild(ge) : a.parentNode.insertBefore(ge, Y ? _ : a), oe && nv(oe, 0, xe - oe.scrollTop), At = ge.parentNode, A !== void 0 && !zs && (Qs = Math.abs(A - Xt(a)[j])), C(), G(!0);
      }
      if (n.contains(ge))
        return G(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    Je(document, "mousemove", this._onTouchMove), Je(document, "touchmove", this._onTouchMove), Je(document, "pointermove", this._onTouchMove), Je(document, "dragover", qi), Je(document, "mousemove", qi), Je(document, "touchmove", qi);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    Je(t, "mouseup", this._onDrop), Je(t, "touchend", this._onDrop), Je(t, "pointerup", this._onDrop), Je(t, "touchcancel", this._onDrop), Je(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var n = this.el, a = this.options;
    if (Wn = ta(ge), xi = ta(ge, a.draggable), Tn("drop", this, {
      evt: t
    }), At = ge && ge.parentNode, Wn = ta(ge), xi = ta(ge, a.draggable), He.eventCanceled) {
      this._nulling();
      return;
    }
    kr = !1, zs = !1, No = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), xd(this.cloneId), xd(this._dragStartId), this.nativeDraggable && (Je(document, "drop", this), Je(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), Po && ze(document.body, "user-select", ""), ze(ge, "transform", ""), t && (Mo && (t.cancelable && t.preventDefault(), !a.dropBubble && t.stopPropagation()), Be && Be.parentNode && Be.parentNode.removeChild(Be), (wt === At || ln && ln.lastPutMode !== "clone") && Ot && Ot.parentNode && Ot.parentNode.removeChild(Ot), ge && (this.nativeDraggable && Je(ge, "dragend", this), Uu(ge), ge.style["will-change"] = "", Mo && !kr && Hn(ge, ln ? ln.options.ghostClass : this.options.ghostClass, !1), Hn(ge, this.options.chosenClass, !1), _n({
      sortable: this,
      name: "unchoose",
      toEl: At,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), wt !== At ? (Wn >= 0 && (_n({
      rootEl: At,
      name: "add",
      toEl: At,
      fromEl: wt,
      originalEvent: t
    }), _n({
      sortable: this,
      name: "remove",
      toEl: At,
      originalEvent: t
    }), _n({
      rootEl: At,
      name: "sort",
      toEl: At,
      fromEl: wt,
      originalEvent: t
    }), _n({
      sortable: this,
      name: "sort",
      toEl: At,
      originalEvent: t
    })), ln && ln.save()) : Wn !== Dr && Wn >= 0 && (_n({
      sortable: this,
      name: "update",
      toEl: At,
      originalEvent: t
    }), _n({
      sortable: this,
      name: "sort",
      toEl: At,
      originalEvent: t
    })), He.active && ((Wn == null || Wn === -1) && (Wn = Dr, xi = Io), _n({
      sortable: this,
      name: "end",
      toEl: At,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    Tn("nulling", this), wt = ge = At = Be = Qi = Ot = Zs = Di = Gi = ma = Mo = Wn = xi = Dr = Io = wr = Yo = ln = Fs = He.dragged = He.ghost = He.clone = He.active = null, ml.forEach(function(t) {
      t.checked = !0;
    }), ml.length = Bu = Vu = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        ge && (this._onDragOver(t), HD(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], n, a = this.el.children, i = 0, r = a.length, o = this.options; i < r; i++)
      n = a[i], Ca(n, o.draggable, this.el, !1) && t.push(n.getAttribute(o.dataIdAttr) || GD(n));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, n) {
    var a = {}, i = this.el;
    this.toArray().forEach(function(r, o) {
      var l = i.children[o];
      Ca(l, this.options.draggable, i, !1) && (a[r] = l);
    }, this), n && this.captureAnimationState(), t.forEach(function(r) {
      a[r] && (i.removeChild(a[r]), i.appendChild(a[r]));
    }), n && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, n) {
    return Ca(t, n || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, n) {
    var a = this.options;
    if (n === void 0)
      return a[t];
    var i = ns.modifyOption(this, t, n);
    typeof i < "u" ? a[t] = i : a[t] = n, t === "group" && ov(a);
  },
  /**
   * Destroy
   */
  destroy: function() {
    Tn("destroy", this);
    var t = this.el;
    t[Bn] = null, Je(t, "mousedown", this._onTapStart), Je(t, "touchstart", this._onTapStart), Je(t, "pointerdown", this._onTapStart), this.nativeDraggable && (Je(t, "dragover", this), Je(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), fl.splice(fl.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!Di) {
      if (Tn("hideClone", this), He.eventCanceled)
        return;
      ze(Ot, "display", "none"), this.options.removeCloneOnHide && Ot.parentNode && Ot.parentNode.removeChild(Ot), Di = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Di) {
      if (Tn("showClone", this), He.eventCanceled)
        return;
      ge.parentNode == wt && !this.options.group.revertClone ? wt.insertBefore(Ot, ge) : Qi ? wt.insertBefore(Ot, Qi) : wt.appendChild(Ot), this.options.group.revertClone && this.animate(ge, Ot), ze(Ot, "display", ""), Di = !1;
    }
  }
};
function HD(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function Ws(e, t, n, a, i, r, o, l) {
  var s, u = e[Bn], d = u.options.onMove, c;
  return window.CustomEvent && !mi && !ts ? s = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (s = document.createEvent("Event"), s.initEvent("move", !0, !0)), s.to = t, s.from = e, s.dragged = n, s.draggedRect = a, s.related = i || t, s.relatedRect = r || Xt(t), s.willInsertAfter = l, s.originalEvent = o, e.dispatchEvent(s), d && (c = d.call(u, s, o)), c;
}
function Uu(e) {
  e.draggable = !1;
}
function WD() {
  kd = !1;
}
function BD(e, t, n) {
  var a = Xt(Br(n.el, 0, n.options, !0)), i = 10;
  return t ? e.clientX < a.left - i || e.clientY < a.top && e.clientX < a.right : e.clientY < a.top - i || e.clientY < a.bottom && e.clientX < a.left;
}
function VD(e, t, n) {
  var a = Xt(Sc(n.el, n.options.draggable)), i = 10;
  return t ? e.clientX > a.right + i || e.clientX <= a.right && e.clientY > a.bottom && e.clientX >= a.left : e.clientX > a.right && e.clientY > a.top || e.clientX <= a.right && e.clientY > a.bottom + i;
}
function jD(e, t, n, a, i, r, o, l) {
  var s = a ? e.clientY : e.clientX, u = a ? n.height : n.width, d = a ? n.top : n.left, c = a ? n.bottom : n.right, f = !1;
  if (!o) {
    if (l && Qs < u * i) {
      if (!No && (Yo === 1 ? s > d + u * r / 2 : s < c - u * r / 2) && (No = !0), No)
        f = !0;
      else if (Yo === 1 ? s < d + Qs : s > c - Qs)
        return -Yo;
    } else if (s > d + u * (1 - i) / 2 && s < c - u * (1 - i) / 2)
      return UD(t);
  }
  return f = f || o, f && (s < d + u * r / 2 || s > c - u * r / 2) ? s > d + u / 2 ? 1 : -1 : 0;
}
function UD(e) {
  return ta(ge) < ta(e) ? 1 : -1;
}
function GD(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, a = 0; n--; )
    a += t.charCodeAt(n);
  return a.toString(36);
}
function qD(e) {
  ml.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var a = t[n];
    a.checked && ml.push(a);
  }
}
function Ks(e) {
  return setTimeout(e, 0);
}
function xd(e) {
  return clearTimeout(e);
}
Fl && rt(document, "touchmove", function(e) {
  (He.active || kr) && e.cancelable && e.preventDefault();
});
He.utils = {
  on: rt,
  off: Je,
  css: ze,
  find: ev,
  is: function(t, n) {
    return !!Ca(t, n, t, !1);
  },
  extend: CD,
  throttle: tv,
  closest: Ca,
  toggleClass: Hn,
  clone: av,
  index: ta,
  nextTick: Ks,
  cancelNextTick: xd,
  detectDirection: rv,
  getChild: Br
};
He.get = function(e) {
  return e[Bn];
};
He.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(a) {
    if (!a.prototype || !a.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(a));
    a.utils && (He.utils = Wa(Wa({}, He.utils), a.utils)), ns.mount(a);
  });
};
He.create = function(e, t) {
  return new He(e, t);
};
He.version = SD;
var jt = [], Do, Md, Dd = !1, Gu, qu, pl, So;
function XD() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(n) {
      var a = n.originalEvent;
      this.sortable.nativeDraggable ? rt(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? rt(document, "pointermove", this._handleFallbackAutoScroll) : a.touches ? rt(document, "touchmove", this._handleFallbackAutoScroll) : rt(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var a = n.originalEvent;
      !this.options.dragOverBubble && !a.rootEl && this._handleAutoScroll(a);
    },
    drop: function() {
      this.sortable.nativeDraggable ? Je(document, "dragover", this._handleAutoScroll) : (Je(document, "pointermove", this._handleFallbackAutoScroll), Je(document, "touchmove", this._handleFallbackAutoScroll), Je(document, "mousemove", this._handleFallbackAutoScroll)), Pf(), Js(), ED();
    },
    nulling: function() {
      pl = Md = Do = Dd = So = Gu = qu = null, jt.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, a) {
      var i = this, r = (n.touches ? n.touches[0] : n).clientX, o = (n.touches ? n.touches[0] : n).clientY, l = document.elementFromPoint(r, o);
      if (pl = n, a || this.options.forceAutoScrollFallback || ts || mi || Po) {
        Xu(n, this.options, l, a);
        var s = Oi(l, !0);
        Dd && (!So || r !== Gu || o !== qu) && (So && Pf(), So = setInterval(function() {
          var u = Oi(document.elementFromPoint(r, o), !0);
          u !== s && (s = u, Js()), Xu(n, i.options, u, a);
        }, 10), Gu = r, qu = o);
      } else {
        if (!this.options.bubbleScroll || Oi(l, !0) === Fa()) {
          Js();
          return;
        }
        Xu(n, this.options, Oi(l, !1), !1);
      }
    }
  }, ci(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function Js() {
  jt.forEach(function(e) {
    clearInterval(e.pid);
  }), jt = [];
}
function Pf() {
  clearInterval(So);
}
var Xu = tv(function(e, t, n, a) {
  if (t.scroll) {
    var i = (e.touches ? e.touches[0] : e).clientX, r = (e.touches ? e.touches[0] : e).clientY, o = t.scrollSensitivity, l = t.scrollSpeed, s = Fa(), u = !1, d;
    Md !== n && (Md = n, Js(), Do = t.scroll, d = t.scrollFn, Do === !0 && (Do = Oi(n, !0)));
    var c = 0, f = Do;
    do {
      var v = f, k = Xt(v), b = k.top, R = k.bottom, V = k.left, G = k.right, C = k.width, q = k.height, re = void 0, $ = void 0, A = v.scrollWidth, I = v.scrollHeight, X = ze(v), j = v.scrollLeft, oe = v.scrollTop;
      v === s ? (re = C < A && (X.overflowX === "auto" || X.overflowX === "scroll" || X.overflowX === "visible"), $ = q < I && (X.overflowY === "auto" || X.overflowY === "scroll" || X.overflowY === "visible")) : (re = C < A && (X.overflowX === "auto" || X.overflowX === "scroll"), $ = q < I && (X.overflowY === "auto" || X.overflowY === "scroll"));
      var xe = re && (Math.abs(G - i) <= o && j + C < A) - (Math.abs(V - i) <= o && !!j), be = $ && (Math.abs(R - r) <= o && oe + q < I) - (Math.abs(b - r) <= o && !!oe);
      if (!jt[c])
        for (var H = 0; H <= c; H++)
          jt[H] || (jt[H] = {});
      (jt[c].vx != xe || jt[c].vy != be || jt[c].el !== v) && (jt[c].el = v, jt[c].vx = xe, jt[c].vy = be, clearInterval(jt[c].pid), (xe != 0 || be != 0) && (u = !0, jt[c].pid = setInterval((function() {
        a && this.layer === 0 && He.active._onTouchMove(pl);
        var _ = jt[this.layer].vy ? jt[this.layer].vy * l : 0, Y = jt[this.layer].vx ? jt[this.layer].vx * l : 0;
        typeof d == "function" && d.call(He.dragged.parentNode[Bn], Y, _, e, pl, jt[this.layer].el) !== "continue" || nv(jt[this.layer].el, Y, _);
      }).bind({
        layer: c
      }), 24))), c++;
    } while (t.bubbleScroll && f !== s && (f = Oi(f, !1)));
    Dd = u;
  }
}, 30), uv = function(t) {
  var n = t.originalEvent, a = t.putSortable, i = t.dragEl, r = t.activeSortable, o = t.dispatchSortableEvent, l = t.hideGhostForTarget, s = t.unhideGhostForTarget;
  if (n) {
    var u = a || r;
    l();
    var d = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, c = document.elementFromPoint(d.clientX, d.clientY);
    s(), u && !u.el.contains(c) && (o("spill"), this.onSpill({
      dragEl: i,
      putSortable: a
    }));
  }
};
function Tc() {
}
Tc.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var n = t.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(t) {
    var n = t.dragEl, a = t.putSortable;
    this.sortable.captureAnimationState(), a && a.captureAnimationState();
    var i = Br(this.sortable.el, this.startIndex, this.options);
    i ? this.sortable.el.insertBefore(n, i) : this.sortable.el.appendChild(n), this.sortable.animateAll(), a && a.animateAll();
  },
  drop: uv
};
ci(Tc, {
  pluginName: "revertOnSpill"
});
function Ac() {
}
Ac.prototype = {
  onSpill: function(t) {
    var n = t.dragEl, a = t.putSortable, i = a || this.sortable;
    i.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), i.animateAll();
  },
  drop: uv
};
ci(Ac, {
  pluginName: "removeOnSpill"
});
He.mount(new XD());
He.mount(Ac, Tc);
function ZD() {
  return typeof window < "u" ? window.console : global.console;
}
const QD = ZD();
function KD(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return function(a) {
    return t[a] || (t[a] = e(a));
  };
}
const JD = /-(\w)/g, Rf = KD((e) => e.replace(JD, (t, n) => n ? n.toUpperCase() : ""));
function Zu(e) {
  e.parentElement !== null && e.parentElement.removeChild(e);
}
function If(e, t, n) {
  const a = n === 0 ? e.children[0] : e.children[n - 1].nextSibling;
  e.insertBefore(t, a);
}
function eS(e, t) {
  return Object.values(e).indexOf(t);
}
function tS(e, t, n, a) {
  if (!e)
    return [];
  const i = Object.values(e), r = t.length - a;
  return [...t].map((l, s) => s >= r ? i.length : i.indexOf(l));
}
function dv(e, t) {
  this.$nextTick(() => this.$emit(e.toLowerCase(), t));
}
function nS(e) {
  return (t) => {
    this.realList !== null && this["onDrag" + e](t), dv.call(this, e, t);
  };
}
function aS(e) {
  return ["transition-group", "TransitionGroup"].includes(e);
}
function iS(e) {
  if (!e || e.length !== 1)
    return !1;
  const [{ type: t }] = e;
  return t ? aS(t.name) : !1;
}
function rS(e, t) {
  return t ? { ...t.props, ...t.attrs } : e;
}
const Sd = ["Start", "Add", "Remove", "Update", "End"], Td = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], oS = ["Move", ...Sd, ...Td].map((e) => "on" + e);
let Qu = null;
const sS = {
  options: Object,
  list: {
    type: Array,
    required: !1,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: !1
  },
  clone: {
    type: Function,
    default: (e) => e
  },
  tag: {
    type: String,
    default: "div"
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: !1,
    default: null
  },
  component: {
    type: String,
    default: null
  },
  modelValue: {
    type: Array,
    required: !1,
    default: null
  }
}, lS = nn({
  name: "VueDraggableNext",
  inheritAttrs: !1,
  emits: [
    "update:modelValue",
    "move",
    "change",
    ...Sd.map((e) => e.toLowerCase()),
    ...Td.map((e) => e.toLowerCase())
  ],
  props: sS,
  data() {
    return {
      transitionMode: !1,
      noneFunctionalComponentMode: !1,
      headerOffset: 0,
      footerOffset: 0,
      _sortable: {},
      visibleIndexes: [],
      context: {}
    };
  },
  render() {
    const e = this.$slots.default ? this.$slots.default() : null, t = rS(this.$attrs, this.componentData);
    return e ? (this.transitionMode = iS(e), nd(this.getTag(), t, e)) : nd(this.getTag(), t, []);
  },
  created() {
    this.list !== null && this.modelValue !== null && QD.error("list props are mutually exclusive! Please set one.");
  },
  mounted() {
    const e = {};
    Sd.forEach((i) => {
      e["on" + i] = nS.call(this, i);
    }), Td.forEach((i) => {
      e["on" + i] = dv.bind(this, i);
    });
    const t = Object.keys(this.$attrs).reduce((i, r) => (i[Rf(r)] = this.$attrs[r], i), {}), n = Object.assign({}, t, e, {
      onMove: (i, r) => this.onDragMove(i, r)
    });
    !("draggable" in n) && (n.draggable = ">*");
    const a = this.$el.nodeType === 1 ? this.$el : this.$el.parentElement;
    this._sortable = new He(a, n), a.__draggable_component__ = this, this.computeIndexes();
  },
  beforeUnmount() {
    try {
      this._sortable !== void 0 && this._sortable.destroy();
    } catch {
    }
  },
  computed: {
    realList() {
      return this.list ? this.list : this.modelValue;
    }
  },
  watch: {
    $attrs: {
      handler(e) {
        this.updateOptions(e);
      },
      deep: !0
    },
    realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getTag() {
      return this.component ? _e(this.component) : this.tag;
    },
    updateOptions(e) {
      for (var t in e) {
        const n = Rf(t);
        oS.indexOf(n) === -1 && this._sortable.option(n, e[t]);
      }
    },
    getChildrenNodes() {
      return this.$el.children;
    },
    computeIndexes() {
      this.$nextTick(() => {
        this.visibleIndexes = tS(this.getChildrenNodes(), this.$el.children, this.transitionMode, this.footerOffset);
      });
    },
    getUnderlyingVm(e) {
      const t = eS(this.getChildrenNodes() || [], e);
      if (t === -1)
        return null;
      const n = this.realList[t];
      return { index: t, element: n };
    },
    emitChanges(e) {
      this.$nextTick(() => {
        this.$emit("change", e);
      });
    },
    alterList(e) {
      if (this.list) {
        e(this.list);
        return;
      }
      const t = [...this.modelValue];
      e(t), this.$emit("update:modelValue", t);
    },
    spliceList() {
      const e = (t) => t.splice(...arguments);
      this.alterList(e);
    },
    updatePosition(e, t) {
      const n = (a) => a.splice(t, 0, a.splice(e, 1)[0]);
      this.alterList(n);
    },
    getVmIndex(e) {
      const t = this.visibleIndexes, n = t.length;
      return e > n - 1 ? n : t[e];
    },
    getComponent() {
      return this.$slots.default ? (
        //@ts-ignore
        this.$slots.default()[0].componentInstance
      ) : null;
    },
    resetTransitionData(e) {
      if (!this.noTransitionOnDrag || !this.transitionMode)
        return;
      var t = this.getChildrenNodes();
      t[e].data = null;
      const n = this.getComponent();
      n.children = [], n.kept = void 0;
    },
    onDragStart(e) {
      this.computeIndexes(), this.context = this.getUnderlyingVm(e.item), this.context && (e.item._underlying_vm_ = this.clone(this.context.element), Qu = e.item);
    },
    onDragAdd(e) {
      const t = e.item._underlying_vm_;
      if (t === void 0)
        return;
      Zu(e.item);
      const n = this.getVmIndex(e.newIndex);
      this.spliceList(n, 0, t), this.computeIndexes();
      const a = { element: t, newIndex: n };
      this.emitChanges({ added: a });
    },
    onDragRemove(e) {
      if (If(this.$el, e.item, e.oldIndex), e.pullMode === "clone") {
        Zu(e.clone);
        return;
      }
      if (!this.context)
        return;
      const t = this.context.index;
      this.spliceList(t, 1);
      const n = { element: this.context.element, oldIndex: t };
      this.resetTransitionData(t), this.emitChanges({ removed: n });
    },
    onDragUpdate(e) {
      Zu(e.item), If(e.from, e.item, e.oldIndex);
      const t = this.context.index, n = this.getVmIndex(e.newIndex);
      this.updatePosition(t, n);
      const a = { element: this.context.element, oldIndex: t, newIndex: n };
      this.emitChanges({ moved: a });
    },
    updateProperty(e, t) {
      e.hasOwnProperty(t) && (e[t] += this.headerOffset);
    },
    onDragMove(e, t) {
      const n = this.move;
      if (!n || !this.realList)
        return !0;
      const a = this.getRelatedContextFromMoveEvent(e), i = this.context, r = this.computeFutureIndex(a, e);
      Object.assign(i, { futureIndex: r });
      const o = Object.assign({}, e, {
        relatedContext: a,
        draggedContext: i
      });
      return n(o, t);
    },
    onDragEnd() {
      this.computeIndexes(), Qu = null;
    },
    getTrargetedComponent(e) {
      return e.__draggable_component__;
    },
    getRelatedContextFromMoveEvent({ to: e, related: t }) {
      const n = this.getTrargetedComponent(e);
      if (!n)
        return { component: n };
      const a = n.realList, i = { list: a, component: n };
      if (e !== t && a && n.getUnderlyingVm) {
        const r = n.getUnderlyingVm(t);
        if (r)
          return Object.assign(r, i);
      }
      return i;
    },
    computeFutureIndex(e, t) {
      const n = [...t.to.children].filter((o) => o.style.display !== "none");
      if (n.length === 0)
        return 0;
      const a = n.indexOf(t.related), i = e.component.getVmIndex(a);
      return n.indexOf(Qu) !== -1 || !t.willInsertAfter ? i : i + 1;
    }
  }
}), uS = {
  components: {
    VisibleIcon: Vf,
    TrashBinIcon: Od,
    BarProgressSm: sg,
    FileIcon: jf,
    ImageIcon: ig,
    DownloadFileIcon: rg
  },
  props: {
    file: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["preview", "remove", "pick"],
  computed: {
    showFileError() {
      return this.file.status === aa.FAILED || this.file.error;
    },
    showFileProgress() {
      return ![
        aa.DONE,
        aa.UPLOADED
      ].includes(this.file.status);
    }
  }
}, dS = ["title"], cS = {
  key: 0,
  class: "h-full w-full flex flex-col items-center justify-center space-y-1"
}, hS = { class: "text-xs ct-text-2 text-center" }, fS = {
  key: 1,
  class: "w-full h-full flex items-center justify-center ct-bg-error--1 rounded-md"
}, mS = { class: "group cursor-pointer absolute inset-2 bg-gray-900 flex items-center justify-center space-x-1 bg-opacity-0 hover:bg-opacity-60 transition-opacity rounded-md" }, pS = {
  key: 2,
  class: "w-full h-full flex items-center justify-center"
}, vS = { class: "group cursor-pointer absolute inset-2 bg-gray-900 flex items-center justify-center space-x-1 bg-opacity-0 hover:bg-opacity-60 transition-opacity rounded-md z-[1]" }, gS = ["href"], yS = ["src", "alt"], wS = ["src"];
function bS(e, t, n, a, i, r) {
  const o = _e("BarProgressSm"), l = _e("TrashBinIcon"), s = _e("ImageIcon"), u = _e("VisibleIcon"), d = _e("DownloadFileIcon"), c = _e("FileIcon");
  return y(), O("div", {
    class: Ne(["relative cursor-pointer rounded-xl w-20 h-20 overflow-hidden border p-2", [r.showFileError ? "ct-border-error" : "ct-border-2"]]),
    title: n.file.name
  }, [
    r.showFileProgress && !r.showFileError ? (y(), O("div", cS, [
      ee("p", hS, et(n.file.progress || "100%"), 1),
      Pe(o, {
        progress: n.file.progress
      }, null, 8, ["progress"])
    ])) : F("", !0),
    r.showFileError ? (y(), O("div", fS, [
      ee("div", mS, [
        n.file.canRemove ? (y(), le(l, {
          key: 0,
          class: "h-4.5 w-4.5 text-white opacity-0 group-hover:opacity-100 transition-opacity",
          onClick: t[0] || (t[0] = (f) => e.$emit("remove"))
        })) : F("", !0)
      ]),
      Pe(s, { class: "h-4 w-4 ct-text-error" })
    ])) : F("", !0),
    !r.showFileError && !r.showFileProgress ? (y(), O("div", pS, [
      ee("div", vS, [
        (n.file.isImage || n.file.isVideo) && n.file.preview && !n.file.canPick ? (y(), le(u, {
          key: 0,
          class: "h-4.5 w-4.5 text-white opacity-0 group-hover:opacity-100 transition-opacity",
          onClick: t[1] || (t[1] = (f) => e.$emit("preview"))
        })) : F("", !0),
        !n.file.isImage && !n.file.isVideo ? (y(), O("a", {
          key: 1,
          href: n.file.url,
          target: "_blank"
        }, [
          Pe(d, { class: "h-4.5 w-4.5 text-white opacity-0 group-hover:opacity-100 transition-opacity" })
        ], 8, gS)) : F("", !0),
        n.file.canRemove ? (y(), le(l, {
          key: 2,
          class: "h-4.5 w-4.5 text-white opacity-0 group-hover:opacity-100 transition-opacity",
          onClick: t[2] || (t[2] = (f) => e.$emit("remove"))
        })) : F("", !0)
      ]),
      n.file.isImage && n.file.preview ? (y(), O("img", {
        key: 0,
        class: "w-full h-full object-cover rounded-md",
        src: n.file.preview,
        alt: `${n.file.name} preview`
      }, null, 8, yS)) : n.file.isVideo && n.file.preview ? (y(), O("video", {
        key: 1,
        class: "w-full h-full object-cover rounded-md",
        src: n.file.preview,
        preload: "metadata"
      }, null, 8, wS)) : (y(), le(c, {
        key: 2,
        class: "ct-text-2 h-6 w-6"
      }))
    ])) : F("", !0)
  ], 10, dS);
}
const _S = /* @__PURE__ */ an(uS, [["render", bS]]), kS = {
  name: "CardFileHorizontal",
  components: {
    FileIcon: jf,
    TrashBinIcon: Od,
    ButtonTertiaryIconSm: Uf,
    BarProgressMd: lg
  },
  props: {
    file: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["remove"],
  computed: {
    showFileError() {
      return !!this.file.error || this.file.status === aa.FAILED;
    },
    showFileProgress() {
      return ![
        aa.DONE,
        aa.UPLOADED
      ].includes(this.file.status);
    },
    showFileSize() {
      var e;
      return !!((e = this.file) != null && e.originalSize);
    }
  }
}, xS = { class: "flex-shrink-0 w-10 sm:w-16 h-10 sm:h-16 rounded-lg border ct-border-2 overflow-hidden" }, MS = ["src", "alt"], DS = {
  key: 1,
  class: "w-full h-full flex justify-center items-center"
}, SS = { class: "flex-grow" }, TS = { class: "w-full flex items-start space-x-1" }, AS = { class: "w-0 flex-grow text-sm pr-8 min-h-8" }, OS = { class: "font-medium ct-text-2 truncate" }, CS = {
  key: 0,
  class: "ct-text-3"
}, ES = {
  key: 0,
  class: "flex items-center space-x-3"
}, PS = { class: "text-sm font-medium ct-text-2" }, RS = {
  key: 1,
  class: "mt-2 text-sm ct-text-error"
};
function IS(e, t, n, a, i, r) {
  const o = _e("FileIcon"), l = _e("BarProgressMd"), s = _e("TrashBinIcon"), u = _e("ButtonTertiaryIconSm");
  return y(), O("div", {
    class: Ne(["relative w-full flex items-start border ct-border-2 rounded-xl p-4 space-x-3", { "ct-border-error ": r.showFileError }])
  }, [
    ee("div", xS, [
      n.file.preview ? (y(), O("img", {
        key: 0,
        class: "w-full h-full object-cover",
        src: n.file.preview,
        alt: `${n.file.name} preview`
      }, null, 8, MS)) : (y(), O("div", DS, [
        Pe(o, { class: "ct-text-2 w-6 h-6" })
      ]))
    ]),
    ee("div", SS, [
      ee("div", TS, [
        ee("div", AS, [
          ee("p", OS, et(n.file.name), 1),
          r.showFileSize ? (y(), O("p", CS, et(n.file.size), 1)) : F("", !0)
        ])
      ]),
      r.showFileProgress ? (y(), O("div", ES, [
        Pe(l, {
          progress: n.file.progress
        }, null, 8, ["progress"]),
        ee("p", PS, et(n.file.progress || "100%"), 1)
      ])) : F("", !0),
      n.file.error ? (y(), O("p", RS, et(n.file.error), 1)) : F("", !0)
    ]),
    n.file.canRemove ? (y(), le(u, {
      key: 0,
      class: "absolute top-2 right-2",
      onClick: t[0] || (t[0] = (d) => e.$emit("remove"))
    }, {
      default: De(() => [
        Pe(s, {
          class: Ne({ "ct-text-error": r.showFileError })
        }, null, 8, ["class"])
      ]),
      _: 1
    })) : F("", !0)
  ], 2);
}
const YS = /* @__PURE__ */ an(kS, [["render", IS]]), NS = jr(
  () => import("./CardGalleryPreview-a1bc6b63.js")
), Yf = {
  invalidSize: "This file exceeds limit of 10MB",
  invalidType: "This file has invalid type"
}, Ku = {
  clickToUpload: "Click to select File",
  dragAndDrop: "or drag and drop",
  fileInfo: "([R]min. [mW]px x [mH]px) SVG, PNG, JPG or GIF",
  cropperDiscard: "Cancel uploading",
  cropperCrop: "Crop image"
}, $S = {
  name: "FormFiles",
  components: {
    FormFilesCropper: c0,
    VueDraggableNext: lS,
    UploadCloudIcon: og,
    HelpIcon: Wf,
    CardFile: _S,
    CardFileHorizontal: YS,
    CardGalleryPreview: NS,
    FormNotification: qf
  },
  props: {
    title: { type: String, default: "" },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    singleFile: {
      type: Boolean,
      default: !1
    },
    accept: {
      type: [Array, String],
      default: "image/*"
    },
    maxSize: {
      type: Number,
      // in kilobytes (KB)
      default: 0
    },
    labels: {
      type: Object,
      default: () => Ku
    },
    errorMessages: {
      type: Object,
      default: () => Yf
    },
    help: {
      type: String,
      default: ""
    },
    canReorder: {
      type: Boolean,
      default: !1
    },
    cropperConfig: {
      type: Object,
      default: () => ({
        ...by.SQUARE(500),
        hidden: !0
        // this prop is only to not show cropper by default
      })
    }
  },
  emits: ["update:modelValue", "fileSelected", "fileRemoved", "filesReordered"],
  setup(e) {
    return Bf(e);
  },
  data() {
    return {
      id: Ur(),
      active: !1,
      internalError: "",
      galleryOpened: !1,
      selectedIndex: 0,
      drag: !1,
      fileToCrop: null
    };
  },
  computed: {
    files: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    hasOneFile() {
      return !!this.files.filter((t) => !t.error).length;
    },
    canUploadMoreFiles() {
      return !(this.singleFile && this.hasOneFile);
    },
    calculatedAccept() {
      const { accept: e } = this;
      return Array.isArray(e) ? e.join(",") : e;
    },
    errorMessagesWithDefaults() {
      return { ...Yf, ...this.errorMessages };
    },
    labelsWithDefaults() {
      var i;
      const { ratio: e, minWidth: t, minHeight: n } = this.cropperConfig || {};
      let a = ((i = this.labels) == null ? void 0 : i.fileInfo) || Ku.fileInfo;
      return !e && !t && !n || !this.useCropper ? a = a.replace("([R]min. [mW]px x [mH]px)", "") : !t && !n && (a = a.replace("[mW]px x [mH]px", "")), this.useCropper && (a = a.replace("[R]", e ? `${e} ` : "").replace("[mW]", t || "500").replace("[mH]", e === "1:1" ? t : n || "500")), { ...Ku, ...this.labels, fileInfo: a };
    },
    galleryImages() {
      return this.files.map((e) => ({
        id: e.id,
        src: e.url
      }));
    },
    useCropper() {
      var e;
      return this.cropperConfig === null ? !1 : ((e = this.cropperConfig) == null ? void 0 : e.hidden) !== !0;
    }
  },
  watch: {
    modelValue: {
      handler(e) {
        if (Array.isArray(e))
          for (const t of e)
            t.id || (t.id = im());
      },
      immediate: !0,
      deep: !0
    },
    errorMessages: {
      handler(e, t) {
        const { invalidSize: n, invalidType: a } = t;
        for (const i of this.files)
          i.error === n && (i.error = e.invalidSize), i.error === a && (i.error = e.invalidType);
      },
      deep: !0
    }
  },
  methods: {
    async selectFiles(e) {
      this.internalError = "";
      for (const t of e) {
        const n = Wh(t, aa.UPLOADING);
        if (this.validateFile(n)) {
          if (n.isImage && this.useCropper) {
            await this.cropTheFile(t);
            continue;
          }
          this.wrapAndEmit(n);
        }
      }
    },
    removeFile(e) {
      const t = this.files.indexOf(e);
      if (t !== -1) {
        const [n] = this.files.splice(t, 1);
        this.$emit("fileRemoved", n);
      }
    },
    validateFile(e) {
      if (this.validateFormat(e)) {
        if (!this.validateMaxSize(e))
          return this.internalError = this.errorMessagesWithDefaults.invalidSize, !1;
      } else
        return this.internalError = this.errorMessagesWithDefaults.invalidType, !1;
      return !0;
    },
    validateMaxSize(e) {
      return this.maxSize ? this.maxSize * 1e3 >= e.originalFile.size : !0;
    },
    validateFormat(e) {
      const { accept: t } = this;
      return this.accept ? (Array.isArray(t) ? t : this.accept.split(",")).map((a) => new RegExp(a.replaceAll("*", ".*"), "g")).some((a) => a.test(e.type)) : !0;
    },
    dragover() {
      this.active = this.canUploadMoreFiles;
    },
    dragleave() {
      this.active = !1;
    },
    drop(e) {
      this.canUploadMoreFiles && this.selectFiles(e.dataTransfer.files), this.active = !1;
    },
    showGallery(e) {
      this.selectedIndex = e, this.galleryOpened = !0;
    },
    hideGallery() {
      this.galleryOpened = !1;
    },
    async cropTheFile(e) {
      return this.fileToCrop = e, new Promise((t) => {
        this.resolveNextFileIfAny = t;
      });
    },
    handleImgCropped(e) {
      e && this.wrapAndEmit(e), this.fileToCrop = null, this.resolveNextFileIfAny();
    },
    wrapAndEmit(e) {
      let t = e;
      e instanceof File && (t = Wh(e, aa.UPLOADING)), this.files.push(t), this.$emit("fileSelected", this.modelValue[this.modelValue.length - 1]);
    }
  }
}, LS = {
  class: "w-full",
  "data-scroll": ""
}, FS = { class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1" }, zS = {
  key: 0,
  class: "ct-text-error"
}, HS = {
  key: 0,
  class: "mb-2 text-sm text-gray-500"
}, WS = ["for"], BS = { class: "flex flex-col items-center" }, VS = { class: "cursor-pointer h-10 w-10 flex items-center justify-center bg-white dark:bg-neutral-900 hover:bg-gray-50 dark:hover:bg-neutral-800 rounded-lg border ct-border-2" }, jS = { class: "mt-3 text-sm ct-text-3 text-center" }, US = { class: "inline-block relative cursor-pointer rounded-md text-sm font-medium text-gray-700 dark:text-neutral-300 hover:text-gray-800 dark:hover:text-neutral-100" }, GS = ["id", "accept", "multiple"], qS = { class: "inline-block pl-1" }, XS = { class: "text-center mt-1 text-xs ct-text-3" }, ZS = {
  key: 2,
  class: "mt-2 text-sm ct-text-error"
}, QS = {
  key: 3,
  class: "mt-4"
}, KS = {
  key: 0,
  class: "space-y-2"
}, JS = { key: 1 }, eT = {
  key: 1,
  class: "flex flex-wrap -mb-2 -mr-2"
};
function tT(e, t, n, a, i, r) {
  const o = _e("HelpIcon"), l = _e("UploadCloudIcon"), s = _e("CardFileHorizontal"), u = _e("CardFile"), d = _e("VueDraggableNext"), c = _e("FormNotification"), f = _e("CardGalleryPreview"), v = _e("FormFilesCropper"), k = td("tooltip");
  return y(), O("div", LS, [
    ee("label", FS, [
      ee("span", null, et(n.title), 1),
      n.required ? (y(), O("span", zS, "*")) : F("", !0),
      n.tooltip ? ai((y(), le(o, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [k, { content: n.tooltip }]
      ]) : F("", !0)
    ]),
    e.$slots.description ? (y(), O("div", HS, [
      me(e.$slots, "description")
    ])) : F("", !0),
    r.canUploadMoreFiles ? (y(), O("label", {
      key: 1,
      for: i.id,
      class: Ne(["mt-1 flex justify-center px-6 py-4 border rounded-xl bg-cover cursor-pointer", {
        "ct-border-error border-2": !!i.internalError,
        "border-2 ct-border-brand--solid": i.active,
        "border-gray-300 dark:border-neutral-700": !i.active
      }]),
      onDragover: t[2] || (t[2] = ii((...b) => r.dragover && r.dragover(...b), ["prevent"])),
      onDragleave: t[3] || (t[3] = ii((...b) => r.dragleave && r.dragleave(...b), ["prevent"])),
      onDrop: t[4] || (t[4] = ii((...b) => r.drop && r.drop(...b), ["prevent"]))
    }, [
      ee("div", BS, [
        ee("div", VS, [
          Pe(l, { class: "h-5 w-5 ct-fg-2" })
        ]),
        ee("div", jS, [
          ee("div", US, [
            ee("span", {
              ref: "input",
              class: ""
            }, et(r.labelsWithDefaults.clickToUpload), 513),
            ee("input", {
              id: i.id,
              type: "file",
              class: "sr-only",
              accept: r.calculatedAccept,
              multiple: !n.singleFile,
              onClick: t[0] || (t[0] = (b) => b.target.value === null),
              onChange: t[1] || (t[1] = (b) => r.selectFiles(b.currentTarget.files))
            }, null, 40, GS)
          ]),
          ee("p", qS, et(r.labelsWithDefaults.dragAndDrop), 1)
        ]),
        ee("p", XS, et(r.labelsWithDefaults.fileInfo), 1)
      ])
    ], 42, WS)) : F("", !0),
    i.internalError ? (y(), O("p", ZS, et(i.internalError), 1)) : F("", !0),
    r.files.length ? (y(), O("div", QS, [
      n.singleFile ? (y(), O("div", KS, [
        (y(!0), O(Fe, null, Xe(r.files, (b) => (y(), le(s, {
          key: b.id,
          file: b,
          onRemove: (R) => r.removeFile(b)
        }, null, 8, ["file", "onRemove"]))), 128))
      ])) : (y(), O("div", JS, [
        n.canReorder ? (y(), le(d, {
          key: 0,
          list: r.files,
          class: "flex flex-wrap mb-2 mr-2 dragArea",
          onChange: t[5] || (t[5] = (b) => e.$emit("filesReordered", b))
        }, {
          default: De(() => [
            (y(!0), O(Fe, null, Xe(r.files, (b, R) => (y(), le(u, {
              key: b.id,
              file: b,
              class: "mr-2 mb-2 ct-drag-item",
              style: { height: "80px" },
              onRemove: (V) => r.removeFile(b),
              onPreview: (V) => r.showGallery(R)
            }, null, 8, ["file", "onRemove", "onPreview"]))), 128))
          ]),
          _: 1
        }, 8, ["list"])) : (y(), O("div", eT, [
          (y(!0), O(Fe, null, Xe(r.files, (b, R) => (y(), le(u, {
            key: b.id,
            file: b,
            class: "mr-2 mb-2 ct-drag-item",
            onRemove: (V) => r.removeFile(b),
            onPreview: (V) => r.showGallery(R)
          }, null, 8, ["file", "onRemove", "onPreview"]))), 128))
        ]))
      ]))
    ])) : F("", !0),
    e.hasHelp ? (y(), le(c, {
      key: 4,
      message: n.help,
      help: ""
    }, {
      default: De(() => [
        me(e.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : F("", !0),
    i.galleryOpened ? (y(), le(f, {
      key: 5,
      media: r.galleryImages,
      "start-at": i.selectedIndex,
      onClose: r.hideGallery
    }, null, 8, ["media", "start-at", "onClose"])) : F("", !0),
    Pe(v, {
      "file-to-crop": i.fileToCrop,
      config: n.cropperConfig,
      "crop-label": r.labelsWithDefaults.cropperCrop,
      "discard-label": r.labelsWithDefaults.cropperDiscard,
      onCropped: r.handleImgCropped
    }, null, 8, ["file-to-crop", "config", "crop-label", "discard-label", "onCropped"])
  ]);
}
const IA = /* @__PURE__ */ an($S, [["render", tT]]);
var Bs = window, bi = Bs.requestAnimationFrame || Bs.webkitRequestAnimationFrame || Bs.mozRequestAnimationFrame || Bs.msRequestAnimationFrame || function(e) {
  return setTimeout(e, 16);
}, Nf = window, Ju = Nf.cancelAnimationFrame || Nf.mozCancelAnimationFrame || function(e) {
  clearTimeout(e);
};
function ed() {
  for (var e, t, n, a = arguments[0] || {}, i = 1, r = arguments.length; i < r; i++)
    if ((e = arguments[i]) !== null)
      for (t in e)
        n = e[t], a !== n && n !== void 0 && (a[t] = n);
  return a;
}
function pa(e) {
  return ["true", "false"].indexOf(e) >= 0 ? JSON.parse(e) : e;
}
function va(e, t, n, a) {
  if (a)
    try {
      e.setItem(t, n);
    } catch {
    }
  return n;
}
function nT() {
  var e = window.tnsId;
  return window.tnsId = e ? e + 1 : 1, "tns" + window.tnsId;
}
function zl() {
  var e = document, t = e.body;
  return t || (t = e.createElement("body"), t.fake = !0), t;
}
var $o = document.documentElement;
function Hl(e) {
  var t = "";
  return e.fake && (t = $o.style.overflow, e.style.background = "", e.style.overflow = $o.style.overflow = "hidden", $o.appendChild(e)), t;
}
function Wl(e, t) {
  e.fake && (e.remove(), $o.style.overflow = t, $o.offsetHeight);
}
function aT() {
  var e = document, t = zl(), n = Hl(t), a = e.createElement("div"), i = !1;
  t.appendChild(a);
  try {
    for (var r = "(10px * 10)", o = ["calc" + r, "-moz-calc" + r, "-webkit-calc" + r], l, s = 0; s < 3; s++)
      if (l = o[s], a.style.width = l, a.offsetWidth === 100) {
        i = l.replace(r, "");
        break;
      }
  } catch {
  }
  return t.fake ? Wl(t, n) : a.remove(), i;
}
function iT() {
  var e = document, t = zl(), n = Hl(t), a = e.createElement("div"), i = e.createElement("div"), r = "", o = 70, l = 3, s = !1;
  a.className = "tns-t-subp2", i.className = "tns-t-ct";
  for (var u = 0; u < o; u++)
    r += "<div></div>";
  return i.innerHTML = r, a.appendChild(i), t.appendChild(a), s = Math.abs(a.getBoundingClientRect().left - i.children[o - l].getBoundingClientRect().left) < 2, t.fake ? Wl(t, n) : a.remove(), s;
}
function rT() {
  if (window.matchMedia || window.msMatchMedia)
    return !0;
  var e = document, t = zl(), n = Hl(t), a = e.createElement("div"), i = e.createElement("style"), r = "@media all and (min-width:1px){.tns-mq-test{position:absolute}}", o;
  return i.type = "text/css", a.className = "tns-mq-test", t.appendChild(i), t.appendChild(a), i.styleSheet ? i.styleSheet.cssText = r : i.appendChild(e.createTextNode(r)), o = window.getComputedStyle ? window.getComputedStyle(a).position : a.currentStyle.position, t.fake ? Wl(t, n) : a.remove(), o === "absolute";
}
function oT(e, t) {
  var n = document.createElement("style");
  return e && n.setAttribute("media", e), t && n.setAttribute("nonce", t), document.querySelector("head").appendChild(n), n.sheet ? n.sheet : n.styleSheet;
}
function Za(e, t, n, a) {
  "insertRule" in e ? e.insertRule(t + "{" + n + "}", a) : e.addRule(t, n, a);
}
function sT(e, t) {
  "deleteRule" in e ? e.deleteRule(t) : e.removeRule(t);
}
function Oa(e) {
  var t = "insertRule" in e ? e.cssRules : e.rules;
  return t.length;
}
function lT(e, t) {
  return Math.atan2(e, t) * (180 / Math.PI);
}
function uT(e, t) {
  var n = !1, a = Math.abs(90 - Math.abs(e));
  return a >= 90 - t ? n = "horizontal" : a <= t && (n = "vertical"), n;
}
function _i(e, t, n) {
  for (var a = 0, i = e.length; a < i; a++)
    t.call(n, e[a], a);
}
var Oc = "classList" in document.createElement("_"), Vr = Oc ? function(e, t) {
  return e.classList.contains(t);
} : function(e, t) {
  return e.className.indexOf(t) >= 0;
}, Yt = Oc ? function(e, t) {
  Vr(e, t) || e.classList.add(t);
} : function(e, t) {
  Vr(e, t) || (e.className += " " + t);
}, An = Oc ? function(e, t) {
  Vr(e, t) && e.classList.remove(t);
} : function(e, t) {
  Vr(e, t) && (e.className = e.className.replace(t, ""));
};
function ko(e, t) {
  return e.hasAttribute(t);
}
function Vs(e, t) {
  return e.getAttribute(t);
}
function cv(e) {
  return typeof e.item < "u";
}
function Ln(e, t) {
  if (e = cv(e) || e instanceof Array ? e : [e], Object.prototype.toString.call(t) === "[object Object]")
    for (var n = e.length; n--; )
      for (var a in t)
        e[n].setAttribute(a, t[a]);
}
function ki(e, t) {
  e = cv(e) || e instanceof Array ? e : [e], t = t instanceof Array ? t : [t];
  for (var n = t.length, a = e.length; a--; )
    for (var i = n; i--; )
      e[a].removeAttribute(t[i]);
}
function $f(e) {
  for (var t = [], n = 0, a = e.length; n < a; n++)
    t.push(e[n]);
  return t;
}
function Fn(e, t) {
  e.style.display !== "none" && (e.style.display = "none");
}
function zn(e, t) {
  e.style.display === "none" && (e.style.display = "");
}
function Lf(e) {
  return window.getComputedStyle(e).display !== "none";
}
function xo(e) {
  if (typeof e == "string") {
    var t = [e], n = e.charAt(0).toUpperCase() + e.substr(1), a = ["Webkit", "Moz", "ms", "O"];
    a.forEach(function(l) {
      (l !== "ms" || e === "transform") && t.push(l + n);
    }), e = t;
  }
  var i = document.createElement("fakeelement");
  e.length;
  for (var r = 0; r < e.length; r++) {
    var o = e[r];
    if (i.style[o] !== void 0)
      return o;
  }
  return !1;
}
function dT(e) {
  if (!e || !window.getComputedStyle)
    return !1;
  var t = document, n = zl(), a = Hl(n), i = t.createElement("p"), r, o = e.length > 9 ? "-" + e.slice(0, -9).toLowerCase() + "-" : "";
  return o += "transform", n.insertBefore(i, null), i.style[e] = "translate3d(1px,1px,1px)", r = window.getComputedStyle(i).getPropertyValue(o), n.fake ? Wl(n, a) : i.remove(), r !== void 0 && r.length > 0 && r !== "none";
}
function Ff(e, t) {
  var n = !1;
  return /^Webkit/.test(e) ? n = "webkit" + t + "End" : /^O/.test(e) ? n = "o" + t + "End" : e && (n = t.toLowerCase() + "end"), n;
}
var hv = !1;
try {
  var cT = Object.defineProperty({}, "passive", {
    get: function() {
      hv = !0;
    }
  });
  window.addEventListener("test", null, cT);
} catch {
}
var fv = hv ? { passive: !0 } : !1;
function Tt(e, t, n) {
  for (var a in t) {
    var i = ["touchstart", "touchmove"].indexOf(a) >= 0 && !n ? fv : !1;
    e.addEventListener(a, t[a], i);
  }
}
function Kt(e, t) {
  for (var n in t) {
    var a = ["touchstart", "touchmove"].indexOf(n) >= 0 ? fv : !1;
    e.removeEventListener(n, t[n], a);
  }
}
function hT() {
  return {
    topics: {},
    on: function(e, t) {
      this.topics[e] = this.topics[e] || [], this.topics[e].push(t);
    },
    off: function(e, t) {
      if (this.topics[e]) {
        for (var n = 0; n < this.topics[e].length; n++)
          if (this.topics[e][n] === t) {
            this.topics[e].splice(n, 1);
            break;
          }
      }
    },
    emit: function(e, t) {
      t.type = e, this.topics[e] && this.topics[e].forEach(function(n) {
        n(t, e);
      });
    }
  };
}
function fT(e, t, n, a, u, r, o) {
  var l = Math.min(r, 10), s = u.indexOf("%") >= 0 ? "%" : "px", u = u.replace(s, ""), d = Number(e.style[t].replace(n, "").replace(a, "").replace(s, "")), c = (u - d) / r * l;
  setTimeout(f, l);
  function f() {
    r -= l, d += c, e.style[t] = n + d + s + a, r > 0 ? setTimeout(f, l) : o();
  }
}
Object.keys || (Object.keys = function(e) {
  var t = [];
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
  return t;
});
"remove" in Element.prototype || (Element.prototype.remove = function() {
  this.parentNode && this.parentNode.removeChild(this);
});
var mv = function(e) {
  e = ed({
    container: ".slider",
    mode: "carousel",
    axis: "horizontal",
    items: 1,
    gutter: 0,
    edgePadding: 0,
    fixedWidth: !1,
    autoWidth: !1,
    viewportMax: !1,
    slideBy: 1,
    center: !1,
    controls: !0,
    controlsPosition: "top",
    controlsText: ["prev", "next"],
    controlsContainer: !1,
    prevButton: !1,
    nextButton: !1,
    nav: !0,
    navPosition: "top",
    navContainer: !1,
    navAsThumbnails: !1,
    arrowKeys: !1,
    speed: 300,
    autoplay: !1,
    autoplayPosition: "top",
    autoplayTimeout: 5e3,
    autoplayDirection: "forward",
    autoplayText: ["start", "stop"],
    autoplayHoverPause: !1,
    autoplayButton: !1,
    autoplayButtonOutput: !0,
    autoplayResetOnVisibility: !0,
    animateIn: "tns-fadeIn",
    animateOut: "tns-fadeOut",
    animateNormal: "tns-normal",
    animateDelay: !1,
    loop: !0,
    rewind: !1,
    autoHeight: !1,
    responsive: !1,
    lazyload: !1,
    lazyloadSelector: ".tns-lazy-img",
    touch: !0,
    mouseDrag: !1,
    swipeAngle: 15,
    nested: !1,
    preventActionWhenRunning: !1,
    preventScrollOnTouch: !1,
    freezable: !0,
    onInit: !1,
    useLocalStorage: !0,
    nonce: !1
  }, e || {});
  var t = document, n = window, a = {
    ENTER: 13,
    SPACE: 32,
    LEFT: 37,
    RIGHT: 39
  }, i = {}, r = e.useLocalStorage;
  if (r) {
    var o = navigator.userAgent, l = /* @__PURE__ */ new Date();
    try {
      i = n.localStorage, i ? (i.setItem(l, l), r = i.getItem(l) == l, i.removeItem(l)) : r = !1, r || (i = {});
    } catch {
      r = !1;
    }
    r && (i.tnsApp && i.tnsApp !== o && ["tC", "tPL", "tMQ", "tTf", "t3D", "tTDu", "tTDe", "tADu", "tADe", "tTE", "tAE"].forEach(function(h) {
      i.removeItem(h);
    }), localStorage.tnsApp = o);
  }
  var s = i.tC ? pa(i.tC) : va(i, "tC", aT(), r), u = i.tPL ? pa(i.tPL) : va(i, "tPL", iT(), r), d = i.tMQ ? pa(i.tMQ) : va(i, "tMQ", rT(), r), c = i.tTf ? pa(i.tTf) : va(i, "tTf", xo("transform"), r), f = i.t3D ? pa(i.t3D) : va(i, "t3D", dT(c), r), v = i.tTDu ? pa(i.tTDu) : va(i, "tTDu", xo("transitionDuration"), r), k = i.tTDe ? pa(i.tTDe) : va(i, "tTDe", xo("transitionDelay"), r), b = i.tADu ? pa(i.tADu) : va(i, "tADu", xo("animationDuration"), r), R = i.tADe ? pa(i.tADe) : va(i, "tADe", xo("animationDelay"), r), V = i.tTE ? pa(i.tTE) : va(i, "tTE", Ff(v, "Transition"), r), G = i.tAE ? pa(i.tAE) : va(i, "tAE", Ff(b, "Animation"), r), C = n.console && typeof n.console.warn == "function", q = ["container", "controlsContainer", "prevButton", "nextButton", "navContainer", "autoplayButton"], re = {};
  if (q.forEach(function(h) {
    if (typeof e[h] == "string") {
      var w = e[h], L = t.querySelector(w);
      if (re[h] = w, L && L.nodeName)
        e[h] = L;
      else {
        C && console.warn("Can't find", e[h]);
        return;
      }
    }
  }), e.container.children.length < 1) {
    C && console.warn("No slides found in", e.container);
    return;
  }
  var $ = e.responsive, A = e.nested, I = e.mode === "carousel";
  if ($) {
    0 in $ && (e = ed(e, $[0]), delete $[0]);
    var X = {};
    for (var j in $) {
      var oe = $[j];
      oe = typeof oe == "number" ? { items: oe } : oe, X[j] = oe;
    }
    $ = X, X = null;
  }
  function xe(h) {
    for (var w in h)
      I || (w === "slideBy" && (h[w] = "page"), w === "edgePadding" && (h[w] = !1), w === "autoHeight" && (h[w] = !1)), w === "responsive" && xe(h[w]);
  }
  if (I || xe(e), !I) {
    e.axis = "horizontal", e.slideBy = "page", e.edgePadding = !1;
    var be = e.animateIn, H = e.animateOut, _ = e.animateDelay, Y = e.animateNormal;
  }
  var p = e.axis === "horizontal", U = t.createElement("div"), ie = t.createElement("div"), fe, J = e.container, D = J.parentNode, Q = J.outerHTML, m = J.children, S = m.length, pe, M = Hc(), ye = !1;
  $ && Jc(), I && (J.className += " tns-vpfix");
  var ce = e.autoWidth, T = Le("fixedWidth"), Me = Le("edgePadding"), g = Le("gutter"), W = Bc(), K = Le("center"), B = ce ? 1 : Math.floor(Le("items")), Z = Le("slideBy"), je = e.viewportMax || e.fixedWidthViewportWidth, N = Le("arrowKeys"), se = Le("speed"), Ee = e.rewind, $e = Ee ? !1 : e.loop, lt = Le("autoHeight"), Oe = Le("controls"), rn = Le("controlsText"), Rt = Le("nav"), Mn = Le("touch"), Dt = Le("mouseDrag"), St = Le("autoplay"), Li = Le("autoplayTimeout"), In = Le("autoplayText"), qn = Le("autoplayHoverPause"), Xn = Le("autoplayResetOnVisibility"), Qe = oT(null, Le("nonce")), ja = e.lazyload, Qr = e.lazyloadSelector, gt, E = [], te = $e ? wv() : 0, P = I ? S + te * 2 : S + te, de = !!((T || ce) && !$e), we = T ? ou() : null, Ut = !I || !$e, Wt = p ? "left" : "top", cn = "", ca = "", ha = function() {
    return T ? function() {
      return K && !$e ? S - 1 : Math.ceil(-we / (T + g));
    } : ce ? function() {
      for (var h = 0; h < P; h++)
        if (gt[h] >= -we)
          return h;
    } : function() {
      return K && I && !$e ? S - 1 : $e || I ? Math.max(0, P - Math.ceil(B)) : P - 1;
    };
  }(), ve = Fc(Le("startIndex")), Zn = ve;
  Lc();
  var Qn = 0, Yn = ce ? null : ha(), as = e.preventActionWhenRunning, is = e.swipeAngle, Ta = is ? "?" : !0, pi = !1, Bl = e.onInit, Gt = new hT(), vi = " tns-slider tns-" + e.mode, yt = J.id || nT(), Dn = Le("disable"), Kr = !1, rs = e.freezable, Kn = rs && !ce ? Jl() : !1, Jr = !1, eo = {
    click: gi,
    keydown: Hv
  }, Vl = {
    click: Iv,
    keydown: Wv
  }, to = {
    mouseover: Lv,
    mouseout: Fv
  }, no = { visibilitychange: $v }, ao = { keydown: zv }, io = {
    touchstart: _h,
    touchmove: kh,
    touchend: Os,
    touchcancel: Os
  }, ro = {
    mousedown: _h,
    mousemove: kh,
    mouseup: Os,
    mouseleave: Os
  }, os = Ua("controls"), jl = Ua("nav"), oo = ce ? !0 : e.navAsThumbnails, Ul = Ua("autoplay"), Ec = Ua("touch"), Pc = Ua("mouseDrag"), Gl = "tns-slide-active", Rc = "tns-slide-cloned", ss = "tns-complete", ls = {
    load: Sv,
    error: Tv
  }, ql, Xl, so = e.preventScrollOnTouch === "force";
  if (os)
    var Bt = e.controlsContainer, Ic = e.controlsContainer ? e.controlsContainer.outerHTML : "", ht = e.prevButton, ft = e.nextButton, vv = e.prevButton ? e.prevButton.outerHTML : "", gv = e.nextButton ? e.nextButton.outerHTML : "", lo, uo;
  if (jl)
    var on = e.navContainer, Yc = e.navContainer ? e.navContainer.outerHTML : "", Nn, Jn = ce ? S : Mh(), Fi = 0, zi = -1, $n = zc(), lr = $n, us = "tns-nav-active", ur = "Carousel Page ", Zl = " (Current Slide)";
  if (Ul)
    var Nc = e.autoplayDirection === "forward" ? 1 : -1, _t = e.autoplayButton, $c = e.autoplayButton ? e.autoplayButton.outerHTML : "", co = ["<span class='tns-visually-hidden'>", " animation</span>"], ds, Sn, cs, dr, hs;
  if (Ec || Pc)
    var Hi = {}, fa = {}, fs, Wi = !1, ea, Ql = p ? function(h, w) {
      return h.x - w.x;
    } : function(h, w) {
      return h.y - w.y;
    };
  ce || ms(Dn || Kn), c && (Wt = c, cn = "translate", f ? (cn += p ? "3d(" : "3d(0px, ", ca = p ? ", 0px, 0px)" : ", 0px)") : (cn += p ? "X(" : "Y(", ca = ")")), I && (J.className = J.className.replace("tns-vpfix", "")), _v(), kv(), Uc();
  function ms(h) {
    h && (Oe = Rt = Mn = Dt = N = St = qn = Xn = !1);
  }
  function Lc() {
    for (var h = I ? ve - te : ve; h < 0; )
      h += S;
    return h % S + 1;
  }
  function Fc(h) {
    return h = h ? Math.max(0, Math.min($e ? S - 1 : S - B, h)) : 0, I ? h + te : h;
  }
  function ps(h) {
    for (h == null && (h = ve), I && (h -= te); h < 0; )
      h += S;
    return Math.floor(h % S);
  }
  function zc() {
    var h = ps(), w;
    return w = oo ? h : T || ce ? Math.ceil((h + 1) * Jn / S - 1) : Math.floor(h / B), !$e && I && ve === Yn && (w = Jn - 1), w;
  }
  function yv() {
    if (ce || T && !je)
      return S - 1;
    var h = T ? "fixedWidth" : "items", w = [];
    if ((T || e[h] < S) && w.push(e[h]), $)
      for (var L in $) {
        var z = $[L][h];
        z && (T || z < S) && w.push(z);
      }
    return w.length || w.push(0), Math.ceil(T ? je / Math.min.apply(null, w) : Math.max.apply(null, w));
  }
  function wv() {
    var h = yv(), w = I ? Math.ceil((h * 5 - S) / 2) : h * 4 - S;
    return w = Math.max(h, w), Ua("edgePadding") ? w + 1 : w;
  }
  function Hc() {
    return n.innerWidth || t.documentElement.clientWidth || t.body.clientWidth;
  }
  function Kl(h) {
    return h === "top" ? "afterbegin" : "beforeend";
  }
  function Wc(h) {
    if (h != null) {
      var w = t.createElement("div"), L, z;
      return h.appendChild(w), L = w.getBoundingClientRect(), z = L.right - L.left, w.remove(), z || Wc(h.parentNode);
    }
  }
  function Bc() {
    var h = Me ? Me * 2 - g : 0;
    return Wc(D) - h;
  }
  function Ua(h) {
    if (e[h])
      return !0;
    if ($) {
      for (var w in $)
        if ($[w][h])
          return !0;
    }
    return !1;
  }
  function Le(h, w) {
    if (w == null && (w = M), h === "items" && T)
      return Math.floor((W + g) / (T + g)) || 1;
    var L = e[h];
    if ($)
      for (var z in $)
        w >= parseInt(z) && h in $[z] && (L = $[z][h]);
    return h === "slideBy" && L === "page" && (L = Le("items")), !I && (h === "slideBy" || h === "items") && (L = Math.floor(L)), L;
  }
  function bv(h) {
    return s ? s + "(" + h * 100 + "% / " + P + ")" : h * 100 / P + "%";
  }
  function vs(h, w, L, z, Se) {
    var Ie = "";
    if (h !== void 0) {
      var Ke = h;
      w && (Ke -= w), Ie = p ? "margin: 0 " + Ke + "px 0 " + h + "px;" : "margin: " + h + "px 0 " + Ke + "px 0;";
    } else if (w && !L) {
      var qt = "-" + w + "px", sn = p ? qt + " 0 0" : "0 " + qt + " 0";
      Ie = "margin: 0 " + sn + ";";
    }
    return !I && Se && v && z && (Ie += Bi(z)), Ie;
  }
  function gs(h, w, L) {
    return h ? (h + w) * P + "px" : s ? s + "(" + P * 100 + "% / " + L + ")" : P * 100 / L + "%";
  }
  function ys(h, w, L) {
    var z;
    if (h)
      z = h + w + "px";
    else {
      I || (L = Math.floor(L));
      var Se = I ? P : L;
      z = s ? s + "(100% / " + Se + ")" : 100 / Se + "%";
    }
    return z = "width:" + z, A !== "inner" ? z + ";" : z + " !important;";
  }
  function ws(h) {
    var w = "";
    if (h !== !1) {
      var L = p ? "padding-" : "margin-", z = p ? "right" : "bottom";
      w = L + z + ": " + h + "px;";
    }
    return w;
  }
  function Vc(h, w) {
    var L = h.substring(0, h.length - w).toLowerCase();
    return L && (L = "-" + L + "-"), L;
  }
  function Bi(h) {
    return Vc(v, 18) + "transition-duration:" + h / 1e3 + "s;";
  }
  function jc(h) {
    return Vc(b, 17) + "animation-duration:" + h / 1e3 + "s;";
  }
  function _v() {
    var h = "tns-outer", w = "tns-inner";
    if (Ua("gutter"), U.className = h, ie.className = w, U.id = yt + "-ow", ie.id = yt + "-iw", J.id === "" && (J.id = yt), vi += u || ce ? " tns-subpixel" : " tns-no-subpixel", vi += s ? " tns-calc" : " tns-no-calc", ce && (vi += " tns-autowidth"), vi += " tns-" + e.axis, J.className += vi, I ? (fe = t.createElement("div"), fe.id = yt + "-mw", fe.className = "tns-ovh", U.appendChild(fe), fe.appendChild(ie)) : U.appendChild(ie), lt) {
      var L = fe || ie;
      L.className += " tns-ah";
    }
    if (D.insertBefore(U, J), ie.appendChild(J), _i(m, function(Vt, hr) {
      Yt(Vt, "tns-item"), Vt.id || (Vt.id = yt + "-item" + hr), !I && Y && Yt(Vt, Y), Ln(Vt, {
        "aria-hidden": "true",
        tabindex: "-1"
      });
    }), te) {
      for (var z = t.createDocumentFragment(), Se = t.createDocumentFragment(), Ie = te; Ie--; ) {
        var Ke = Ie % S, qt = m[Ke].cloneNode(!0);
        if (Yt(qt, Rc), ki(qt, "id"), Se.insertBefore(qt, Se.firstChild), I) {
          var sn = m[S - 1 - Ke].cloneNode(!0);
          Yt(sn, Rc), ki(sn, "id"), z.appendChild(sn);
        }
      }
      J.insertBefore(z, J.firstChild), J.appendChild(Se), m = J.children;
    }
  }
  function Uc() {
    if (Ua("autoHeight") || ce || !p) {
      var h = J.querySelectorAll("img");
      _i(h, function(w) {
        var L = w.src;
        ja || (L && L.indexOf("data:image") < 0 ? (w.src = "", Tt(w, ls), Yt(w, "loading"), w.src = L) : rh(w));
      }), bi(function() {
        ks($f(h), function() {
          ql = !0;
        });
      }), Ua("autoHeight") && (h = iu(ve, Math.min(ve + B - 1, P - 1))), ja ? Gc() : bi(function() {
        ks($f(h), Gc);
      });
    } else
      I && fo(), Xc(), Zc();
  }
  function Gc() {
    if (ce && S > 1) {
      var h = $e ? ve : S - 1;
      (function w() {
        var L = m[h].getBoundingClientRect().left, z = m[h - 1].getBoundingClientRect().right;
        Math.abs(L - z) <= 1 ? qc() : setTimeout(function() {
          w();
        }, 16);
      })();
    } else
      qc();
  }
  function qc() {
    (!p || ce) && (uh(), ce ? (we = ou(), rs && (Kn = Jl()), Yn = ha(), ms(Dn || Kn)) : uu()), I && fo(), Xc(), Zc();
  }
  function kv() {
    if (!I)
      for (var h = ve, w = ve + Math.min(S, B); h < w; h++) {
        var L = m[h];
        L.style.left = (h - ve) * 100 / B + "%", Yt(L, be), An(L, Y);
      }
    if (p && (u || ce ? (Za(Qe, "#" + yt + " > .tns-item", "font-size:" + n.getComputedStyle(m[0]).fontSize + ";", Oa(Qe)), Za(Qe, "#" + yt, "font-size:0;", Oa(Qe))) : I && _i(m, function(fu, mu) {
      fu.style.marginLeft = bv(mu);
    })), d) {
      if (v) {
        var z = fe && e.autoHeight ? Bi(e.speed) : "";
        Za(Qe, "#" + yt + "-mw", z, Oa(Qe));
      }
      z = vs(e.edgePadding, e.gutter, e.fixedWidth, e.speed, e.autoHeight), Za(Qe, "#" + yt + "-iw", z, Oa(Qe)), I && (z = p && !ce ? "width:" + gs(e.fixedWidth, e.gutter, e.items) + ";" : "", v && (z += Bi(se)), Za(Qe, "#" + yt, z, Oa(Qe))), z = p && !ce ? ys(e.fixedWidth, e.gutter, e.items) : "", e.gutter && (z += ws(e.gutter)), I || (v && (z += Bi(se)), b && (z += jc(se))), z && Za(Qe, "#" + yt + " > .tns-item", z, Oa(Qe));
    } else {
      Ov(), ie.style.cssText = vs(Me, g, T, lt), I && p && !ce && (J.style.width = gs(T, g, B));
      var z = p && !ce ? ys(T, g, B) : "";
      g && (z += ws(g)), z && Za(Qe, "#" + yt + " > .tns-item", z, Oa(Qe));
    }
    if ($ && d)
      for (var Se in $) {
        Se = parseInt(Se);
        var Ie = $[Se], z = "", Ke = "", qt = "", sn = "", Vt = "", hr = ce ? null : Le("items", Se), vo = Le("fixedWidth", Se), ji = Le("speed", Se), cu = Le("edgePadding", Se), hu = Le("autoHeight", Se), fr = Le("gutter", Se);
        v && fe && Le("autoHeight", Se) && "speed" in Ie && (Ke = "#" + yt + "-mw{" + Bi(ji) + "}"), ("edgePadding" in Ie || "gutter" in Ie) && (qt = "#" + yt + "-iw{" + vs(cu, fr, vo, ji, hu) + "}"), I && p && !ce && ("fixedWidth" in Ie || "items" in Ie || T && "gutter" in Ie) && (sn = "width:" + gs(vo, fr, hr) + ";"), v && "speed" in Ie && (sn += Bi(ji)), sn && (sn = "#" + yt + "{" + sn + "}"), ("fixedWidth" in Ie || T && "gutter" in Ie || !I && "items" in Ie) && (Vt += ys(vo, fr, hr)), "gutter" in Ie && (Vt += ws(fr)), !I && "speed" in Ie && (v && (Vt += Bi(ji)), b && (Vt += jc(ji))), Vt && (Vt = "#" + yt + " > .tns-item{" + Vt + "}"), z = Ke + qt + sn + Vt, z && Qe.insertRule("@media (min-width: " + Se / 16 + "em) {" + z + "}", Qe.cssRules.length);
      }
  }
  function Xc() {
    if (ru(), U.insertAdjacentHTML("afterbegin", '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + ih() + "</span>  of " + S + "</div>"), Xl = U.querySelector(".tns-liveregion .current"), Ul) {
      var h = St ? "stop" : "start";
      _t ? Ln(_t, { "data-action": h }) : e.autoplayButtonOutput && (U.insertAdjacentHTML(Kl(e.autoplayPosition), '<button type="button" data-action="' + h + '">' + co[0] + h + co[1] + In[0] + "</button>"), _t = U.querySelector("[data-action]")), _t && Tt(_t, { click: gh }), St && (As(), qn && Tt(J, to), Xn && Tt(J, no));
    }
    if (jl) {
      if (on)
        Ln(on, { "aria-label": "Carousel Pagination" }), Nn = on.children, _i(Nn, function(Ke, qt) {
          Ln(Ke, {
            "data-nav": qt,
            tabindex: "-1",
            "aria-label": ur + (qt + 1),
            "aria-controls": yt
          });
        });
      else {
        for (var w = "", L = oo ? "" : 'style="display:none"', z = 0; z < S; z++)
          w += '<button type="button" data-nav="' + z + '" tabindex="-1" aria-controls="' + yt + '" ' + L + ' aria-label="' + ur + (z + 1) + '"></button>';
        w = '<div class="tns-nav" aria-label="Carousel Pagination">' + w + "</div>", U.insertAdjacentHTML(Kl(e.navPosition), w), on = U.querySelector(".tns-nav"), Nn = on.children;
      }
      if (du(), v) {
        var Se = v.substring(0, v.length - 18).toLowerCase(), Ie = "transition: all " + se / 1e3 + "s";
        Se && (Ie = "-" + Se + "-" + Ie), Za(Qe, "[aria-controls^=" + yt + "-item]", Ie, Oa(Qe));
      }
      Ln(Nn[$n], { "aria-label": ur + ($n + 1) + Zl }), ki(Nn[$n], "tabindex"), Yt(Nn[$n], us), Tt(on, Vl);
    }
    os && (!Bt && (!ht || !ft) && (U.insertAdjacentHTML(Kl(e.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + yt + '">' + rn[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + yt + '">' + rn[1] + "</button></div>"), Bt = U.querySelector(".tns-controls")), (!ht || !ft) && (ht = Bt.children[0], ft = Bt.children[1]), e.controlsContainer && Ln(Bt, {
      "aria-label": "Carousel Navigation",
      tabindex: "0"
    }), (e.controlsContainer || e.prevButton && e.nextButton) && Ln([ht, ft], {
      "aria-controls": yt,
      tabindex: "-1"
    }), (e.controlsContainer || e.prevButton && e.nextButton) && (Ln(ht, { "data-controls": "prev" }), Ln(ft, { "data-controls": "next" })), lo = ch(ht), uo = ch(ft), fh(), Bt ? Tt(Bt, eo) : (Tt(ht, eo), Tt(ft, eo))), tu();
  }
  function Zc() {
    if (I && V) {
      var h = {};
      h[V] = Aa, Tt(J, h);
    }
    Mn && Tt(J, io, e.preventScrollOnTouch), Dt && Tt(J, ro), N && Tt(t, ao), A === "inner" ? Gt.on("outerResized", function() {
      Kc(), Gt.emit("innerLoaded", hn());
    }) : ($ || T || ce || lt || !p) && Tt(n, { resize: Qc }), lt && (A === "outer" ? Gt.on("innerLoaded", _s) : Dn || _s()), nu(), Dn ? nh() : Kn && th(), Gt.on("indexChanged", oh), A === "inner" && Gt.emit("innerLoaded", hn()), typeof Bl == "function" && Bl(hn()), ye = !0;
  }
  function xv() {
    if (Qe.disabled = !0, Qe.ownerNode && Qe.ownerNode.remove(), Kt(n, { resize: Qc }), N && Kt(t, ao), Bt && Kt(Bt, eo), on && Kt(on, Vl), Kt(J, to), Kt(J, no), _t && Kt(_t, { click: gh }), St && clearInterval(ds), I && V) {
      var h = {};
      h[V] = Aa, Kt(J, h);
    }
    Mn && Kt(J, io), Dt && Kt(J, ro);
    var w = [Q, Ic, vv, gv, Yc, $c];
    q.forEach(function(z, Se) {
      var Ie = z === "container" ? U : e[z];
      if (typeof Ie == "object" && Ie) {
        var Ke = Ie.previousElementSibling ? Ie.previousElementSibling : !1, qt = Ie.parentNode;
        Ie.outerHTML = w[Se], e[z] = Ke ? Ke.nextElementSibling : qt.firstElementChild;
      }
    }), q = be = H = _ = Y = p = U = ie = J = D = Q = m = S = pe = M = ce = T = Me = g = W = B = Z = je = N = se = Ee = $e = lt = Qe = ja = gt = E = te = P = de = we = Ut = Wt = cn = ca = ha = ve = Zn = Qn = Yn = is = Ta = pi = Bl = Gt = vi = yt = Dn = Kr = rs = Kn = Jr = eo = Vl = to = no = ao = io = ro = os = jl = oo = Ul = Ec = Pc = Gl = ss = ls = ql = Oe = rn = Bt = Ic = ht = ft = lo = uo = Rt = on = Yc = Nn = Jn = Fi = zi = $n = lr = us = ur = Zl = St = Li = Nc = In = qn = _t = $c = Xn = co = ds = Sn = cs = dr = hs = Hi = fa = fs = Wi = ea = Ql = Mn = Dt = null;
    for (var L in this)
      L !== "rebuild" && (this[L] = null);
    ye = !1;
  }
  function Qc(h) {
    bi(function() {
      Kc(Ga(h));
    });
  }
  function Kc(h) {
    if (ye) {
      A === "outer" && Gt.emit("outerResized", hn(h)), M = Hc();
      var w, L = pe, z = !1;
      $ && (Jc(), w = L !== pe, w && Gt.emit("newBreakpointStart", hn(h)));
      var Se, Ie, Ke = B, qt = Dn, sn = Kn, Vt = N, hr = Oe, vo = Rt, ji = Mn, cu = Dt, hu = St, fr = qn, fu = Xn, mu = ve;
      if (w) {
        var Bv = T, Vv = lt, jv = rn, Uv = K, pu = In;
        if (!d)
          var Gv = g, qv = Me;
      }
      if (N = Le("arrowKeys"), Oe = Le("controls"), Rt = Le("nav"), Mn = Le("touch"), K = Le("center"), Dt = Le("mouseDrag"), St = Le("autoplay"), qn = Le("autoplayHoverPause"), Xn = Le("autoplayResetOnVisibility"), w && (Dn = Le("disable"), T = Le("fixedWidth"), se = Le("speed"), lt = Le("autoHeight"), rn = Le("controlsText"), In = Le("autoplayText"), Li = Le("autoplayTimeout"), d || (Me = Le("edgePadding"), g = Le("gutter"))), ms(Dn), W = Bc(), (!p || ce) && !Dn && (uh(), p || (uu(), z = !0)), (T || ce) && (we = ou(), Yn = ha()), (w || T) && (B = Le("items"), Z = Le("slideBy"), Ie = B !== Ke, Ie && (!T && !ce && (Yn = ha()), eu())), w && Dn !== qt && (Dn ? nh() : Dv()), rs && (w || T || ce) && (Kn = Jl(), Kn !== sn && (Kn ? (su(Ds(Fc(0))), th()) : (Mv(), z = !0))), ms(Dn || Kn), St || (qn = Xn = !1), N !== Vt && (N ? Tt(t, ao) : Kt(t, ao)), Oe !== hr && (Oe ? Bt ? zn(Bt) : (ht && zn(ht), ft && zn(ft)) : Bt ? Fn(Bt) : (ht && Fn(ht), ft && Fn(ft))), Rt !== vo && (Rt ? (zn(on), du()) : Fn(on)), Mn !== ji && (Mn ? Tt(J, io, e.preventScrollOnTouch) : Kt(J, io)), Dt !== cu && (Dt ? Tt(J, ro) : Kt(J, ro)), St !== hu && (St ? (_t && zn(_t), !Sn && !dr && As()) : (_t && Fn(_t), Sn && po())), qn !== fr && (qn ? Tt(J, to) : Kt(J, to)), Xn !== fu && (Xn ? Tt(t, no) : Kt(t, no)), w) {
        if ((T !== Bv || K !== Uv) && (z = !0), lt !== Vv && (lt || (ie.style.height = "")), Oe && rn !== jv && (ht.innerHTML = rn[0], ft.innerHTML = rn[1]), _t && In !== pu) {
          var vu = St ? 1 : 0, gu = _t.innerHTML, Dh = gu.length - pu[vu].length;
          gu.substring(Dh) === pu[vu] && (_t.innerHTML = gu.substring(0, Dh) + In[vu]);
        }
      } else
        K && (T || ce) && (z = !0);
      if ((Ie || T && !ce) && (Jn = Mh(), du()), Se = ve !== mu, Se ? (Gt.emit("indexChanged", hn()), z = !0) : Ie ? Se || oh() : (T || ce) && (nu(), ru(), ah()), Ie && !I && Cv(), !Dn && !Kn) {
        if (w && !d && ((Me !== qv || g !== Gv) && (ie.style.cssText = vs(Me, g, T, se, lt)), p)) {
          I && (J.style.width = gs(T, g, B));
          var Xv = ys(T, g, B) + ws(g);
          sT(Qe, Oa(Qe) - 1), Za(Qe, "#" + yt + " > .tns-item", Xv, Oa(Qe));
        }
        lt && _s(), z && (fo(), Zn = ve);
      }
      w && Gt.emit("newBreakpointEnd", hn(h));
    }
  }
  function Jl() {
    if (!T && !ce) {
      var h = K ? B - (B - 1) / 2 : B;
      return S <= h;
    }
    var w = T ? (T + g) * S : gt[S], L = Me ? W + Me * 2 : W + g;
    return K && (L -= T ? (W - T) / 2 : (W - (gt[ve + 1] - gt[ve] - g)) / 2), w <= L;
  }
  function Jc() {
    pe = 0;
    for (var h in $)
      h = parseInt(h), M >= h && (pe = h);
  }
  var eu = function() {
    return $e ? I ? (
      // loop + carousel
      function() {
        var h = Qn, w = Yn;
        h += Z, w -= Z, Me ? (h += 1, w -= 1) : T && (W + g) % (T + g) && (w -= 1), te && (ve > w ? ve -= S : ve < h && (ve += S));
      }
    ) : (
      // loop + gallery
      function() {
        if (ve > Yn)
          for (; ve >= Qn + S; )
            ve -= S;
        else if (ve < Qn)
          for (; ve <= Yn - S; )
            ve += S;
      }
    ) : (
      // non-loop
      function() {
        ve = Math.max(Qn, Math.min(Yn, ve));
      }
    );
  }();
  function tu() {
    !St && _t && Fn(_t), !Rt && on && Fn(on), Oe || (Bt ? Fn(Bt) : (ht && Fn(ht), ft && Fn(ft)));
  }
  function eh() {
    St && _t && zn(_t), Rt && on && zn(on), Oe && (Bt ? zn(Bt) : (ht && zn(ht), ft && zn(ft)));
  }
  function th() {
    if (!Jr) {
      if (Me && (ie.style.margin = "0px"), te)
        for (var h = "tns-transparent", w = te; w--; )
          I && Yt(m[w], h), Yt(m[P - w - 1], h);
      tu(), Jr = !0;
    }
  }
  function Mv() {
    if (Jr) {
      if (Me && d && (ie.style.margin = ""), te)
        for (var h = "tns-transparent", w = te; w--; )
          I && An(m[w], h), An(m[P - w - 1], h);
      eh(), Jr = !1;
    }
  }
  function nh() {
    if (!Kr) {
      if (Qe.disabled = !0, J.className = J.className.replace(vi.substring(1), ""), ki(J, ["style"]), $e)
        for (var h = te; h--; )
          I && Fn(m[h]), Fn(m[P - h - 1]);
      if ((!p || !I) && ki(ie, ["style"]), !I)
        for (var w = ve, L = ve + S; w < L; w++) {
          var z = m[w];
          ki(z, ["style"]), An(z, be), An(z, Y);
        }
      tu(), Kr = !0;
    }
  }
  function Dv() {
    if (Kr) {
      if (Qe.disabled = !1, J.className += vi, fo(), $e)
        for (var h = te; h--; )
          I && zn(m[h]), zn(m[P - h - 1]);
      if (!I)
        for (var w = ve, L = ve + S; w < L; w++) {
          var z = m[w], Se = w < ve + B ? be : Y;
          z.style.left = (w - ve) * 100 / B + "%", Yt(z, Se);
        }
      eh(), Kr = !1;
    }
  }
  function ah() {
    var h = ih();
    Xl.innerHTML !== h && (Xl.innerHTML = h);
  }
  function ih() {
    var h = bs(), w = h[0] + 1, L = h[1] + 1;
    return w === L ? w + "" : w + " to " + L;
  }
  function bs(h) {
    h == null && (h = Ds());
    var w = ve, L, z, Se;
    if (K || Me ? (ce || T) && (z = -(parseFloat(h) + Me), Se = z + W + Me * 2) : ce && (z = gt[ve], Se = z + W), ce)
      gt.forEach(function(sn, Vt) {
        Vt < P && ((K || Me) && sn <= z + 0.5 && (w = Vt), Se - sn >= 0.5 && (L = Vt));
      });
    else {
      if (T) {
        var Ie = T + g;
        K || Me ? (w = Math.floor(z / Ie), L = Math.ceil(Se / Ie - 1)) : L = w + Math.ceil(W / Ie) - 1;
      } else if (K || Me) {
        var Ke = B - 1;
        if (K ? (w -= Ke / 2, L = ve + Ke / 2) : L = ve + Ke, Me) {
          var qt = Me * B / W;
          w -= qt, L += qt;
        }
        w = Math.floor(w), L = Math.ceil(L);
      } else
        L = w + B - 1;
      w = Math.max(w, 0), L = Math.min(L, P - 1);
    }
    return [w, L];
  }
  function nu() {
    if (ja && !Dn) {
      var h = bs();
      h.push(Qr), iu.apply(null, h).forEach(function(w) {
        if (!Vr(w, ss)) {
          var L = {};
          L[V] = function(Se) {
            Se.stopPropagation();
          }, Tt(w, L), Tt(w, ls), w.src = Vs(w, "data-src");
          var z = Vs(w, "data-srcset");
          z && (w.srcset = z), Yt(w, "loading");
        }
      });
    }
  }
  function Sv(h) {
    rh(cr(h));
  }
  function Tv(h) {
    Av(cr(h));
  }
  function rh(h) {
    Yt(h, "loaded"), au(h);
  }
  function Av(h) {
    Yt(h, "failed"), au(h);
  }
  function au(h) {
    Yt(h, ss), An(h, "loading"), Kt(h, ls);
  }
  function iu(h, w, L) {
    var z = [];
    for (L || (L = "img"); h <= w; )
      _i(m[h].querySelectorAll(L), function(Se) {
        z.push(Se);
      }), h++;
    return z;
  }
  function _s() {
    var h = iu.apply(null, bs());
    bi(function() {
      ks(h, lh);
    });
  }
  function ks(h, w) {
    if (ql || (h.forEach(function(L, z) {
      !ja && L.complete && au(L), Vr(L, ss) && h.splice(z, 1);
    }), !h.length))
      return w();
    bi(function() {
      ks(h, w);
    });
  }
  function oh() {
    nu(), ru(), ah(), fh(), Ev();
  }
  function Ov() {
    I && lt && (fe.style[v] = se / 1e3 + "s");
  }
  function sh(h, w) {
    for (var L = [], z = h, Se = Math.min(h + w, P); z < Se; z++)
      L.push(m[z].offsetHeight);
    return Math.max.apply(null, L);
  }
  function lh() {
    var h = lt ? sh(ve, B) : sh(te, S), w = fe || ie;
    w.style.height !== h && (w.style.height = h + "px");
  }
  function uh() {
    gt = [0];
    var h = p ? "left" : "top", w = p ? "right" : "bottom", L = m[0].getBoundingClientRect()[h];
    _i(m, function(z, Se) {
      Se && gt.push(z.getBoundingClientRect()[h] - L), Se === P - 1 && gt.push(z.getBoundingClientRect()[w] - L);
    });
  }
  function ru() {
    var h = bs(), w = h[0], L = h[1];
    _i(m, function(z, Se) {
      Se >= w && Se <= L ? ko(z, "aria-hidden") && (ki(z, ["aria-hidden", "tabindex"]), Yt(z, Gl)) : ko(z, "aria-hidden") || (Ln(z, {
        "aria-hidden": "true",
        tabindex: "-1"
      }), An(z, Gl));
    });
  }
  function Cv() {
    for (var h = ve + Math.min(S, B), w = P; w--; ) {
      var L = m[w];
      w >= ve && w < h ? (Yt(L, "tns-moving"), L.style.left = (w - ve) * 100 / B + "%", Yt(L, be), An(L, Y)) : L.style.left && (L.style.left = "", Yt(L, Y), An(L, be)), An(L, H);
    }
    setTimeout(function() {
      _i(m, function(z) {
        An(z, "tns-moving");
      });
    }, 300);
  }
  function Ev() {
    if (Rt && ($n = zi >= 0 ? zi : zc(), zi = -1, $n !== lr)) {
      var h = Nn[lr], w = Nn[$n];
      Ln(h, {
        tabindex: "-1",
        "aria-label": ur + (lr + 1)
      }), An(h, us), Ln(w, { "aria-label": ur + ($n + 1) + Zl }), ki(w, "tabindex"), Yt(w, us), lr = $n;
    }
  }
  function dh(h) {
    return h.nodeName.toLowerCase();
  }
  function ch(h) {
    return dh(h) === "button";
  }
  function hh(h) {
    return h.getAttribute("aria-disabled") === "true";
  }
  function xs(h, w, L) {
    h ? w.disabled = L : w.setAttribute("aria-disabled", L.toString());
  }
  function fh() {
    if (!(!Oe || Ee || $e)) {
      var h = lo ? ht.disabled : hh(ht), w = uo ? ft.disabled : hh(ft), L = ve <= Qn, z = !Ee && ve >= Yn;
      L && !h && xs(lo, ht, !0), !L && h && xs(lo, ht, !1), z && !w && xs(uo, ft, !0), !z && w && xs(uo, ft, !1);
    }
  }
  function Ms(h, w) {
    v && (h.style[v] = w);
  }
  function Pv() {
    return T ? (T + g) * P : gt[P];
  }
  function ho(h) {
    h == null && (h = ve);
    var w = Me ? g : 0;
    return ce ? (W - w - (gt[h + 1] - gt[h] - g)) / 2 : T ? (W - T) / 2 : (B - 1) / 2;
  }
  function ou() {
    var h = Me ? g : 0, w = W + h - Pv();
    return K && !$e && (w = T ? -(T + g) * (P - 1) - ho() : ho(P - 1) - gt[P - 1]), w > 0 && (w = 0), w;
  }
  function Ds(h) {
    h == null && (h = ve);
    var w;
    if (p && !ce)
      if (T)
        w = -(T + g) * h, K && (w += ho());
      else {
        var L = c ? P : B;
        K && (h -= ho()), w = -h * 100 / L;
      }
    else
      w = -gt[h], K && ce && (w += ho());
    return de && (w = Math.max(w, we)), w += p && !ce && !T ? "%" : "px", w;
  }
  function fo(h) {
    Ms(J, "0s"), su(h);
  }
  function su(h) {
    h == null && (h = Ds()), J.style[Wt] = cn + h + ca;
  }
  function mh(h, w, L, z) {
    var Se = h + B;
    $e || (Se = Math.min(Se, P));
    for (var Ie = h; Ie < Se; Ie++) {
      var Ke = m[Ie];
      z || (Ke.style.left = (Ie - ve) * 100 / B + "%"), _ && k && (Ke.style[k] = Ke.style[R] = _ * (Ie - h) / 1e3 + "s"), An(Ke, w), Yt(Ke, L), z && E.push(Ke);
    }
  }
  var Rv = function() {
    return I ? function() {
      Ms(J, ""), v || !se ? (su(), (!se || !Lf(J)) && Aa()) : fT(J, Wt, cn, ca, Ds(), se, Aa), p || uu();
    } : function() {
      E = [];
      var h = {};
      h[V] = h[G] = Aa, Kt(m[Zn], h), Tt(m[ve], h), mh(Zn, be, H, !0), mh(ve, Y, be), (!V || !G || !se || !Lf(J)) && Aa();
    };
  }();
  function lu(h, w) {
    Ut && eu(), (ve !== Zn || w) && (Gt.emit("indexChanged", hn()), Gt.emit("transitionStart", hn()), lt && _s(), Sn && h && ["click", "keydown"].indexOf(h.type) >= 0 && po(), pi = !0, Rv());
  }
  function ph(h) {
    return h.toLowerCase().replace(/-/g, "");
  }
  function Aa(h) {
    if (I || pi) {
      if (Gt.emit("transitionEnd", hn(h)), !I && E.length > 0)
        for (var w = 0; w < E.length; w++) {
          var L = E[w];
          L.style.left = "", R && k && (L.style[R] = "", L.style[k] = ""), An(L, H), Yt(L, Y);
        }
      if (!h || !I && h.target.parentNode === J || h.target === J && ph(h.propertyName) === ph(Wt)) {
        if (!Ut) {
          var z = ve;
          eu(), ve !== z && (Gt.emit("indexChanged", hn()), fo());
        }
        A === "inner" && Gt.emit("innerLoaded", hn()), pi = !1, Zn = ve;
      }
    }
  }
  function mo(h, w) {
    if (!Kn)
      if (h === "prev")
        gi(w, -1);
      else if (h === "next")
        gi(w, 1);
      else {
        if (pi) {
          if (as)
            return;
          Aa();
        }
        var L = ps(), z = 0;
        if (h === "first" ? z = -L : h === "last" ? z = I ? S - B - L : S - 1 - L : (typeof h != "number" && (h = parseInt(h)), isNaN(h) || (w || (h = Math.max(0, Math.min(S - 1, h))), z = h - L)), !I && z && Math.abs(z) < B) {
          var Se = z > 0 ? 1 : -1;
          z += ve + z - S >= Qn ? S * Se : S * 2 * Se * -1;
        }
        ve += z, I && $e && (ve < Qn && (ve += S), ve > Yn && (ve -= S)), ps(ve) !== ps(Zn) && lu(w);
      }
  }
  function gi(h, w) {
    if (pi) {
      if (as)
        return;
      Aa();
    }
    var L;
    if (!w) {
      h = Ga(h);
      for (var z = cr(h); z !== Bt && [ht, ft].indexOf(z) < 0; )
        z = z.parentNode;
      var Se = [ht, ft].indexOf(z);
      Se >= 0 && (L = !0, w = Se === 0 ? -1 : 1);
    }
    if (Ee) {
      if (ve === Qn && w === -1) {
        mo("last", h);
        return;
      } else if (ve === Yn && w === 1) {
        mo("first", h);
        return;
      }
    }
    w && (ve += Z * w, ce && (ve = Math.floor(ve)), lu(L || h && h.type === "keydown" ? h : null));
  }
  function Iv(h) {
    if (pi) {
      if (as)
        return;
      Aa();
    }
    h = Ga(h);
    for (var w = cr(h), L; w !== on && !ko(w, "data-nav"); )
      w = w.parentNode;
    if (ko(w, "data-nav")) {
      var L = zi = Number(Vs(w, "data-nav")), z = T || ce ? L * S / Jn : L * B, Se = oo ? L : Math.min(Math.ceil(z), S - 1);
      mo(Se, h), $n === L && (Sn && po(), zi = -1);
    }
  }
  function Ss() {
    ds = setInterval(function() {
      gi(null, Nc);
    }, Li), Sn = !0;
  }
  function Ts() {
    clearInterval(ds), Sn = !1;
  }
  function vh(h, w) {
    Ln(_t, { "data-action": h }), _t.innerHTML = co[0] + h + co[1] + w;
  }
  function As() {
    Ss(), _t && vh("stop", In[1]);
  }
  function po() {
    Ts(), _t && vh("start", In[0]);
  }
  function Yv() {
    St && !Sn && (As(), dr = !1);
  }
  function Nv() {
    Sn && (po(), dr = !0);
  }
  function gh() {
    Sn ? (po(), dr = !0) : (As(), dr = !1);
  }
  function $v() {
    t.hidden ? Sn && (Ts(), hs = !0) : hs && (Ss(), hs = !1);
  }
  function Lv() {
    Sn && (Ts(), cs = !0);
  }
  function Fv() {
    cs && (Ss(), cs = !1);
  }
  function zv(h) {
    h = Ga(h);
    var w = [a.LEFT, a.RIGHT].indexOf(h.keyCode);
    w >= 0 && gi(h, w === 0 ? -1 : 1);
  }
  function Hv(h) {
    h = Ga(h);
    var w = [a.LEFT, a.RIGHT].indexOf(h.keyCode);
    w >= 0 && (w === 0 ? ht.disabled || gi(h, -1) : ft.disabled || gi(h, 1));
  }
  function yh(h) {
    h.focus();
  }
  function Wv(h) {
    h = Ga(h);
    var w = t.activeElement;
    if (ko(w, "data-nav")) {
      var L = [a.LEFT, a.RIGHT, a.ENTER, a.SPACE].indexOf(h.keyCode), z = Number(Vs(w, "data-nav"));
      L >= 0 && (L === 0 ? z > 0 && yh(Nn[z - 1]) : L === 1 ? z < Jn - 1 && yh(Nn[z + 1]) : (zi = z, mo(z, h)));
    }
  }
  function Ga(h) {
    return h = h || n.event, Vi(h) ? h.changedTouches[0] : h;
  }
  function cr(h) {
    return h.target || n.event.srcElement;
  }
  function Vi(h) {
    return h.type.indexOf("touch") >= 0;
  }
  function wh(h) {
    h.preventDefault ? h.preventDefault() : h.returnValue = !1;
  }
  function bh() {
    return uT(lT(fa.y - Hi.y, fa.x - Hi.x), is) === e.axis;
  }
  function _h(h) {
    if (pi) {
      if (as)
        return;
      Aa();
    }
    St && Sn && Ts(), Wi = !0, ea && (Ju(ea), ea = null);
    var w = Ga(h);
    Gt.emit(Vi(h) ? "touchStart" : "dragStart", hn(h)), !Vi(h) && ["img", "a"].indexOf(dh(cr(h))) >= 0 && wh(h), fa.x = Hi.x = w.clientX, fa.y = Hi.y = w.clientY, I && (fs = parseFloat(J.style[Wt].replace(cn, "")), Ms(J, "0s"));
  }
  function kh(h) {
    if (Wi) {
      var w = Ga(h);
      fa.x = w.clientX, fa.y = w.clientY, I ? ea || (ea = bi(function() {
        xh(h);
      })) : (Ta === "?" && (Ta = bh()), Ta && (so = !0)), (typeof h.cancelable != "boolean" || h.cancelable) && so && h.preventDefault();
    }
  }
  function xh(h) {
    if (!Ta) {
      Wi = !1;
      return;
    }
    if (Ju(ea), Wi && (ea = bi(function() {
      xh(h);
    })), Ta === "?" && (Ta = bh()), Ta) {
      !so && Vi(h) && (so = !0);
      try {
        h.type && Gt.emit(Vi(h) ? "touchMove" : "dragMove", hn(h));
      } catch {
      }
      var w = fs, L = Ql(fa, Hi);
      if (!p || T || ce)
        w += L, w += "px";
      else {
        var z = c ? L * B * 100 / ((W + g) * P) : L * 100 / (W + g);
        w += z, w += "%";
      }
      J.style[Wt] = cn + w + ca;
    }
  }
  function Os(h) {
    if (Wi) {
      ea && (Ju(ea), ea = null), I && Ms(J, ""), Wi = !1;
      var w = Ga(h);
      fa.x = w.clientX, fa.y = w.clientY;
      var L = Ql(fa, Hi);
      if (Math.abs(L)) {
        if (!Vi(h)) {
          var z = cr(h);
          Tt(z, { click: function Se(Ie) {
            wh(Ie), Kt(z, { click: Se });
          } });
        }
        I ? ea = bi(function() {
          if (p && !ce) {
            var Se = -L * B / (W + g);
            Se = L > 0 ? Math.floor(Se) : Math.ceil(Se), ve += Se;
          } else {
            var Ie = -(fs + L);
            if (Ie <= 0)
              ve = Qn;
            else if (Ie >= gt[P - 1])
              ve = Yn;
            else
              for (var Ke = 0; Ke < P && Ie >= gt[Ke]; )
                ve = Ke, Ie > gt[Ke] && L < 0 && (ve += 1), Ke++;
          }
          lu(h, L), Gt.emit(Vi(h) ? "touchEnd" : "dragEnd", hn(h));
        }) : Ta && gi(h, L > 0 ? -1 : 1);
      }
    }
    e.preventScrollOnTouch === "auto" && (so = !1), is && (Ta = "?"), St && !Sn && Ss();
  }
  function uu() {
    var h = fe || ie;
    h.style.height = gt[ve + B] - gt[ve] + "px";
  }
  function Mh() {
    var h = T ? (T + g) * S / W : S / B;
    return Math.min(Math.ceil(h), S);
  }
  function du() {
    if (!(!Rt || oo) && Jn !== Fi) {
      var h = Fi, w = Jn, L = zn;
      for (Fi > Jn && (h = Jn, w = Fi, L = Fn); h < w; )
        L(Nn[h]), h++;
      Fi = Jn;
    }
  }
  function hn(h) {
    return {
      container: J,
      slideItems: m,
      navContainer: on,
      navItems: Nn,
      controlsContainer: Bt,
      hasControls: os,
      prevButton: ht,
      nextButton: ft,
      items: B,
      slideBy: Z,
      cloneCount: te,
      slideCount: S,
      slideCountNew: P,
      index: ve,
      indexCached: Zn,
      displayIndex: Lc(),
      navCurrentIndex: $n,
      navCurrentIndexCached: lr,
      pages: Jn,
      pagesCached: Fi,
      sheet: Qe,
      isOn: ye,
      event: h || {}
    };
  }
  return {
    version: "2.9.4",
    getInfo: hn,
    events: Gt,
    goTo: mo,
    play: Yv,
    pause: Nv,
    isOn: ye,
    updateSliderHeight: lh,
    refresh: Uc,
    destroy: xv,
    rebuild: function() {
      return mv(ed(e, re));
    }
  };
};
const mT = {
  components: {
    ButtonSecondaryIconSm: hg,
    ChevronLeftIcon: gg,
    ChevronRightIcon: vg
  },
  props: {
    sliderClass: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      slider: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.startSlider();
    });
  },
  beforeUnmount() {
    this.destroySlider();
  },
  methods: {
    startSlider() {
      this.slider = mv({
        container: `.${this.sliderClass}`,
        gutter: 16,
        slideBy: "page",
        nav: !1,
        loop: !1,
        nextButton: document.querySelector(`.${this.sliderClass}Btns.slider-arrow-right`),
        prevButton: document.querySelector(`.${this.sliderClass}Btns.slider-arrow-left`),
        ...this.config
      });
    },
    destroySlider() {
      var e;
      (e = this.slider) != null && e.destroy && this.slider.destroy();
    }
  }
}, pT = { class: "relative" }, vT = { class: "absolute inset-y-0 left-0 flex items-center transform -translate-x-1/2 z-[1]" }, gT = { class: "absolute inset-y-0 right-0 flex items-center transform translate-x-1/2 z-[1]" };
function yT(e, t, n, a, i, r) {
  const o = _e("ChevronLeftIcon"), l = _e("ButtonSecondaryIconSm"), s = _e("ChevronRightIcon");
  return y(), O("div", pT, [
    ee("div", vT, [
      Pe(l, {
        class: Ne(["slider-arrow-left disabled:hidden", `${n.sliderClass}Btns`])
      }, {
        default: De(() => [
          Pe(o)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    ee("div", gT, [
      Pe(l, {
        class: Ne(["slider-arrow-right disabled:hidden", `${n.sliderClass}Btns`])
      }, {
        default: De(() => [
          Pe(s)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    ee("div", {
      class: Ne(n.sliderClass)
    }, [
      me(e.$slots, "default")
    ], 2)
  ]);
}
const Cc = /* @__PURE__ */ an(mT, [["render", yT]]), wT = {
  components: {
    PlayFillIcon: Cd
  },
  props: {
    src: {
      type: String,
      default: ""
    },
    thumbnail: {
      type: String,
      default: ""
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    isVideo: {
      type: Boolean,
      defaul: !1
    },
    colors: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["select"]
}, bT = {
  key: 0,
  class: "relative w-full h-full"
}, _T = ["src"], kT = ["src"], xT = { class: "cursor-pointer absolute inset-0 bg-black flex items-center justify-center bg-opacity-30" }, MT = ["src"];
function DT(e, t, n, a, i, r) {
  const o = _e("PlayFillIcon");
  return y(), O("div", null, [
    ee("div", {
      class: Ne([
        "relative cursor-pointer w-14 h-14 rounded-lg overflow-hidden",
        n.isSelected ? "border-2 ct-border-brand--solid" : "border ct-border-2 hover:border-2"
      ]),
      style: kn({ "border-color": n.isSelected ? n.colors.focus : n.colors.border }),
      onClick: t[0] || (t[0] = (l) => e.$emit("select"))
    }, [
      n.isVideo ? (y(), O("div", bT, [
        n.thumbnail ? (y(), O("img", {
          key: 1,
          class: "w-full h-full object-cover",
          src: n.thumbnail
        }, null, 8, kT)) : (y(), O("video", {
          key: 0,
          src: n.src,
          class: "w-full h-full"
        }, null, 8, _T)),
        ee("div", xT, [
          Pe(o, { class: "w-4 h-4 text-white" })
        ])
      ])) : (y(), O("img", {
        key: 1,
        class: "w-full h-full object-cover",
        src: n.src
      }, null, 8, MT))
    ], 6)
  ]);
}
const pv = /* @__PURE__ */ an(wT, [["render", DT]]), ST = {
  components: {
    ButtonPlay: Ad,
    PlayFillIcon: Cd
  },
  props: {
    src: {
      type: String,
      default: ""
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    isVideo: {
      type: Boolean,
      defaul: !1
    }
  },
  emits: ["select"]
}, TT = {
  key: 0,
  class: "relative w-full h-full"
}, AT = ["src"], OT = { class: "cursor-pointer absolute inset-0 bg-black flex items-center justify-center bg-opacity-30" }, CT = ["src"];
function ET(e, t, n, a, i, r) {
  const o = _e("PlayFillIcon"), l = _e("ButtonPlay");
  return y(), O("div", null, [
    ee("div", {
      class: Ne([
        "relative cursor-pointer w-14 lg:w-[200px] h-14 lg:h-28 rounded-lg overflow-hidden",
        n.isSelected ? "border-2 border-gray-900/100" : "border border-gray-900/10 hover:border-gray-900/30"
      ]),
      onClick: t[0] || (t[0] = (s) => e.$emit("select"))
    }, [
      n.isVideo ? (y(), O("div", TT, [
        ee("video", {
          src: n.src,
          class: "w-full h-full"
        }, null, 8, AT),
        ee("div", OT, [
          Pe(o, { class: "w-4 h-4 text-white lg:hidden" }),
          Pe(l, { class: "hidden lg:block" })
        ])
      ])) : (y(), O("img", {
        key: 1,
        class: "w-full h-full object-cover",
        src: n.src
      }, null, 8, CT))
    ], 2)
  ]);
}
const PT = /* @__PURE__ */ an(ST, [["render", ET]]), RT = jr(() => import("./CardGalleryPreview-a1bc6b63.js")), IT = {
  video: "video",
  image: "image"
}, YT = {
  components: {
    CardsInlineSlider: Cc,
    CardGalleryItem: pv,
    CardGalleryPreview: RT,
    ZoomInIcon: Ed,
    ButtonPlay: Ad
  },
  props: {
    images: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: String,
      default: ""
    },
    colors: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      galleryOpened: !1,
      sliderConfig: {
        gutter: 12,
        fixedWidth: 56
      },
      sliderClass: `inline-slider-${Ur()}`
    };
  },
  computed: {
    selectedImage() {
      return this.images.find((e) => e.src === this.selected);
    },
    selected: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    selectedIndex() {
      return this.images.findIndex((e) => e.src === this.selected);
    }
  },
  methods: {
    showGallery() {
      this.galleryOpened = !0;
    },
    hideGallery() {
      this.galleryOpened = !1;
    },
    isVideo(e) {
      return e.type === IT.video;
    }
  }
}, NT = { class: "space-y-3" }, $T = ["src"], LT = ["src"], FT = ["src"];
function zT(e, t, n, a, i, r) {
  const o = _e("ButtonPlay"), l = _e("ZoomInIcon"), s = _e("CardGalleryItem"), u = _e("CardsInlineSlider"), d = _e("CardGalleryPreview");
  return y(), O("div", NT, [
    ee("div", {
      class: "relative w-full aspect-video rounded-lg border ct-border-2 overflow-hidden",
      style: kn({ "border-color": n.colors.border })
    }, [
      r.isVideo(r.selectedImage) ? (y(), O("div", {
        key: 0,
        class: "cursor-pointer absolute inset-0 bg-black flex items-center justify-center opacity-30 hover:opacity-15 transition-opacity z-[1]",
        onClick: t[0] || (t[0] = (...c) => r.showGallery && r.showGallery(...c))
      }, [
        Pe(o)
      ])) : (y(), O("div", {
        key: 1,
        class: "cursor-pointer absolute inset-0 bg-black flex items-center justify-center opacity-0 hover:opacity-60 transition-opacity",
        onClick: t[1] || (t[1] = (...c) => r.showGallery && r.showGallery(...c))
      }, [
        Pe(l, { class: "h-8 w-8 text-white" })
      ])),
      r.isVideo(r.selectedImage) ? (y(), O(Fe, { key: 2 }, [
        r.selectedImage.thumbnail ? (y(), O("img", {
          key: 1,
          src: r.selectedImage.thumbnail,
          class: "w-full h-full object-cover"
        }, null, 8, LT)) : (y(), O("video", {
          key: 0,
          src: `${r.selectedImage.src}#t=0.01`,
          preload: "metadata",
          class: "w-full h-full"
        }, null, 8, $T))
      ], 64)) : (y(), O("img", {
        key: 3,
        src: r.selectedImage.src,
        class: "w-full h-full object-cover"
      }, null, 8, FT))
    ], 4),
    n.images.length > 1 ? (y(), le(u, {
      key: 0,
      config: i.sliderConfig,
      "slider-class": i.sliderClass
    }, {
      default: De(() => [
        (y(!0), O(Fe, null, Xe(n.images, (c) => (y(), le(s, {
          key: c.id,
          src: c.src,
          thumbnail: c.thumbnail,
          "is-video": r.isVideo(c),
          "is-selected": r.selected === c.src,
          colors: n.colors,
          onSelect: (f) => r.selected = c.src
        }, null, 8, ["src", "thumbnail", "is-video", "is-selected", "colors", "onSelect"]))), 128))
      ]),
      _: 1
    }, 8, ["config", "slider-class"])) : F("", !0),
    i.galleryOpened ? (y(), le(d, {
      key: 1,
      media: n.images,
      "start-at": r.selectedIndex,
      onClose: r.hideGallery
    }, null, 8, ["media", "start-at", "onClose"])) : F("", !0)
  ]);
}
const YA = /* @__PURE__ */ an(YT, [["render", zT]]), HT = jr(() => import("./CardGalleryPreview-a1bc6b63.js")), WT = {
  video: "video",
  image: "image"
}, BT = {
  components: {
    CardsInlineSlider: Cc,
    CardGalleryItem: pv,
    CardGalleryPreview: HT,
    ZoomInIcon: Ed
  },
  props: {
    images: {
      type: Array,
      required: !0
    },
    sliderConfig: {
      type: Object,
      default: () => ({
        gutter: 12,
        fixedWidth: 56
      })
    }
  },
  data() {
    return {
      showSlider: !0,
      selectedIndex: 0,
      galleryOpened: !1,
      sliderClass: `inline-slider-${Ur()}`
    };
  },
  computed: {
    imagesLength() {
      return this.images.length;
    }
  },
  watch: {
    imagesLength() {
      this.rebuildSlider();
    }
  },
  methods: {
    showGallery(e) {
      this.selectedIndex = e, this.galleryOpened = !0;
    },
    hideGallery() {
      this.galleryOpened = !1;
    },
    isVideo(e) {
      var t;
      return e.type === WT.video || ((t = e.src) == null ? void 0 : t.includes(".mp4"));
    },
    rebuildSlider() {
      this.showSlider = !1, setTimeout(() => {
        this.showSlider = !0;
      }, 100);
    }
  }
}, VT = ["onClick"];
function jT(e, t, n, a, i, r) {
  const o = _e("CardGalleryItem"), l = _e("ZoomInIcon"), s = _e("CardsInlineSlider"), u = _e("CardGalleryPreview");
  return y(), O("div", null, [
    i.showSlider && n.images.length ? (y(), le(s, {
      key: 0,
      "slider-class": i.sliderClass,
      config: n.sliderConfig
    }, {
      default: De(() => [
        (y(!0), O(Fe, null, Xe(n.images, (d, c) => (y(), O("div", {
          key: d.src,
          class: "relative h-14 rounded-lg overflow-hidden"
        }, [
          Pe(o, {
            src: d.src,
            "is-video": r.isVideo(d)
          }, null, 8, ["src", "is-video"]),
          ee("div", {
            class: "cursor-pointer absolute top-0 left-0 w-14 h-full bg-black flex items-center justify-center opacity-0 hover:opacity-60 transition-opacity rounded-lg overflow-hidden",
            onClick: (f) => r.showGallery(c)
          }, [
            r.isVideo(d) ? F("", !0) : (y(), le(l, {
              key: 0,
              class: "h-5 w-5 text-white"
            }))
          ], 8, VT)
        ]))), 128))
      ]),
      _: 1
    }, 8, ["slider-class", "config"])) : F("", !0),
    i.galleryOpened ? (y(), le(u, {
      key: 1,
      media: n.images,
      "start-at": i.selectedIndex,
      onClose: r.hideGallery
    }, null, 8, ["media", "start-at", "onClose"])) : F("", !0)
  ]);
}
const NA = /* @__PURE__ */ an(BT, [["render", jT]]), UT = jr(() => import("./CardGalleryPreview-a1bc6b63.js")), GT = {
  video: "video",
  image: "image"
}, qT = {
  components: {
    CardsInlineSlider: Cc,
    CardGalleryItemMd: PT,
    CardGalleryPreview: UT,
    ZoomInIcon: Ed
  },
  props: {
    images: {
      type: Array,
      required: !0
    },
    sliderConfig: {
      type: Object,
      default: () => ({
        gutter: 12,
        responsive: { 1024: { fixedWidth: 200 } },
        fixedWidth: 56
      })
    }
  },
  data() {
    return {
      showSlider: !0,
      selectedIndex: 0,
      galleryOpened: !1,
      sliderClass: `inline-md-slider-${Ur()}`
    };
  },
  computed: {
    imagesLength() {
      return this.images.length;
    }
  },
  watch: {
    imagesLength() {
      this.rebuildSlider();
    }
  },
  methods: {
    showGallery(e) {
      this.selectedIndex = e, this.galleryOpened = !0;
    },
    hideGallery() {
      this.galleryOpened = !1;
    },
    isVideo(e) {
      return e.type === GT.video;
    },
    rebuildSlider() {
      this.showSlider = !1, setTimeout(() => {
        this.showSlider = !0;
      }, 100);
    }
  }
}, XT = ["onClick"];
function ZT(e, t, n, a, i, r) {
  const o = _e("CardGalleryItemMd"), l = _e("ZoomInIcon"), s = _e("CardsInlineSlider"), u = _e("CardGalleryPreview");
  return y(), O("div", null, [
    i.showSlider && n.images.length ? (y(), le(s, {
      key: 0,
      "slider-class": i.sliderClass,
      config: n.sliderConfig
    }, {
      default: De(() => [
        (y(!0), O(Fe, null, Xe(n.images, (d, c) => (y(), O("div", {
          key: d.src,
          class: "relative h-14 lg:h-28 rounded-lg overflow-hidden"
        }, [
          Pe(o, {
            src: d.src,
            "is-video": r.isVideo(d)
          }, null, 8, ["src", "is-video"]),
          ee("div", {
            class: "cursor-pointer absolute top-0 left-0 w-14 lg:w-[200px] h-full bg-black flex items-center justify-center opacity-0 hover:opacity-60 transition-opacity rounded-lg overflow-hidden",
            onClick: (f) => r.showGallery(c)
          }, [
            r.isVideo(d) ? F("", !0) : (y(), le(l, {
              key: 0,
              class: "h-5 lg:h-8 w-5 lg:w-10 text-white"
            }))
          ], 8, XT)
        ]))), 128))
      ]),
      _: 1
    }, 8, ["slider-class", "config"])) : F("", !0),
    i.galleryOpened ? (y(), le(u, {
      key: 1,
      media: n.images,
      "start-at": i.selectedIndex,
      onClose: r.hideGallery
    }, null, 8, ["media", "start-at", "onClose"])) : F("", !0)
  ]);
}
const $A = /* @__PURE__ */ an(qT, [["render", ZT]]), QT = {
  components: {
    PlayFillIcon: Cd,
    AddIcon: yg,
    VisibleIcon: Vf,
    TrashBinIcon: Od
  },
  props: {
    src: {
      type: String,
      default: ""
    },
    isVideo: {
      type: Boolean,
      defaul: !1
    },
    pickMode: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["preview", "remove", "pick"]
}, KT = { class: "relative cursor-pointer w-20 h-20 rounded-xl overflow-hidden border ct-border-2 p-2" }, JT = {
  key: 0,
  class: "relative w-full h-full"
}, eA = ["src"], tA = { class: "cursor-pointer absolute inset-0 bg-black flex items-center justify-center bg-opacity-30" }, nA = ["src"], aA = { class: "group cursor-pointer absolute inset-2 bg-gray-900 flex items-center justify-center space-x-1 bg-opacity-0 hover:bg-opacity-60 transition-opacity rounded-md" };
function iA(e, t, n, a, i, r) {
  const o = _e("PlayFillIcon"), l = _e("AddIcon"), s = _e("VisibleIcon"), u = _e("TrashBinIcon");
  return y(), O("div", null, [
    ee("div", KT, [
      n.isVideo ? (y(), O("div", JT, [
        ee("video", {
          src: n.src,
          class: "w-full h-full rounded-md"
        }, null, 8, eA),
        ee("div", tA, [
          Pe(o, { class: "w-4 h-4 text-white" })
        ])
      ])) : (y(), O("img", {
        key: 1,
        class: "w-full h-full object-cover rounded-md",
        src: n.src
      }, null, 8, nA)),
      ee("div", aA, [
        n.pickMode ? (y(), le(l, {
          key: 0,
          class: "h-4.5 w-4.5 text-white opacity-0 group-hover:opacity-100 transition-opacity",
          onClick: t[0] || (t[0] = (d) => e.$emit("pick"))
        })) : F("", !0),
        n.pickMode ? F("", !0) : (y(), le(s, {
          key: 1,
          class: "h-4.5 w-4.5 text-white opacity-0 group-hover:opacity-100 transition-opacity",
          onClick: t[1] || (t[1] = (d) => e.$emit("preview"))
        })),
        n.pickMode ? F("", !0) : (y(), le(u, {
          key: 2,
          class: "h-4.5 w-4.5 text-white opacity-0 group-hover:opacity-100 transition-opacity",
          onClick: t[2] || (t[2] = (d) => e.$emit("remove"))
        }))
      ])
    ])
  ]);
}
const rA = /* @__PURE__ */ an(QT, [["render", iA]]), oA = jr(() => import("./CardGalleryPreview-a1bc6b63.js")), sA = {
  components: {
    CardGalleryEditItem: rA,
    CardGalleryPreview: oA
  },
  props: {
    images: {
      type: Array,
      required: !0
    },
    pickMode: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["pick", "remove"],
  data() {
    return {
      galleryOpened: !1,
      selectedIndex: 0
    };
  },
  methods: {
    showGallery(e) {
      this.selectedIndex = e, this.galleryOpened = !0;
    },
    hideGallery() {
      this.galleryOpened = !1;
    },
    isVideo(e) {
      return e ? e.includes(".webm") || e.includes(".mp4") || e.includes(".mov") || e.includes(".m4v") : !1;
    }
  }
}, lA = { class: "flex flex-wrap -mb-2 -mr-2" };
function uA(e, t, n, a, i, r) {
  const o = _e("CardGalleryEditItem"), l = _e("CardGalleryPreview");
  return y(), O("div", lA, [
    (y(!0), O(Fe, null, Xe(n.images, (s, u) => (y(), le(o, {
      key: u,
      src: s,
      "is-video": r.isVideo(s),
      "pick-mode": n.pickMode,
      class: "mr-2 mb-2",
      onPick: (d) => e.$emit("pick", s),
      onRemove: (d) => e.$emit("remove", s),
      onPreview: (d) => r.showGallery(u)
    }, null, 8, ["src", "is-video", "pick-mode", "onPick", "onRemove", "onPreview"]))), 128)),
    i.galleryOpened ? (y(), le(l, {
      key: 0,
      media: n.images,
      "start-at": i.selectedIndex,
      onClose: r.hideGallery
    }, null, 8, ["media", "start-at", "onClose"])) : F("", !0)
  ]);
}
const LA = /* @__PURE__ */ an(sA, [["render", uA]]), dA = jr(() => import("./CardGalleryPreview-a1bc6b63.js")), cA = {
  video: "video",
  image: "image"
}, hA = {
  components: {
    ButtonPlay: Ad,
    CardGalleryPreview: dA
  },
  props: {
    src: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      galleryOpened: !1
    };
  },
  computed: {
    videoData() {
      return [
        {
          src: this.src,
          type: cA.video
        }
      ];
    }
  },
  methods: {
    showGallery() {
      this.galleryOpened = !0;
    },
    hideGallery() {
      this.galleryOpened = !1;
    }
  }
}, fA = { class: "relative cursor-pointer max-w-full w-72 aspect-video rounded-lg overflow-hidden" }, mA = { class: "absolute inset-0 w-full h-full" }, pA = ["src"];
function vA(e, t, n, a, i, r) {
  const o = _e("ButtonPlay"), l = _e("CardGalleryPreview");
  return y(), O("div", null, [
    ee("div", fA, [
      ee("div", mA, [
        ee("video", {
          src: n.src,
          class: "w-full h-full"
        }, null, 8, pA),
        ee("div", {
          class: "cursor-pointer absolute inset-0 bg-black flex items-center justify-center bg-opacity-30 hover:bg-opacity-15",
          onClick: t[0] || (t[0] = (...s) => r.showGallery && r.showGallery(...s))
        }, [
          Pe(o)
        ])
      ]),
      i.galleryOpened ? (y(), le(l, {
        key: 0,
        media: r.videoData,
        onClose: r.hideGallery
      }, null, 8, ["media", "onClose"])) : F("", !0)
    ])
  ]);
}
const FA = /* @__PURE__ */ an(hA, [["render", vA]]);
export {
  Cc as C,
  c0 as F,
  Qp as H,
  Xf as L,
  s0 as M,
  qf as _,
  pv as a,
  PT as b,
  YA as c,
  NA as d,
  $A as e,
  _S as f,
  Ur as g,
  ke as h,
  CA as i,
  rA as j,
  LA as k,
  FA as l,
  YS as m,
  by as n,
  Wh as o,
  IA as p,
  RA as q,
  mv as t
};
